
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref139"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref139"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lVQGa", function(module, exports) {

$parcel$export(module.exports, "encode", () => $ff77c8cf93acccbb$export$c564cdbbe6da493, (v) => $ff77c8cf93acccbb$export$c564cdbbe6da493 = v);
// encode.js
var $ff77c8cf93acccbb$export$c564cdbbe6da493;
$ff77c8cf93acccbb$export$c564cdbbe6da493 = $ff77c8cf93acccbb$var$encode;

var $f2IWs = parcelRequire("f2IWs");
var $ff77c8cf93acccbb$require$EncodeBuffer = $f2IWs.EncodeBuffer;
function $ff77c8cf93acccbb$var$encode(input, options) {
    var encoder = new $ff77c8cf93acccbb$require$EncodeBuffer(options);
    encoder.write(input);
    return encoder.read();
}

});
parcelRegister("f2IWs", function(module, exports) {

$parcel$export(module.exports, "EncodeBuffer", () => $af39e76a63078159$export$9547582b1f5d6363, (v) => $af39e76a63078159$export$9547582b1f5d6363 = v);
// encode-buffer.js
var $af39e76a63078159$export$9547582b1f5d6363;
$af39e76a63078159$export$9547582b1f5d6363 = $af39e76a63078159$var$EncodeBuffer;

var $hVzVX = parcelRequire("hVzVX");
var $af39e76a63078159$require$preset = $hVzVX.preset;

var $crMK8 = parcelRequire("crMK8");
var $af39e76a63078159$require$FlexEncoder = $crMK8.FlexEncoder;
$af39e76a63078159$require$FlexEncoder.mixin($af39e76a63078159$var$EncodeBuffer.prototype);
function $af39e76a63078159$var$EncodeBuffer(options) {
    if (!(this instanceof $af39e76a63078159$var$EncodeBuffer)) return new $af39e76a63078159$var$EncodeBuffer(options);
    if (options) {
        this.options = options;
        if (options.codec) {
            var codec = this.codec = options.codec;
            if (codec.bufferish) this.bufferish = codec.bufferish;
        }
    }
}
$af39e76a63078159$var$EncodeBuffer.prototype.codec = $af39e76a63078159$require$preset;
$af39e76a63078159$var$EncodeBuffer.prototype.write = function(input) {
    this.codec.encode(this, input);
};

});
parcelRegister("hVzVX", function(module, exports) {

$parcel$export(module.exports, "preset", () => $d0d3a237fd442f07$export$f5ab8217e0edff04, (v) => $d0d3a237fd442f07$export$f5ab8217e0edff04 = v);
// write-core.js
var $d0d3a237fd442f07$export$f5ab8217e0edff04;

var $bhJdc = parcelRequire("bhJdc");
var $d0d3a237fd442f07$require$ExtBuffer = $bhJdc.ExtBuffer;

var $kf9sO = parcelRequire("kf9sO");

var $a4cEb = parcelRequire("a4cEb");

var $exLMk = parcelRequire("exLMk");
$exLMk.install({
    addExtPacker: $d0d3a237fd442f07$var$addExtPacker,
    getExtPacker: $d0d3a237fd442f07$var$getExtPacker,
    init: $d0d3a237fd442f07$var$init
});
$d0d3a237fd442f07$export$f5ab8217e0edff04 = $d0d3a237fd442f07$var$init.call($exLMk.preset);
function $d0d3a237fd442f07$var$getEncoder(options) {
    var writeType = $a4cEb.getWriteType(options);
    return encode;
    function encode(encoder, value) {
        var func = writeType[typeof value];
        if (!func) throw new Error('Unsupported type "' + typeof value + '": ' + value);
        func(encoder, value);
    }
}
function $d0d3a237fd442f07$var$init() {
    var options = this.options;
    this.encode = $d0d3a237fd442f07$var$getEncoder(options);
    if (options && options.preset) $kf9sO.setExtPackers(this);
    return this;
}
function $d0d3a237fd442f07$var$addExtPacker(etype, Class, packer) {
    packer = $exLMk.filter(packer);
    var name = Class.name;
    if (name && name !== "Object") {
        var packers = this.extPackers || (this.extPackers = {});
        packers[name] = extPacker;
    } else {
        // fallback for IE
        var list = this.extEncoderList || (this.extEncoderList = []);
        list.unshift([
            Class,
            extPacker
        ]);
    }
    function extPacker(value) {
        if (packer) value = packer(value);
        return new $d0d3a237fd442f07$require$ExtBuffer(value, etype);
    }
}
function $d0d3a237fd442f07$var$getExtPacker(value) {
    var packers = this.extPackers || (this.extPackers = {});
    var c = value.constructor;
    var e = c && c.name && packers[c.name];
    if (e) return e;
    // fallback for IE
    var list = this.extEncoderList || (this.extEncoderList = []);
    var len = list.length;
    for(var i = 0; i < len; i++){
        var pair = list[i];
        if (c === pair[0]) return pair[1];
    }
}

});
parcelRegister("bhJdc", function(module, exports) {

$parcel$export(module.exports, "ExtBuffer", () => $83745a5cfdb5c210$export$fa671ba1f40b711c, (v) => $83745a5cfdb5c210$export$fa671ba1f40b711c = v);
// ext-buffer.js
var $83745a5cfdb5c210$export$fa671ba1f40b711c;
$83745a5cfdb5c210$export$fa671ba1f40b711c = $83745a5cfdb5c210$var$ExtBuffer;

var $78TVd = parcelRequire("78TVd");
function $83745a5cfdb5c210$var$ExtBuffer(buffer, type) {
    if (!(this instanceof $83745a5cfdb5c210$var$ExtBuffer)) return new $83745a5cfdb5c210$var$ExtBuffer(buffer, type);
    this.buffer = $78TVd.from(buffer);
    this.type = type;
}

});
parcelRegister("78TVd", function(module, exports) {
// bufferish.js

var $5334a8b009816885$var$Buffer = module.exports.global = (parcelRequire("8x05Z"));
var $5334a8b009816885$var$hasBuffer = module.exports.hasBuffer = $5334a8b009816885$var$Buffer && !!$5334a8b009816885$var$Buffer.isBuffer;
var $5334a8b009816885$var$hasArrayBuffer = module.exports.hasArrayBuffer = "undefined" !== typeof ArrayBuffer;

var $5334a8b009816885$var$isArray = module.exports.isArray = (parcelRequire("767Wy"));
module.exports.isArrayBuffer = $5334a8b009816885$var$hasArrayBuffer ? $5334a8b009816885$var$isArrayBuffer : $5334a8b009816885$var$_false;
var $5334a8b009816885$var$isBuffer = module.exports.isBuffer = $5334a8b009816885$var$hasBuffer ? $5334a8b009816885$var$Buffer.isBuffer : $5334a8b009816885$var$_false;
var $5334a8b009816885$var$isView = module.exports.isView = $5334a8b009816885$var$hasArrayBuffer ? ArrayBuffer.isView || $5334a8b009816885$var$_is("ArrayBuffer", "buffer") : $5334a8b009816885$var$_false;
module.exports.alloc = $5334a8b009816885$var$alloc;
module.exports.concat = $5334a8b009816885$var$concat;
module.exports.from = $5334a8b009816885$var$from;

var $5334a8b009816885$var$BufferArray = module.exports.Array = (parcelRequire("5WZQ0"));

var $5334a8b009816885$var$BufferBuffer = module.exports.Buffer = (parcelRequire("183sb"));

var $5334a8b009816885$var$BufferUint8Array = module.exports.Uint8Array = (parcelRequire("6x2by"));

var $5334a8b009816885$var$BufferProto = module.exports.prototype = (parcelRequire("VLC7O"));
/**
 * @param value {Array|ArrayBuffer|Buffer|String}
 * @returns {Buffer|Uint8Array|Array}
 */ function $5334a8b009816885$var$from(value) {
    if (typeof value === "string") return $5334a8b009816885$var$fromString.call(this, value);
    else return $5334a8b009816885$var$auto(this).from(value);
}
/**
 * @param size {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function $5334a8b009816885$var$alloc(size) {
    return $5334a8b009816885$var$auto(this).alloc(size);
}
/**
 * @param list {Array} array of (Buffer|Uint8Array|Array)s
 * @param [length]
 * @returns {Buffer|Uint8Array|Array}
 */ function $5334a8b009816885$var$concat(list, length) {
    if (!length) {
        length = 0;
        Array.prototype.forEach.call(list, dryrun);
    }
    var ref = this !== module.exports && this || list[0];
    var result = $5334a8b009816885$var$alloc.call(ref, length);
    var offset = 0;
    Array.prototype.forEach.call(list, append);
    return result;
    function dryrun(buffer) {
        length += buffer.length;
    }
    function append(buffer) {
        offset += $5334a8b009816885$var$BufferProto.copy.call(buffer, result, offset);
    }
}
var $5334a8b009816885$var$_isArrayBuffer = $5334a8b009816885$var$_is("ArrayBuffer");
function $5334a8b009816885$var$isArrayBuffer(value) {
    return value instanceof ArrayBuffer || $5334a8b009816885$var$_isArrayBuffer(value);
}
/**
 * @private
 */ function $5334a8b009816885$var$fromString(value) {
    var expected = value.length * 3;
    var that = $5334a8b009816885$var$alloc.call(this, expected);
    var actual = $5334a8b009816885$var$BufferProto.write.call(that, value);
    if (expected !== actual) that = $5334a8b009816885$var$BufferProto.slice.call(that, 0, actual);
    return that;
}
function $5334a8b009816885$var$auto(that) {
    return $5334a8b009816885$var$isBuffer(that) ? $5334a8b009816885$var$BufferBuffer : $5334a8b009816885$var$isView(that) ? $5334a8b009816885$var$BufferUint8Array : $5334a8b009816885$var$isArray(that) ? $5334a8b009816885$var$BufferArray : $5334a8b009816885$var$hasBuffer ? $5334a8b009816885$var$BufferBuffer : $5334a8b009816885$var$hasArrayBuffer ? $5334a8b009816885$var$BufferUint8Array : $5334a8b009816885$var$BufferArray;
}
function $5334a8b009816885$var$_false() {
    return false;
}
function $5334a8b009816885$var$_is(name, key) {
    /* jshint eqnull:true */ name = "[object " + name + "]";
    return function(value) {
        return value != null && ({}).toString.call(key ? value[key] : value) === name;
    };
}

});
parcelRegister("8x05Z", function(module, exports) {
/* globals Buffer */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $63617ac26589f1b6$require$Buffer = $6ZWSX.Buffer;
module.exports = $63617ac26589f1b6$var$c("undefined" !== typeof $63617ac26589f1b6$require$Buffer && $63617ac26589f1b6$require$Buffer) || $63617ac26589f1b6$var$c(module.exports.Buffer) || $63617ac26589f1b6$var$c("undefined" !== typeof window && window.Buffer) || module.exports.Buffer;
function $63617ac26589f1b6$var$c(B) {
    return B && B.isBuffer && B;
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("5WZQ0", function(module, exports) {
// bufferish-array.js

var $78TVd = parcelRequire("78TVd");
var $45525636c846f665$var$exports = module.exports = $45525636c846f665$var$alloc(0);
$45525636c846f665$var$exports.alloc = $45525636c846f665$var$alloc;
$45525636c846f665$var$exports.concat = $78TVd.concat;
$45525636c846f665$var$exports.from = $45525636c846f665$var$from;
/**
 * @param size {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function $45525636c846f665$var$alloc(size) {
    return new Array(size);
}
/**
 * @param value {Array|ArrayBuffer|Buffer|String}
 * @returns {Array}
 */ function $45525636c846f665$var$from(value) {
    if (!$78TVd.isBuffer(value) && $78TVd.isView(value)) // TypedArray to Uint8Array
    value = $78TVd.Uint8Array.from(value);
    else if ($78TVd.isArrayBuffer(value)) // ArrayBuffer to Uint8Array
    value = new Uint8Array(value);
    else if (typeof value === "string") // String to Array
    return $78TVd.from.call($45525636c846f665$var$exports, value);
    else if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    // Array-like to Array
    return Array.prototype.slice.call(value);
}

});

parcelRegister("183sb", function(module, exports) {
// bufferish-buffer.js

var $78TVd = parcelRequire("78TVd");
var $0d293799ebb24a32$var$Buffer = $78TVd.global;
var $0d293799ebb24a32$var$exports = module.exports = $78TVd.hasBuffer ? $0d293799ebb24a32$var$alloc(0) : [];
$0d293799ebb24a32$var$exports.alloc = $78TVd.hasBuffer && $0d293799ebb24a32$var$Buffer.alloc || $0d293799ebb24a32$var$alloc;
$0d293799ebb24a32$var$exports.concat = $78TVd.concat;
$0d293799ebb24a32$var$exports.from = $0d293799ebb24a32$var$from;
/**
 * @param size {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function $0d293799ebb24a32$var$alloc(size) {
    return new $0d293799ebb24a32$var$Buffer(size);
}
/**
 * @param value {Array|ArrayBuffer|Buffer|String}
 * @returns {Buffer}
 */ function $0d293799ebb24a32$var$from(value) {
    if (!$78TVd.isBuffer(value) && $78TVd.isView(value)) // TypedArray to Uint8Array
    value = $78TVd.Uint8Array.from(value);
    else if ($78TVd.isArrayBuffer(value)) // ArrayBuffer to Uint8Array
    value = new Uint8Array(value);
    else if (typeof value === "string") // String to Buffer
    return $78TVd.from.call($0d293799ebb24a32$var$exports, value);
    else if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    // Array-like to Buffer
    if ($0d293799ebb24a32$var$Buffer.from && $0d293799ebb24a32$var$Buffer.from.length !== 1) return $0d293799ebb24a32$var$Buffer.from(value); // node v6+
    else return new $0d293799ebb24a32$var$Buffer(value); // node v4
}

});

parcelRegister("6x2by", function(module, exports) {
// bufferish-uint8array.js

var $78TVd = parcelRequire("78TVd");
var $4c178516000e1aa2$var$exports = module.exports = $78TVd.hasArrayBuffer ? $4c178516000e1aa2$var$alloc(0) : [];
$4c178516000e1aa2$var$exports.alloc = $4c178516000e1aa2$var$alloc;
$4c178516000e1aa2$var$exports.concat = $78TVd.concat;
$4c178516000e1aa2$var$exports.from = $4c178516000e1aa2$var$from;
/**
 * @param size {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function $4c178516000e1aa2$var$alloc(size) {
    return new Uint8Array(size);
}
/**
 * @param value {Array|ArrayBuffer|Buffer|String}
 * @returns {Uint8Array}
 */ function $4c178516000e1aa2$var$from(value) {
    if ($78TVd.isView(value)) {
        // TypedArray to ArrayBuffer
        var byteOffset = value.byteOffset;
        var byteLength = value.byteLength;
        value = value.buffer;
        if (value.byteLength !== byteLength) {
            if (value.slice) value = value.slice(byteOffset, byteOffset + byteLength);
            else {
                // Android 4.1 does not have ArrayBuffer.prototype.slice
                value = new Uint8Array(value);
                if (value.byteLength !== byteLength) // TypedArray to ArrayBuffer to Uint8Array to Array
                value = Array.prototype.slice.call(value, byteOffset, byteOffset + byteLength);
            }
        }
    } else if (typeof value === "string") // String to Uint8Array
    return $78TVd.from.call($4c178516000e1aa2$var$exports, value);
    else if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    return new Uint8Array(value);
}

});

parcelRegister("VLC7O", function(module, exports) {
// bufferish-proto.js
/* jshint eqnull:true */ 
var $ddfiz = parcelRequire("ddfiz");
exports.copy = copy;
exports.slice = slice;
exports.toString = toString;
exports.write = gen("write");

var $78TVd = parcelRequire("78TVd");
var Buffer = $78TVd.global;
var isBufferShim = $78TVd.hasBuffer && "TYPED_ARRAY_SUPPORT" in Buffer;
var brokenTypedArray = isBufferShim && !Buffer.TYPED_ARRAY_SUPPORT;
/**
 * @param target {Buffer|Uint8Array|Array}
 * @param [targetStart] {Number}
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function copy(target, targetStart, start, end) {
    var thisIsBuffer = $78TVd.isBuffer(this);
    var targetIsBuffer = $78TVd.isBuffer(target);
    if (thisIsBuffer && targetIsBuffer) // Buffer to Buffer
    return this.copy(target, targetStart, start, end);
    else if (!brokenTypedArray && !thisIsBuffer && !targetIsBuffer && $78TVd.isView(this) && $78TVd.isView(target)) {
        // Uint8Array to Uint8Array (except for minor some browsers)
        var buffer = start || end != null ? slice.call(this, start, end) : this;
        target.set(buffer, targetStart);
        return buffer.length;
    } else // other cases
    return $ddfiz.copy.call(this, target, targetStart, start, end);
}
/**
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {Buffer|Uint8Array|Array}
 */ function slice(start, end) {
    // for Buffer, Uint8Array (except for minor some browsers) and Array
    var f = this.slice || !brokenTypedArray && this.subarray;
    if (f) return f.call(this, start, end);
    // Uint8Array (for minor some browsers)
    var target = $78TVd.alloc.call(this, end - start);
    copy.call(this, target, 0, start, end);
    return target;
}
/**
 * Buffer.prototype.toString()
 *
 * @param [encoding] {String} ignored
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {String}
 */ function toString(encoding, start, end) {
    var f = !isBufferShim && $78TVd.isBuffer(this) ? this.toString : $ddfiz.toString;
    return f.apply(this, arguments);
}
/**
 * @private
 */ function gen(method) {
    return wrap;
    function wrap() {
        var f = this[method] || $ddfiz[method];
        return f.apply(this, arguments);
    }
}

});
parcelRegister("ddfiz", function(module, exports) {

$parcel$export(module.exports, "copy", () => $99e85b3aa0ff6c3b$export$784d13d8ee351f07, (v) => $99e85b3aa0ff6c3b$export$784d13d8ee351f07 = v);
$parcel$export(module.exports, "toString", () => $99e85b3aa0ff6c3b$export$f84e8e69fd4488a5, (v) => $99e85b3aa0ff6c3b$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "write", () => $99e85b3aa0ff6c3b$export$68d8715fc104d294, (v) => $99e85b3aa0ff6c3b$export$68d8715fc104d294 = v);
// buffer-lite.js
var $99e85b3aa0ff6c3b$export$784d13d8ee351f07;
var $99e85b3aa0ff6c3b$export$f84e8e69fd4488a5;
var $99e85b3aa0ff6c3b$export$68d8715fc104d294;
var $99e85b3aa0ff6c3b$var$MAXBUFLEN = 8192;
$99e85b3aa0ff6c3b$export$784d13d8ee351f07 = $99e85b3aa0ff6c3b$var$copy;
$99e85b3aa0ff6c3b$export$f84e8e69fd4488a5 = $99e85b3aa0ff6c3b$var$toString;
$99e85b3aa0ff6c3b$export$68d8715fc104d294 = $99e85b3aa0ff6c3b$var$write;
/**
 * Buffer.prototype.write()
 *
 * @param string {String}
 * @param [offset] {Number}
 * @returns {Number}
 */ function $99e85b3aa0ff6c3b$var$write(string, offset) {
    var buffer = this;
    var index = offset || (offset |= 0);
    var length = string.length;
    var chr = 0;
    var i = 0;
    while(i < length){
        chr = string.charCodeAt(i++);
        if (chr < 128) buffer[index++] = chr;
        else if (chr < 0x800) {
            // 2 bytes
            buffer[index++] = 0xC0 | chr >>> 6;
            buffer[index++] = 0x80 | chr & 0x3F;
        } else if (chr < 0xD800 || chr > 0xDFFF) {
            // 3 bytes
            buffer[index++] = 0xE0 | chr >>> 12;
            buffer[index++] = 0x80 | chr >>> 6 & 0x3F;
            buffer[index++] = 0x80 | chr & 0x3F;
        } else {
            // 4 bytes - surrogate pair
            chr = (chr - 0xD800 << 10 | string.charCodeAt(i++) - 0xDC00) + 0x10000;
            buffer[index++] = 0xF0 | chr >>> 18;
            buffer[index++] = 0x80 | chr >>> 12 & 0x3F;
            buffer[index++] = 0x80 | chr >>> 6 & 0x3F;
            buffer[index++] = 0x80 | chr & 0x3F;
        }
    }
    return index - offset;
}
/**
 * Buffer.prototype.toString()
 *
 * @param [encoding] {String} ignored
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {String}
 */ function $99e85b3aa0ff6c3b$var$toString(encoding, start, end) {
    var buffer = this;
    var index = start | 0;
    if (!end) end = buffer.length;
    var string = "";
    var chr = 0;
    while(index < end){
        chr = buffer[index++];
        if (chr < 128) {
            string += String.fromCharCode(chr);
            continue;
        }
        if ((chr & 0xE0) === 0xC0) // 2 bytes
        chr = (chr & 0x1F) << 6 | buffer[index++] & 0x3F;
        else if ((chr & 0xF0) === 0xE0) // 3 bytes
        chr = (chr & 0x0F) << 12 | (buffer[index++] & 0x3F) << 6 | buffer[index++] & 0x3F;
        else if ((chr & 0xF8) === 0xF0) // 4 bytes
        chr = (chr & 0x07) << 18 | (buffer[index++] & 0x3F) << 12 | (buffer[index++] & 0x3F) << 6 | buffer[index++] & 0x3F;
        if (chr >= 0x010000) {
            // A surrogate pair
            chr -= 0x010000;
            string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
        } else string += String.fromCharCode(chr);
    }
    return string;
}
/**
 * Buffer.prototype.copy()
 *
 * @param target {Buffer}
 * @param [targetStart] {Number}
 * @param [start] {Number}
 * @param [end] {Number}
 * @returns {number}
 */ function $99e85b3aa0ff6c3b$var$copy(target, targetStart, start, end) {
    var i;
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (!targetStart) targetStart = 0;
    var len = end - start;
    if (target === this && start < targetStart && targetStart < end) // descending
    for(i = len - 1; i >= 0; i--)target[i + targetStart] = this[i + start];
    else // ascending
    for(i = 0; i < len; i++)target[i + targetStart] = this[i + start];
    return len;
}

});




parcelRegister("kf9sO", function(module, exports) {

$parcel$export(module.exports, "setExtPackers", () => $ebcc8ca58364a95b$export$860189e95c38d517, (v) => $ebcc8ca58364a95b$export$860189e95c38d517 = v);
// ext-packer.js
var $ebcc8ca58364a95b$export$860189e95c38d517;
$ebcc8ca58364a95b$export$860189e95c38d517 = $ebcc8ca58364a95b$var$setExtPackers;

var $78TVd = parcelRequire("78TVd");
var $ebcc8ca58364a95b$var$Buffer = $78TVd.global;
var $ebcc8ca58364a95b$var$packTypedArray = $78TVd.Uint8Array.from;
var $ebcc8ca58364a95b$var$_encode;
var $ebcc8ca58364a95b$var$ERROR_COLUMNS = {
    name: 1,
    message: 1,
    stack: 1,
    columnNumber: 1,
    fileName: 1,
    lineNumber: 1
};
function $ebcc8ca58364a95b$var$setExtPackers(codec) {
    codec.addExtPacker(0x0E, Error, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x01, EvalError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x02, RangeError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x03, ReferenceError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x04, SyntaxError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x05, TypeError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x06, URIError, [
        $ebcc8ca58364a95b$var$packError,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0A, RegExp, [
        $ebcc8ca58364a95b$var$packRegExp,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0B, Boolean, [
        $ebcc8ca58364a95b$var$packValueOf,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0C, String, [
        $ebcc8ca58364a95b$var$packValueOf,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0D, Date, [
        Number,
        $ebcc8ca58364a95b$var$encode
    ]);
    codec.addExtPacker(0x0F, Number, [
        $ebcc8ca58364a95b$var$packValueOf,
        $ebcc8ca58364a95b$var$encode
    ]);
    if ("undefined" !== typeof Uint8Array) {
        codec.addExtPacker(0x11, Int8Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x12, Uint8Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x13, Int16Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x14, Uint16Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x15, Int32Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x16, Uint32Array, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x17, Float32Array, $ebcc8ca58364a95b$var$packTypedArray);
        // PhantomJS/1.9.7 doesn't have Float64Array
        if ("undefined" !== typeof Float64Array) codec.addExtPacker(0x18, Float64Array, $ebcc8ca58364a95b$var$packTypedArray);
        // IE10 doesn't have Uint8ClampedArray
        if ("undefined" !== typeof Uint8ClampedArray) codec.addExtPacker(0x19, Uint8ClampedArray, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x1A, ArrayBuffer, $ebcc8ca58364a95b$var$packTypedArray);
        codec.addExtPacker(0x1D, DataView, $ebcc8ca58364a95b$var$packTypedArray);
    }
    if ($78TVd.hasBuffer) codec.addExtPacker(0x1B, $ebcc8ca58364a95b$var$Buffer, $78TVd.from);
}

function $ebcc8ca58364a95b$var$encode(input) {
    if (!$ebcc8ca58364a95b$var$_encode) $ebcc8ca58364a95b$var$_encode = (parcelRequire("lVQGa")).encode; // lazy load
    return $ebcc8ca58364a95b$var$_encode(input);
}
function $ebcc8ca58364a95b$var$packValueOf(value) {
    return value.valueOf();
}
function $ebcc8ca58364a95b$var$packRegExp(value) {
    value = RegExp.prototype.toString.call(value).split("/");
    value.shift();
    var out = [
        value.pop()
    ];
    out.unshift(value.join("/"));
    return out;
}
function $ebcc8ca58364a95b$var$packError(value) {
    var out = {};
    for(var key in $ebcc8ca58364a95b$var$ERROR_COLUMNS)out[key] = value[key];
    return out;
}

});

parcelRegister("a4cEb", function(module, exports) {

$parcel$export(module.exports, "getWriteType", () => $7544169297b46f4f$export$deb9b4eed403170, (v) => $7544169297b46f4f$export$deb9b4eed403170 = v);
// write-type.js
var $7544169297b46f4f$export$deb9b4eed403170;

var $767Wy = parcelRequire("767Wy");

var $8mDzd = parcelRequire("8mDzd");
var $7544169297b46f4f$var$Uint64BE = $8mDzd.Uint64BE;
var $7544169297b46f4f$var$Int64BE = $8mDzd.Int64BE;

var $78TVd = parcelRequire("78TVd");

var $VLC7O = parcelRequire("VLC7O");

var $et8ZR = parcelRequire("et8ZR");

var $1sYhO = parcelRequire("1sYhO");
var $7544169297b46f4f$require$uint8 = $1sYhO.uint8;

var $bhJdc = parcelRequire("bhJdc");
var $7544169297b46f4f$require$ExtBuffer = $bhJdc.ExtBuffer;
var $7544169297b46f4f$var$HAS_UINT8ARRAY = "undefined" !== typeof Uint8Array;
var $7544169297b46f4f$var$HAS_MAP = "undefined" !== typeof Map;
var $7544169297b46f4f$var$extmap = [];
$7544169297b46f4f$var$extmap[1] = 0xd4;
$7544169297b46f4f$var$extmap[2] = 0xd5;
$7544169297b46f4f$var$extmap[4] = 0xd6;
$7544169297b46f4f$var$extmap[8] = 0xd7;
$7544169297b46f4f$var$extmap[16] = 0xd8;
$7544169297b46f4f$export$deb9b4eed403170 = $7544169297b46f4f$var$getWriteType;
function $7544169297b46f4f$var$getWriteType(options) {
    var token = $et8ZR.getWriteToken(options);
    var useraw = options && options.useraw;
    var binarraybuffer = $7544169297b46f4f$var$HAS_UINT8ARRAY && options && options.binarraybuffer;
    var isBuffer = binarraybuffer ? $78TVd.isArrayBuffer : $78TVd.isBuffer;
    var bin = binarraybuffer ? bin_arraybuffer : bin_buffer;
    var usemap = $7544169297b46f4f$var$HAS_MAP && options && options.usemap;
    var map = usemap ? map_to_map : obj_to_map;
    var writeType = {
        "boolean": bool,
        "function": nil,
        "number": number,
        "object": useraw ? object_raw : object,
        "string": _string(useraw ? raw_head_size : str_head_size),
        "symbol": nil,
        "undefined": nil
    };
    return writeType;
    // false -- 0xc2
    // true -- 0xc3
    function bool(encoder, value) {
        var type = value ? 0xc3 : 0xc2;
        token[type](encoder, value);
    }
    function number(encoder, value) {
        var ivalue = value | 0;
        var type;
        if (value !== ivalue) {
            // float 64 -- 0xcb
            type = 0xcb;
            token[type](encoder, value);
            return;
        } else if (-32 <= ivalue && ivalue <= 0x7F) // positive fixint -- 0x00 - 0x7f
        // negative fixint -- 0xe0 - 0xff
        type = ivalue & 0xFF;
        else if (0 <= ivalue) // uint 8 -- 0xcc
        // uint 16 -- 0xcd
        // uint 32 -- 0xce
        type = ivalue <= 0xFF ? 0xcc : ivalue <= 0xFFFF ? 0xcd : 0xce;
        else // int 8 -- 0xd0
        // int 16 -- 0xd1
        // int 32 -- 0xd2
        type = -128 <= ivalue ? 0xd0 : -32768 <= ivalue ? 0xd1 : 0xd2;
        token[type](encoder, ivalue);
    }
    // uint 64 -- 0xcf
    function uint64(encoder, value) {
        var type = 0xcf;
        token[type](encoder, value.toArray());
    }
    // int 64 -- 0xd3
    function int64(encoder, value) {
        var type = 0xd3;
        token[type](encoder, value.toArray());
    }
    // str 8 -- 0xd9
    // str 16 -- 0xda
    // str 32 -- 0xdb
    // fixstr -- 0xa0 - 0xbf
    function str_head_size(length) {
        return length < 32 ? 1 : length <= 0xFF ? 2 : length <= 0xFFFF ? 3 : 5;
    }
    // raw 16 -- 0xda
    // raw 32 -- 0xdb
    // fixraw -- 0xa0 - 0xbf
    function raw_head_size(length) {
        return length < 32 ? 1 : length <= 0xFFFF ? 3 : 5;
    }
    function _string(head_size) {
        return string;
        function string(encoder, value) {
            // prepare buffer
            var length = value.length;
            var maxsize = 5 + length * 3;
            encoder.offset = encoder.reserve(maxsize);
            var buffer = encoder.buffer;
            // expected header size
            var expected = head_size(length);
            // expected start point
            var start = encoder.offset + expected;
            // write string
            length = $VLC7O.write.call(buffer, value, start);
            // actual header size
            var actual = head_size(length);
            // move content when needed
            if (expected !== actual) {
                var targetStart = start + actual - expected;
                var end = start + length;
                $VLC7O.copy.call(buffer, buffer, targetStart, start, end);
            }
            // write header
            var type = actual === 1 ? 0xa0 + length : actual <= 3 ? 0xd7 + actual : 0xdb;
            token[type](encoder, length);
            // move cursor
            encoder.offset += length;
        }
    }
    function object(encoder, value) {
        // null
        if (value === null) return nil(encoder, value);
        // Buffer
        if (isBuffer(value)) return bin(encoder, value);
        // Array
        if ($767Wy(value)) return array(encoder, value);
        // int64-buffer objects
        if ($7544169297b46f4f$var$Uint64BE.isUint64BE(value)) return uint64(encoder, value);
        if ($7544169297b46f4f$var$Int64BE.isInt64BE(value)) return int64(encoder, value);
        // ext formats
        var packer = encoder.codec.getExtPacker(value);
        if (packer) value = packer(value);
        if (value instanceof $7544169297b46f4f$require$ExtBuffer) return ext(encoder, value);
        // plain old Objects or Map
        map(encoder, value);
    }
    function object_raw(encoder, value) {
        // Buffer
        if (isBuffer(value)) return raw(encoder, value);
        // others
        object(encoder, value);
    }
    // nil -- 0xc0
    function nil(encoder, value) {
        var type = 0xc0;
        token[type](encoder, value);
    }
    // fixarray -- 0x90 - 0x9f
    // array 16 -- 0xdc
    // array 32 -- 0xdd
    function array(encoder, value) {
        var length = value.length;
        var type = length < 16 ? 0x90 + length : length <= 0xFFFF ? 0xdc : 0xdd;
        token[type](encoder, length);
        var encode = encoder.codec.encode;
        for(var i = 0; i < length; i++)encode(encoder, value[i]);
    }
    // bin 8 -- 0xc4
    // bin 16 -- 0xc5
    // bin 32 -- 0xc6
    function bin_buffer(encoder, value) {
        var length = value.length;
        var type = length < 0xFF ? 0xc4 : length <= 0xFFFF ? 0xc5 : 0xc6;
        token[type](encoder, length);
        encoder.send(value);
    }
    function bin_arraybuffer(encoder, value) {
        bin_buffer(encoder, new Uint8Array(value));
    }
    // fixext 1 -- 0xd4
    // fixext 2 -- 0xd5
    // fixext 4 -- 0xd6
    // fixext 8 -- 0xd7
    // fixext 16 -- 0xd8
    // ext 8 -- 0xc7
    // ext 16 -- 0xc8
    // ext 32 -- 0xc9
    function ext(encoder, value) {
        var buffer = value.buffer;
        var length = buffer.length;
        var type = $7544169297b46f4f$var$extmap[length] || (length < 0xFF ? 0xc7 : length <= 0xFFFF ? 0xc8 : 0xc9);
        token[type](encoder, length);
        $7544169297b46f4f$require$uint8[value.type](encoder);
        encoder.send(buffer);
    }
    // fixmap -- 0x80 - 0x8f
    // map 16 -- 0xde
    // map 32 -- 0xdf
    function obj_to_map(encoder, value) {
        var keys = Object.keys(value);
        var length = keys.length;
        var type = length < 16 ? 0x80 + length : length <= 0xFFFF ? 0xde : 0xdf;
        token[type](encoder, length);
        var encode = encoder.codec.encode;
        keys.forEach(function(key) {
            encode(encoder, key);
            encode(encoder, value[key]);
        });
    }
    // fixmap -- 0x80 - 0x8f
    // map 16 -- 0xde
    // map 32 -- 0xdf
    function map_to_map(encoder, value) {
        if (!(value instanceof Map)) return obj_to_map(encoder, value);
        var length = value.size;
        var type = length < 16 ? 0x80 + length : length <= 0xFFFF ? 0xde : 0xdf;
        token[type](encoder, length);
        var encode = encoder.codec.encode;
        value.forEach(function(val, key, m) {
            encode(encoder, key);
            encode(encoder, val);
        });
    }
    // raw 16 -- 0xda
    // raw 32 -- 0xdb
    // fixraw -- 0xa0 - 0xbf
    function raw(encoder, value) {
        var length = value.length;
        var type = length < 32 ? 0xa0 + length : length <= 0xFFFF ? 0xda : 0xdb;
        token[type](encoder, length);
        encoder.send(value);
    }
}

});
parcelRegister("8mDzd", function(module, exports) {
// int64-buffer.js
/*jshint -W018 */ // Confusing use of '!'.
/*jshint -W030 */ // Expected an assignment or function call and instead saw an expression.
/*jshint -W093 */ // Did you mean to return a conditional instead of an assignment?

var $6ZWSX = parcelRequire("6ZWSX");
var $616f11fad08f74f9$require$Buffer = $6ZWSX.Buffer;
var $616f11fad08f74f9$var$Uint64BE, $616f11fad08f74f9$var$Int64BE, $616f11fad08f74f9$var$Uint64LE, $616f11fad08f74f9$var$Int64LE;
!function(exports1) {
    // constants
    var UNDEFINED = "undefined";
    var BUFFER = UNDEFINED !== typeof $616f11fad08f74f9$require$Buffer && $616f11fad08f74f9$require$Buffer;
    var UINT8ARRAY = UNDEFINED !== typeof Uint8Array && Uint8Array;
    var ARRAYBUFFER = UNDEFINED !== typeof ArrayBuffer && ArrayBuffer;
    var ZERO = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var isArray = Array.isArray || _isArray;
    var BIT32 = 4294967296;
    var BIT24 = 16777216;
    // storage class
    var storage; // Array;
    // generate classes
    $616f11fad08f74f9$var$Uint64BE = factory("Uint64BE", true, true);
    $616f11fad08f74f9$var$Int64BE = factory("Int64BE", true, false);
    $616f11fad08f74f9$var$Uint64LE = factory("Uint64LE", false, true);
    $616f11fad08f74f9$var$Int64LE = factory("Int64LE", false, false);
    // class factory
    function factory(name, bigendian, unsigned) {
        var posH = bigendian ? 0 : 4;
        var posL = bigendian ? 4 : 0;
        var pos0 = bigendian ? 0 : 3;
        var pos1 = bigendian ? 1 : 2;
        var pos2 = bigendian ? 2 : 1;
        var pos3 = bigendian ? 3 : 0;
        var fromPositive = bigendian ? fromPositiveBE : fromPositiveLE;
        var fromNegative = bigendian ? fromNegativeBE : fromNegativeLE;
        var proto = Int64.prototype;
        var isName = "is" + name;
        var _isInt64 = "_" + isName;
        // properties
        proto.buffer = void 0;
        proto.offset = 0;
        proto[_isInt64] = true;
        // methods
        proto.toNumber = toNumber;
        proto.toString = toString;
        proto.toJSON = toNumber;
        proto.toArray = toArray;
        // add .toBuffer() method only when Buffer available
        if (BUFFER) proto.toBuffer = toBuffer;
        // add .toArrayBuffer() method only when Uint8Array available
        if (UINT8ARRAY) proto.toArrayBuffer = toArrayBuffer;
        // isUint64BE, isInt64BE
        Int64[isName] = isInt64;
        // CommonJS
        exports1[name] = Int64;
        return Int64;
        // constructor
        function Int64(buffer, offset, value, raddix) {
            if (!(this instanceof Int64)) return new Int64(buffer, offset, value, raddix);
            return init(this, buffer, offset, value, raddix);
        }
        // isUint64BE, isInt64BE
        function isInt64(b) {
            return !!(b && b[_isInt64]);
        }
        // initializer
        function init(that, buffer, offset, value, raddix) {
            if (UINT8ARRAY && ARRAYBUFFER) {
                if (buffer instanceof ARRAYBUFFER) buffer = new UINT8ARRAY(buffer);
                if (value instanceof ARRAYBUFFER) value = new UINT8ARRAY(value);
            }
            // Int64BE() style
            if (!buffer && !offset && !value && !storage) {
                // shortcut to initialize with zero
                that.buffer = newArray(ZERO, 0);
                return;
            }
            // Int64BE(value, raddix) style
            if (!isValidBuffer(buffer, offset)) {
                var _storage = storage || Array;
                raddix = offset;
                value = buffer;
                offset = 0;
                buffer = new _storage(8);
            }
            that.buffer = buffer;
            that.offset = offset |= 0;
            // Int64BE(buffer, offset) style
            if (UNDEFINED === typeof value) return;
            // Int64BE(buffer, offset, value, raddix) style
            if ("string" === typeof value) fromString(buffer, offset, value, raddix || 10);
            else if (isValidBuffer(value, raddix)) fromArray(buffer, offset, value, raddix);
            else if ("number" === typeof raddix) {
                writeInt32(buffer, offset + posH, value); // high
                writeInt32(buffer, offset + posL, raddix); // low
            } else if (value > 0) fromPositive(buffer, offset, value); // positive
            else if (value < 0) fromNegative(buffer, offset, value); // negative
            else fromArray(buffer, offset, ZERO, 0); // zero, NaN and others
        }
        function fromString(buffer, offset, str, raddix) {
            var pos = 0;
            var len = str.length;
            var high = 0;
            var low = 0;
            if (str[0] === "-") pos++;
            var sign = pos;
            while(pos < len){
                var chr = parseInt(str[pos++], raddix);
                if (!(chr >= 0)) break; // NaN
                low = low * raddix + chr;
                high = high * raddix + Math.floor(low / BIT32);
                low %= BIT32;
            }
            if (sign) {
                high = ~high;
                if (low) low = BIT32 - low;
                else high++;
            }
            writeInt32(buffer, offset + posH, high);
            writeInt32(buffer, offset + posL, low);
        }
        function toNumber() {
            var buffer = this.buffer;
            var offset = this.offset;
            var high = readInt32(buffer, offset + posH);
            var low = readInt32(buffer, offset + posL);
            if (!unsigned) high |= 0; // a trick to get signed
            return high ? high * BIT32 + low : low;
        }
        function toString(radix) {
            var buffer = this.buffer;
            var offset = this.offset;
            var high = readInt32(buffer, offset + posH);
            var low = readInt32(buffer, offset + posL);
            var str = "";
            var sign = !unsigned && high & 0x80000000;
            if (sign) {
                high = ~high;
                low = BIT32 - low;
            }
            radix = radix || 10;
            while(true){
                var mod = high % radix * BIT32 + low;
                high = Math.floor(high / radix);
                low = Math.floor(mod / radix);
                str = (mod % radix).toString(radix) + str;
                if (!high && !low) break;
            }
            if (sign) str = "-" + str;
            return str;
        }
        function writeInt32(buffer, offset, value) {
            buffer[offset + pos3] = value & 255;
            value = value >> 8;
            buffer[offset + pos2] = value & 255;
            value = value >> 8;
            buffer[offset + pos1] = value & 255;
            value = value >> 8;
            buffer[offset + pos0] = value & 255;
        }
        function readInt32(buffer, offset) {
            return buffer[offset + pos0] * BIT24 + (buffer[offset + pos1] << 16) + (buffer[offset + pos2] << 8) + buffer[offset + pos3];
        }
    }
    function toArray(raw) {
        var buffer = this.buffer;
        var offset = this.offset;
        storage = null; // Array
        if (raw !== false && offset === 0 && buffer.length === 8 && isArray(buffer)) return buffer;
        return newArray(buffer, offset);
    }
    function toBuffer(raw) {
        var buffer = this.buffer;
        var offset = this.offset;
        storage = BUFFER;
        if (raw !== false && offset === 0 && buffer.length === 8 && $616f11fad08f74f9$require$Buffer.isBuffer(buffer)) return buffer;
        var dest = new BUFFER(8);
        fromArray(dest, 0, buffer, offset);
        return dest;
    }
    function toArrayBuffer(raw) {
        var buffer = this.buffer;
        var offset = this.offset;
        var arrbuf = buffer.buffer;
        storage = UINT8ARRAY;
        if (raw !== false && offset === 0 && arrbuf instanceof ARRAYBUFFER && arrbuf.byteLength === 8) return arrbuf;
        var dest = new UINT8ARRAY(8);
        fromArray(dest, 0, buffer, offset);
        return dest.buffer;
    }
    function isValidBuffer(buffer, offset) {
        var len = buffer && buffer.length;
        offset |= 0;
        return len && offset + 8 <= len && "string" !== typeof buffer[offset];
    }
    function fromArray(destbuf, destoff, srcbuf, srcoff) {
        destoff |= 0;
        srcoff |= 0;
        for(var i = 0; i < 8; i++)destbuf[destoff++] = srcbuf[srcoff++] & 255;
    }
    function newArray(buffer, offset) {
        return Array.prototype.slice.call(buffer, offset, offset + 8);
    }
    function fromPositiveBE(buffer, offset, value) {
        var pos = offset + 8;
        while(pos > offset){
            buffer[--pos] = value & 255;
            value /= 256;
        }
    }
    function fromNegativeBE(buffer, offset, value) {
        var pos = offset + 8;
        value++;
        while(pos > offset){
            buffer[--pos] = -value & 255 ^ 255;
            value /= 256;
        }
    }
    function fromPositiveLE(buffer, offset, value) {
        var end = offset + 8;
        while(offset < end){
            buffer[offset++] = value & 255;
            value /= 256;
        }
    }
    function fromNegativeLE(buffer, offset, value) {
        var end = offset + 8;
        value++;
        while(offset < end){
            buffer[offset++] = -value & 255 ^ 255;
            value /= 256;
        }
    }
    // https://github.com/retrofox/is-array
    function _isArray(val) {
        return !!val && "[object Array]" == Object.prototype.toString.call(val);
    }
}(typeof module.exports.nodeName !== "string" ? module.exports : module.exports || {});

});

parcelRegister("et8ZR", function(module, exports) {

$parcel$export(module.exports, "getWriteToken", () => $a88ac0b3df0345c2$export$eded4acbd3ff6542, (v) => $a88ac0b3df0345c2$export$eded4acbd3ff6542 = v);
// write-token.js
var $a88ac0b3df0345c2$export$eded4acbd3ff6542;

var $9NvM5 = parcelRequire("9NvM5");

var $8mDzd = parcelRequire("8mDzd");
var $a88ac0b3df0345c2$var$Uint64BE = $8mDzd.Uint64BE;
var $a88ac0b3df0345c2$var$Int64BE = $8mDzd.Int64BE;

var $1sYhO = parcelRequire("1sYhO");
var $a88ac0b3df0345c2$require$uint8 = $1sYhO.uint8;

var $78TVd = parcelRequire("78TVd");
var $a88ac0b3df0345c2$var$Buffer = $78TVd.global;
var $a88ac0b3df0345c2$var$IS_BUFFER_SHIM = $78TVd.hasBuffer && "TYPED_ARRAY_SUPPORT" in $a88ac0b3df0345c2$var$Buffer;
var $a88ac0b3df0345c2$var$NO_TYPED_ARRAY = $a88ac0b3df0345c2$var$IS_BUFFER_SHIM && !$a88ac0b3df0345c2$var$Buffer.TYPED_ARRAY_SUPPORT;
var $a88ac0b3df0345c2$var$Buffer_prototype = $78TVd.hasBuffer && $a88ac0b3df0345c2$var$Buffer.prototype || {};
$a88ac0b3df0345c2$export$eded4acbd3ff6542 = $a88ac0b3df0345c2$var$getWriteToken;
function $a88ac0b3df0345c2$var$getWriteToken(options) {
    if (options && options.uint8array) return $a88ac0b3df0345c2$var$init_uint8array();
    else if ($a88ac0b3df0345c2$var$NO_TYPED_ARRAY || $78TVd.hasBuffer && options && options.safe) return $a88ac0b3df0345c2$var$init_safe();
    else return $a88ac0b3df0345c2$var$init_token();
}
function $a88ac0b3df0345c2$var$init_uint8array() {
    var token = $a88ac0b3df0345c2$var$init_token();
    // float 32 -- 0xca
    // float 64 -- 0xcb
    token[0xca] = $a88ac0b3df0345c2$var$writeN(0xca, 4, $a88ac0b3df0345c2$var$writeFloatBE);
    token[0xcb] = $a88ac0b3df0345c2$var$writeN(0xcb, 8, $a88ac0b3df0345c2$var$writeDoubleBE);
    return token;
}
// Node.js and browsers with TypedArray
function $a88ac0b3df0345c2$var$init_token() {
    // (immediate values)
    // positive fixint -- 0x00 - 0x7f
    // nil -- 0xc0
    // false -- 0xc2
    // true -- 0xc3
    // negative fixint -- 0xe0 - 0xff
    var token = $a88ac0b3df0345c2$require$uint8.slice();
    // bin 8 -- 0xc4
    // bin 16 -- 0xc5
    // bin 32 -- 0xc6
    token[0xc4] = $a88ac0b3df0345c2$var$write1(0xc4);
    token[0xc5] = $a88ac0b3df0345c2$var$write2(0xc5);
    token[0xc6] = $a88ac0b3df0345c2$var$write4(0xc6);
    // ext 8 -- 0xc7
    // ext 16 -- 0xc8
    // ext 32 -- 0xc9
    token[0xc7] = $a88ac0b3df0345c2$var$write1(0xc7);
    token[0xc8] = $a88ac0b3df0345c2$var$write2(0xc8);
    token[0xc9] = $a88ac0b3df0345c2$var$write4(0xc9);
    // float 32 -- 0xca
    // float 64 -- 0xcb
    token[0xca] = $a88ac0b3df0345c2$var$writeN(0xca, 4, $a88ac0b3df0345c2$var$Buffer_prototype.writeFloatBE || $a88ac0b3df0345c2$var$writeFloatBE, true);
    token[0xcb] = $a88ac0b3df0345c2$var$writeN(0xcb, 8, $a88ac0b3df0345c2$var$Buffer_prototype.writeDoubleBE || $a88ac0b3df0345c2$var$writeDoubleBE, true);
    // uint 8 -- 0xcc
    // uint 16 -- 0xcd
    // uint 32 -- 0xce
    // uint 64 -- 0xcf
    token[0xcc] = $a88ac0b3df0345c2$var$write1(0xcc);
    token[0xcd] = $a88ac0b3df0345c2$var$write2(0xcd);
    token[0xce] = $a88ac0b3df0345c2$var$write4(0xce);
    token[0xcf] = $a88ac0b3df0345c2$var$writeN(0xcf, 8, $a88ac0b3df0345c2$var$writeUInt64BE);
    // int 8 -- 0xd0
    // int 16 -- 0xd1
    // int 32 -- 0xd2
    // int 64 -- 0xd3
    token[0xd0] = $a88ac0b3df0345c2$var$write1(0xd0);
    token[0xd1] = $a88ac0b3df0345c2$var$write2(0xd1);
    token[0xd2] = $a88ac0b3df0345c2$var$write4(0xd2);
    token[0xd3] = $a88ac0b3df0345c2$var$writeN(0xd3, 8, $a88ac0b3df0345c2$var$writeInt64BE);
    // str 8 -- 0xd9
    // str 16 -- 0xda
    // str 32 -- 0xdb
    token[0xd9] = $a88ac0b3df0345c2$var$write1(0xd9);
    token[0xda] = $a88ac0b3df0345c2$var$write2(0xda);
    token[0xdb] = $a88ac0b3df0345c2$var$write4(0xdb);
    // array 16 -- 0xdc
    // array 32 -- 0xdd
    token[0xdc] = $a88ac0b3df0345c2$var$write2(0xdc);
    token[0xdd] = $a88ac0b3df0345c2$var$write4(0xdd);
    // map 16 -- 0xde
    // map 32 -- 0xdf
    token[0xde] = $a88ac0b3df0345c2$var$write2(0xde);
    token[0xdf] = $a88ac0b3df0345c2$var$write4(0xdf);
    return token;
}
// safe mode: for old browsers and who needs asserts
function $a88ac0b3df0345c2$var$init_safe() {
    // (immediate values)
    // positive fixint -- 0x00 - 0x7f
    // nil -- 0xc0
    // false -- 0xc2
    // true -- 0xc3
    // negative fixint -- 0xe0 - 0xff
    var token = $a88ac0b3df0345c2$require$uint8.slice();
    // bin 8 -- 0xc4
    // bin 16 -- 0xc5
    // bin 32 -- 0xc6
    token[0xc4] = $a88ac0b3df0345c2$var$writeN(0xc4, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt8);
    token[0xc5] = $a88ac0b3df0345c2$var$writeN(0xc5, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xc6] = $a88ac0b3df0345c2$var$writeN(0xc6, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    // ext 8 -- 0xc7
    // ext 16 -- 0xc8
    // ext 32 -- 0xc9
    token[0xc7] = $a88ac0b3df0345c2$var$writeN(0xc7, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt8);
    token[0xc8] = $a88ac0b3df0345c2$var$writeN(0xc8, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xc9] = $a88ac0b3df0345c2$var$writeN(0xc9, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    // float 32 -- 0xca
    // float 64 -- 0xcb
    token[0xca] = $a88ac0b3df0345c2$var$writeN(0xca, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeFloatBE);
    token[0xcb] = $a88ac0b3df0345c2$var$writeN(0xcb, 8, $a88ac0b3df0345c2$var$Buffer.prototype.writeDoubleBE);
    // uint 8 -- 0xcc
    // uint 16 -- 0xcd
    // uint 32 -- 0xce
    // uint 64 -- 0xcf
    token[0xcc] = $a88ac0b3df0345c2$var$writeN(0xcc, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt8);
    token[0xcd] = $a88ac0b3df0345c2$var$writeN(0xcd, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xce] = $a88ac0b3df0345c2$var$writeN(0xce, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    token[0xcf] = $a88ac0b3df0345c2$var$writeN(0xcf, 8, $a88ac0b3df0345c2$var$writeUInt64BE);
    // int 8 -- 0xd0
    // int 16 -- 0xd1
    // int 32 -- 0xd2
    // int 64 -- 0xd3
    token[0xd0] = $a88ac0b3df0345c2$var$writeN(0xd0, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeInt8);
    token[0xd1] = $a88ac0b3df0345c2$var$writeN(0xd1, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeInt16BE);
    token[0xd2] = $a88ac0b3df0345c2$var$writeN(0xd2, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeInt32BE);
    token[0xd3] = $a88ac0b3df0345c2$var$writeN(0xd3, 8, $a88ac0b3df0345c2$var$writeInt64BE);
    // str 8 -- 0xd9
    // str 16 -- 0xda
    // str 32 -- 0xdb
    token[0xd9] = $a88ac0b3df0345c2$var$writeN(0xd9, 1, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt8);
    token[0xda] = $a88ac0b3df0345c2$var$writeN(0xda, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xdb] = $a88ac0b3df0345c2$var$writeN(0xdb, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    // array 16 -- 0xdc
    // array 32 -- 0xdd
    token[0xdc] = $a88ac0b3df0345c2$var$writeN(0xdc, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xdd] = $a88ac0b3df0345c2$var$writeN(0xdd, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    // map 16 -- 0xde
    // map 32 -- 0xdf
    token[0xde] = $a88ac0b3df0345c2$var$writeN(0xde, 2, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt16BE);
    token[0xdf] = $a88ac0b3df0345c2$var$writeN(0xdf, 4, $a88ac0b3df0345c2$var$Buffer.prototype.writeUInt32BE);
    return token;
}
function $a88ac0b3df0345c2$var$write1(type) {
    return function(encoder, value) {
        var offset = encoder.reserve(2);
        var buffer = encoder.buffer;
        buffer[offset++] = type;
        buffer[offset] = value;
    };
}
function $a88ac0b3df0345c2$var$write2(type) {
    return function(encoder, value) {
        var offset = encoder.reserve(3);
        var buffer = encoder.buffer;
        buffer[offset++] = type;
        buffer[offset++] = value >>> 8;
        buffer[offset] = value;
    };
}
function $a88ac0b3df0345c2$var$write4(type) {
    return function(encoder, value) {
        var offset = encoder.reserve(5);
        var buffer = encoder.buffer;
        buffer[offset++] = type;
        buffer[offset++] = value >>> 24;
        buffer[offset++] = value >>> 16;
        buffer[offset++] = value >>> 8;
        buffer[offset] = value;
    };
}
function $a88ac0b3df0345c2$var$writeN(type, len, method, noAssert) {
    return function(encoder, value) {
        var offset = encoder.reserve(len + 1);
        encoder.buffer[offset++] = type;
        method.call(encoder.buffer, value, offset, noAssert);
    };
}
function $a88ac0b3df0345c2$var$writeUInt64BE(value, offset) {
    new $a88ac0b3df0345c2$var$Uint64BE(this, offset, value);
}
function $a88ac0b3df0345c2$var$writeInt64BE(value, offset) {
    new $a88ac0b3df0345c2$var$Int64BE(this, offset, value);
}
function $a88ac0b3df0345c2$var$writeFloatBE(value, offset) {
    $9NvM5.write(this, value, offset, false, 23, 4);
}
function $a88ac0b3df0345c2$var$writeDoubleBE(value, offset) {
    $9NvM5.write(this, value, offset, false, 52, 8);
}

});
parcelRegister("1sYhO", function(module, exports) {

$parcel$export(module.exports, "uint8", () => $11172b8efa90f0ea$export$52e103c63c4e68cf, (v) => $11172b8efa90f0ea$export$52e103c63c4e68cf = v);
// write-unit8.js
var $11172b8efa90f0ea$export$52e103c63c4e68cf;
var $11172b8efa90f0ea$var$constant = $11172b8efa90f0ea$export$52e103c63c4e68cf = new Array(256);
for(var $11172b8efa90f0ea$var$i = 0x00; $11172b8efa90f0ea$var$i <= 0xFF; $11172b8efa90f0ea$var$i++)$11172b8efa90f0ea$var$constant[$11172b8efa90f0ea$var$i] = $11172b8efa90f0ea$var$write0($11172b8efa90f0ea$var$i);
function $11172b8efa90f0ea$var$write0(type) {
    return function(encoder) {
        var offset = encoder.reserve(1);
        encoder.buffer[offset] = type;
    };
}

});



parcelRegister("exLMk", function(module, exports) {

$parcel$export(module.exports, "createCodec", () => $a9693595180fb0e6$export$a4cf2f585987cc8, (v) => $a9693595180fb0e6$export$a4cf2f585987cc8 = v);
$parcel$export(module.exports, "install", () => $a9693595180fb0e6$export$4b3e715f166fdd78, (v) => $a9693595180fb0e6$export$4b3e715f166fdd78 = v);
$parcel$export(module.exports, "filter", () => $a9693595180fb0e6$export$3dea766d36a8935f, (v) => $a9693595180fb0e6$export$3dea766d36a8935f = v);
$parcel$export(module.exports, "preset", () => $a9693595180fb0e6$export$f5ab8217e0edff04, (v) => $a9693595180fb0e6$export$f5ab8217e0edff04 = v);
// codec-base.js
var $a9693595180fb0e6$export$a4cf2f585987cc8;
var $a9693595180fb0e6$export$4b3e715f166fdd78;
var $a9693595180fb0e6$export$3dea766d36a8935f;
// default shared codec
var $a9693595180fb0e6$export$f5ab8217e0edff04;

var $767Wy = parcelRequire("767Wy");
$a9693595180fb0e6$export$a4cf2f585987cc8 = $a9693595180fb0e6$var$createCodec;
$a9693595180fb0e6$export$4b3e715f166fdd78 = $a9693595180fb0e6$var$install;
$a9693595180fb0e6$export$3dea766d36a8935f = $a9693595180fb0e6$var$filter;

var $78TVd = parcelRequire("78TVd");
function $a9693595180fb0e6$var$Codec(options) {
    if (!(this instanceof $a9693595180fb0e6$var$Codec)) return new $a9693595180fb0e6$var$Codec(options);
    this.options = options;
    this.init();
}
$a9693595180fb0e6$var$Codec.prototype.init = function() {
    var options = this.options;
    if (options && options.uint8array) this.bufferish = $78TVd.Uint8Array;
    return this;
};
function $a9693595180fb0e6$var$install(props) {
    for(var key in props)$a9693595180fb0e6$var$Codec.prototype[key] = $a9693595180fb0e6$var$add($a9693595180fb0e6$var$Codec.prototype[key], props[key]);
}
function $a9693595180fb0e6$var$add(a, b) {
    return a && b ? ab : a || b;
    function ab() {
        a.apply(this, arguments);
        return b.apply(this, arguments);
    }
}
function $a9693595180fb0e6$var$join(filters) {
    filters = filters.slice();
    return function(value) {
        return filters.reduce(iterator, value);
    };
    function iterator(value, filter) {
        return filter(value);
    }
}
function $a9693595180fb0e6$var$filter(filter) {
    return $767Wy(filter) ? $a9693595180fb0e6$var$join(filter) : filter;
}
// @public
// msgpack.createCodec()
function $a9693595180fb0e6$var$createCodec(options) {
    return new $a9693595180fb0e6$var$Codec(options);
}
$a9693595180fb0e6$export$f5ab8217e0edff04 = $a9693595180fb0e6$var$createCodec({
    preset: true
});

});


parcelRegister("crMK8", function(module, exports) {

$parcel$export(module.exports, "FlexDecoder", () => $90fdd1030cd4d735$export$dc31976c5858f14d, (v) => $90fdd1030cd4d735$export$dc31976c5858f14d = v);
$parcel$export(module.exports, "FlexEncoder", () => $90fdd1030cd4d735$export$bd62260bb192511e, (v) => $90fdd1030cd4d735$export$bd62260bb192511e = v);
// flex-buffer.js
var $90fdd1030cd4d735$export$dc31976c5858f14d;
var $90fdd1030cd4d735$export$bd62260bb192511e;
$90fdd1030cd4d735$export$dc31976c5858f14d = $90fdd1030cd4d735$var$FlexDecoder;
$90fdd1030cd4d735$export$bd62260bb192511e = $90fdd1030cd4d735$var$FlexEncoder;

var $78TVd = parcelRequire("78TVd");
var $90fdd1030cd4d735$var$MIN_BUFFER_SIZE = 2048;
var $90fdd1030cd4d735$var$MAX_BUFFER_SIZE = 65536;
var $90fdd1030cd4d735$var$BUFFER_SHORTAGE = "BUFFER_SHORTAGE";
function $90fdd1030cd4d735$var$FlexDecoder() {
    if (!(this instanceof $90fdd1030cd4d735$var$FlexDecoder)) return new $90fdd1030cd4d735$var$FlexDecoder();
}
function $90fdd1030cd4d735$var$FlexEncoder() {
    if (!(this instanceof $90fdd1030cd4d735$var$FlexEncoder)) return new $90fdd1030cd4d735$var$FlexEncoder();
}
$90fdd1030cd4d735$var$FlexDecoder.mixin = $90fdd1030cd4d735$var$mixinFactory($90fdd1030cd4d735$var$getDecoderMethods());
$90fdd1030cd4d735$var$FlexDecoder.mixin($90fdd1030cd4d735$var$FlexDecoder.prototype);
$90fdd1030cd4d735$var$FlexEncoder.mixin = $90fdd1030cd4d735$var$mixinFactory($90fdd1030cd4d735$var$getEncoderMethods());
$90fdd1030cd4d735$var$FlexEncoder.mixin($90fdd1030cd4d735$var$FlexEncoder.prototype);
function $90fdd1030cd4d735$var$getDecoderMethods() {
    return {
        bufferish: $78TVd,
        write: write,
        fetch: $90fdd1030cd4d735$var$fetch,
        flush: flush,
        push: $90fdd1030cd4d735$var$push,
        pull: $90fdd1030cd4d735$var$pull,
        read: $90fdd1030cd4d735$var$read,
        reserve: reserve,
        offset: 0
    };
    function write(chunk) {
        var prev = this.offset ? $78TVd.prototype.slice.call(this.buffer, this.offset) : this.buffer;
        this.buffer = prev ? chunk ? this.bufferish.concat([
            prev,
            chunk
        ]) : prev : chunk;
        this.offset = 0;
    }
    function flush() {
        while(this.offset < this.buffer.length){
            var start = this.offset;
            var value;
            try {
                value = this.fetch();
            } catch (e) {
                if (e && e.message != $90fdd1030cd4d735$var$BUFFER_SHORTAGE) throw e;
                // rollback
                this.offset = start;
                break;
            }
            this.push(value);
        }
    }
    function reserve(length) {
        var start = this.offset;
        var end = start + length;
        if (end > this.buffer.length) throw new Error($90fdd1030cd4d735$var$BUFFER_SHORTAGE);
        this.offset = end;
        return start;
    }
}
function $90fdd1030cd4d735$var$getEncoderMethods() {
    return {
        bufferish: $78TVd,
        write: $90fdd1030cd4d735$var$write,
        fetch: fetch,
        flush: flush,
        push: $90fdd1030cd4d735$var$push,
        pull: pull,
        read: $90fdd1030cd4d735$var$read,
        reserve: reserve,
        send: send,
        maxBufferSize: $90fdd1030cd4d735$var$MAX_BUFFER_SIZE,
        minBufferSize: $90fdd1030cd4d735$var$MIN_BUFFER_SIZE,
        offset: 0,
        start: 0
    };
    function fetch() {
        var start = this.start;
        if (start < this.offset) {
            var end = this.start = this.offset;
            return $78TVd.prototype.slice.call(this.buffer, start, end);
        }
    }
    function flush() {
        while(this.start < this.offset){
            var value = this.fetch();
            if (value) this.push(value);
        }
    }
    function pull() {
        var buffers = this.buffers || (this.buffers = []);
        var chunk = buffers.length > 1 ? this.bufferish.concat(buffers) : buffers[0];
        buffers.length = 0; // buffer exhausted
        return chunk;
    }
    function reserve(length) {
        var req = length | 0;
        if (this.buffer) {
            var size = this.buffer.length;
            var start = this.offset | 0;
            var end = start + req;
            // is it long enough?
            if (end < size) {
                this.offset = end;
                return start;
            }
            // flush current buffer
            this.flush();
            // resize it to 2x current length
            length = Math.max(length, Math.min(size * 2, this.maxBufferSize));
        }
        // minimum buffer size
        length = Math.max(length, this.minBufferSize);
        // allocate new buffer
        this.buffer = this.bufferish.alloc(length);
        this.start = 0;
        this.offset = req;
        return 0;
    }
    function send(buffer) {
        var length = buffer.length;
        if (length > this.minBufferSize) {
            this.flush();
            this.push(buffer);
        } else {
            var offset = this.reserve(length);
            $78TVd.prototype.copy.call(buffer, this.buffer, offset);
        }
    }
}
// common methods
function $90fdd1030cd4d735$var$write() {
    throw new Error("method not implemented: write()");
}
function $90fdd1030cd4d735$var$fetch() {
    throw new Error("method not implemented: fetch()");
}
function $90fdd1030cd4d735$var$read() {
    var length = this.buffers && this.buffers.length;
    // fetch the first result
    if (!length) return this.fetch();
    // flush current buffer
    this.flush();
    // read from the results
    return this.pull();
}
function $90fdd1030cd4d735$var$push(chunk) {
    var buffers = this.buffers || (this.buffers = []);
    buffers.push(chunk);
}
function $90fdd1030cd4d735$var$pull() {
    var buffers = this.buffers || (this.buffers = []);
    return buffers.shift();
}
function $90fdd1030cd4d735$var$mixinFactory(source) {
    return mixin;
    function mixin(target) {
        for(var key in source)target[key] = source[key];
        return target;
    }
}

});



parcelRegister("k7dTF", function(module, exports) {

$parcel$export(module.exports, "decode", () => $ea4f3db5dacd81d7$export$2f872c0f2117be69, (v) => $ea4f3db5dacd81d7$export$2f872c0f2117be69 = v);
// decode.js
var $ea4f3db5dacd81d7$export$2f872c0f2117be69;
$ea4f3db5dacd81d7$export$2f872c0f2117be69 = $ea4f3db5dacd81d7$var$decode;

var $1w0SX = parcelRequire("1w0SX");
var $ea4f3db5dacd81d7$require$DecodeBuffer = $1w0SX.DecodeBuffer;
function $ea4f3db5dacd81d7$var$decode(input, options) {
    var decoder = new $ea4f3db5dacd81d7$require$DecodeBuffer(options);
    decoder.write(input);
    return decoder.read();
}

});
parcelRegister("1w0SX", function(module, exports) {

$parcel$export(module.exports, "DecodeBuffer", () => $11a9776e3cfdb23f$export$e04f9cd16b1f90b5, (v) => $11a9776e3cfdb23f$export$e04f9cd16b1f90b5 = v);
// decode-buffer.js
var $11a9776e3cfdb23f$export$e04f9cd16b1f90b5;
$11a9776e3cfdb23f$export$e04f9cd16b1f90b5 = $11a9776e3cfdb23f$var$DecodeBuffer;

var $iqQb0 = parcelRequire("iqQb0");
var $11a9776e3cfdb23f$require$preset = $iqQb0.preset;

var $crMK8 = parcelRequire("crMK8");
var $11a9776e3cfdb23f$require$FlexDecoder = $crMK8.FlexDecoder;
$11a9776e3cfdb23f$require$FlexDecoder.mixin($11a9776e3cfdb23f$var$DecodeBuffer.prototype);
function $11a9776e3cfdb23f$var$DecodeBuffer(options) {
    if (!(this instanceof $11a9776e3cfdb23f$var$DecodeBuffer)) return new $11a9776e3cfdb23f$var$DecodeBuffer(options);
    if (options) {
        this.options = options;
        if (options.codec) {
            var codec = this.codec = options.codec;
            if (codec.bufferish) this.bufferish = codec.bufferish;
        }
    }
}
$11a9776e3cfdb23f$var$DecodeBuffer.prototype.codec = $11a9776e3cfdb23f$require$preset;
$11a9776e3cfdb23f$var$DecodeBuffer.prototype.fetch = function() {
    return this.codec.decode(this);
};

});
parcelRegister("iqQb0", function(module, exports) {

$parcel$export(module.exports, "preset", () => $d6b320de0670d0c7$export$f5ab8217e0edff04, (v) => $d6b320de0670d0c7$export$f5ab8217e0edff04 = v);
// read-core.js
var $d6b320de0670d0c7$export$f5ab8217e0edff04;

var $bhJdc = parcelRequire("bhJdc");
var $d6b320de0670d0c7$require$ExtBuffer = $bhJdc.ExtBuffer;

var $mpjdp = parcelRequire("mpjdp");

var $kz6K3 = parcelRequire("kz6K3");
var $d6b320de0670d0c7$require$readUint8 = $kz6K3.readUint8;

var $lcnle = parcelRequire("lcnle");

var $exLMk = parcelRequire("exLMk");
$exLMk.install({
    addExtUnpacker: $d6b320de0670d0c7$var$addExtUnpacker,
    getExtUnpacker: $d6b320de0670d0c7$var$getExtUnpacker,
    init: $d6b320de0670d0c7$var$init
});
$d6b320de0670d0c7$export$f5ab8217e0edff04 = $d6b320de0670d0c7$var$init.call($exLMk.preset);
function $d6b320de0670d0c7$var$getDecoder(options) {
    var readToken = $lcnle.getReadToken(options);
    return decode;
    function decode(decoder) {
        var type = $d6b320de0670d0c7$require$readUint8(decoder);
        var func = readToken[type];
        if (!func) throw new Error("Invalid type: " + (type ? "0x" + type.toString(16) : type));
        return func(decoder);
    }
}
function $d6b320de0670d0c7$var$init() {
    var options = this.options;
    this.decode = $d6b320de0670d0c7$var$getDecoder(options);
    if (options && options.preset) $mpjdp.setExtUnpackers(this);
    return this;
}
function $d6b320de0670d0c7$var$addExtUnpacker(etype, unpacker) {
    var unpackers = this.extUnpackers || (this.extUnpackers = []);
    unpackers[etype] = $exLMk.filter(unpacker);
}
function $d6b320de0670d0c7$var$getExtUnpacker(type) {
    var unpackers = this.extUnpackers || (this.extUnpackers = []);
    return unpackers[type] || extUnpacker;
    function extUnpacker(buffer) {
        return new $d6b320de0670d0c7$require$ExtBuffer(buffer, type);
    }
}

});
parcelRegister("mpjdp", function(module, exports) {

$parcel$export(module.exports, "setExtUnpackers", () => $0435b00383ef65a7$export$fdf7bcdbf71b0bd2, (v) => $0435b00383ef65a7$export$fdf7bcdbf71b0bd2 = v);
// ext-unpacker.js
var $0435b00383ef65a7$export$fdf7bcdbf71b0bd2;
$0435b00383ef65a7$export$fdf7bcdbf71b0bd2 = $0435b00383ef65a7$var$setExtUnpackers;

var $78TVd = parcelRequire("78TVd");
var $0435b00383ef65a7$var$Buffer = $78TVd.global;
var $0435b00383ef65a7$var$_decode;
var $0435b00383ef65a7$var$ERROR_COLUMNS = {
    name: 1,
    message: 1,
    stack: 1,
    columnNumber: 1,
    fileName: 1,
    lineNumber: 1
};
function $0435b00383ef65a7$var$setExtUnpackers(codec) {
    codec.addExtUnpacker(0x0E, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(Error)
    ]);
    codec.addExtUnpacker(0x01, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(EvalError)
    ]);
    codec.addExtUnpacker(0x02, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(RangeError)
    ]);
    codec.addExtUnpacker(0x03, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(ReferenceError)
    ]);
    codec.addExtUnpacker(0x04, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(SyntaxError)
    ]);
    codec.addExtUnpacker(0x05, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(TypeError)
    ]);
    codec.addExtUnpacker(0x06, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackError(URIError)
    ]);
    codec.addExtUnpacker(0x0A, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackRegExp
    ]);
    codec.addExtUnpacker(0x0B, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackClass(Boolean)
    ]);
    codec.addExtUnpacker(0x0C, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackClass(String)
    ]);
    codec.addExtUnpacker(0x0D, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackClass(Date)
    ]);
    codec.addExtUnpacker(0x0F, [
        $0435b00383ef65a7$var$decode,
        $0435b00383ef65a7$var$unpackClass(Number)
    ]);
    if ("undefined" !== typeof Uint8Array) {
        codec.addExtUnpacker(0x11, $0435b00383ef65a7$var$unpackClass(Int8Array));
        codec.addExtUnpacker(0x12, $0435b00383ef65a7$var$unpackClass(Uint8Array));
        codec.addExtUnpacker(0x13, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Int16Array)
        ]);
        codec.addExtUnpacker(0x14, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Uint16Array)
        ]);
        codec.addExtUnpacker(0x15, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Int32Array)
        ]);
        codec.addExtUnpacker(0x16, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Uint32Array)
        ]);
        codec.addExtUnpacker(0x17, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Float32Array)
        ]);
        // PhantomJS/1.9.7 doesn't have Float64Array
        if ("undefined" !== typeof Float64Array) codec.addExtUnpacker(0x18, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(Float64Array)
        ]);
        // IE10 doesn't have Uint8ClampedArray
        if ("undefined" !== typeof Uint8ClampedArray) codec.addExtUnpacker(0x19, $0435b00383ef65a7$var$unpackClass(Uint8ClampedArray));
        codec.addExtUnpacker(0x1A, $0435b00383ef65a7$var$unpackArrayBuffer);
        codec.addExtUnpacker(0x1D, [
            $0435b00383ef65a7$var$unpackArrayBuffer,
            $0435b00383ef65a7$var$unpackClass(DataView)
        ]);
    }
    if ($78TVd.hasBuffer) codec.addExtUnpacker(0x1B, $0435b00383ef65a7$var$unpackClass($0435b00383ef65a7$var$Buffer));
}

function $0435b00383ef65a7$var$decode(input) {
    if (!$0435b00383ef65a7$var$_decode) $0435b00383ef65a7$var$_decode = (parcelRequire("k7dTF")).decode; // lazy load
    return $0435b00383ef65a7$var$_decode(input);
}
function $0435b00383ef65a7$var$unpackRegExp(value) {
    return RegExp.apply(null, value);
}
function $0435b00383ef65a7$var$unpackError(Class) {
    return function(value) {
        var out = new Class();
        for(var key in $0435b00383ef65a7$var$ERROR_COLUMNS)out[key] = value[key];
        return out;
    };
}
function $0435b00383ef65a7$var$unpackClass(Class) {
    return function(value) {
        return new Class(value);
    };
}
function $0435b00383ef65a7$var$unpackArrayBuffer(value) {
    return new Uint8Array(value).buffer;
}

});

parcelRegister("kz6K3", function(module, exports) {

$parcel$export(module.exports, "getReadFormat", () => $ef8c4e53a4891bca$export$98bfe32ea1f56ac, (v) => $ef8c4e53a4891bca$export$98bfe32ea1f56ac = v);
$parcel$export(module.exports, "readUint8", () => $ef8c4e53a4891bca$export$d5778a2beba4ceef, (v) => $ef8c4e53a4891bca$export$d5778a2beba4ceef = v);
// read-format.js
var $ef8c4e53a4891bca$export$98bfe32ea1f56ac;
var $ef8c4e53a4891bca$export$d5778a2beba4ceef;

var $9NvM5 = parcelRequire("9NvM5");

var $8mDzd = parcelRequire("8mDzd");
var $ef8c4e53a4891bca$var$Uint64BE = $8mDzd.Uint64BE;
var $ef8c4e53a4891bca$var$Int64BE = $8mDzd.Int64BE;
$ef8c4e53a4891bca$export$98bfe32ea1f56ac = $ef8c4e53a4891bca$var$getReadFormat;
$ef8c4e53a4891bca$export$d5778a2beba4ceef = $ef8c4e53a4891bca$var$uint8;

var $78TVd = parcelRequire("78TVd");

var $VLC7O = parcelRequire("VLC7O");
var $ef8c4e53a4891bca$var$HAS_MAP = "undefined" !== typeof Map;
var $ef8c4e53a4891bca$var$NO_ASSERT = true;
function $ef8c4e53a4891bca$var$getReadFormat(options) {
    var binarraybuffer = $78TVd.hasArrayBuffer && options && options.binarraybuffer;
    var int64 = options && options.int64;
    var usemap = $ef8c4e53a4891bca$var$HAS_MAP && options && options.usemap;
    var readFormat = {
        map: usemap ? $ef8c4e53a4891bca$var$map_to_map : $ef8c4e53a4891bca$var$map_to_obj,
        array: $ef8c4e53a4891bca$var$array,
        str: $ef8c4e53a4891bca$var$str,
        bin: binarraybuffer ? $ef8c4e53a4891bca$var$bin_arraybuffer : $ef8c4e53a4891bca$var$bin_buffer,
        ext: $ef8c4e53a4891bca$var$ext,
        uint8: $ef8c4e53a4891bca$var$uint8,
        uint16: $ef8c4e53a4891bca$var$uint16,
        uint32: $ef8c4e53a4891bca$var$uint32,
        uint64: $ef8c4e53a4891bca$var$read(8, int64 ? $ef8c4e53a4891bca$var$readUInt64BE_int64 : $ef8c4e53a4891bca$var$readUInt64BE),
        int8: $ef8c4e53a4891bca$var$int8,
        int16: $ef8c4e53a4891bca$var$int16,
        int32: $ef8c4e53a4891bca$var$int32,
        int64: $ef8c4e53a4891bca$var$read(8, int64 ? $ef8c4e53a4891bca$var$readInt64BE_int64 : $ef8c4e53a4891bca$var$readInt64BE),
        float32: $ef8c4e53a4891bca$var$read(4, $ef8c4e53a4891bca$var$readFloatBE),
        float64: $ef8c4e53a4891bca$var$read(8, $ef8c4e53a4891bca$var$readDoubleBE)
    };
    return readFormat;
}
function $ef8c4e53a4891bca$var$map_to_obj(decoder, len) {
    var value = {};
    var i;
    var k = new Array(len);
    var v = new Array(len);
    var decode = decoder.codec.decode;
    for(i = 0; i < len; i++){
        k[i] = decode(decoder);
        v[i] = decode(decoder);
    }
    for(i = 0; i < len; i++)value[k[i]] = v[i];
    return value;
}
function $ef8c4e53a4891bca$var$map_to_map(decoder, len) {
    var value = new Map();
    var i;
    var k = new Array(len);
    var v = new Array(len);
    var decode = decoder.codec.decode;
    for(i = 0; i < len; i++){
        k[i] = decode(decoder);
        v[i] = decode(decoder);
    }
    for(i = 0; i < len; i++)value.set(k[i], v[i]);
    return value;
}
function $ef8c4e53a4891bca$var$array(decoder, len) {
    var value = new Array(len);
    var decode = decoder.codec.decode;
    for(var i = 0; i < len; i++)value[i] = decode(decoder);
    return value;
}
function $ef8c4e53a4891bca$var$str(decoder, len) {
    var start = decoder.reserve(len);
    var end = start + len;
    return $VLC7O.toString.call(decoder.buffer, "utf-8", start, end);
}
function $ef8c4e53a4891bca$var$bin_buffer(decoder, len) {
    var start = decoder.reserve(len);
    var end = start + len;
    var buf = $VLC7O.slice.call(decoder.buffer, start, end);
    return $78TVd.from(buf);
}
function $ef8c4e53a4891bca$var$bin_arraybuffer(decoder, len) {
    var start = decoder.reserve(len);
    var end = start + len;
    var buf = $VLC7O.slice.call(decoder.buffer, start, end);
    return $78TVd.Uint8Array.from(buf).buffer;
}
function $ef8c4e53a4891bca$var$ext(decoder, len) {
    var start = decoder.reserve(len + 1);
    var type = decoder.buffer[start++];
    var end = start + len;
    var unpack = decoder.codec.getExtUnpacker(type);
    if (!unpack) throw new Error("Invalid ext type: " + (type ? "0x" + type.toString(16) : type));
    var buf = $VLC7O.slice.call(decoder.buffer, start, end);
    return unpack(buf);
}
function $ef8c4e53a4891bca$var$uint8(decoder) {
    var start = decoder.reserve(1);
    return decoder.buffer[start];
}
function $ef8c4e53a4891bca$var$int8(decoder) {
    var start = decoder.reserve(1);
    var value = decoder.buffer[start];
    return value & 0x80 ? value - 0x100 : value;
}
function $ef8c4e53a4891bca$var$uint16(decoder) {
    var start = decoder.reserve(2);
    var buffer = decoder.buffer;
    return buffer[start++] << 8 | buffer[start];
}
function $ef8c4e53a4891bca$var$int16(decoder) {
    var start = decoder.reserve(2);
    var buffer = decoder.buffer;
    var value = buffer[start++] << 8 | buffer[start];
    return value & 0x8000 ? value - 0x10000 : value;
}
function $ef8c4e53a4891bca$var$uint32(decoder) {
    var start = decoder.reserve(4);
    var buffer = decoder.buffer;
    return buffer[start++] * 16777216 + (buffer[start++] << 16) + (buffer[start++] << 8) + buffer[start];
}
function $ef8c4e53a4891bca$var$int32(decoder) {
    var start = decoder.reserve(4);
    var buffer = decoder.buffer;
    return buffer[start++] << 24 | buffer[start++] << 16 | buffer[start++] << 8 | buffer[start];
}
function $ef8c4e53a4891bca$var$read(len, method) {
    return function(decoder) {
        var start = decoder.reserve(len);
        return method.call(decoder.buffer, start, $ef8c4e53a4891bca$var$NO_ASSERT);
    };
}
function $ef8c4e53a4891bca$var$readUInt64BE(start) {
    return new $ef8c4e53a4891bca$var$Uint64BE(this, start).toNumber();
}
function $ef8c4e53a4891bca$var$readInt64BE(start) {
    return new $ef8c4e53a4891bca$var$Int64BE(this, start).toNumber();
}
function $ef8c4e53a4891bca$var$readUInt64BE_int64(start) {
    return new $ef8c4e53a4891bca$var$Uint64BE(this, start);
}
function $ef8c4e53a4891bca$var$readInt64BE_int64(start) {
    return new $ef8c4e53a4891bca$var$Int64BE(this, start);
}
function $ef8c4e53a4891bca$var$readFloatBE(start) {
    return $9NvM5.read(this, start, false, 23, 4);
}
function $ef8c4e53a4891bca$var$readDoubleBE(start) {
    return $9NvM5.read(this, start, false, 52, 8);
}

});

parcelRegister("lcnle", function(module, exports) {

$parcel$export(module.exports, "getReadToken", () => $f6ecd310caa6dd30$export$ad386ab00192ec61, (v) => $f6ecd310caa6dd30$export$ad386ab00192ec61 = v);
// read-token.js
var $f6ecd310caa6dd30$export$ad386ab00192ec61;

var $kz6K3 = parcelRequire("kz6K3");
$f6ecd310caa6dd30$export$ad386ab00192ec61 = $f6ecd310caa6dd30$var$getReadToken;
function $f6ecd310caa6dd30$var$getReadToken(options) {
    var format = $kz6K3.getReadFormat(options);
    if (options && options.useraw) return $f6ecd310caa6dd30$var$init_useraw(format);
    else return $f6ecd310caa6dd30$var$init_token(format);
}
function $f6ecd310caa6dd30$var$init_token(format) {
    var i;
    var token = new Array(256);
    // positive fixint -- 0x00 - 0x7f
    for(i = 0x00; i <= 0x7f; i++)token[i] = $f6ecd310caa6dd30$var$constant(i);
    // fixmap -- 0x80 - 0x8f
    for(i = 0x80; i <= 0x8f; i++)token[i] = $f6ecd310caa6dd30$var$fix(i - 0x80, format.map);
    // fixarray -- 0x90 - 0x9f
    for(i = 0x90; i <= 0x9f; i++)token[i] = $f6ecd310caa6dd30$var$fix(i - 0x90, format.array);
    // fixstr -- 0xa0 - 0xbf
    for(i = 0xa0; i <= 0xbf; i++)token[i] = $f6ecd310caa6dd30$var$fix(i - 0xa0, format.str);
    // nil -- 0xc0
    token[0xc0] = $f6ecd310caa6dd30$var$constant(null);
    // (never used) -- 0xc1
    token[0xc1] = null;
    // false -- 0xc2
    // true -- 0xc3
    token[0xc2] = $f6ecd310caa6dd30$var$constant(false);
    token[0xc3] = $f6ecd310caa6dd30$var$constant(true);
    // bin 8 -- 0xc4
    // bin 16 -- 0xc5
    // bin 32 -- 0xc6
    token[0xc4] = $f6ecd310caa6dd30$var$flex(format.uint8, format.bin);
    token[0xc5] = $f6ecd310caa6dd30$var$flex(format.uint16, format.bin);
    token[0xc6] = $f6ecd310caa6dd30$var$flex(format.uint32, format.bin);
    // ext 8 -- 0xc7
    // ext 16 -- 0xc8
    // ext 32 -- 0xc9
    token[0xc7] = $f6ecd310caa6dd30$var$flex(format.uint8, format.ext);
    token[0xc8] = $f6ecd310caa6dd30$var$flex(format.uint16, format.ext);
    token[0xc9] = $f6ecd310caa6dd30$var$flex(format.uint32, format.ext);
    // float 32 -- 0xca
    // float 64 -- 0xcb
    token[0xca] = format.float32;
    token[0xcb] = format.float64;
    // uint 8 -- 0xcc
    // uint 16 -- 0xcd
    // uint 32 -- 0xce
    // uint 64 -- 0xcf
    token[0xcc] = format.uint8;
    token[0xcd] = format.uint16;
    token[0xce] = format.uint32;
    token[0xcf] = format.uint64;
    // int 8 -- 0xd0
    // int 16 -- 0xd1
    // int 32 -- 0xd2
    // int 64 -- 0xd3
    token[0xd0] = format.int8;
    token[0xd1] = format.int16;
    token[0xd2] = format.int32;
    token[0xd3] = format.int64;
    // fixext 1 -- 0xd4
    // fixext 2 -- 0xd5
    // fixext 4 -- 0xd6
    // fixext 8 -- 0xd7
    // fixext 16 -- 0xd8
    token[0xd4] = $f6ecd310caa6dd30$var$fix(1, format.ext);
    token[0xd5] = $f6ecd310caa6dd30$var$fix(2, format.ext);
    token[0xd6] = $f6ecd310caa6dd30$var$fix(4, format.ext);
    token[0xd7] = $f6ecd310caa6dd30$var$fix(8, format.ext);
    token[0xd8] = $f6ecd310caa6dd30$var$fix(16, format.ext);
    // str 8 -- 0xd9
    // str 16 -- 0xda
    // str 32 -- 0xdb
    token[0xd9] = $f6ecd310caa6dd30$var$flex(format.uint8, format.str);
    token[0xda] = $f6ecd310caa6dd30$var$flex(format.uint16, format.str);
    token[0xdb] = $f6ecd310caa6dd30$var$flex(format.uint32, format.str);
    // array 16 -- 0xdc
    // array 32 -- 0xdd
    token[0xdc] = $f6ecd310caa6dd30$var$flex(format.uint16, format.array);
    token[0xdd] = $f6ecd310caa6dd30$var$flex(format.uint32, format.array);
    // map 16 -- 0xde
    // map 32 -- 0xdf
    token[0xde] = $f6ecd310caa6dd30$var$flex(format.uint16, format.map);
    token[0xdf] = $f6ecd310caa6dd30$var$flex(format.uint32, format.map);
    // negative fixint -- 0xe0 - 0xff
    for(i = 0xe0; i <= 0xff; i++)token[i] = $f6ecd310caa6dd30$var$constant(i - 0x100);
    return token;
}
function $f6ecd310caa6dd30$var$init_useraw(format) {
    var i;
    var token = $f6ecd310caa6dd30$var$init_token(format).slice();
    // raw 8 -- 0xd9
    // raw 16 -- 0xda
    // raw 32 -- 0xdb
    token[0xd9] = token[0xc4];
    token[0xda] = token[0xc5];
    token[0xdb] = token[0xc6];
    // fixraw -- 0xa0 - 0xbf
    for(i = 0xa0; i <= 0xbf; i++)token[i] = $f6ecd310caa6dd30$var$fix(i - 0xa0, format.bin);
    return token;
}
function $f6ecd310caa6dd30$var$constant(value) {
    return function() {
        return value;
    };
}
function $f6ecd310caa6dd30$var$flex(lenFunc, decodeFunc) {
    return function(decoder) {
        var len = lenFunc(decoder);
        return decodeFunc(decoder, len);
    };
}
function $f6ecd310caa6dd30$var$fix(len, method) {
    return function(decoder) {
        return method(decoder, len);
    };
}

});




parcelRegister("968dK", function(module, exports) {

$parcel$export(module.exports, "Encoder", () => $69fb0d0a6ce7cdf2$export$a50aceb0e02a00aa, (v) => $69fb0d0a6ce7cdf2$export$a50aceb0e02a00aa = v);
// encoder.js
var $69fb0d0a6ce7cdf2$export$a50aceb0e02a00aa;
$69fb0d0a6ce7cdf2$export$a50aceb0e02a00aa = $69fb0d0a6ce7cdf2$var$Encoder;

var $afTs0 = parcelRequire("afTs0");

var $f2IWs = parcelRequire("f2IWs");
var $69fb0d0a6ce7cdf2$require$EncodeBuffer = $f2IWs.EncodeBuffer;
function $69fb0d0a6ce7cdf2$var$Encoder(options) {
    if (!(this instanceof $69fb0d0a6ce7cdf2$var$Encoder)) return new $69fb0d0a6ce7cdf2$var$Encoder(options);
    $69fb0d0a6ce7cdf2$require$EncodeBuffer.call(this, options);
}
$69fb0d0a6ce7cdf2$var$Encoder.prototype = new $69fb0d0a6ce7cdf2$require$EncodeBuffer();
$afTs0.mixin($69fb0d0a6ce7cdf2$var$Encoder.prototype);
$69fb0d0a6ce7cdf2$var$Encoder.prototype.encode = function(chunk) {
    this.write(chunk);
    this.emit("data", this.read());
};
$69fb0d0a6ce7cdf2$var$Encoder.prototype.end = function(chunk) {
    if (arguments.length) this.encode(chunk);
    this.flush();
    this.emit("end");
};

});
parcelRegister("afTs0", function(module, exports) {
/**
 * event-lite.js - Light-weight EventEmitter (less than 1KB when gzipped)
 *
 * @copyright Yusuke Kawasaki
 * @license MIT
 * @constructor
 * @see https://github.com/kawanet/event-lite
 * @see http://kawanet.github.io/event-lite/EventLite.html
 * @example
 * var EventLite = require("event-lite");
 *
 * function MyClass() {...}             // your class
 *
 * EventLite.mixin(MyClass.prototype);  // import event methods
 *
 * var obj = new MyClass();
 * obj.on("foo", function() {...});     // add event listener
 * obj.once("bar", function() {...});   // add one-time event listener
 * obj.emit("foo");                     // dispatch event
 * obj.emit("bar");                     // dispatch another event
 * obj.off("foo");                      // remove event listener
 */ function $777651728943314d$var$EventLite() {
    if (!(this instanceof $777651728943314d$var$EventLite)) return new $777651728943314d$var$EventLite();
}
(function(EventLite) {
    module.exports = EventLite;
    // property name to hold listeners
    var LISTENERS = "listeners";
    // methods to export
    var methods = {
        on: on,
        once: once,
        off: off,
        emit: emit
    };
    // mixin to self
    mixin(EventLite.prototype);
    // export mixin function
    EventLite.mixin = mixin;
    /**
   * Import on(), once(), off() and emit() methods into target object.
   *
   * @function EventLite.mixin
   * @param target {Prototype}
   */ function mixin(target) {
        for(var key in methods)target[key] = methods[key];
        return target;
    }
    /**
   * Add an event listener.
   *
   * @function EventLite.prototype.on
   * @param type {string}
   * @param func {Function}
   * @returns {EventLite} Self for method chaining
   */ function on(type, func) {
        getListeners(this, type).push(func);
        return this;
    }
    /**
   * Add one-time event listener.
   *
   * @function EventLite.prototype.once
   * @param type {string}
   * @param func {Function}
   * @returns {EventLite} Self for method chaining
   */ function once(type, func) {
        var that = this;
        wrap.originalListener = func;
        getListeners(that, type).push(wrap);
        return that;
        function wrap() {
            off.call(that, type, wrap);
            func.apply(this, arguments);
        }
    }
    /**
   * Remove an event listener.
   *
   * @function EventLite.prototype.off
   * @param [type] {string}
   * @param [func] {Function}
   * @returns {EventLite} Self for method chaining
   */ function off(type, func) {
        var that = this;
        var listners;
        if (!arguments.length) delete that[LISTENERS];
        else if (!func) {
            listners = that[LISTENERS];
            if (listners) {
                delete listners[type];
                if (!Object.keys(listners).length) return off.call(that);
            }
        } else {
            listners = getListeners(that, type, true);
            if (listners) {
                listners = listners.filter(ne);
                if (!listners.length) return off.call(that, type);
                that[LISTENERS][type] = listners;
            }
        }
        return that;
        function ne(test) {
            return test !== func && test.originalListener !== func;
        }
    }
    /**
   * Dispatch (trigger) an event.
   *
   * @function EventLite.prototype.emit
   * @param type {string}
   * @param [value] {*}
   * @returns {boolean} True when a listener received the event
   */ function emit(type, value) {
        var that = this;
        var listeners = getListeners(that, type, true);
        if (!listeners) return false;
        var arglen = arguments.length;
        if (arglen === 1) listeners.forEach(zeroarg);
        else if (arglen === 2) listeners.forEach(onearg);
        else {
            var args = Array.prototype.slice.call(arguments, 1);
            listeners.forEach(moreargs);
        }
        return !!listeners.length;
        function zeroarg(func) {
            func.call(that);
        }
        function onearg(func) {
            func.call(that, value);
        }
        function moreargs(func) {
            func.apply(that, args);
        }
    }
    /**
   * @ignore
   */ function getListeners(that, type, readonly) {
        if (readonly && !that[LISTENERS]) return;
        var listeners = that[LISTENERS] || (that[LISTENERS] = {});
        return listeners[type] || (listeners[type] = []);
    }
})($777651728943314d$var$EventLite);

});


parcelRegister("HSvGO", function(module, exports) {

$parcel$export(module.exports, "Decoder", () => $083e4cd76578bf09$export$f9de6ca0bc043724, (v) => $083e4cd76578bf09$export$f9de6ca0bc043724 = v);
// decoder.js
var $083e4cd76578bf09$export$f9de6ca0bc043724;
$083e4cd76578bf09$export$f9de6ca0bc043724 = $083e4cd76578bf09$var$Decoder;

var $afTs0 = parcelRequire("afTs0");

var $1w0SX = parcelRequire("1w0SX");
var $083e4cd76578bf09$require$DecodeBuffer = $1w0SX.DecodeBuffer;
function $083e4cd76578bf09$var$Decoder(options) {
    if (!(this instanceof $083e4cd76578bf09$var$Decoder)) return new $083e4cd76578bf09$var$Decoder(options);
    $083e4cd76578bf09$require$DecodeBuffer.call(this, options);
}
$083e4cd76578bf09$var$Decoder.prototype = new $083e4cd76578bf09$require$DecodeBuffer();
$afTs0.mixin($083e4cd76578bf09$var$Decoder.prototype);
$083e4cd76578bf09$var$Decoder.prototype.decode = function(chunk) {
    if (arguments.length) this.write(chunk);
    this.flush();
};
$083e4cd76578bf09$var$Decoder.prototype.push = function(chunk) {
    this.emit("data", chunk);
};
$083e4cd76578bf09$var$Decoder.prototype.end = function(chunk) {
    this.decode(chunk);
    this.emit("end");
};

});

parcelRegister("5Fza0", function(module, exports) {

$parcel$export(module.exports, "createCodec", () => $420c0e3164cd49ec$export$a4cf2f585987cc8, (v) => $420c0e3164cd49ec$export$a4cf2f585987cc8 = v);
// ext.js
// load both interfaces
var $420c0e3164cd49ec$export$a4cf2f585987cc8;
parcelRequire("iqQb0");
parcelRequire("hVzVX");

$420c0e3164cd49ec$export$a4cf2f585987cc8 = (parcelRequire("exLMk")).createCodec;

});

parcelRegister("762Am", function(module, exports) {

$parcel$export(module.exports, "codec", () => $52ab1960a6789808$export$1c37c01eba8ed446, (v) => $52ab1960a6789808$export$1c37c01eba8ed446 = v);
// codec.js
// load both interfaces
// @public
// msgpack.codec.preset
var $52ab1960a6789808$export$1c37c01eba8ed446;
parcelRequire("iqQb0");
parcelRequire("hVzVX");

$52ab1960a6789808$export$1c37c01eba8ed446 = {
    preset: (parcelRequire("exLMk")).preset
};

});

parcelRegister("9l3Lt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cc8fed272338330$export$2e2bcd8739ae039);

var $8RjUS = parcelRequire("8RjUS");
function $6cc8fed272338330$export$2e2bcd8739ae039() {
    // setup static methods
    const uint8Array = Uint8Array;
    const float32Array = Float32Array;
    if (!$6cc8fed272338330$export$2e2bcd8739ae039.modules) Object.defineProperties($6cc8fed272338330$export$2e2bcd8739ae039, {
        modules: {
            value: new WeakMap()
        },
        setModule: {
            value (Ref, module) {
                $6cc8fed272338330$export$2e2bcd8739ae039.modules.set(Ref, Promise.resolve(module));
            }
        },
        getModule: {
            value (Ref, wasmString) {
                let module = $6cc8fed272338330$export$2e2bcd8739ae039.modules.get(Ref);
                if (!module) {
                    if (!wasmString) {
                        wasmString = Ref.wasm;
                        module = $6cc8fed272338330$export$2e2bcd8739ae039.inflateDynEncodeString(wasmString).then((data)=>WebAssembly.compile(data));
                    } else module = WebAssembly.compile((0, $8RjUS.decode)(wasmString));
                    $6cc8fed272338330$export$2e2bcd8739ae039.modules.set(Ref, module);
                }
                return module;
            }
        },
        concatFloat32: {
            value (buffers, length) {
                let ret = new float32Array(length), i = 0, offset = 0;
                while(i < buffers.length){
                    ret.set(buffers[i], offset);
                    offset += buffers[i++].length;
                }
                return ret;
            }
        },
        getDecodedAudio: {
            value: (errors, channelData, samplesDecoded, sampleRate, bitDepth)=>({
                    errors: errors,
                    channelData: channelData,
                    samplesDecoded: samplesDecoded,
                    sampleRate: sampleRate,
                    bitDepth: bitDepth
                })
        },
        getDecodedAudioMultiChannel: {
            value (errors, input, channelsDecoded, samplesDecoded, sampleRate, bitDepth) {
                let channelData = [], i, j;
                for(i = 0; i < channelsDecoded; i++){
                    const channel = [];
                    for(j = 0; j < input.length;)channel.push(input[j++][i] || []);
                    channelData.push($6cc8fed272338330$export$2e2bcd8739ae039.concatFloat32(channel, samplesDecoded));
                }
                return $6cc8fed272338330$export$2e2bcd8739ae039.getDecodedAudio(errors, channelData, samplesDecoded, sampleRate, bitDepth);
            }
        },
        /*
       ******************
       * Compression Code
       ******************
       */ inflateDynEncodeString: {
            value (source) {
                source = (0, $8RjUS.decode)(source);
                return new Promise((resolve)=>{
                    // prettier-ignore
                    const puffString = String.raw`dynEncode012804c7886d()((()>+*§§)§,§§§§)§+§§§)§+.-()(*)-+)(.7*§)i¸¸,3§(i¸¸,3/G+.¡*(,(,3+)2å:-),§H(P*DI*H(P*@I++hH)H*r,hH(H(P*<J,i)^*<H,H(P*4U((I-H(H*i0J,^*DH+H-H*I+H,I*4)33H(H*H)^*DH(H+H)^*@H+i§H)i§3æ*).§K(iHI/+§H,iHn,§H+i(H+i(rCJ0I,H*I-+hH,,hH(H-V)(i)J.H.W)(i)c)(H,i)I,H-i*I-4)33i(I.*hH(V)(H+n5(H(i*I-i(I,i)I.+hH,i*J+iHn,hi(I-i*I,+hH,H/H-c)(H,iFn,hi(I,+hH,H0n5-H*V)(J(,hH/H(i)J(H(V)(J(i)c)(H)H(i)H,c)(3H*i*I*H,i)I,4(3(-H(H,W)(H-I-H,i*I,4)3(3(3H,H-I1H+I,H.i)H1V)(J.i(v5(33H.-H(H,i(c)(H,i*I,4)333)-§i*I*+§H*iHn,hi73H,H(i)8(H+J+H)P*(H*V)(J-r,§H)P*,H.i)H+H,i)V)(-H*i*I*H+i)I+H-H.I.H,H-i)I,4)333Ã+)-§iø7i(^*(iü7I,*h+hH+iDn,h*hilI+i)I,+hH+,hH+iô7H,c)(i)H+i´8W)(H,I,H+i*I+4)-+hH(H)8*J-i(p5.*h*h*hH-i')u,hH(P*(J+,hH(P*0J,H(P*,n50H+H,H-b((3H(P*0i)I.4)3H-i¨*n5*H-iÅ*s,hi73H-i)J+V)&+I,H(H+V)æ,8(I.H(H*8*J-i(p51H-i)J+i¸7V)(H(H+iø7V)(8(J/H(P*0J+s,hi73H+H,H.J,I.H(P*(m5(H.H(P*,s5.+hH,m5*H(P*(J.H+H.H+H/U((b((H(H(P*0i)J+^*0H,i)I,4(3(3H(H.^*03H-i¨*o5)33i(73(3(3-H,H+i)c)(H,i*I,H+i)I+4)33i)I-3H-3!2)0§K(i2J,L(H,H(^*(H,H*^*4H,i(^*0H,i(^*DH,j(_*<H,H)P*(^*,H,H+P*(^*8*h*h+hH,i)8(I3i§I**h*h*h*h*h*h*hH,i*8(6+(),03H,j(_*@i*I-H,P*<J.i,J(H,P*8J/s50H,H.i+J0^*<i¦I*H.H,P*4J1J.U(*H.U((J2i')o5/H.U()I.H,H(^*<H0H1U((H.i0J.i§i0i')o5/H/H.H2J*H(J.q50H,P*0J/H*I-H,P*(J0,hH,P*,H-q,hi)I-423+hH*m5+H/H0H(H1U((b((H/i)I/H(i)I(H*i)I*4(3(3H,H.^*<H,H-^*04*3iØ1U((5+i(I(i¨7i1^*(i$6iè1^*(i°7iè6^*(i¬7iÈ6^*(+hH(iÈ*n,hiÈ*I(+hH(i¨,n,hi¨,I(+hH(iØ,n,hiØ,I(+hH(iè,o,hH,i-H(i0c)(H(i*I(4)33iè1i1H,i-iÈ*8)Bi(I(+hH(ido,hH,i-H(i-c)(H(i*I(4)33iÈ6iè6H,i-iF8)BiØ1i)b((41-H,i-H(i/c)(H(i*I(4)3(3(-H,i-H(i1c)(H(i*I(4)3(3(-H,i-H(i0c)(H(i*I(4)3(3(3H,H/^*0H,H(^*<3i(I*4*3H,H,i¸)^*TH,H,iø-^*PH,H,iX^*LH,H,i(^*HH,i-8(I(H,i-8(I-i¥I*H,i,8(I.H(iErH-iEr5)H(i©*I1H-i)I0i(i;H.i,J(i(H(i(rCJ(J*H*i;sCI*i¨1I-H(I/+hH/,hH,i-H-V)(i)H,i+8(c)(H/i)I/H-i*I-H*i)I*4)-H(i)i¨1I/+hH(H*o,hH,i-H/V)(i)i(c)(H/i*I/H(i)I(4)33i¤I*H,iø-H,i¸)H,i-i;8)5+H0H1I2i(I-+hH-H2p,hH,H,iP8*J*i(p5-H*i7u,hH,i-H-i)H*c)(H-i)I-4*3i(I/i+I.i+I(*h*h*hH*i86*(*)3H-m,hi£I*403H-i)H,W)-I/i*I(4)3i3I.i/I(3H2H,H(8(H.J(H-J.p,hi¢I*4.3H,i-H-i)I*+hH(,hH*H/c)(H*i*I*H(i)I(4)-H.I-4+3(3(33H,W)1m,hiI*4,3H,iø-H,i¸)H,i-H18)J(,hi¡I*H(i(p5,H1H,V)ú-H,V)ø-o5,3H,i(H,iXH,i-H1i)H08)J(,hi I*H(i(p5,H0H,V)H,V)o5,3H,H,iPH,iH8+I*4+3(3(3H,i$6i¬78+I*3H*H3m5(3i)I-H*i(r5)3H)H,P*0^*(H+H,P*<^*(H*I-3H,i2L(H-33Á)+(i¨03b+(,(-(.(/(0(1(2(3(5(7(9(;(?(C(G(K(S([(c(k({(((«(Ë(ë((*)(iø03O)()()()(*(*(*(*(+(+(+(+(,(,(,(,(-(-(-(-(i¨13M8(9(:(((0(/(1(.(2(-(3(,(4(+(5(*(6()(7(T7*S7US0U `;
                    $6cc8fed272338330$export$2e2bcd8739ae039.getModule($6cc8fed272338330$export$2e2bcd8739ae039, puffString).then((wasm)=>WebAssembly.instantiate(wasm, {})).then(({ exports: exports })=>{
                        // required for minifiers that mangle the __heap_base property
                        const instanceExports = new Map(Object.entries(exports));
                        const puff = instanceExports.get("puff");
                        const memory = instanceExports.get("memory")["buffer"];
                        const dataArray = new uint8Array(memory);
                        const heapView = new DataView(memory);
                        let heapPos = instanceExports.get("__heap_base");
                        // source length
                        const sourceLength = source.length;
                        const sourceLengthPtr = heapPos;
                        heapPos += 4;
                        heapView.setInt32(sourceLengthPtr, sourceLength, true);
                        // source data
                        const sourcePtr = heapPos;
                        heapPos += sourceLength;
                        dataArray.set(source, sourcePtr);
                        // destination length
                        const destLengthPtr = heapPos;
                        heapPos += 4;
                        heapView.setInt32(destLengthPtr, dataArray.byteLength - heapPos, true);
                        // destination data fills in the rest of the heap
                        puff(heapPos, destLengthPtr, sourcePtr, sourceLengthPtr);
                        resolve(dataArray.slice(heapPos, heapPos + heapView.getInt32(destLengthPtr, true)));
                    });
                });
            }
        }
    });
    Object.defineProperty(this, "wasm", {
        enumerable: true,
        get: ()=>this._wasm
    });
    this.getOutputChannels = (outputData, channelsDecoded, samplesDecoded)=>{
        let output = [], i = 0;
        while(i < channelsDecoded)output.push(outputData.slice(i * samplesDecoded, i++ * samplesDecoded + samplesDecoded));
        return output;
    };
    this.allocateTypedArray = (len, TypedArray, setPointer = true)=>{
        const ptr = this._wasm.malloc(TypedArray.BYTES_PER_ELEMENT * len);
        if (setPointer) this._pointers.add(ptr);
        return {
            ptr: ptr,
            len: len,
            buf: new TypedArray(this._wasm.HEAP, ptr, len)
        };
    };
    this.free = ()=>{
        this._pointers.forEach((ptr)=>{
            this._wasm.free(ptr);
        });
        this._pointers.clear();
    };
    this.codeToString = (ptr)=>{
        const characters = [], heap = new Uint8Array(this._wasm.HEAP);
        for(let character = heap[ptr]; character !== 0; character = heap[++ptr])characters.push(character);
        return String.fromCharCode.apply(null, characters);
    };
    this.addError = (errors, message, frameLength, frameNumber, inputBytes, outputSamples)=>{
        errors.push({
            message: message,
            frameLength: frameLength,
            frameNumber: frameNumber,
            inputBytes: inputBytes,
            outputSamples: outputSamples
        });
    };
    this.instantiate = (_EmscriptenWASM, _module)=>{
        if (_module) $6cc8fed272338330$export$2e2bcd8739ae039.setModule(_EmscriptenWASM, _module);
        this._wasm = new _EmscriptenWASM($6cc8fed272338330$export$2e2bcd8739ae039).instantiate();
        this._pointers = new Set();
        return this._wasm.ready.then(()=>this);
    };
}

});
parcelRegister("8RjUS", function(module, exports) {

$parcel$export(module.exports, "decode", () => $6732b8f697e1d194$export$2f872c0f2117be69);
const $6732b8f697e1d194$export$1cd93882633e45f5 = (t, n = 4294967295, e = 79764919)=>{
    const r = new Int32Array(256);
    let o, s, i, c = n;
    for(o = 0; o < 256; o++){
        for(i = o << 24, s = 8; s > 0; --s)i = 2147483648 & i ? i << 1 ^ e : i << 1;
        r[o] = i;
    }
    for(o = 0; o < t.length; o++)c = c << 8 ^ r[255 & (c >> 24 ^ t[o])];
    return c;
}, $6732b8f697e1d194$export$c564cdbbe6da493 = (t)=>{
    const n = [];
    for (const e of t){
        let t = (e + 42) % 256;
        0 === t || 10 === t || 13 === t || 61 === t ? n.push("=" + String.fromCharCode((t + 64) % 256)) : n.push(String.fromCharCode(t));
    }
    return n.join("");
}, $6732b8f697e1d194$export$2f872c0f2117be69 = (n, e = $6732b8f697e1d194$export$1cd93882633e45f5)=>{
    const r = (t)=>new Uint8Array(t.length / 2).map((n, e)=>parseInt(t.substring(2 * e, 2 * (e + 1)), 16)), o = (t)=>r(t)[0], s = new Map;
    [
        ,
        8364,
        ,
        8218,
        402,
        8222,
        8230,
        8224,
        8225,
        710,
        8240,
        352,
        8249,
        338,
        ,
        381,
        ,
        ,
        8216,
        8217,
        8220,
        8221,
        8226,
        8211,
        8212,
        732,
        8482,
        353,
        8250,
        339,
        ,
        382,
        376
    ].forEach((t, n)=>s.set(t, n));
    const i = new Uint8Array(n.length);
    let c, a, l, f = !1, g = 0, h = 42, p = n.length > 13 && "dynEncode" === n.substring(0, 9), u = 0;
    p && (u = 11, a = o(n.substring(9, u)), a <= 1 && (u += 2, h = o(n.substring(11, u))), 1 === a && (u += 8, l = ((t)=>new DataView(r(t).buffer).getInt32(0, !0))(n.substring(13, u))));
    const d = 256 - h;
    for(let t = u; t < n.length; t++)if (c = n.charCodeAt(t), 61 !== c || f) {
        if (92 === c && t < n.length - 5 && p) {
            const e = n.charCodeAt(t + 1);
            117 !== e && 85 !== e || (c = parseInt(n.substring(t + 2, t + 6), 16), t += 5);
        }
        if (c > 255) {
            const t = s.get(c);
            t && (c = t + 127);
        }
        f && (f = !1, c -= 64), i[g++] = c < h && c > 0 ? c + d : c - h;
    } else f = !0;
    const m = i.subarray(0, g);
    if (p && 1 === a) {
        const t = e(m);
        if (t !== l) {
            const n = "Decode failed crc32 validation";
            throw console.error("`simple-yenc`\n", n + "\n", "Expected: " + l + "; Got: " + t + "\n", "Visit https://github.com/eshaz/simple-yenc for more information"), Error(n);
        }
    }
    return m;
}, $6732b8f697e1d194$export$c7423f8ce0b2cbf9 = (n, e = '"', r = $6732b8f697e1d194$export$1cd93882633e45f5, o)=>{
    const s = (t, n)=>(t % n + n) % n, i = (t, n)=>n.push(String.fromCharCode(61, (t + 64) % 256)), c = (t)=>t.map((t)=>t.toString(16).padStart(2, "0"));
    let a, l, f = [], g = 1 / 0, h = Array(256).fill(0);
    if ('"' === e ? (l = [
        0,
        8,
        9,
        10,
        11,
        12,
        13,
        34,
        92,
        61
    ], a = (t)=>0 === t || 8 === t || 9 === t || 10 === t || 11 === t || 12 === t || 13 === t || 34 === t || 92 === t || 61 === t) : "'" === e ? (l = [
        0,
        8,
        9,
        10,
        11,
        12,
        13,
        39,
        92,
        61
    ], a = (t)=>0 === t || 8 === t || 9 === t || 10 === t || 11 === t || 12 === t || 13 === t || 39 === t || 92 === t || 61 === t) : "`" === e && (l = [
        13,
        61,
        96
    ], f = [
        7,
        205,
        231
    ], a = (t, n)=>13 === t || 36 === t && 123 === n || 61 === t || 92 === t && (85 === n || 117 === n) || 96 === t), void 0 === o) {
        o = 0;
        for(let t = 0; t < n.length; t++){
            const e = 0 | n[t];
            h[e]++;
            for(let r = 0; r < f.length; r++){
                const o = f[r];
                s(e - n[t + 1] | 0, 256) === o && h[e]++;
            }
        }
        for(let t = 0; t < 256; t++){
            let n = 0;
            for(let e = 0; e < l.length; e++)n += h[s(l[e] - t, 256)];
            n < g && (g = n, o = t);
        }
    }
    const p = [
        "dynEncode",
        "01",
        c([
            o
        ]),
        ...c(((t)=>{
            const n = new Uint8Array(4);
            return new DataView(n.buffer).setInt32(0, t, !0), [
                ...n
            ];
        })(r(n)))
    ];
    for(let t = 0; t < n.length; t++){
        const e = (n[t] + o) % 256;
        a(e, (n[t + 1] + o) % 256) ? i(e, p) : p.push(String.fromCharCode(e));
    }
    return "\\" === p[p.length - 1] && (p.pop(), i(92, p)), p.join("");
}, $6732b8f697e1d194$export$fac44ee5b035f737 = (t)=>t.replace(/[\\]/g, "\\\\").replace(/[`]/g, "\\`").replace(/\${/g, "\\${");

});


parcelRegister("ii0lZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d50a2ea465b7287c$export$2e2bcd8739ae039);

var $fqBvU = parcelRequire("fqBvU");

var $9l3Lt = parcelRequire("9l3Lt");

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $d50a2ea465b7287c$require$Buffer = $6ZWSX.Buffer;
const $d50a2ea465b7287c$var$getWorker = ()=>globalThis.Worker || (0, (/*@__PURE__*/$parcel$interopDefault($fqBvU)));
class $d50a2ea465b7287c$export$2e2bcd8739ae039 extends $d50a2ea465b7287c$var$getWorker() {
    constructor(options, name, Decoder, EmscriptenWASM){
        if (!(0, $9l3Lt.default).modules) new (0, $9l3Lt.default)();
        let source = (0, $9l3Lt.default).modules.get(Decoder);
        if (!source) {
            let type = "text/javascript", isNode, webworkerSourceCode = "'use strict';" + // dependencies need to be manually resolved when stringifying this function
            `(${((_Decoder, _WASMAudioDecoderCommon, _EmscriptenWASM)=>{
                // We're in a Web Worker
                // setup Promise that will be resolved once the WebAssembly Module is received
                let decoder, moduleResolve, modulePromise = new Promise((resolve)=>{
                    moduleResolve = resolve;
                });
                self.onmessage = ({ data: { id: id, command: command, data: data } })=>{
                    let messagePromise = modulePromise, messagePayload = {
                        id: id
                    }, transferList;
                    if (command === "init") {
                        Object.defineProperties(_Decoder, {
                            WASMAudioDecoderCommon: {
                                value: _WASMAudioDecoderCommon
                            },
                            EmscriptenWASM: {
                                value: _EmscriptenWASM
                            },
                            module: {
                                value: data.module
                            },
                            isWebWorker: {
                                value: true
                            }
                        });
                        decoder = new _Decoder(data.options);
                        moduleResolve();
                    } else if (command === "free") decoder.free();
                    else if (command === "ready") messagePromise = messagePromise.then(()=>decoder.ready);
                    else if (command === "reset") messagePromise = messagePromise.then(()=>decoder.reset());
                    else {
                        // "decode":
                        // "decodeFrame":
                        // "decodeFrames":
                        Object.assign(messagePayload, decoder[command](// detach buffers
                        Array.isArray(data) ? data.map((data)=>new Uint8Array(data)) : new Uint8Array(data)));
                        // The "transferList" parameter transfers ownership of channel data to main thread,
                        // which avoids copying memory.
                        transferList = messagePayload.channelData ? messagePayload.channelData.map((channel)=>channel.buffer) : [];
                    }
                    messagePromise.then(()=>self.postMessage(messagePayload, transferList));
                };
            }).toString()})(${Decoder}, ${0, $9l3Lt.default}, ${EmscriptenWASM})`;
            try {
                isNode = typeof $hPtJY.versions.node !== "undefined";
            } catch  {}
            source = isNode ? `data:${type};base64,${$d50a2ea465b7287c$require$Buffer.from(webworkerSourceCode).toString("base64")}` : URL.createObjectURL(new Blob([
                webworkerSourceCode
            ], {
                type: type
            }));
            (0, $9l3Lt.default).modules.set(Decoder, source);
        }
        super(source, {
            name: name
        });
        this._id = Number.MIN_SAFE_INTEGER;
        this._enqueuedOperations = new Map();
        this.onmessage = ({ data: data })=>{
            const { id: id, ...rest } = data;
            this._enqueuedOperations.get(id)(rest);
            this._enqueuedOperations.delete(id);
        };
        new EmscriptenWASM((0, $9l3Lt.default)).getModule().then((module)=>{
            this.postToDecoder("init", {
                module: module,
                options: options
            });
        });
    }
    async postToDecoder(command, data) {
        return new Promise((resolve)=>{
            this.postMessage({
                command: command,
                id: this._id,
                data: data
            });
            this._enqueuedOperations.set(this._id++, resolve);
        });
    }
    get ready() {
        return this.postToDecoder("ready");
    }
    async free() {
        await this.postToDecoder("free").finally(()=>{
            this.terminate();
        });
    }
    async reset() {
        await this.postToDecoder("reset");
    }
}

});
parcelRegister("fqBvU", function(module, exports) {
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ module.exports = Worker;

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("ctpdC", function(module, exports) {

$parcel$export(module.exports, "assignNames", () => $914bc161c46b40a3$export$6915126ba85aae77);
const $914bc161c46b40a3$export$6915126ba85aae77 = (Class, name)=>{
    Object.defineProperty(Class, "name", {
        value: name
    });
};

});

parcelRegister("5TAle", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8l0T7").then(()=>parcelRequire("gWfaE"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


var $fd28d333ad7e5007$exports = {};
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


function $02f33e5afac044cb$var$parse(uuid) {
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Invalid UUID");
    let v;
    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff; // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff; // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff; // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff; // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
var $02f33e5afac044cb$export$2e2bcd8739ae039 = $02f33e5afac044cb$var$parse;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}



function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


var $fd28d333ad7e5007$require$uuidV4 = $3fa3ae484854b431$export$2e2bcd8739ae039;
var $fd28d333ad7e5007$require$uuidParse = $02f33e5afac044cb$export$2e2bcd8739ae039;
var $fd28d333ad7e5007$require$uuidStringify = $1d0137947e8554ce$export$2e2bcd8739ae039;
const $fd28d333ad7e5007$var$promisify = (method)=>{
    return (...args)=>{
        try {
            const result = method(...args);
            if (result instanceof Promise) return result;
            return Promise.resolve(result);
        } catch (error) {
            return Promise.reject(error);
        }
    };
};
// browser.js
var $b4febe4ed2fc60b5$export$c564cdbbe6da493;
var $b4febe4ed2fc60b5$export$2f872c0f2117be69;
var $b4febe4ed2fc60b5$export$a50aceb0e02a00aa;
var $b4febe4ed2fc60b5$export$f9de6ca0bc043724;
var $b4febe4ed2fc60b5$export$a4cf2f585987cc8;
var $b4febe4ed2fc60b5$export$1c37c01eba8ed446;

$b4febe4ed2fc60b5$export$c564cdbbe6da493 = (parcelRequire("lVQGa")).encode;

$b4febe4ed2fc60b5$export$2f872c0f2117be69 = (parcelRequire("k7dTF")).decode;

$b4febe4ed2fc60b5$export$a50aceb0e02a00aa = (parcelRequire("968dK")).Encoder;

$b4febe4ed2fc60b5$export$f9de6ca0bc043724 = (parcelRequire("HSvGO")).Decoder;

$b4febe4ed2fc60b5$export$a4cf2f585987cc8 = (parcelRequire("5Fza0")).createCodec;

$b4febe4ed2fc60b5$export$1c37c01eba8ed446 = (parcelRequire("762Am")).codec;


$fd28d333ad7e5007$exports = (handlerTable, writeMethod)=>{
    const protocol = {
        _taskLookup: {},
        _handleCall: (data)=>{
            const id = $fd28d333ad7e5007$require$uuidStringify(data.id);
            const handler = handlerTable[data.command + ""];
            if (handler === undefined) return protocol.response(id, false, new Error("Command not registered"));
            return $fd28d333ad7e5007$var$promisify(handler)(data.data).then((data)=>{
                return protocol.response(id, true, data);
            }).catch((error)=>{
                return protocol.response(id, false, error);
            });
        },
        _handleResponse: (data)=>{
            const id = $fd28d333ad7e5007$require$uuidStringify(data.id);
            const task = protocol._taskLookup[id];
            if (task === undefined) return;
            if (data.success) task.resolve(data.data);
            else task.reject(data.data);
        },
        readMethod: (arrayBuffer)=>{
            const data = new Uint8Array(arrayBuffer);
            const decodedMessage = $b4febe4ed2fc60b5$export$2f872c0f2117be69(data);
            const typeHandlers = {
                call: protocol._handleCall,
                response: protocol._handleResponse
            };
            const handler = typeHandlers[decodedMessage.type + ""];
            if (handler) handler(decodedMessage);
        },
        response: (uuid, success, data)=>{
            const binaryUuid = $fd28d333ad7e5007$require$uuidParse(uuid);
            const packet = {
                type: "response",
                id: binaryUuid,
                start: new Date(),
                data: data,
                success: success
            };
            const encodedPacket = $b4febe4ed2fc60b5$export$c564cdbbe6da493(packet);
            writeMethod(encodedPacket);
        },
        call: (name, data)=>{
            const uuid = $fd28d333ad7e5007$require$uuidV4();
            const binaryUuid = $fd28d333ad7e5007$require$uuidParse(uuid);
            const packet = {
                type: "call",
                id: binaryUuid,
                start: new Date(),
                command: name,
                data: data
            };
            const encodedPacket = $b4febe4ed2fc60b5$export$c564cdbbe6da493(packet);
            return new Promise((resolve, reject)=>{
                protocol._taskLookup[uuid] = {
                    resolve: resolve,
                    reject: reject
                };
                writeMethod(encodedPacket);
            });
        }
    };
    return protocol;
};


var $c53890eb3e021adc$exports = {};
var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


var $5e0eb040f3eceaa7$exports = {};
var $f2be4bfe7faad0b8$exports = {};
/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */ "use strict";
Object.defineProperty($f2be4bfe7faad0b8$exports, "__esModule", {
    value: true
});
/**
 * @typedef {object} PrivateData
 * @property {EventTarget} eventTarget The event target.
 * @property {{type:string}} event The original event object.
 * @property {number} eventPhase The current event phase.
 * @property {EventTarget|null} currentTarget The current event target.
 * @property {boolean} canceled The flag to prevent default.
 * @property {boolean} stopped The flag to stop propagation immediately.
 * @property {Function|null} passiveListener The listener if the current listener is passive. Otherwise this is null.
 * @property {number} timeStamp The unix time.
 * @private
 */ /**
 * Private data for event wrappers.
 * @type {WeakMap<Event, PrivateData>}
 * @private
 */ const $f2be4bfe7faad0b8$var$privateData = new WeakMap();
/**
 * Cache for wrapper classes.
 * @type {WeakMap<Object, Function>}
 * @private
 */ const $f2be4bfe7faad0b8$var$wrappers = new WeakMap();
/**
 * Get private data.
 * @param {Event} event The event object to get private data.
 * @returns {PrivateData} The private data of the event.
 * @private
 */ function $f2be4bfe7faad0b8$var$pd(event) {
    const retv = $f2be4bfe7faad0b8$var$privateData.get(event);
    console.assert(retv != null, "'this' is expected an Event object, but got", event);
    return retv;
}
/**
 * @see https://dom.spec.whatwg.org/#interface-event
 * @private
 */ /**
 * The event wrapper.
 * @constructor
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Event|{type:string}} event The original event to wrap.
 */ function $f2be4bfe7faad0b8$var$Event(eventTarget, event) {
    $f2be4bfe7faad0b8$var$privateData.set(this, {
        eventTarget: eventTarget,
        event: event,
        eventPhase: 2,
        currentTarget: eventTarget,
        canceled: false,
        stopped: false,
        passiveListener: null,
        timeStamp: event.timeStamp || Date.now()
    });
    // https://heycam.github.io/webidl/#Unforgeable
    Object.defineProperty(this, "isTrusted", {
        value: false,
        enumerable: true
    });
    // Define accessors
    const keys = Object.keys(event);
    for(let i = 0; i < keys.length; ++i){
        const key = keys[i];
        if (!(key in this)) Object.defineProperty(this, key, $f2be4bfe7faad0b8$var$defineRedirectDescriptor(key));
    }
}
// Should be enumerable, but class methods are not enumerable.
$f2be4bfe7faad0b8$var$Event.prototype = {
    /**
     * The type of this event.
     * @type {string}
     */ get type () {
        return $f2be4bfe7faad0b8$var$pd(this).event.type;
    },
    /**
     * The target of this event.
     * @type {EventTarget}
     */ get target () {
        return $f2be4bfe7faad0b8$var$pd(this).eventTarget;
    },
    /**
     * The target of this event.
     * @type {EventTarget}
     */ get currentTarget () {
        return $f2be4bfe7faad0b8$var$pd(this).currentTarget;
    },
    /**
     * @returns {EventTarget[]} The composed path of this event.
     */ composedPath () {
        const currentTarget = $f2be4bfe7faad0b8$var$pd(this).currentTarget;
        if (currentTarget == null) return [];
        return [
            currentTarget
        ];
    },
    /**
     * Constant of NONE.
     * @type {number}
     */ get NONE () {
        return 0;
    },
    /**
     * Constant of CAPTURING_PHASE.
     * @type {number}
     */ get CAPTURING_PHASE () {
        return 1;
    },
    /**
     * Constant of AT_TARGET.
     * @type {number}
     */ get AT_TARGET () {
        return 2;
    },
    /**
     * Constant of BUBBLING_PHASE.
     * @type {number}
     */ get BUBBLING_PHASE () {
        return 3;
    },
    /**
     * The target of this event.
     * @type {number}
     */ get eventPhase () {
        return $f2be4bfe7faad0b8$var$pd(this).eventPhase;
    },
    /**
     * Stop event bubbling.
     * @returns {void}
     */ stopPropagation () {
        const data = $f2be4bfe7faad0b8$var$pd(this);
        if (typeof data.event.stopPropagation === "function") data.event.stopPropagation();
    },
    /**
     * Stop event bubbling.
     * @returns {void}
     */ stopImmediatePropagation () {
        const data = $f2be4bfe7faad0b8$var$pd(this);
        data.stopped = true;
        if (typeof data.event.stopImmediatePropagation === "function") data.event.stopImmediatePropagation();
    },
    /**
     * The flag to be bubbling.
     * @type {boolean}
     */ get bubbles () {
        return Boolean($f2be4bfe7faad0b8$var$pd(this).event.bubbles);
    },
    /**
     * The flag to be cancelable.
     * @type {boolean}
     */ get cancelable () {
        return Boolean($f2be4bfe7faad0b8$var$pd(this).event.cancelable);
    },
    /**
     * Cancel this event.
     * @returns {void}
     */ preventDefault () {
        const data = $f2be4bfe7faad0b8$var$pd(this);
        if (data.passiveListener != null) {
            console.warn("Event#preventDefault() was called from a passive listener:", data.passiveListener);
            return;
        }
        if (!data.event.cancelable) return;
        data.canceled = true;
        if (typeof data.event.preventDefault === "function") data.event.preventDefault();
    },
    /**
     * The flag to indicate cancellation state.
     * @type {boolean}
     */ get defaultPrevented () {
        return $f2be4bfe7faad0b8$var$pd(this).canceled;
    },
    /**
     * The flag to be composed.
     * @type {boolean}
     */ get composed () {
        return Boolean($f2be4bfe7faad0b8$var$pd(this).event.composed);
    },
    /**
     * The unix time of this event.
     * @type {number}
     */ get timeStamp () {
        return $f2be4bfe7faad0b8$var$pd(this).timeStamp;
    }
};
// `constructor` is not enumerable.
Object.defineProperty($f2be4bfe7faad0b8$var$Event.prototype, "constructor", {
    value: $f2be4bfe7faad0b8$var$Event,
    configurable: true,
    writable: true
});
// Ensure `event instanceof window.Event` is `true`.
if (typeof window !== "undefined" && typeof window.Event !== "undefined") {
    Object.setPrototypeOf($f2be4bfe7faad0b8$var$Event.prototype, window.Event.prototype);
    // Make association for wrappers.
    $f2be4bfe7faad0b8$var$wrappers.set(window.Event.prototype, $f2be4bfe7faad0b8$var$Event);
}
/**
 * Get the property descriptor to redirect a given property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to redirect the property.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineRedirectDescriptor(key) {
    return {
        get () {
            return $f2be4bfe7faad0b8$var$pd(this).event[key];
        },
        set (value) {
            $f2be4bfe7faad0b8$var$pd(this).event[key] = value;
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Get the property descriptor to call a given method property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to call the method property.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineCallDescriptor(key) {
    return {
        value () {
            const event = $f2be4bfe7faad0b8$var$pd(this).event;
            return event[key].apply(event, arguments);
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Define new wrapper class.
 * @param {Function} BaseEvent The base wrapper class.
 * @param {Object} proto The prototype of the original event.
 * @returns {Function} The defined wrapper class.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineWrapper(BaseEvent, proto) {
    const keys = Object.keys(proto);
    if (keys.length === 0) return BaseEvent;
    /** CustomEvent */ function CustomEvent(eventTarget, event) {
        BaseEvent.call(this, eventTarget, event);
    }
    CustomEvent.prototype = Object.create(BaseEvent.prototype, {
        constructor: {
            value: CustomEvent,
            configurable: true,
            writable: true
        }
    });
    // Define accessors.
    for(let i = 0; i < keys.length; ++i){
        const key = keys[i];
        if (!(key in BaseEvent.prototype)) {
            const descriptor = Object.getOwnPropertyDescriptor(proto, key);
            const isFunc = typeof descriptor.value === "function";
            Object.defineProperty(CustomEvent.prototype, key, isFunc ? $f2be4bfe7faad0b8$var$defineCallDescriptor(key) : $f2be4bfe7faad0b8$var$defineRedirectDescriptor(key));
        }
    }
    return CustomEvent;
}
/**
 * Get the wrapper class of a given prototype.
 * @param {Object} proto The prototype of the original event to get its wrapper.
 * @returns {Function} The wrapper class.
 * @private
 */ function $f2be4bfe7faad0b8$var$getWrapper(proto) {
    if (proto == null || proto === Object.prototype) return $f2be4bfe7faad0b8$var$Event;
    let wrapper = $f2be4bfe7faad0b8$var$wrappers.get(proto);
    if (wrapper == null) {
        wrapper = $f2be4bfe7faad0b8$var$defineWrapper($f2be4bfe7faad0b8$var$getWrapper(Object.getPrototypeOf(proto)), proto);
        $f2be4bfe7faad0b8$var$wrappers.set(proto, wrapper);
    }
    return wrapper;
}
/**
 * Wrap a given event to management a dispatching.
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Object} event The event to wrap.
 * @returns {Event} The wrapper instance.
 * @private
 */ function $f2be4bfe7faad0b8$var$wrapEvent(eventTarget, event) {
    const Wrapper = $f2be4bfe7faad0b8$var$getWrapper(Object.getPrototypeOf(event));
    return new Wrapper(eventTarget, event);
}
/**
 * Get the stopped flag of a given event.
 * @param {Event} event The event to get.
 * @returns {boolean} The flag to stop propagation immediately.
 * @private
 */ function $f2be4bfe7faad0b8$var$isStopped(event) {
    return $f2be4bfe7faad0b8$var$pd(event).stopped;
}
/**
 * Set the current event phase of a given event.
 * @param {Event} event The event to set current target.
 * @param {number} eventPhase New event phase.
 * @returns {void}
 * @private
 */ function $f2be4bfe7faad0b8$var$setEventPhase(event, eventPhase) {
    $f2be4bfe7faad0b8$var$pd(event).eventPhase = eventPhase;
}
/**
 * Set the current target of a given event.
 * @param {Event} event The event to set current target.
 * @param {EventTarget|null} currentTarget New current target.
 * @returns {void}
 * @private
 */ function $f2be4bfe7faad0b8$var$setCurrentTarget(event, currentTarget) {
    $f2be4bfe7faad0b8$var$pd(event).currentTarget = currentTarget;
}
/**
 * Set a passive listener of a given event.
 * @param {Event} event The event to set current target.
 * @param {Function|null} passiveListener New passive listener.
 * @returns {void}
 * @private
 */ function $f2be4bfe7faad0b8$var$setPassiveListener(event, passiveListener) {
    $f2be4bfe7faad0b8$var$pd(event).passiveListener = passiveListener;
}
/**
 * @typedef {object} ListenerNode
 * @property {Function} listener
 * @property {1|2|3} listenerType
 * @property {boolean} passive
 * @property {boolean} once
 * @property {ListenerNode|null} next
 * @private
 */ /**
 * @type {WeakMap<object, Map<string, ListenerNode>>}
 * @private
 */ const $f2be4bfe7faad0b8$var$listenersMap = new WeakMap();
// Listener types
const $f2be4bfe7faad0b8$var$CAPTURE = 1;
const $f2be4bfe7faad0b8$var$BUBBLE = 2;
const $f2be4bfe7faad0b8$var$ATTRIBUTE = 3;
/**
 * Check whether a given value is an object or not.
 * @param {any} x The value to check.
 * @returns {boolean} `true` if the value is an object.
 */ function $f2be4bfe7faad0b8$var$isObject(x) {
    return x !== null && typeof x === "object" //eslint-disable-line no-restricted-syntax
    ;
}
/**
 * Get listeners.
 * @param {EventTarget} eventTarget The event target to get.
 * @returns {Map<string, ListenerNode>} The listeners.
 * @private
 */ function $f2be4bfe7faad0b8$var$getListeners(eventTarget) {
    const listeners = $f2be4bfe7faad0b8$var$listenersMap.get(eventTarget);
    if (listeners == null) throw new TypeError("'this' is expected an EventTarget object, but got another value.");
    return listeners;
}
/**
 * Get the property descriptor for the event attribute of a given event.
 * @param {string} eventName The event name to get property descriptor.
 * @returns {PropertyDescriptor} The property descriptor.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineEventAttributeDescriptor(eventName) {
    return {
        get () {
            const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
            let node = listeners.get(eventName);
            while(node != null){
                if (node.listenerType === $f2be4bfe7faad0b8$var$ATTRIBUTE) return node.listener;
                node = node.next;
            }
            return null;
        },
        set (listener) {
            if (typeof listener !== "function" && !$f2be4bfe7faad0b8$var$isObject(listener)) listener = null; // eslint-disable-line no-param-reassign
            const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
            // Traverse to the tail while removing old value.
            let prev = null;
            let node = listeners.get(eventName);
            while(node != null){
                if (node.listenerType === $f2be4bfe7faad0b8$var$ATTRIBUTE) {
                    // Remove old value.
                    if (prev !== null) prev.next = node.next;
                    else if (node.next !== null) listeners.set(eventName, node.next);
                    else listeners.delete(eventName);
                } else prev = node;
                node = node.next;
            }
            // Add new value.
            if (listener !== null) {
                const newNode = {
                    listener: listener,
                    listenerType: $f2be4bfe7faad0b8$var$ATTRIBUTE,
                    passive: false,
                    once: false,
                    next: null
                };
                if (prev === null) listeners.set(eventName, newNode);
                else prev.next = newNode;
            }
        },
        configurable: true,
        enumerable: true
    };
}
/**
 * Define an event attribute (e.g. `eventTarget.onclick`).
 * @param {Object} eventTargetPrototype The event target prototype to define an event attrbite.
 * @param {string} eventName The event name to define.
 * @returns {void}
 */ function $f2be4bfe7faad0b8$var$defineEventAttribute(eventTargetPrototype, eventName) {
    Object.defineProperty(eventTargetPrototype, `on${eventName}`, $f2be4bfe7faad0b8$var$defineEventAttributeDescriptor(eventName));
}
/**
 * Define a custom EventTarget with event attributes.
 * @param {string[]} eventNames Event names for event attributes.
 * @returns {EventTarget} The custom EventTarget.
 * @private
 */ function $f2be4bfe7faad0b8$var$defineCustomEventTarget(eventNames) {
    /** CustomEventTarget */ function CustomEventTarget() {
        $f2be4bfe7faad0b8$var$EventTarget.call(this);
    }
    CustomEventTarget.prototype = Object.create($f2be4bfe7faad0b8$var$EventTarget.prototype, {
        constructor: {
            value: CustomEventTarget,
            configurable: true,
            writable: true
        }
    });
    for(let i = 0; i < eventNames.length; ++i)$f2be4bfe7faad0b8$var$defineEventAttribute(CustomEventTarget.prototype, eventNames[i]);
    return CustomEventTarget;
}
/**
 * EventTarget.
 *
 * - This is constructor if no arguments.
 * - This is a function which returns a CustomEventTarget constructor if there are arguments.
 *
 * For example:
 *
 *     class A extends EventTarget {}
 *     class B extends EventTarget("message") {}
 *     class C extends EventTarget("message", "error") {}
 *     class D extends EventTarget(["message", "error"]) {}
 */ function $f2be4bfe7faad0b8$var$EventTarget() {
    /*eslint-disable consistent-return */ if (this instanceof $f2be4bfe7faad0b8$var$EventTarget) {
        $f2be4bfe7faad0b8$var$listenersMap.set(this, new Map());
        return;
    }
    if (arguments.length === 1 && Array.isArray(arguments[0])) return $f2be4bfe7faad0b8$var$defineCustomEventTarget(arguments[0]);
    if (arguments.length > 0) {
        const types = new Array(arguments.length);
        for(let i = 0; i < arguments.length; ++i)types[i] = arguments[i];
        return $f2be4bfe7faad0b8$var$defineCustomEventTarget(types);
    }
    throw new TypeError("Cannot call a class as a function");
/*eslint-enable consistent-return */ }
// Should be enumerable, but class methods are not enumerable.
$f2be4bfe7faad0b8$var$EventTarget.prototype = {
    /**
     * Add a given listener to this event target.
     * @param {string} eventName The event name to add.
     * @param {Function} listener The listener to add.
     * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
     * @returns {boolean} `true` if the listener was added actually.
     */ addEventListener (eventName, listener, options) {
        if (listener == null) return false;
        if (typeof listener !== "function" && !$f2be4bfe7faad0b8$var$isObject(listener)) throw new TypeError("'listener' should be a function or an object.");
        const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
        const optionsIsObj = $f2be4bfe7faad0b8$var$isObject(options);
        const capture = optionsIsObj ? Boolean(options.capture) : Boolean(options);
        const listenerType = capture ? $f2be4bfe7faad0b8$var$CAPTURE : $f2be4bfe7faad0b8$var$BUBBLE;
        const newNode = {
            listener: listener,
            listenerType: listenerType,
            passive: optionsIsObj && Boolean(options.passive),
            once: optionsIsObj && Boolean(options.once),
            next: null
        };
        // Set it as the first node if the first node is null.
        let node = listeners.get(eventName);
        if (node === undefined) {
            listeners.set(eventName, newNode);
            return true;
        }
        // Traverse to the tail while checking duplication..
        let prev = null;
        while(node != null){
            if (node.listener === listener && node.listenerType === listenerType) // Should ignore duplication.
            return false;
            prev = node;
            node = node.next;
        }
        // Add it.
        prev.next = newNode;
        return true;
    },
    /**
     * Remove a given listener from this event target.
     * @param {string} eventName The event name to remove.
     * @param {Function} listener The listener to remove.
     * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
     * @returns {boolean} `true` if the listener was removed actually.
     */ removeEventListener (eventName, listener, options) {
        if (listener == null) return false;
        const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
        const capture = $f2be4bfe7faad0b8$var$isObject(options) ? Boolean(options.capture) : Boolean(options);
        const listenerType = capture ? $f2be4bfe7faad0b8$var$CAPTURE : $f2be4bfe7faad0b8$var$BUBBLE;
        let prev = null;
        let node = listeners.get(eventName);
        while(node != null){
            if (node.listener === listener && node.listenerType === listenerType) {
                if (prev !== null) prev.next = node.next;
                else if (node.next !== null) listeners.set(eventName, node.next);
                else listeners.delete(eventName);
                return true;
            }
            prev = node;
            node = node.next;
        }
        return false;
    },
    /**
     * Dispatch a given event.
     * @param {Event|{type:string}} event The event to dispatch.
     * @returns {boolean} `false` if canceled.
     */ dispatchEvent (event) {
        if (event == null || typeof event.type !== "string") throw new TypeError('"event.type" should be a string.');
        // If listeners aren't registered, terminate.
        const listeners = $f2be4bfe7faad0b8$var$getListeners(this);
        const eventName = event.type;
        let node = listeners.get(eventName);
        if (node == null) return true;
        // Since we cannot rewrite several properties, so wrap object.
        const wrappedEvent = $f2be4bfe7faad0b8$var$wrapEvent(this, event);
        // This doesn't process capturing phase and bubbling phase.
        // This isn't participating in a tree.
        let prev = null;
        while(node != null){
            // Remove this listener if it's once
            if (node.once) {
                if (prev !== null) prev.next = node.next;
                else if (node.next !== null) listeners.set(eventName, node.next);
                else listeners.delete(eventName);
            } else prev = node;
            // Call this listener
            $f2be4bfe7faad0b8$var$setPassiveListener(wrappedEvent, node.passive ? node.listener : null);
            if (typeof node.listener === "function") try {
                node.listener.call(this, wrappedEvent);
            } catch (err) {
                /*eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(err);
            /*eslint-enable no-console */ }
            else if (node.listenerType !== $f2be4bfe7faad0b8$var$ATTRIBUTE && typeof node.listener.handleEvent === "function") node.listener.handleEvent(wrappedEvent);
            // Break if `event.stopImmediatePropagation` was called.
            if ($f2be4bfe7faad0b8$var$isStopped(wrappedEvent)) break;
            node = node.next;
        }
        $f2be4bfe7faad0b8$var$setPassiveListener(wrappedEvent, null);
        $f2be4bfe7faad0b8$var$setEventPhase(wrappedEvent, 0);
        $f2be4bfe7faad0b8$var$setCurrentTarget(wrappedEvent, null);
        return !wrappedEvent.defaultPrevented;
    }
};
// `constructor` is not enumerable.
Object.defineProperty($f2be4bfe7faad0b8$var$EventTarget.prototype, "constructor", {
    value: $f2be4bfe7faad0b8$var$EventTarget,
    configurable: true,
    writable: true
});
// Ensure `eventTarget instanceof window.EventTarget` is `true`.
if (typeof window !== "undefined" && typeof window.EventTarget !== "undefined") Object.setPrototypeOf($f2be4bfe7faad0b8$var$EventTarget.prototype, window.EventTarget.prototype);
$f2be4bfe7faad0b8$exports.defineEventAttribute = $f2be4bfe7faad0b8$var$defineEventAttribute;
$f2be4bfe7faad0b8$exports.EventTarget = $f2be4bfe7faad0b8$var$EventTarget;
$f2be4bfe7faad0b8$exports.default = $f2be4bfe7faad0b8$var$EventTarget;
$f2be4bfe7faad0b8$exports = $f2be4bfe7faad0b8$var$EventTarget;
$f2be4bfe7faad0b8$exports.EventTarget = $f2be4bfe7faad0b8$exports["default"] = $f2be4bfe7faad0b8$var$EventTarget;
$f2be4bfe7faad0b8$exports.defineEventAttribute = $f2be4bfe7faad0b8$var$defineEventAttribute;


var $5e0eb040f3eceaa7$require$EventTarget = $f2be4bfe7faad0b8$exports.EventTarget;
var $5e0eb040f3eceaa7$require$defineEventAttribute = $f2be4bfe7faad0b8$exports.defineEventAttribute;
var $cbcee261d685d22a$exports = {};

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $cbcee261d685d22a$var$__spreadArrays = $cbcee261d685d22a$exports && $cbcee261d685d22a$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($cbcee261d685d22a$exports, "__esModule", {
    value: true
});
var $cbcee261d685d22a$var$BrowserInfo = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}();
$cbcee261d685d22a$exports.BrowserInfo = $cbcee261d685d22a$var$BrowserInfo;
var $cbcee261d685d22a$var$NodeInfo = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.name = "node";
        this.os = $hPtJY.platform;
    }
    return NodeInfo;
}();
$cbcee261d685d22a$exports.NodeInfo = $cbcee261d685d22a$var$NodeInfo;
var $cbcee261d685d22a$var$BotInfo = /** @class */ function() {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
$cbcee261d685d22a$exports.BotInfo = $cbcee261d685d22a$var$BotInfo;
// tslint:disable-next-line:max-line-length
var $cbcee261d685d22a$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $cbcee261d685d22a$var$SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var $cbcee261d685d22a$var$REQUIRED_VERSION_PARTS = 3;
var $cbcee261d685d22a$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "vivaldi",
        /Vivaldi\/([0-9\.]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /Edg\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FBAV\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "searchbot",
        $cbcee261d685d22a$var$SEARCHBOX_UA_REGEX
    ]
];
var $cbcee261d685d22a$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ],
    [
        "Search Bot",
        $cbcee261d685d22a$var$SEARCHBOT_OS_REGEX
    ]
];
function $cbcee261d685d22a$var$detect(userAgent) {
    if (!!userAgent) return $cbcee261d685d22a$var$parseUserAgent(userAgent);
    if (typeof navigator !== "undefined") return $cbcee261d685d22a$var$parseUserAgent(navigator.userAgent);
    return $cbcee261d685d22a$var$getNodeVersion();
}
$cbcee261d685d22a$exports.detect = $cbcee261d685d22a$var$detect;
function $cbcee261d685d22a$var$parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== "" && $cbcee261d685d22a$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $cbcee261d685d22a$var$BotInfo();
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $cbcee261d685d22a$var$REQUIRED_VERSION_PARTS) versionParts = $cbcee261d685d22a$var$__spreadArrays(versionParts, $cbcee261d685d22a$var$createVersionParts($cbcee261d685d22a$var$REQUIRED_VERSION_PARTS - versionParts.length));
    } else versionParts = [];
    return new $cbcee261d685d22a$var$BrowserInfo(name, versionParts.join("."), $cbcee261d685d22a$var$detectOS(ua));
}
$cbcee261d685d22a$exports.parseUserAgent = $cbcee261d685d22a$var$parseUserAgent;
function $cbcee261d685d22a$var$detectOS(ua) {
    for(var ii = 0, count = $cbcee261d685d22a$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $cbcee261d685d22a$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) return os;
    }
    return null;
}
$cbcee261d685d22a$exports.detectOS = $cbcee261d685d22a$var$detectOS;
function $cbcee261d685d22a$var$getNodeVersion() {
    var isNode = typeof $hPtJY !== "undefined" && $hPtJY.version;
    return isNode ? new $cbcee261d685d22a$var$NodeInfo($hPtJY.version.slice(1)) : null;
}
$cbcee261d685d22a$exports.getNodeVersion = $cbcee261d685d22a$var$getNodeVersion;
function $cbcee261d685d22a$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}


var $5e0eb040f3eceaa7$require$detect = $cbcee261d685d22a$exports.detect;
const $5e0eb040f3eceaa7$var$browser = $5e0eb040f3eceaa7$require$detect();
const $5e0eb040f3eceaa7$var$AudioContext = $parcel$global.AudioContext || $parcel$global.webkitAudioContext;
const $5e0eb040f3eceaa7$var$BUFFER_SIZE = 4096;
/**
 * Reference: https://w3c.github.io/mediacapture-record/#mediarecorder-api
 * @extends EventTarget
 */ class $5e0eb040f3eceaa7$var$OpusMediaRecorder extends $5e0eb040f3eceaa7$require$EventTarget {
    /**
   * A function that returns the encoder web worker
   * @name workerFactory
   * @function
   * @returns {worker} An instance of ./encoderWorker.js web worker.
   */ /**
   *
   * @param {MediaStream} stream - The MediaStream to be recorded. This will
   *          be the value of the stream attribute.
   * @param {MediaRecorderOptions} [options] - A dictionary of options to for
   *          the UA instructing how the recording will take part.
   *          options.mimeType, if present, will become the value of mimeType
   *          attribute.
   * @param {Object} [workerOptions] This is a NON-STANDARD options to
   *          configure how to import the web worker .wasm compiled binaries
   *          used for encoding.
   * @param {workerFactory} [workerOptions.encoderWorkerFactory] A factory
   *          function that create a web worker instance of ./encoderWorker.js
   *          and returns it. function(){return new Worker('./encoderWorker.umd.js')}
   *          is used by default. This is NON-STANDARD.
   * @param {string} [workerOptions.OggOpusEncoderWasmPath]
   *          Path of ./OggOpusEncoder.wasm which is used for OGG Opus encoding
   *          by the encoder worker. This is NON-STANDARD.
   * @param {string} [workerOptions.WebMOpusEncoderWasmPath]
   *          Path of ./WebMOpusEncoder.wasm which is used for WebM Opus encoding
   *          by the encoder worker. This is NON-STANDARD.
   */ constructor(stream, options = {}, workerOptions = {}){
        const { mimeType: mimeType, audioBitsPerSecond: audioBitsPerSecond, videoBitsPerSecond: videoBitsPerSecond, bitsPerSecond: bitsPerSecond } = options; // eslint-disable-line
        // NON-STANDARD options
        const { encoderWorkerFactory: encoderWorkerFactory, OggOpusEncoderWasmPath: OggOpusEncoderWasmPath, WebMOpusEncoderWasmPath: WebMOpusEncoderWasmPath } = workerOptions;
        super();
        // Attributes for the specification conformance. These have their own getters.
        this._stream = stream;
        this._state = "inactive";
        this._mimeType = mimeType || "";
        this._audioBitsPerSecond = audioBitsPerSecond || bitsPerSecond;
        /** @type {'inactive'|'readyToInit'|'encoding'|'closed'} */ this.workerState = "inactive";
        // Parse MIME Type
        if (!$5e0eb040f3eceaa7$var$OpusMediaRecorder.isTypeSupported(this._mimeType)) throw new TypeError("invalid arguments, a MIME Type is not supported");
        switch($5e0eb040f3eceaa7$var$OpusMediaRecorder._parseType(this._mimeType).subtype){
            case "wave":
            case "wav":
                this._mimeType = "audio/wave";
                break;
            case "webm":
                this._mimeType = "audio/webm";
                break;
            case "ogg":
                this._mimeType = "audio/ogg";
                break;
            default:
                // Select a type depending on OS.
                switch($5e0eb040f3eceaa7$var$browser && $5e0eb040f3eceaa7$var$browser.name){
                    case "chrome":
                        this._mimeType = "audio/webm";
                        break;
                    case "firefox":
                        this._mimeType = "audio/ogg";
                        break;
                    case "edge":
                        this._mimeType = "audio/webm";
                        break;
                    case "ios":
                    case "safari":
                        this._mimeType = "audio/wave";
                        break;
                    default:
                        this._mimeType = "audio/webm";
                }
        }
        switch(this._mimeType){
            case "audio/wave":
                this._wasmPath = ""; // wasm is not used
                break;
            case "audio/webm":
                this._wasmPath = WebMOpusEncoderWasmPath || "";
                break;
            case "audio/ogg":
                this._wasmPath = OggOpusEncoderWasmPath || "";
                break;
            default:
                throw new Error(`Internal Error: Unexpected MIME Type: ${this._mimeType}`);
        }
        // Get current directory for worker
        let workerDir = "";
        if (document.currentScript) workerDir = document.currentScript.src;
        else if (self.location) workerDir = self.location.href;
        workerDir = workerDir.substr(0, workerDir.lastIndexOf("/")) + "/encoderWorker.umd.js";
        // If worker function is imported via <script> tag, make it blob to get URL.
        if (typeof $5e0eb040f3eceaa7$var$OpusMediaRecorder.encoderWorker === "function") workerDir = URL.createObjectURL(new Blob([
            `(${$5e0eb040f3eceaa7$var$OpusMediaRecorder.encoderWorker})()`
        ]));
        // Spawn a encoder worker
        this._workerFactory = typeof encoderWorkerFactory === "function" ? encoderWorkerFactory : (_)=>new Worker(workerDir);
        this._spawnWorker();
    }
    /**
   * The MediaStream [GETUSERMEDIA] to be recorded.
   * @return {MediaStream}
   */ get stream() {
        return this._stream;
    }
    /**
   * The MIME type [RFC2046] that has been selected as the container for
   * recording. This entry includes all the parameters to the base
   * mimeType. The UA should be able to play back any of the MIME types
   * it supports for recording. For example, it should be able to display
   * a video recording in the HTML <video> tag. The default value for
   * this property is platform-specific.
   * @return {string}
   */ get mimeType() {
        return this._mimeType;
    }
    /**
   * The current state of the OpusMediaRecorder object. When the OpusMediaRecorder
   * is created, the UA MUST set this attribute to inactive.
   * @return {"inactive"|"recording"|"paused"}
   */ get state() {
        return this._state;
    }
    /**
   * The value of the Video encoding. Unsupported.
   * @return {undefined}
   */ get videoBitsPerSecond() {
        // Video encoding is not supported
        return undefined;
    }
    /**
   * The value of the Audio encoding target bit rate that was passed to
   * the Platform (potentially truncated, rounded, etc), or the calculated one
   * if the user has specified bitsPerSecond.
   * @return {number|undefined}
   */ get audioBitsPerSecond() {
        return this._audioBitsPerSecond;
    }
    /**
   * Initialize worker
   */ _spawnWorker() {
        this.worker = this._workerFactory();
        this.worker.onmessage = (e)=>this._onmessageFromWorker(e);
        this.worker.onerror = (e)=>this._onerrorFromWorker(e);
        this._postMessageToWorker("loadEncoder", {
            mimeType: this._mimeType,
            wasmPath: this._wasmPath
        });
    }
    /**
   * Post message to the encoder web worker.
   * @param {"init"|"pushInputData"|"getEncodedData"|"done"} command - Type of message to send to the worker
   * @param {object} message - Payload to the worker
   */ _postMessageToWorker(command, message = {}) {
        switch(command){
            case "loadEncoder":
                let { mimeType: mimeType, wasmPath: wasmPath } = message;
                this.worker.postMessage({
                    command: command,
                    mimeType: mimeType,
                    wasmPath: wasmPath
                });
                break;
            case "init":
                // Initialize the worker
                let { sampleRate: sampleRate, channelCount: channelCount, bitsPerSecond: bitsPerSecond } = message;
                this.worker.postMessage({
                    command: command,
                    sampleRate: sampleRate,
                    channelCount: channelCount,
                    bitsPerSecond: bitsPerSecond
                });
                this.workerState = "encoding";
                // Start streaming
                this.source.connect(this.processor);
                this.processor.connect(this.context.destination);
                let eventToPush = new $parcel$global.Event("start");
                this.dispatchEvent(eventToPush);
                break;
            case "pushInputData":
                // Pass input audio buffer to the encoder to encode.
                // The worker MAY trigger 'encodedData'.
                let { channelBuffers: channelBuffers, length: length, duration: duration } = message;
                this.worker.postMessage({
                    command: command,
                    channelBuffers: channelBuffers,
                    length: length,
                    duration: duration
                });
                break;
            case "getEncodedData":
                // Request encoded result.
                // Expected 'encodedData' event from the worker
                this.worker.postMessage({
                    command: command
                });
                break;
            case "done":
                // Tell encoder finallize the job and destory itself.
                // Expected 'lastEncodedData' event from the worker.
                this.worker.postMessage({
                    command: command
                });
                break;
            default:
                // This is an error case
                throw new Error("Internal Error: Incorrect postMessage requested.");
        }
    }
    /**
   * onmessage() callback from the worker.
   * @param {message} event - message from the worker
   */ _onmessageFromWorker(event) {
        const { command: command, buffers: buffers } = event.data;
        let eventToPush;
        switch(command){
            case "readyToInit":
                const { sampleRate: sampleRate, channelCount: channelCount } = this;
                this.workerState = "readyToInit";
                // If start() is already called initialize worker
                if (this.state === "recording") this._postMessageToWorker("init", {
                    sampleRate: sampleRate,
                    channelCount: channelCount,
                    bitsPerSecond: this.audioBitsPerSecond
                });
                break;
            case "encodedData":
            case "lastEncodedData":
                let data = new Blob(buffers, {
                    "type": this._mimeType
                });
                eventToPush = new $parcel$global.Event("dataavailable");
                eventToPush.data = data;
                this.dispatchEvent(eventToPush);
                // Detect of stop() called before
                if (command === "lastEncodedData") {
                    eventToPush = new $parcel$global.Event("stop");
                    this.dispatchEvent(eventToPush);
                    this.workerState = "closed";
                }
                break;
            default:
                break; // Ignore
        }
    }
    /**
   * onerror() callback from the worker.
   * @param {ErrorEvent} error - error object from the worker
   */ _onerrorFromWorker(error) {
        // Stop stream first
        this.source.disconnect();
        this.processor.disconnect();
        this.worker.terminate();
        this.workerState = "closed";
        // Send message to host
        let message = [
            "FileName: " + error.filename,
            "LineNumber: " + error.lineno,
            "Message: " + error.message
        ].join(" - ");
        let errorToPush = new $parcel$global.Event("error");
        errorToPush.name = "UnknownError";
        errorToPush.message = message;
        this.dispatchEvent(errorToPush);
    }
    /**
   * Enable onaudioprocess() callback.
   * @param {number} timeslice - In seconds. OpusMediaRecorder should request data
   *                              from the worker every timeslice seconds.
   */ _enableAudioProcessCallback(timeslice) {
        // pass frame buffers to the worker
        let elapsedTime = 0;
        this.processor.onaudioprocess = (e)=>{
            const { inputBuffer: inputBuffer, playbackTime: playbackTime } = e; // eslint-disable-line
            const { sampleRate: sampleRate, length: length, duration: duration, numberOfChannels: numberOfChannels } = inputBuffer; // eslint-disable-line
            // Create channel buffers to pass to the worker
            const channelBuffers = new Array(numberOfChannels);
            for(let i = 0; i < numberOfChannels; i++)channelBuffers[i] = inputBuffer.getChannelData(i);
            // Pass data to the worker
            const message = {
                channelBuffers: channelBuffers,
                length: length,
                duration: duration
            };
            this._postMessageToWorker("pushInputData", message);
            // Calculate time
            elapsedTime += duration;
            if (elapsedTime >= timeslice) {
                this._postMessageToWorker("getEncodedData");
                elapsedTime = 0;
            }
        };
    }
    /**
   * Begins recording media; this method can optionally be passed a timeslice
   * argument with a value in milliseconds.
   * @param {number} timeslice - If this is specified, the media will be captured
   *        in separate chunks of that duration, rather than the default behavior
   *        of recording the media in a single large chunk. In other words, an
   *        undefined value of timeslice will be understood as the largest long value.
   */ start(timeslice = Number.MAX_SAFE_INTEGER) {
        if (this.state !== "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must be inactive.");
        if (timeslice < 0) throw new TypeError("invalid arguments, timeslice should be 0 or higher.");
        timeslice /= 1000; // Convert milliseconds to seconds
        // Check worker is closed (usually by stop()) and init.
        if (this.workerState === "closed") this._spawnWorker();
        // Get channel count and sampling rate
        // channelCount: https://www.w3.org/TR/mediacapture-streams/#media-track-settings
        // sampleRate: https://developer.mozilla.org/en-US/docs/Web/API/BaseAudioContext/sampleRate
        this.context = new $5e0eb040f3eceaa7$var$AudioContext();
        let tracks = this.stream.getAudioTracks();
        if (!tracks[0]) throw new Error("DOMException: UnkownError, media track not found.");
        this.channelCount = tracks[0].getSettings().channelCount || 1;
        this.sampleRate = this.context.sampleRate;
        /** @type {MediaStreamAudioSourceNode} */ this.source = this.context.createMediaStreamSource(this.stream);
        /** @type {ScriptProcessorNode} */ this.processor = this.context.createScriptProcessor($5e0eb040f3eceaa7$var$BUFFER_SIZE, this.channelCount, this.channelCount);
        // Start recording
        this._state = "recording";
        this._enableAudioProcessCallback(timeslice);
        // If the worker is already loaded then start
        if (this.workerState === "readyToInit") {
            const { sampleRate: sampleRate, channelCount: channelCount } = this;
            this._postMessageToWorker("init", {
                sampleRate: sampleRate,
                channelCount: channelCount,
                bitsPerSecond: this.audioBitsPerSecond
            });
        }
    }
    /**
   * Stops recording, at which point a dataavailable event containing
   * the final Blob of saved data is fired. No more recording occurs.
   */ stop() {
        if (this.state === "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must NOT be inactive.");
        // Stop stream first
        this.source.disconnect();
        this.processor.disconnect();
        this.context.close();
        // Stop event will be triggered at _onmessageFromWorker(),
        this._postMessageToWorker("done");
        this._state = "inactive";
    }
    /**
   * Pauses the recording of media.
   */ pause() {
        if (this.state === "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must NOT be inactive.");
        // Stop stream first
        this.source.disconnect();
        this.processor.disconnect();
        let event = new $parcel$global.Event("pause");
        this.dispatchEvent(event);
        this._state = "paused";
    }
    /**
   * Resumes recording of media after having been paused.
   */ resume() {
        if (this.state === "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must NOT be inactive.");
        // Restart streaming data
        this.source.connect(this.processor);
        this.processor.connect(this.context.destination);
        let event = new $parcel$global.Event("resume");
        this.dispatchEvent(event);
        this._state = "recording";
    }
    /**
   * Requests a Blob containing the saved data received thus far (or since
   * the last time requestData() was called. After calling this method,
   * recording continues, but in a new Blob.
   */ requestData() {
        if (this.state === "inactive") throw new Error("DOMException: INVALID_STATE_ERR, state must NOT be inactive.");
        // dataavailable event will be triggerd at _onmessageFromWorker()
        this._postMessageToWorker("getEncodedData");
    }
    /**
   * Returns a Boolean value indicating if the given MIME type is supported
   * by the current user agent .
   * @param {string} typeType - A MIME Type, including parameters when needed,
   *          specifying a container and/or codec formats for recording.
   * @return {boolean}
   */ static isTypeSupported(mimeType) {
        // See: https://w3c.github.io/mediacapture-record/#dom-mediarecorder-istypesupported
        // 1. If empty string, return true.
        if (typeof mimeType === "string" && !mimeType) return true;
        try {
            var { type: type, subtype: subtype, codec: codec } = $5e0eb040f3eceaa7$var$OpusMediaRecorder._parseType(mimeType);
        } catch (error) {
            // 2. If not a valid string, return false.
            return false;
        }
        if (type !== "audio" || !(subtype === "ogg" || subtype === "webm" || subtype === "wave" || subtype === "wav")) // 3,4. If type and subtype are unsupported the return false.
        return false;
        // 5. If codec is unsupported then return false.
        // 6. If the specified combination of all is not supported than return false.
        switch(subtype){
            case "ogg":
                if (codec !== "opus" && codec) return false;
                break;
            case "webm":
                if (codec !== "opus" && codec) return false;
                break;
            case "wave":
            case "wav":
                if (codec) return false; // Currently only supports signed 16 bits
                break;
        }
        // 7. return true.
        return true;
    }
    /**
   * Parse MIME. A helper function for isTypeSupported() and etc.
   * @param {string} mimeType - typeType - A MIME Type, including parameters when needed,
   *          specifying a container and/or codec formats for recording.
   * @return {?object} - An object with type, subtype, codec attributes
   *          if parsed correctly. null is returned if parsing failed.
   *          If mimeType is an empty string then return an object with attributes
   *          are empty strings
   */ static _parseType(mimeType) {
        try {
            const regex = /^(\w+)\/(\w+)(;\s*codecs=(\w+))?$/;
            var [, type, subtype, , codec] = mimeType.match(regex);
        } catch (error) {
            if (typeof mimeType === "string" && !mimeType) return {
                type: "",
                subtype: "",
                codec: ""
            };
            return null;
        }
        return {
            type: type,
            subtype: subtype,
            codec: codec
        };
    }
}
// EventHandler attributes.
// This code is a non-standard EventTarget but required by event-target-shim.
[
    "start",
    "stop",
    "dataavailable",
    /* Called to handle the dataavailable event. The Blob of
                        recorded data is contained in this event and can be
                        accessed via its data attribute. */ "pause",
    "resume",
    "error" // Called to handle a MediaRecorderErrorEvent.
].forEach((name)=>$5e0eb040f3eceaa7$require$defineEventAttribute($5e0eb040f3eceaa7$var$OpusMediaRecorder.prototype, name));
// MS Edge specific monkey patching:
// onaudioprocess callback cannot be triggered more than twice when postMessage
// uses the seconde transfer argument. So disable the transfer argument only in Edge.
if ($5e0eb040f3eceaa7$var$browser && $5e0eb040f3eceaa7$var$browser.name === "edge") (function() {
    var original = Worker.prototype.postMessage;
    Worker.prototype.postMessage = function(message, transfer = null) {
        original.apply(this, [
            message
        ]);
    };
})();
$5e0eb040f3eceaa7$exports = $5e0eb040f3eceaa7$var$OpusMediaRecorder;


var $815844dde2cfbfb2$exports = {};
const $815844dde2cfbfb2$var$logs = document.querySelector(".logs");
$815844dde2cfbfb2$exports = {
    log: (message)=>{
        console.log(message);
        const log = document.createElement("div");
        log.classList.add("log");
        log.innerText = message;
        $815844dde2cfbfb2$var$logs.prepend(log);
    },
    error: (message)=>{
        console.error(message);
        const log = document.createElement("div");
        log.classList.add("log");
        log.classList.add("error");
        log.innerText = message;
        $815844dde2cfbfb2$var$logs.prepend(log);
    },
    warning: (message)=>{
        console.error(message);
        const log = document.createElement("div");
        log.classList.add("log");
        log.classList.add("warning");
        log.innerText = message;
        $815844dde2cfbfb2$var$logs.prepend(log);
    }
};


var $999f9709ad6a83f8$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $999f9709ad6a83f8$var$url = new URL("encoderWorker.umd.22eb93c3.js", import.meta.url);
$999f9709ad6a83f8$exports = $56b621a6dd25b2cb$exports($999f9709ad6a83f8$var$url.toString(), $999f9709ad6a83f8$var$url.origin, true);


var $5cc1452d1d161c2f$exports = {};
$5cc1452d1d161c2f$exports = new URL("gate-processor.e3df5e68.js", import.meta.url).toString();


$c53890eb3e021adc$exports = (options = {})=>{
    const rawMode = options.raw || false;
    const recorder = {
        _events: new $5440e9199a418654$exports(),
        _mediaRecorder: undefined,
        _stream: undefined,
        _micStream: undefined,
        _recCtx: undefined,
        getMediaRecorder: (stream)=>{
            if (window.MediaRecorder && window.MediaRecorder.isTypeSupported("audio/ogg; codecs=opus")) {
                $815844dde2cfbfb2$exports.log("Using native MediaRecorder (ogg/opus)");
                return new window.MediaRecorder(stream, {
                    mimeType: "audio/ogg; codecs=opus"
                });
            }
            // Log supported formats for debugging
            if (window.MediaRecorder) {
                const formats = [
                    "audio/webm",
                    "audio/webm;codecs=opus",
                    "audio/mp4",
                    "audio/ogg"
                ];
                const supported = formats.filter((f)=>window.MediaRecorder.isTypeSupported(f));
                console.log("Supported formats:", supported);
            }
            $815844dde2cfbfb2$exports.warning("Using OpusMediaRecorder polyfill - for best experience, use Firefox");
            const workerOptions = {
                encoderWorkerFactory: function() {
                    return new Worker($999f9709ad6a83f8$exports);
                },
                OggOpusEncoderWasmPath: "https://cdn.jsdelivr.net/npm/opus-media-recorder@latest/OggOpusEncoder.wasm",
                WebMOpusEncoderWasmPath: "https://cdn.jsdelivr.net/npm/opus-media-recorder@latest/WebMOpusEncoder.wasm"
            };
            return new $5e0eb040f3eceaa7$exports(stream, {
                mimeType: "audio/ogg; codecs=opus"
            }, workerOptions);
        },
        getLocalStream: ()=>{
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                $815844dde2cfbfb2$exports.error("Microphone not supported");
                return Promise.reject(new Error("mediaDevices not supported"));
            }
            const requestStream = ()=>navigator.mediaDevices.getUserMedia({
                    video: false,
                    audio: {
                        channelCount: 1,
                        sampleRate: 24000,
                        noiseSuppression: true,
                        echoCancellation: true,
                        autoGainControl: true,
                        voiceIsolation: true
                    }
                }).then((stream)=>{
                    const track = stream.getAudioTracks()[0];
                    const settings = track.getSettings();
                    const micSampleRate = settings.sampleRate || 48000;
                    $815844dde2cfbfb2$exports.log(`Audio: ${micSampleRate}Hz, ${settings.channelCount || "?"}ch`);
                    const features = [
                        settings.noiseSuppression ? "Noise Suppression" : null,
                        settings.echoCancellation ? "Echo Cancellation" : null,
                        settings.autoGainControl ? "Auto Gain" : null,
                        settings.voiceIsolation ? "Voice Isolation" : null
                    ].filter(Boolean);
                    $815844dde2cfbfb2$exports.log(`Features: ${features.length ? features.join(", ") : "none"}`);
                    // Use mic's sample rate - Firefox doesn't allow mismatched rates
                    const recCtx = new (window.AudioContext || window.webkitAudioContext)({
                        sampleRate: micSampleRate
                    });
                    recorder._recCtx = recCtx;
                    // Raw mode: bypass all DSP
                    if (rawMode) {
                        $815844dde2cfbfb2$exports.log("Raw mode: DSP bypassed");
                        recorder._micStream = stream;
                        return Promise.resolve(stream);
                    }
                    // Audio chain: source → bandpass → gate → compressor → gain → output
                    const source = recCtx.createMediaStreamSource(stream);
                    // Bandpass filter (300-3400Hz voice band)
                    const highpass = recCtx.createBiquadFilter();
                    highpass.type = "highpass";
                    highpass.frequency.value = 300;
                    const lowpass = recCtx.createBiquadFilter();
                    lowpass.type = "lowpass";
                    lowpass.frequency.value = 3400;
                    const compressor = recCtx.createDynamicsCompressor();
                    compressor.threshold.value = -50;
                    compressor.knee.value = 6;
                    compressor.ratio.value = 20;
                    compressor.attack.value = 0.001;
                    compressor.release.value = 0.1;
                    // Makeup gain to boost compressed signal back up
                    const makeupGain = recCtx.createGain();
                    makeupGain.gain.value = 10; // ~20dB boost
                    const destination = recCtx.createMediaStreamDestination();
                    // Try to add noise gate (requires AudioWorklet support)
                    return recCtx.audioWorklet.addModule(new URL($5cc1452d1d161c2f$exports)).then(()=>{
                        const gate = new AudioWorkletNode(recCtx, "gate-processor");
                        source.connect(highpass);
                        highpass.connect(lowpass);
                        lowpass.connect(gate);
                        gate.connect(compressor);
                        compressor.connect(makeupGain);
                        makeupGain.connect(destination);
                        $815844dde2cfbfb2$exports.log("Noise gate enabled");
                        return destination.stream;
                    }).catch((err)=>{
                        // Fallback: no gate
                        console.warn("AudioWorklet not supported, skipping noise gate:", err);
                        source.connect(highpass);
                        highpass.connect(lowpass);
                        lowpass.connect(compressor);
                        compressor.connect(makeupGain);
                        makeupGain.connect(destination);
                        return destination.stream;
                    }).finally(()=>{
                        // Store original stream for cleanup
                        recorder._micStream = stream;
                    });
                });
            return requestStream().catch((err)=>{
                $815844dde2cfbfb2$exports.warning("Retrying microphone access...");
                return requestStream();
            }).catch((err)=>{
                console.error(`you got an error: ${err}`);
                $815844dde2cfbfb2$exports.error("Microphone access failed");
            });
        },
        record: ()=>{
            return recorder.getLocalStream().then((stream)=>{
                return new Promise((resolve)=>{
                    const mediaRecorder = recorder.getMediaRecorder(stream);
                    mediaRecorder.onerror = (e)=>{
                        const errorDetails = e.error ? `${e.error.name}: ${e.error.message}` : JSON.stringify(e);
                        $815844dde2cfbfb2$exports.error(`MediaRecorder error: ${errorDetails}`);
                        console.error("MediaRecorder error event:", e);
                    };
                    mediaRecorder.onstart = ()=>{
                        resolve();
                    };
                    mediaRecorder.ondataavailable = (e)=>{
                        if (e.data.size === 0) return;
                        recorder._events.emit("samples", e.data);
                    };
                    recorder._mediaRecorder = mediaRecorder;
                    recorder._stream = stream;
                    mediaRecorder.start(10);
                });
            });
        },
        stop: ()=>{
            if (recorder._mediaRecorder && recorder._mediaRecorder.state === "recording") {
                recorder._mediaRecorder.stop();
                recorder._stream.getTracks().forEach(function(track) {
                    track.stop();
                });
                // Also stop original mic stream
                if (recorder._micStream) recorder._micStream.getTracks().forEach(function(track) {
                    track.stop();
                });
                // Close recording AudioContext
                if (recorder._recCtx) recorder._recCtx.close();
            }
        },
        on: (...args)=>{
            return recorder._events.on(...args);
        }
    };
    return recorder;
};


var $00583c9794cbe277$exports = {};

var $9l3Lt = parcelRequire("9l3Lt");

var $9l3Lt = parcelRequire("9l3Lt");
/* **************************************************
 * This file is auto-generated during the build process.
 * Any edits to this file will be overwritten.
 ****************************************************/ function $42da1043ef19c7aa$export$2e2bcd8739ae039(WASMAudioDecoderCommon) {
    // include: shell_minimal.js
    var Module = Module;
    // Override this function in a --pre-js file to get a signal for when
    // compilation is ready. In that callback, call the function run() to start
    // the program.
    function ready() {}
    // --pre-jses are emitted after the Module integration code, so that they can
    // refer to Module (if they choose; they can also define Module)
    // include: src/opus-decoder/src/emscripten-pre.js
    Module = {};
    // end include: src/opus-decoder/src/emscripten-pre.js
    // end include: shell_minimal.js
    // include: preamble_minimal.js
    /** @param {string|number=} what */ function abort(what) {
        throw what;
    }
    var HEAP8, HEAP16, HEAP32, HEAPU8, HEAPU16, HEAPU32, HEAPF32, HEAPF64, HEAP64, HEAPU64, wasmMemory;
    // include: runtime_shared.js
    // include: runtime_stack_check.js
    // end include: runtime_stack_check.js
    // include: runtime_exceptions.js
    // end include: runtime_exceptions.js
    // include: runtime_debug.js
    // end include: runtime_debug.js
    // include: memoryprofiler.js
    // end include: memoryprofiler.js
    function updateMemoryViews() {
        var b = wasmMemory.buffer;
        HEAP8 = new Int8Array(b);
        HEAP16 = new Int16Array(b);
        HEAPU8 = new Uint8Array(b);
        HEAPU16 = new Uint16Array(b);
        HEAP32 = new Int32Array(b);
        HEAPU32 = new Uint32Array(b);
        HEAPF32 = new Float32Array(b);
        HEAPF64 = new Float64Array(b);
        HEAP64 = new BigInt64Array(b);
        HEAPU64 = new BigUint64Array(b);
    }
    // end include: runtime_shared.js
    // end include: preamble_minimal.js
    // Begin JS library code
    /** @noinline */ var base64Decode = (b64)=>{
        var b1, b2, i = 0, j = 0, bLength = b64.length;
        var output = new Uint8Array((bLength * 3 >> 2) - (b64[bLength - 2] == "=") - (b64[bLength - 1] == "="));
        for(; i < bLength; i += 4, j += 3){
            b1 = base64ReverseLookup[b64.charCodeAt(i + 1)];
            b2 = base64ReverseLookup[b64.charCodeAt(i + 2)];
            output[j] = base64ReverseLookup[b64.charCodeAt(i)] << 2 | b1 >> 4;
            output[j + 1] = b1 << 4 | b2 >> 2;
            output[j + 2] = b2 << 6 | base64ReverseLookup[b64.charCodeAt(i + 3)];
        }
        return output;
    };
    var __abort_js = ()=>abort("");
    var __emscripten_runtime_keepalive_clear = ()=>{};
    var timers = {};
    var callUserCallback = (func)=>func();
    var _emscripten_get_now = ()=>performance.now();
    var __setitimer_js = (which, timeout_ms)=>{
        // First, clear any existing timer.
        if (timers[which]) {
            clearTimeout(timers[which].id);
            delete timers[which];
        }
        // A timeout of zero simply cancels the current timeout so we have nothing
        // more to do.
        if (!timeout_ms) return 0;
        var id = setTimeout(()=>{
            delete timers[which];
            callUserCallback(()=>__emscripten_timeout(which, _emscripten_get_now()));
        }, timeout_ms);
        timers[which] = {
            id: id,
            timeout_ms: timeout_ms
        };
        return 0;
    };
    var _emscripten_math_cos = Math.cos;
    var _emscripten_resize_heap = (requestedSize)=>{
        var oldSize = HEAPU8.length;
        // With CAN_ADDRESS_2GB or MEMORY64, pointers are already unsigned.
        requestedSize >>>= 0;
        return false;
    };
    var _proc_exit = (code)=>{
        throw `exit(${code})`;
    };
    // Precreate a reverse lookup table from chars
    // "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" back to
    // bytes to make decoding fast.
    for(var base64ReverseLookup = new Uint8Array(123), i = 25; i >= 0; --i){
        base64ReverseLookup[48 + i] = 52 + i;
        // '0-9'
        base64ReverseLookup[65 + i] = i;
        // 'A-Z'
        base64ReverseLookup[97 + i] = 26 + i;
    }
    base64ReverseLookup[43] = 62;
    // '+'
    base64ReverseLookup[47] = 63;
    var wasmImports = {
        /** @export */ "d": __abort_js,
        /** @export */ "c": __emscripten_runtime_keepalive_clear,
        /** @export */ "e": __setitimer_js,
        /** @export */ "a": _emscripten_math_cos,
        /** @export */ "f": _emscripten_resize_heap,
        /** @export */ "b": _proc_exit
    };
    function assignWasmExports(wasmExports) {
        _opus_frame_decoder_create = wasmExports["i"];
        _malloc = wasmExports["j"];
        _opus_frame_decode_float_deinterleaved = wasmExports["k"];
        _opus_frame_decoder_destroy = wasmExports["l"];
        _free = wasmExports["m"];
        __emscripten_timeout = wasmExports["o"];
    }
    var _opus_frame_decoder_create, _malloc, _opus_frame_decode_float_deinterleaved, _opus_frame_decoder_destroy, _free, __emscripten_timeout;
    // include: postamble_minimal.js
    // === Auto-generated postamble setup entry stuff ===
    function initRuntime(wasmExports) {
        // No ATINITS hooks
        wasmExports["h"]();
    }
    // Initialize wasm (asynchronous)
    if (!$42da1043ef19c7aa$export$2e2bcd8739ae039.wasm) Object.defineProperty($42da1043ef19c7aa$export$2e2bcd8739ae039, "wasm", {
        get: ()=>String.raw`dynEncode013bc58350c1Éð|@|O*XØ3R}@³ùÆöÁ¤½Cu­ÙFõ¶=}VònÐ¾ÑX³W~aGÕ5?Q= ÚÎN= WeÇ¸ß3í=MÛßÇ¹HÜjLvïêÀ:m°¹30>ÉX!¿býOýn
®Fj{øú¢ç=}(ÝñÜn moÇ°¥àeò?È×µh
ØW¨;Ñ aØX­æU{¤øàÖÕÀì·ÝÌ­íø±tâÔøeVO÷PÉ´È~ÃòsX1´ÊPyK·ÿKZçµ WÑ¡¡_ dÍí+]Õ~%Yïþîñ ¾Ú·p[òß ¶ó÷ylhnn«²ù*¶Ìéñ®ï(éÇÃRÊÆRÌ-¬ÐoÒÊ2z+ä$:ÄsxÏ#Ït!MlBq§%Jè	®Ä 3ó°á¸eÅ_Ö=}iTÐÍmoðbMpl¬EP°e,¼Æju®ix>#}NgdÿÇÄbç9WZÇ·n\Öá1ÚÈt.ú6bì:ûào¯ú4Ïø  ü­zå¯#ÆkM#úÿ9ë:üÒÝëÚà¡d%0ÒekÓ×mðÆ¸½ùÿâ¿Ò9	ÄgªÕÂ%ü¸»	HÁM#Âq²~èn¯Ûa_9j= ùÿRèæÊó%M
¨,Àæq%98a9% T2)´z«9gsÒÖ!ZhRõRÛyÕ²Ý=M<Öcº	»~VFÕÖx:þrÞðn£x¦8.è$K9þÂ¹úSnÍ3¦v üuºsÕñ=}1=M5ZÊ¦CÿSÉ2×qÒ««Sa»ù±(¢º]ÀmÍh÷ /¥3@sns2	%7ù-Q|nÏoöjYÛ]}à2{EBêÎ6>ÁbÄü
á,	[DAÐuùjeNDEëÔàZºlq» J/Ë²ájºßCÃÝ1b)øtN7Ê=}gÕ®òÍá§8² kDïû¤åÒÅóºc=M²= aË.ooèf.QZj@bñ>qV©?æxñRô|_xwê¸÷È¡ö"C¶2[¼ï¯¸©KmäºúZ¡%^°bóþ»-¼Ú¥ZI(pþµS%øµã*Ò±8f:t¡éþõz¶<Äfñ*öeP8AÓ¾/g×\Ð¡1Ï"= ¤ûGsW_¹ÔÈX	TãàuTíEKPüÝ¸#åB¢ñ?:µßÄ¬îFI8QY;X ¶í¦k{|¦éíà/fªi>´EÈoK= 6¼lÖr²ÿ*YÇvÄ­dàG{Ö,Gz½.gzSdïV%z¥8¶²bO¡2\nOßV¡S2KçK´UûuÛã~f¾K)ÊÖ#´?#»ÅYXOøò TCB}LUk,kÍ)]íiE^ÿyW)Ê»³= ô1_½úÌÞÊçýS¡
»£jÆkhÐ1G<è^àÙç?æF¦Ç/ã«Eý6ZI¹tl.aëül|!&:MÓå?N@øËÅf 6cì$w,3~17F=Mð¸³°aõu\9æk	 I&>V®Æ/Øa´ %¶¢],ÿ:±wäé¬áS¥FK±U¢±ÓPóß&®e= ÍÍÜ¯Ï×À@= Ø#Ðk[NCó÷ÀÄÞGQRcnI}HGñ\ç­= öè^áygyDÔa©D¦'ß£Mß£PI¯à¨=}=MUÀ¸çy 9W½LíU·ôzwzÃsÝZòÓ3F¸Áè£âÑnÕ%Í¥ká®=M×GTÀÊøfëM-UF;uåÙ#X#
n©ïÖDÅñ¸q ,Ô¹Ð¸;h¿åñ#µNÓ÷¸v} *Îª_= ãýØb6N=MH§'®Iu¯78ªÊÝ#42p´[/¿E= =MxåÄV§Ým©3?;bô9fb÷Ð'¨ÈIS7ñ>¬IÍÜK tçÖJ	7û6ß¥A/|BÏ=Mõªw¿T¼91ó íÒèÔ_6»Âõªvg2ý¡õ÷Ò=}Å3ýXm²¬bÛ}U¬0¸Ük~e
aY¬ÈÛµ¨¢0Nñ¬t³VÉhÖYvx§"Ç5\N'ªÂ£æKlÂ?þ{m¼ôê±ñÔ|Lm¬t_2%¤E}Ù>ÎFûalSXø²tRªÀ8¥£Å|ÖW(Ù)\3Úwåì:oíý±Y4ì©géµC³¨Q\ÍõMÕ
!J½6ë:Ëg ípoÒ=}I=}ëS¯¸F=}ÙT__U¾&\íÛ ¼Âkg#úÚ¡ÀsÏÔTµ³ÑËßxNÉæGç^4Ñ¡%.¦U±O[ø¼4 pÍº7ÜâªcÔ¦¢:ou¹8ÌzîXf¬56DC´Þ]Ó!=MOÀÕâGÖÓ«0¤¿Å2ú
éÎ·NóÚÄr_Z)6y&2^F|#²ì36eòa¦rcLõ5Hö<r¼J!í¼©DøÓ@¨åPóf Ñ£®·§hQ®õ½c±M¥W,ÝàÜ««¿¢Vmù|	Ë·wj$témè±°&í9yòµfæuC:E@[RX\.qéuDýé(iao»]W5?I!z®¡±âàkËý¼LóFµUM¨cEu¼üÃFÔì<@y´ÜøÆ#y«µàdMå@ÛXüû¼á¾ù[CHºÀ[4ñ5z:ÓàV[BÒ/I!ÕÓÂXj«ýH&o³©sFÍ&-ö«7d\X#>¦yñÜÃMGc~#!Tüt? ªÌ·«á¨É»ÕBms¸Û®0úBjÛ(^ÓÅ®¤ÛF¹Ðma)'¨ë(²ÄÞÍm²¦á¡Bá|%«L¹a\×Ub= -f®¢Ü¢«GÌSÔxÖXcÃÈÄh½4e#"';P	>Rõo;%t ÐC$g%Ä>70* *©cX!C7yôîËtO'j?óíÛµÁûH= IróÛ= kòwiJ]]þßY÷{mûpLÿÊeLA¾À <½åi­WÎ?o©t¡caâB¼iBüÛÚ¯:_îOJ7"\¥^­EPHQ¼Cõ *{ÎÁIÅÅ$ÉVÇbo]XÆs)^H²®wójÔÎE6OÙÿsRÍ¨Eùï¼/²OÉQÿmå«õØÆZa;Ä{ <}¸°Ró=MÖ²ýÜz´|´pµÛá!cïÆ,@zÃT«¶d³åoÙ-KyÁÓ4gß-²ÂxÊØÏ\@q&}eÔÂè\ßÍT1Ï\ kì÷Úwé\ÀÄ~<à¢e«4E¡/«Ä­aõu½=}l°ÃNë/J­å=}ÿ®!.N8Ær)HÖ43¡C3Ôz/N:
Ú7!Z1Þqö)Mî½%"O7^+TÉêaF 8øc2ú%ù3}Ô²dU(³ÍZÅ±£y¤af¿Ï][Hþs·Ù$EpFæt4¦$Vú
í!h ãV53øKéâ=}Nå22Úú"AÃ5£áª6WÕæYôÈ^ AÜÍ)ýYÌúë¾a0= ºvéè:7Mô=MWsE²£²ÇL¿òÞ²Ü³J+= 5æ+,>
¸M÷7jè;/_ý7ãzÈ)D÷·Ç4*È#Ú¹"ó­!z 0	º®µZ*ìx®
R>sÚýP7:Â¯ZZ=MÍW²Dê6Ó^Nq= fÍbN¿VþÒª£;û<cVýîåª6§7dËÃ-²us¶Ò¹%·iÄs4òf N(á¨|õ-yZ$E)¹ï5¶Wí]Q\·1U9:[-zQ¼É7÷/þiÉõ	¿«Ob)Iµñ0
lÁNpÊ¦Ë-+Kfø»
cù@®W¡Y,îuC6ZK¤éÏ²µI=}= óáÔÁ4´-õfÔmõVÛvFÞ Àç*=}éåú6î®£³úÄßy'GD1dÕ±È"x^ù1)DÚ'ö\©^6§ö_³îªZ|¾S= @$^*- 'ªÈÄb7ÎÜt7Z4©ö§ÉUhY{ÓÚh£	±TÞÁÉýÒR7Ë¡t¨<#Ä¨¡@EK7Ïb3Uri)åw=}ø»n#MMuåÛÄ	 ¼ü÷´ÒuâÆ8¯¬»R6I¡WBòîtnP=Má-0óà¤ÕÆ+¯KæÛcâÑG½þÛÀFä7"ATMáu+mø¼?Ó^Ê?Ts÷ÁR7ñ³!åogã	_ËRª«J$¼­nÇ	h ýõgcíÿ·ÅºÊ§~Ì= @<Ûx¿a¥L¦ÃO·òi½ eûÎL~tÞ/'­=M$x@½tZÅYÖ&¼£]6o¹åÛÑvàMfgp£7Ç6ùßkØ5i>9àlÊ >Ð7w)ý;³(JKLª.z7ðfê2jÐ"£.SJ®.çòìV\3(ÎÍ­Êt"´»µ¾¸[
¸8÷Ê+¶AúCñ&ÿøH]÷hly^Îàî®ðgåA6íKÊ7ÒäGo¿:¥G[Åþ¡«a¶GÞ¾!â
=MnB»ªÖ1ÔIZò2»JkëÆwùºÃtª¯xÇ»×ut#jà:æîOÒ6P¿èrñË×ôm2¸ÓJ±*h«koâ}îµ»¯£F÷§÷¸#a®Å.ùÌ/³3Ú9VÏ[³22L[Ó,ö«W&$/UVq*	fÐ;F°®/Ñ¦·qo:SCÚÉ¼ñ|¨íu09é±|Þ'­ÏYÍ. 5Cm;Àúñ=MmW8ÒSM³¦äHmsA^mÞ¢£Â©}oO21*ÒÃÊFbäT~¿P'7ÑDØÖW®äO{Z»AØ;t£82Jb^:®ÇOß­v@r*o:×>·ûxGÌt/ë*F:7ÝÁwd¾º£D´{¢= ´¾3EK·<MÉ¿8ÂìiÔÁ°r6Ö!F{'H§Ü
y¢rÍn(2RæQ{ Û»Ìg{¸ G%~»¥QÜm$BË¡[Ú®jþXè59[ô
âRAÁïywìüwrz)yhX#p¼èt!Â1~^ h6kî^C6}hpB{£Q5x¿ÁoÐ= à £É<ó«¡ìè31ÜÌç±3X~:ÚÂS~«3/÷9ÚJ8Æ~­^\¨ÕÀvÈØýd9zX|ÿ1¨
= S^bÅ]É:×l÷EÜ1= ¦¼Ê
T4ÙCéhåìcÅ»èZ³}!©ð:~^¯ãó*Mï8rÚm}6S3#ùÊ(%òYï¬%a¶¯N½
ïõ­î/Q	½É}I£Û£þ×ÍLtä,QMÊÚ0la; {Z½¥{é¹3§£:Nj´¸ÆbýÖÜÊÝizeµvýEärìY(£Î£Ô¾oþ39hn,9øÚ¯úõyä¿Ôb4q
ÏTÊî·ÑÚQÆï+zy¥0ob;¢Àï­üÕçIòõ[I"îY°âÂp×AÕ	# }êN92Ü'Ú=}Å®Õà¹Xg[9ÿÐ58¿Cke.ÓÏ#êzü=}ÒGkÌ%Æ"èÏ^q±R3
=}*@Å@¹æÛi r·÷Â³¸{Ôd«WÈHÒ=M®Ôææa!RqÄ×óÁá¯SÛ®?Ãëê ¨.ÃW §r+TSóÛ5_µ®cT8_WqPãtå!Wü= ºmµ¬È
Ò+Kq¢¢ãgõ ËÁYbHG@¡yt]NÖ¥¼~0X+ûx85&Bù2×Ûßoç¤A:$'áôÑÀ9º|:ª °­zï:­$Jo¯«ËÜÛ÷àSWîK5´ÁË$fÙÓÂ¨ÃÞ1£L .uïÇ-ê{Â¹/&êÖVÆcí[>£µØ¢ÅµûÈ{-VÊm_°S³òÀmªQ©FlaÞñíÏW¬D©lÑñ)ðss½ÎÿVBt	LªS+¬KB\;ªå'þmd'=}ÈnÊu&þÚ®4Ps±ô°ñZ÷¹(ÌýlÜ*M»N «Ïö:[Õ.lrP½0w¬=Mâ×sWíQx_ó?CA'
ZW-òªi±´¥²ÊMZ§ædÀZÐùõ«óZófÉÑüÔè­\rNÀóV6Á69f~6dOgD	Ð¿o>é#Y¾u?ØÞØ-Ù±¶WEÂ¯=M^ÏèbÈ½qÚäqjr½ZmFïâjÊ4áÃ1XÒ93OÊ´YöcÛj¥[Èñ£@!9+ÿIübFu#PB©
DÑÌYíuÃàÓ+µ"8q1·ìÚ¸óTü-¤¯ïiõæ)êI÷ïÑýÙ¤£.Ð£Û	P¬A-|¸ëu¥ätj ì¬ÔåÔ8O¥	§IØqÍB¨|D8xò)ºmÕCÚßÒj&çþâ&}D#² ½Af9« ÛÐÑWï^Àþ°w4Ì÷ÿäÅ¦ü-yÑïc®Tú÷5YQp'ùÆ×Íçj1vaî@;åQÃÀ~¶´õ|}ñh×ébÔF4\BÂC&ÿé>SB0qç=}¤+«mÜp®¶-[j7ÈÁ­(bC´=}CÑ¼±§ =}Êx±µn!üÍ@je ¾Új¯q!Ró6×üv$2ÐCÿÞ2!ý^oäuÏtmQ»ý)ËgÏ_¦npËvõâ;þª«âÍ×;sbûûoD³auæ³e<=}ÿaSªrýô:kûÜuü>YÃWa³'ÞF{À¼ì ragïÞP-n£íñN¬Xª½Z43<yþ²]¡a®ãK[³'·	h~ÚW6xòv2ß:.Y¢vÐ|°3_+Æ×@8±+p e+©Æû|­Ã\|.	g è+âT%ç#0ÃêÛ|ò4Õ®ü= 6©Q?Ð¾ô=}Vnqæö«ø{ÕÝ­£y"ërkÜn§ÛVKý¯«¼2Ìäí½÷Á_9¸­O$6GÌljÜÁªYý»ï#ç[Þ&0¸5á# p*zÄÉ¦/¦ ßõè{»ú-%Ç.¥	×¾A?Ñ¥m0!{eõR,nÖ° íe .Ë= \pÈÞ=}4½²N\xÏnYÏÁÏ®»Ö½T¡Ðº.^¿èÝÛ.@¸u9¼pÖZ¹ÞÐöxjC%fÚl1	÷þ¬Ñ­qâ|Tí*mc~
4:íd;8Å"7Jî^óðP<ª4ïîrØ¶gc

m©°áÔ ßjf+áÁC®êAªiO!Ðp8!1ÇÒë-Jö9Õp+mz¸K#ôxpGS øQP@c1)Ó	¢_·=}ºøÁ9VÙ£ÞþôbF0C±ózHþ,	ÏÊ?dgºPÙ6	ìÒòÐMþz²ÓR½7d~t¾óÍw¼äN×3lVªk	·6­O@*%1ð®ÐùãÍ¸iæhÔ3é6åº¦ªÐN:A6xðéÝË =}¾\&¿§ß<Í=MS¼Ê¬ü8â÷/Þä:ô*4Äê¯b(çi@ñ¼(|«¥M$.'i3ÖL>\#qkºýþé;3éyM)"N\>'?9.Û6c7síÒÛ)°tU9QA5zòfvèð.+þèÃÐg?»|îb$±)|9äáàgJaJù[ÿh:©rÎxò¼ÿ*­ h5z«ÅØ¶KÚÛ¯èß«Àú½¾]½íDØÙ¼mñx½E¯T£E·*%eúÙ=}å>òGG7Õ.ì(ö,(lÙ³¶°çÿßrê§@óOcZßëÏ/m|Ñ4J­ô-@dbºX­þx.I*çÃ3éÙx9dÚ*zQÙP;Òönk·µ×ú­¤îB@ÇW[3îÉ"­Lhó Y["nÌH8<^ ¬ =}µ«|Í±^·+¤¬Å/3h^Óìçç» *ãöø5a¿3uýñÌ0 |jWp.mÞ.MÉÅw*iìe|î¼ÂSÈÊWÒ£éÜLbé4^&©SÉ«°çnx¨Jg­Ä9°XXî=MñÒ?Ñ¢öN¿= 
AèWÜ õþ5¿¡~ì "3nßÐ×¿â¨Bª3ÎNdÖb(,,âÿé®wä¨Â[ þ4þè|Çaán?C¦°¼è{Üsîb>ûåxmîNúÿZ"Lß+û= ÞßOüwí·¨î®Ü_Rä± \Õì±g?Òst¢ÌcÂÉ,ÊE9<{{ì20Jùl{JDE¯= JõËaÿôÀbàè±Ô¥hV>¡%á:Æ¯îÈ%E3-8ð= öüönÑ[Q_fTpEFc½´ÇÖýc§PÄOOdâ+IÒR%Ï7	¦Ãe¬ô®9¢2Ù*4
EòCñÔ·T¦aG¯a*1HOX®Ï=}J¦¿JæÂ m¯J1«uð¦JJw
ÄtÌñVÔkMqÛÄ=MTÏ&ïÌÒ9}¨ânzìrµ³¤ñæ4lÔ=MÎ7l¾É-¿oÐwàâf¯RìàÅXÿbÃfõÈS$y^x{u=M~ÿõ	K¸x}ÏµRÌ&¸ÿÕ	Læ5;Â¬©Ü¤{³«0{ÿ¹g«êD¾ÓWFäQ ù]±koÊBÖUÁ!ìörH~.LHþwq>nGÂSÕáÁÜ´';§§SÕþïM]Ê"p'­ÚÅÞ«äÕãZöêAè(¦7fa&ÁÜ´§BçoGEñ¡SÕ±üµÁÜ£1;Þ.t±aJöL¥o:]ôáÉÊ"¨ªhì­*GÑ=} 1ÙBW'(ßk{­TÎ¾!ñi2kË¼´wô|&¤Õê·,Ú=M¡oV¡î|8HÔùK$¥J(mËßÝïOís¹Cÿ½au^<ï£Édó/%í²Ýá'_dKÉ;æó} :5­®Ì?9ÈdÒ¯Gúa}{=}¡bG23bØ26Þpâë@QÃÞoÜ«í¸Äî5ß:¶9¹4¨·ó5}A·~¯m¥©ªs{?ÓüôZ3rèzÔUª¬<ur¥}uµmT{~c3!ºù(h$ÙÄ5!8Ýö¨ç½ý½lÇ·ü^VfÉ£i§³væ·3Bm;«­ä³ãVÁ©Òò"³ñëíëß§T¬ý¦CÝHéôtàÔ1¦<¦e¶\qÚ$9­2¦>-oO
!ú)h;qS£Ç@²äÃÔw×Õê99©¯Oñ^á|mæé4´áíiñI¥\¼)±Ù=MÛÈ¦cîõy4~1uh\é=Mòðs=MËhç¬¹Ã§ ¥Ò$IºQfK·|ëpÆ©{Ù3?ñêÑKòV¨ôÿ½ªÝyÎ'¯4oôØäï§cXfy¬q: <|µÿ9$9jÒ[ÙÌc#KHÜL4&g|ÎÝ&°¥ô££Öþ(µØ2u3:¾Jptjb^/X8½Þñ!°.^Î97ÚØ	úÉcDÉP0óï>Ì~y5ïÍ{ÿgµ'Næ¤ö¾+ÙÊîiìüXRjàF1Ïñ*
>>¦s'ÉØð§ãñ¥A<uÍ'XV÷Fd}^ÿÑILÖÓAÅÉL^P?Y©Oð)]i$pÿõ}/Là)[­Øk¹Vìå6ÃÙYï0Iß#³{Ç(ù*1$q?àôb;MìÁÜ´§=}qpGvrH~.Ó½kGòû1G~.pklGöÁÜ´'ukoÂ¤\sñn}} Ì_ÜhùåÌ7oÊ¨»èVÁ!ìà£YV½èTÁ!ìL
kïF1ãËÝ}ôÉFàß2¸½ò¿áW±RÄËÐðãó¾!òýù©
N~%sL¬cv®)iUïJ«]R¸yJr\xÿö\P¸i¯e¿)JßÌÂM§ÈñI
LUz¦
1µØ,5ôq,:
EC0P$Î¸>Âì¥ª+8ÌÀ]RPÄ¼£cÎü´éÿôÚÄî?sÜ$ÿÆSÇDô¸]O yÎ-j¦*<a¬ßÄ±Ô)é)%ÙéTGB>]åC½;DbM_ìOÎOCKà»O cè¸~)½=}4×«Ú¯Ù2=}!÷´âø®&Òsªï6³ªh
¶**8º7¨;Çÿ2Ù»ªõef^n^n^^n^^^y iµÔÙ÷Ä>ÍÒ<.ø²±,À6<
.VRF	é üÏ@¢®gsÖí'UQ×tF	×@¢¼@¢QÜÂûd±ûxªÐ	ÉäH§¸Ú+
ÍuBý*
¬E¤´a#±¯uÌyÊQåÑÏzâØåj¨sPðÉðn± Õ¼£ááH¬óGsz¶5$>àAÆbT§¸ßäÓB÷ûÀË{³á½À5ÍÞæÓ­«Éz5%Úþ±c*|ð)o÷ ·Kôàþÿ~Ùc0>ãvP«A° K8·¡¹ÚªÑÖ·ùgÆwÆÆ®,céuÎæ´ò'ü
ÈeÚð?enojÉGþ±âRÙòõòõ1~%îPozá>zwVÊuR âÞR[¯¥J%ÕS æWT_Ñ7ËWø1*¡=MÀYµ:¥ðZ·üø ¦Âõ3JÂ5ýü¤FüºQÒªÖ êBvQT²ç)Û
%çI¯«ù
õç°|Õ	ïiÛê~b¼ZQ&ûÕN²ùC²(^Äv¥Äëk
§.øÇü
Ð|Q= á&	!I$±bö½Âí9îmÔ ¶IyÖg×!Ä¼i^(¬³óx}5'&¶2ÎgL~à"ÙÏã^ðãD~aíBÄøãS þ<@4¥è»iäb#ïèUÑUhèÏìªL[ÙQ]©â_Hi_¾°Yîµ7vn¶ieÕØÈF³Êå,ètKýKÉýBS&ØÅw»0¤ÈlûÍ¼l£[= ø5»]a8bÈUÎ-,zDÜ«dÏäsQ
¹.Ýõã¡co$'ð§ éÞT-¦æm&Ã±äÄ1ÊÉLC|($àÛCØ³W/¸âÉÇ@âAtVb¸5À
Ý%ËÞËÑ¼jÀß¶ÛN¿2âaä_oÃ'°^ÓåÞpòÏÏýóJHð¨6ñ  â×xà»öX5¯;|J Èº©(SèþÃ³MZìÞ+à#·7¼£W»©6zª ¯w±ÆAHcËæïøÝÈ­ÐF[þ\Wñ£Ò¨Éýóª<D éä;$-=MõmN·çeF³ï²½öaÎ­X´.&ICÃ~üK NßÚÉXKèa2C[ñëÇY³ÌøöµÀvÞÿRë>SJ®sºîÜwûöHÞ [8Y/£ä2Ï¾Ör÷2ûFI÷@+óWg#7,åûd¨×ÞyµOÊ wë¾B-~ö×/X3Íè|êÊ¹"Ê.A	¦óöDYêÖD J»5èI0*U»}:]\X]*»>Béúûücv= }#å
âËª27,7]òÛ¼ìñýWÅ8'¼êe~»7¿ªFËruÃâWë	Ä«=M= ÄÏÓXIóoN8->Y/~6H_­Ð¥Ä	¬ª¢c]d)Málúr57§k~¼÷aÃÍL}WE;ÄÛG~Mêæ¦·Å'D^ñ<zJµ,ÂÅ8ùÈ©^Î¶Ëõihê?´à¿åh÷÷D3Ô2ëhð"èç°í½0°§Ä ëPHà:Yjuû])²®ØXÞÉç]Üiù±Zp}ZL¾r
Iñ>ßv¼>O¡W}kbêîô¡AIØ²uïÖãíå¢Úpv¿!_ÿA¬¡!òË51@B¯~¨QÂQ¦G<ÜclHôµÓÊ¶=}©T¬3*ÂDà"ÃsI&=Mî¦ª p"EéjÊ;ÑÂ}¾¯,¶.Þ¦òò¸C!^kLØJ.Ð%~Á:Ê¹:xJ'wµ+z³TÊ%	Â+6zjx¯4ÂgU¯¬ç¨ÀZdútÚ=M¯^U¦rNPÔæO£EîÖ÷i§Â*ÄZþ^í¿Þ£|þÁ|:y&{6g(<«K-Y®ûðz©m-zQD¢ÄÃÅls(Ù$ÅK-ë3Îe´Ô j-¼µËüÍTITÐ)¡âZWäV­ëã>Ûß#ÜÆo3<= 2Ó£¬è	ZtFtLüªó#Å	Ct-é>¯¤Ë$¿ªBex ¦£õÌ!Ég©åÃ¯ÍB~Å4¬}­ÊÕåÄÑc©þ{¢ÆTêU!Ò,Ph}ä~ôçéU©h½Ð=}_0©ïþFn£k¨ÓýVFéýïc=Máv-÷Vn= v¹ÅgÍ¸^*5Ý$¯rÜÞRÄK&ÊfíåÃKÈÄA¦ò¯9iië:Ù0´ .V f$= ¥í. òùØËMIÆ«¦Ëý0ËõW6õ	8I¹]&kóNgì3Û¶M²«hc.ùN= TF%É1=}Ô;ñ_Öº6@Z² îë¤pò6]©rcºa¼o2ç¶á¡YçdDÌ±H×6íãí/f¹°Ö#Í¹G=}Ë¬Q°Åwõ ùYY$waì ÿ¿³Ä§ß³º¸xù4ÐøÒ¯)Ãé*-±øÐVöFÃ©ñ#ðj^´¬N Ã{þ0ø´-vHDå)LN¡ñ2¿ÇIÜªZ{Ñ ë:B6ßè>Ø=}ðaÃcJ-Á_ëâÀïþÇðÃ¯ð^¿åN]ÆX¦-Ô¼^&¢j~óFÅÜSÕß¼l bR»BØöÂÍ^<p$k(kCÚç§=d{()ÌJýv\ e*XÉ!¢)XÂ[¿ëö Êü¢JãÛW=}±«öuÃ¯^TÔâ«9¹O$ßÖY°LtZØ= qåN2UÔ}îÓÆ¯¼ÉÃ mÉM1g%²½£hÅq]÷hÂÂ¨oÊ$¼e>B¥]e^Ñ'QÿL= ó¤J¨yÉ õ<ÛJDáhG ³d[bñz-wWªxýÙcöcÎPÆx|«AXÚÎÉRLæ3cÁ+ôä\0Wyâ?î@·aº3z ¦ÅÁp³=}"	 Ë=  L0¨ÝK¶Úõpi¬Y{¸#ø³[¯zãBw¿øØ"å³ò(mpß³=MI-Ûp´69¬°Âe<JíªíXy¶)kô0¦8»ýmIó%SÑ'Ov³]ó§S|M	òs z	
ËÁ..#ç¬A<ð<£ãOà'Ü\ò§"ùxÓh*ÅPC~
Òá(a?-ÍJtUÿU?=}ó
lÖöa­ß.Êl.f#þxñü÷D²WdÀTæ7ÔÁ'r¬Yï6£ëö&©ðÎ'ìÎð9(G©òä:·kãúñêUàs±=}àÛ¢Ud¸!;PN4RÝõ EKå¦í¥ë iuõ½ïÕ©?sx&ÌËjï=MÍè£Ï zÞ|\Ùâü%Ó§¿Ííà±Ço³×Op{vµ²Ä=}Å/Q£Ig&[UèY}oòÄ©.¥>½öÔ½ÃdRN:Î]åj­W'ÃYÒàßEqJòuJtBédIvRñyÂÖe?íb{ælWÆû°uÙ3-ÇQîfSÿK²sÉÃ$mm!¼MTª(·Û-Cß?-\HXÚ=M\é¤JÜô¦5ta,}Z±Í¨JÃÑX¢¨ÀÌÝÈFk@ª)ÄK®YvÄ}<h%&³ÀCn¶ØEß#êöp»n¬ÉäNÓ²WA>t@f½loso{'òÉÎ·øðÂ§Å¶=}ÊûNJ%ú/%:pû¹=}'µ»K'@'! åj1l?3XF<·Úå¯nûÜ¹jAÎFë »è®ò;1û Ç÷k{óvîæu{°q±ûL WùXöñKnî¥©ìM¼0ügUi©X²{¶vÒüËuÜ| XkÛÆmø÷af?÷°ªBé¶@G#fç¶ÛêHßQ¨õÒ±Ëà¤à0§H¿ÊÑÌç* WyTf|éw¼½2=}®
 ÅÃÔn­VãoM+¨±fZò|ws´+çÄ6Kd3JÊl¯Éf¯}ïÄ^Ì¸¸8'Ãx[V ¦õÉ&+Ó\ÚÜ]©ÃIÄ^©u]3v'?êIÁpSymÒÙQ#Â7sæ¿¿ÕÞýèIt£1ªÔ=}Xàv$Õn¬Æþç-µ,Qñ*À·7wÊ¾äû¤z°á×K¬¿ÐtÝpWÌÄÌÂT óBGJ¦XÄÐÃkÜ^étpï 3·Mêo¤"Æ»(­Ä~jr¦æàè¨GñNß(1.©iõË=M©ÁuµSKù¹ãÝÐ ~ä¹s;©êÑ¤ rw¶O«m¾ùéÜ¡­Ú¢ÒÌ'"°3³ÿM{v*W¸¶]¿ÿôèxBÖÛO ï= ;n¹Îf;7:ÝÇ1½cÞ¾¼W+Ã3¸)ÿRHñ¢ÞÙô¢¨çt[¥Æa£hìl, ~ËäÔ
7ª=Mû-ÅàêÒxýað!gGÃÿ³Ë_½)ýÚÅÜ %#ay!WÔxÀÀÝåTíÏ¤¹®ø;(gU¥´(ØMÈ²:gªýü(Ï0BÝc×éË@¹¦jÎoyì¯¶'½a>õiKÂÓ÷Åc$ÃãöËûÏy_UÏwø{ÿm«9 ?cÞT#Mê8=}¶Pôì_#µýì7¼c%?gÎ }ÕüéÖÿmNÐiF(ãqçoxh>Nä«Ï¤&ÈkûÈ´í´¿ªÕn?èÀ²ÆÿÔxoÚi÷ÃÚ
]Ø;$3DÆ¼âW2ÚÝ= ÃBdQ}ø±W¢Ü ZUN×©ð´rr+ËÏ²º$)¨à>ê=M&Èt¬Ë,º/ê|ÈÇ*½U®î*¤ïßÚ=Má!$92ÕávJä
°ò5gqa:#D8¹ÈXqøë±Ã:°:ô>+K¨U°*YnçÑ:32ùuÀ"öë%KæP¯]vÎ%¥§Ñ×@üþ±Y×Òd!ÀÚ_¨éH8ÄgÖíÙ«´äñ«TÀW4*½
4G?ÊRÛÁ[ý©L@§÷MyjÐÎôzG{¯ZÏB¼[UGjmGÑÛcKÔÜýH¢>Qì"^Ý,XÇÈ~ÿ[ ÷âÑÔ«Gï/ò[3Ëm<¡IS?º+R|+Â¾í½ú¯e3Æ¡½úC½zÇê@ºÌM7ôx÷cC9µAç_3ÎRÉ]ÃÊÃ}üò¦?ºD9^zÎqü:s2k½¸|9½¨´x!{hÔ_iû7-w ýsÅõ»zz¼S R÷-²ma½üDy~½E
Y¶:qgWýURDÏjr¥ú>ÏüP²¨!ê=Mº_¦ækÏ×¦ÏÃ§Ømx	,17Jds!¥á¨mòmý}ÉÍêÙzZïTò%¼ óõÓµÁQ9Ôõ= §òUB~Üáìsæi_.zWb$fc+îÏ$vD3ôì	i3u	z?ªD/9k¹.r¬ó)£êðY8ü¸£"BÆÁ£Ô¹Ëd¬jhôc¬¡GÐ×5u³Ð5è\é4-ÊsàlT2ºá¥øÉÜ6n6°Þbpw !×^ßdeÛ,cg rääÃqÈ ·1¤Å^ o8 ®â¦dæWÂßTÎaF1sºíD¶×ø¯
Z"Ü/èïúÝ aè}ÅåãòlêÉAîÄ<óª}V=MbÏ>OÉl¥+ì'U¢ø¨Ñº?ùZ¦ï³»ºÛI©³+ÈuóÒÿ1,Üë¨¸Ç
Y=}Dµ¤ç:¥áTdL÷Ï ï¢ G4¨Q¾îm1ü-ôîûYV=}æñoF§É·mO¯¯tÞx= ¥(ôÙ¸	ðXå©Ü5XF!mã^½³'5ÁïF×¼å×eÂc­kyß<QÞ,h òo·âªãÁêº4:¬kçÑÖñÂãNP»QÑ Xy°(¯°ºmö8tb[°rH]=}d^ØKäà=M§¾Ûä~RîûYpã ¥A©ð©qpµî3 (bèÜÿÜùêfÝÌ®F°I0Hê²'/e¶éàÞ,Q:À)#Èi=} $\Ê\ÿù]Ì<ÒþMÆ¢$¤üo1X¿÷9ÇHLlÑkÑÌØª6uG¶>²ÏäTÝñvÔÀwRa]÷pxZì¹ð>ëê¤÷ü= ÌJvÚ¬ØAÄáÝfçë]þú·ÚÇVêym3pÊÚÀDzÇ=}U"¾îÇÐhP8ËÂ¹	r8_ûL.ÕìÑ^ªÐ%	¹òì¥¿4L[ùÉcÛí8Ä@Ðhå1HåãYf¡hê6&ÈÔ¹~åAÇÿ¶ìï­½,iu¸+{
Û0Çóæ8ÕãÑ¨z3z?Nýhg1ç^7È·= \ØwaV5QÅ¥FöÒÂÇ©Q'³%cogßgÓºÂò8_uÚó.Ä¹S¥©*¬h´þ¯¬²v2z-Æw&[ÿbIû^>;?ùÎ««nTjÅJÑQëóÈãÖ_öÔHeÞ®ËtÇ¤SÂpnáøó¿ÌuµØ~YPL½y4æÑ;!:«¸-ô"=}Ò±§»X ¨Ýñ¡Ì§>Uâ>Yã¾"çaFfe´·6e.Ã$NÉÔÃ_ü÷ÛßË:ücó'¬ð[øé.àú/hè#Nyq*¢½ûÀáÍ¦Bq!9;ögMgùÊ«®ºÊ$£ûÌÌ¤K[Ïnv(ó$±ãâÉÏ-
ú{ÂÅ,<ÊT8ö¤ê}æõq¤!aü:Ê¨Ôû\¹I}ëT5Æ\Ïiÿ0QEïµ*ñKh7b¾gæ'ÐÂd[§hsYàm£¹KP®pýîöñè¼¸[u/Ú¸= Y6 ÀYu÷²ÖÖ]r[7bmj¨'æjòàlMO*Ç·¤ñ1(*TÙZûÇIîiÁþ.ÖûS6Õb6yYìÒ$©iêãâ{9DÖ[0t*4ÿÐzº0ð*µÝJ7ÐRbå§ G'Ká
è2xêy­.êä:kñnËÞ8ÖúuqhÛâ|èä(Æ5õ}v÷êÍF=MîXé³mî´ü|pî´ÌõÆÅµÔ÷)jDoL¾6ücÖtÞÔ,Æ3 eð_ÄÏ.3,VöHDNå@ÔIØhÈ1¾¸ô"§wt]Càñìßï÷\kò§Ëk¡áÛØ<vÐJÞQi[ÂÇ¢Nª¹á¥¹$­t¹Ða&Á_r5×hzM8%
Îf93é.¸E¿ÒZ_=}Ì¯Üµ±üù×fó ù2½NQXEÿZ ìt«î9^z?êfô0Hf4êêfá¤>P^^'­Öâhäª½
à§÷ÊZ4t¯.®'cÎ÷þ!%n/	=}¤=}}Ú²Spêw½ËÖPçT¤õßªU,2õVuPT8ÌÍ!YVÕ,,]^éyào7=MRÇt]= .&ùdDÒh­P\ã¨-FRÆx3´¿¥ûOªÄ:{·ª7A=}ÛEx¥=}VîAOúõL*þ¥ÑÚ¬,t .²ÑO·(ùqò×Q1 Iì(é¡U©ª_L÷¼Ü jmªÑm_{ÞQQõÔ}óköJ%¡ÚL£²ÆÓuSU#zÓ*§ºl¶8BÐ"@b3ôÚzbÛvÈdÓÌg&á­êühSÍw3È[©tÄn*\2¢¦à
v6ßyÜ0Íw)à×èS{Ñ.Ò¦Íæ ÙbÂµîÑ<eá_ñB.½®u÷\'&nRTx)= Í=}-ûô¥Í.>éô5) 'ý¨êëçõª·õJ+mvä¯1= 9×µÄúb3®:OaÌw;±QãJt= .÷g)^=}%9Òwq9D>èÅí:9º_À$ÒÁ{cÅ?°Nzíø~ÊY8Ä)#2b°µ#¢ix3ñÈiæ9z¨ÿJæäë%<êR MÑÄQÖ2Ô½aôc5}t5ìø#Vñb	Iòj&=M¶Êwd!
é7[ÀÚU*l6¸ïÙ©¡NIn%ä Ì%GùÑ6¨ uo·6Å)=}PíÎîT=Mìª¤){èÐSX&P2¿ÜÍvHÎâ¶Á3ÇÌð¹õ-êÂâ©s¥¾¨ò-õ£seø«OÛÝ·ÔnW@e¤l4¯	ÏÞ¾QjAÞiòÈë,òPGPñ¾wfQdSu^ïÿ+l©ª£¡Eõ£){æ ìððõâ¡ÿ¬ Ôé
£¶p¾løw³= ¡Km=}û5HàI§Ò%S5x÷i$¡;ÈwßôRxfaðZj&h6æé+4²èþ"ñ­Ð
ú¤ UÚªôÆßØ°;¯Ê¹¸ùÊ§ÈÖßoÑZ!ÞôÙÙÊÃ¾#·/ÙÀ#P±/·/}¯1®¶¸zÉöóýaaâ%
â]
÷^ïCÙã¥þ]÷FvÈ­ÅHÒJ÷Ùñs¦ÖGúìtp»²Xæßñ 3ÞF}ÃéD½~Úkí]æd®ã±êµ×èÑèq1%¹ªÓåÌÇ-ùµFøI´ðìeò3ëí
#1ñ)ì)Þ÷ÔÊ0­ÐÊ­ÈÊÐ­ØÊÝ÷D"¢×û>öÑ X>>>éÍ5u²m¦Ìd lÏg=MFSôSQÄ@×¬Gó^Å£y©ZIdÉÜÌýwË}E¬G0Tò0RñSòÜsÁ¡¬ßâ= É÷Ù¨+­Ò_)Mv«<§(ÁQbùÀÇ=}Þk¨ jl¿Ð±ðØ÷ÙjÕ²"éñpÑ¤ûØ±¸Ø1\âÙ= û÷áùTn¯8 1¢:«çùdõ¦ÖÝ'dd1&"w2uù$Ì$Ì%üÕÉïÁá~E£ÄâÅ¤ÆÂÚ¤ JÙ© ¡¤î= Wxòý%=}QÚÄ­ö ªÖþopgÇ Xr*ôMR#ìmÕ§Íõp-¥ÆÑaòÿL¼ÿÑ­Í±P3; Â^W])³Ïãþm¨8e»êÈÓ=MJ­UðPmr	¹-=}®	Äy H LúRX(,Ð:= Õ^',ÖnÂ¶jØÜiPW2(Ò7©<:4Ê:2N¸ÍÊ8²Ï.ýI4·I"k¦$ôq{ øâ¹f ñe1hªQ¼[_é2NÈ´jQ°*YÉîÍÏ¾ÿÑ
Ív@Øiú!zÚ.>ÔZ³b]@ëú²çÝ+ ÑFP¹»áEZ¥4ÈJ-Û£-ºzUØÛq3= Å´Ôw© P±-ÊQÊfYcÊ×Á_~%*©{Øº)àÀÒ÷ø'Öd¯Ý²Yíì»Ço!LÍ9ËË$+À5)O½È¯¡ÉzØÊqAaûÔ4IæÊxâ&[CÊ.¥iÂw×9iW°ÀC¸(^'©ÇÊTºL±uvýÀQÉënðÈ¿·ö!CvH²ÇxÎÚÉ5ÒÃy¶ôÿúÍÅ-
>ÉÿHìæ U4Î¯þ§½ûmÁÈÁÈ&mGx¹¨¾Tc²Ø
ª|ð(JK¡+BN©ÅÝácÕ®O©ÅÝöd}´sã¶Ð©~Ýî#{µ/ÅÚM8özÂ)$WÜbªÀß÷ÙÏ²$Ì4Tú2Ö©q¥VµCÙ%<PÓHùQ^h ?Ü³óÞ38_Ó:Mu´[@®2	È,q~*:Câ©µÏ¶i¡Øb´_õRàag÷ÂÖ£á=MIÃ(\|MdX^¥dÞH¿¯¨®ÎEWöroODlÙ¶£¥²r±íòq%@Ë}\âÇi"PÖ àÂôÆß®YZ¹£Î ÞLð'7}=}:¢ÿÊ$¬­¥ßÐ:£v| M,¯ÚE¹y5§ôLóx*Ó¶¢ð¢©½é®#;8@ðn5;UI¾w$"-ÎÁuµí±ÜÚ. Jû2¦ÓBì+²¢!QÈ¹i¤Öù¿ìÃ ÿ¹·QlBa!¤kh)ý¹Rª¿}I2gÔ×BÔ¯Ï¬ª/@õ¦*;iÂØëÞpÝ= ÝÃd$= ?¦OrQÐ½Ì"x¤ÙR²fòW*s8|¼¸2Ô	õ ÂcÔQ´µªôÚ<ã6Ñ?{Â j®Rj(ÏKáWë³½ÓÛ[¢"kaå k¦Ðwï­±bëýF¦ÞàYvôrH¨Z>èç/Å¿ËTtºã#:}@÷æ(2Ö}væ } ÑØIxÕ¨NÏxúÿIMc¶ÒåwtJ»Ç¢Ð>Q{Ôòh.ph.ù¡]Æ¼Ô¹&¯áMÐy]­LÌÆ¥µÿ³·á*ùPwãSÛ|">4·[U8
I®ð,õï4\\Aÿb5+]QRL&5ãh£\ÆE!s1ÏÄ±+2pÓôÏ9¶ÖR¡¶m)5!^PqÏRf%\hR'Ã±«òSßîÃÍH3íÿÌ'RÝ¯þÙJñÝ©\\PVQÞ{ewjÍî=}MåuçbÕõ·Ð?Âßmì\¡2Îd©EG¥G= Ê}-¶Ùw¸R ¢zy(Ï¡Xê¿q½ö±»ýø6vÞÄ7«¨¹Ü	Ø=MÕh {çÓ]ñ1)%Ðj£TNqõ~r¥à×õðè¥®x¹BûÛèbÍ¿õ-Ò¹Òæ\¤_BAýQ±¨4²|×>9WP®&ÊëMèØ¶&{ÑîGb¢è¦=MEèÀ¶eî¯a=MáÓ!jvñ#ÝÔ¦D¨¯|;ÈRRj"éFÅ{1ÿÏr<ÑÄwöå¾zÈùÇy© ­13'&7x.uzØ"
Â£JßóÀ@ ù~TMS°@Ù\ê= óe%Ñâ§mþ÷f RôAäêtjõ3Iár4&¤×ùÍÜ´¼Ý|Õ¥ñ³çBä!vØéXxÕ²§DËR<=}~aXuä·%Ì Ðñ+µÁº
%*g(Xâ±3÷ñX0ËOÊGË>Å=Md[[hg®1·D!v&/íjoô®bü= T?iBÔØ= ªX+óq6Eôyãa·ÂXI¡ªbp¬{q¦-¤É­õ¢ÀÕgÚCD®±±¶ÑN?fÇ¢Ò lÙ­ûnHê¸!zþThl¿VÖY5*Tº=M-füfè/4;)
«éáh»¯ÜdFÎrhÈûåJSùáÎW¾^7<gøò¬
ÃT{(êwq¥â~-ß§O yú^yåæ;íÎûPyÉ?÷øÆñÊµâþu¸|pa×ÅÐøj&
>c*Ò¯ 1½xÈ«µwSîÃðIðO3XËKÉ(tì66þ<çÊñ2J /bÝ}tä ëåq¦¸â$à±­GSC°Þý§îá.èKëí
a/Z¸ðWöI¦(|R)Ç³ÖL²,¦ÞëJ¡±âMô{Öã¨ñµ«¯Î'~7,[¸Ì,:Ø'zÊ9WÊlLAÄÊK/x¼<Æí·1äÕ:½Ö¦ }È¦qÑûÚá~p.

-Ù0ùýÈ= H3Âm°nOzªxBÂ 4$o÷·V\nÐà+wÅV¬® âhþ	ä	t¶5Nþt*6FÎ§û¿¿}¾Ë\¥^igiî¸×/._'*öÃq=}Ì=M½£á9	?LÕÓ&­sÄ& Ø> :Áê7WP7'z4üºÓ.¦0àr"ËNÍ¨	°Yñ!Uñ¤¤Ó&¤0	;äL= ÝD¨KÃ÷Ò¿ëYFb#2¹ôñ¸ÑÑxì¾[/Ë·Ø¡ßy9?	7s*$OaìÃ=}ºñËÃàÏ¿ZCÉà×å}ÆÏ³ÃyÈ"¦ø7ã	L1	äÛqhlfó=MÈ¨ÐZ^sfúì¹9ÈLsrÂÝå|.Á%Jðó×zÆZ¶C÷òKI ÉÕkd
Ü¹Ú·/vÍ6²å®v±i·4M0ñ d*-ÏÿFË Þ,X,Kîºi´å÷¹)Z6Â±ÊlãÙ, -G¡Y$Ò+þÒ"Y8/©txÙ$îæ±
Ý±ZîÊ'bG0}av1¶µy©"²'ä0ô-^1Äly"â(-7pè½þ<Õk5}JÞ¦ýé":­Rí²g:»®ðuv²Io¥ÇUÝ{èÐ!Õ"fl.W²½'>4N¨cóxí*ÃÅöèì¼qiï	hò7·UÚ£«Ü	¬g$ÝèõÞ¨îÜ1cÌ(ßçÉå^cãÅ-%Q>ø$Î kKÿß·µØæ¬:è¼Ãyzµ.R­wÃkÈÚ,Ñ;Õ¸»^O¥' 
ræï½|Ð:¯7Ú=}|ù¦õÇk'ð¯÷0Å·Ýêwµ²xï.WMyH¡Æ=M
ÚÏò©ì/3_Ö=M ²ü|a÷²=MÄÙ¶We©ÏäN¹?ï×Ñ^W*szý~Næ«¤ÔèímÜ¸«óä³Ä´q9òKKZ³Û]ÂMÞÐµuÚÓOôxIäõx¼H&D'#È8Æö¥ÃrÉiª°ÅÎYGy	ñÃÐNXÛ³ÙªO2¨X¦Y=MÓ"¦&Æ'Zô2¸IÓÃw6-®Ð¯SïÉ÷À»-Q9ÅÛ¡TV\å>CÇØ¡òo[+lÞéQnU¨k®ïn ³_Î>ø9ß-§¼?A(QD]>ýßOÉªÝ:ï´hy'ÍRÔeL ÐÄº.jÚ-jÌº¤4Ò(põ§°7­>­·G|wÙP¦êyÉ[YÚ/Þ5?½³wòZ= V}Äú;5l>û(ôûíy ¬Ú}bT2W	lI7&Ò´j~®ÇvbñÁskóJ¶Â@æÞÚÀ"ÿ±
Õ±6kVñ òòpù¸ÅªTyò½ÄE&Þë^·U­I¼HÍeÈÝ'©L½8"ýÓTÆ#PºnC6ÉÏàWíPÜ}9ÅÅhoÃ'ÃR9«x®]î *§__G¦TtòÛ×ÎJ}Þ(QjÈü³å /ìúJ®ó·ÿy'N"ÂÚVô/ %7IEô@äµ,»jlg~=}UQÃÌÉÁ dhÈ\SPbTzÒUUÔqøÖ±ÈÌGÕY.N	¾h=}ÔãiÆw{ÈèLºÒ;·$­k¥ç<p®×
*¥2ÕÁbÆeý£³å¢ØRÅRwîé'øa&a-þ*Hl¶baiç%¦/EÐX33"Ý³êé|hÈp-ÆVÊ7= fþj<ÚgG°¹Êp8ÆAºùØ¼óU7S7hH9]G9ÑAºLAº¾úêB3HBºSrW7s¬ÞünÏ}éì·ïQA:Q,ÑAzPfô3cvüø ¥Zð>ßüfÃhÅ7 1¯ÃOEã®»gat|¸	@c¼âp³Qû¤ºßA*Næù i¸O²
¬ÒQP{{×ºÅ¤ê3TðÒAó@U§â¤éóÃ ¤+ØÞ?Ò×â0TØq©ùÆÁ^úÜùëw©g-ÜÀ\¦ùý¸K¾4Nï×ÿ.>Oª²\Åm>Â,Ò"·ÇKU3ù²	$4ÖùÃ	ÐäO:»È<ÔøæU=}Ä¨J¥:¶¨éÚêòÏ§àÓÆx¸í0ËÜÜ±èüx"R¹÷l±Im°¾3wA­ðÄ(îB·2)7d×ÖÄê71÷·[çW.©ShêÞü6®àù°íNVR-0S5"aÄP*{ 3[9 vcXî= ¶lJ±øÕ¥4CqèÈ´Kõæk>âæiÚæo'ÇóÓÆö	3!7ìË¢Ö/õïæâC²,ZÝ' )í)¹Þ!iöFÆð¹>ïþTTwjd æäsºRø ÝI9EyFEÜß¼X?«dNö&gÊ6/ÝÁA:ÂR§5m1¨|ÊÑOë»±´=}3y½>i )JFß¥öÐ!í(¸×VcØS,£àe]ÅÛÓi¿cZäÀcHò«¹µc´ªy¾/÷Ò18 Õ÷¯ìHyñ²Öðëä"ÙÈdBt 8±YªJ2Ûx6×JÈréîe)^#!¢ê;-WYû9ÚSvM¹Ù^4<YÌS¢	6wÙh}ÿn!c ôN*5l~A¿â¶¨^2¾-2~ÂcçØù-£ò)¸ËÆªºtM~á*#xbÄõËD{ºöüuòª19NLO)LªöçªûYPô8z:µ4Çêººï¥L}æJ×U¹UJO(	uóyx!PÍ<"= ôj·ÆèÆé¤0É©òT©¥ù ÿ¡Th-íÓ½3E¶ó19O[©ÕW«IoTø~ÊCN;Ò<X
8NIY$'ÕJ¢¡Ô·¶¨î2.b8¯²X^ÚØJØïPþ6ø,j})S¬D­ CÓr¿ÈXYìtï¯³§[r'÷tªìbWÊà|hÍj6;æ#1Ä2à
Ï¨]ºÄturUÀ<xdS§iÖÑÿW´ÆHð×'Åæßpº<}sæjñ×	jþ0LÔ ì¢[$;3_KT%'Uì¹¨®ªðv!ß*þÒY§¯¾ïÆ·¼²·ä= <2üF Ú¸
´ñÝÀúÇÉTãN>ås&juZ´­¼3RøÁ&~ë\rÑPÊç'iIcY{ªþ]»âæãZÐÂ+~ðZpj ZþÃ×ûÁ7îßpräÆçýÀûqEâ¾,¶éV¬tû³¦.ø
¼æqÆQÆ¶ö¸Ó¢°ÜbKmjgøÃÖ×®²T,fIZa
]Õë´U»°F°Ý³ÑTw<hÒühÇ üE¯ÐMë>É³Tä©lW4QJÂs©r'©> <e Ò¾Ys¨£¹@¾f¶ÈýíZ1¡DØê£Ù~Ò>ÞÅòñ2aÆâ2@gÕùñdªÉ#¿.ÙNë Îr:·Û-tÉtÜ®½¯qµ=Mû|èÏï±Ù}<L	%?g xÐÂfÈM¦Nî~ïîð 
Ó^iÙÈÀ­K÷RgÛÅ%ÈÙ¨Þ¢×Ãp¡^gZ·t¸ã|­z£*Ø*2£Æ1ø+-[£çR°bb§8«sê,f­µ\Â±aß=}ØèÝ(ÜÈkÓÃ	Ô>¦½Ø©³ZÒÐ2uAjXø1øLDâU¼,gFV¿ãªèíB-Þs Xw­Nc³RI+ Xjr<ä-ëènÑÚå©|Ãi!K1yH{ob iµ)VÏR¾çh¢Ë÷Þ¨vg §±<EøÅ¥Þ¿/½=M³,váÂ ©ù4ûÅoÑÒÑª~&3]iéª@óÃÓKíÈíå².e,ÈþèJµôØ²'|bò6p¾øeKß(ð¥ÖnÄÝhóîú¨&ùÙîxE8ó¢vÛÈñøMl¥Û|Z¶ @ÕpÿËÏåÑSÇP²¶­Ï³hõºÜ!n¨kÞÝm7áü²ãüFrðýâ.s&ò_åì$=}U@ã$üD%ZJfo=}ó´(c×}^a¥Æ·Êâ'Bú5
ª}"mù¼Ñü?W®ÑChÍ©"ÃÀù¦ÇEgIË´ÄÑ®ðRÕfËøA+ö©øP\GTuà-yAQä?=MÇì²Ð®$T~nÐ¢òG¤õph0¤¶Qs¹ù¶­1®öD ý-ÝZÇ|ég®<p p ÌEÑÖÛ|A
>Ö>·AäÞ¡ïDïìoàÈ= ·N¨¯BÆïìoVìá@õvÖMAã@&æÉÀABL'?Ê¾)à¢Ñ
+oëR¡ÌÑF«nv5°ÏÙ%åiùEqÛëXã÷míQN1Xä!Hc
"°tt­bïØ~Å>)qcÔÒ­) Òqv}ßÈýÈQõç¡.¼º|Ñÿï¦@Ðo®uØ×½|:}ÐpÜ±·ÿÖ·Fy£(Uî¶K;¦3>Y@ÁèSYÀtÛQèyM©>ÕÁÖ%ù¨÷¼J^Â¯ôtBíü³m¡V! ûÚ/QA ¿¼&Ñ/R¿qW.Û¬¼ñËÊhTÁºå{Ãâha]NÈÆPÙ9 ;bKwF[ñó+²æe²ÊWeÌ^2¡ã>1vÛÅé¶xØ÷5¸©ði=MiMH!UQ5çR/EÅÖm³Úö¬ûF¤ÑZjå[ÌrP =MxÂ	È®ãÄO/ÕÈ d¢Ø4Wì=}·'~T"Ô¶°'ûóu3ý îç&5MÉQ[7s¾¾¥©c"cë­¼'lÕà{î¦ÿVÙèOÈ
YAM%£r¼Oª6TEú ?!©ò\Ký©1 d¦ÀÙ;Pª>kdÇjmQ=MßRD>_®ð/by©§9ËM¸	pð';hõîêe;R¤¦Ìù³ô @ãÛöa'Ã%´#= ¡¾g»ê°+9ß#,³è~>1[ð@÷Xeñ¸ÑÊ+>ý»ÃF;[aÿâ÷wKVÍÚmÌ
?	ô!¯Údiø<f[2Ìz\Y8RÛå°CW§FÆ%â3ìÀY-lòÓEðÙ_²ÞW{¸£ ®(_4!¶WXx_0 cHüÜ|ÔÑG¦BKÑrwî?¦'Ô	Ä<­Q[YEý'ÝWÛæ8TÂ¯kÓ©z- Cîry­´OÈÑiù$I,ò,Þ¬Eà¤ÏÁ{Ù×¼Lá	ÎàæìÝÕ¾ãXòF0ã-¤·rê!nu[jZ"Þ¹ûq[cJkÏÑìö14kòo«Ûzä©u¢2Uúu}!º©ñ6øx¯ii'GBä«XÈp7)D'×æWm2[)íë8éª5DcNçZ),,ð+»­6ºÂìßÇ:Áâ¸Ù3ZÀ+¡³PY\®ßi?ns(Dõ¶ÈÇÁºëO	Ôg]eLÓåW¸1Ï",{4e­æÑ_ÄöoÅ<7?rLèÂ¶±Áç&k=}Î%L	Î¡)Q¦[õ·E§k\Þ,Rø§§	Ä×åJ  þ ALÊ­Ãð¬7Iã|X¢I=}¬#Vúo<µ;×²®w÷ºU")LíîÈÂNúEnMV5P³IH,6~)Øeÿ0¶¬= 9´MjR\þõËÓMVã¹I%-ªcöÇ.JJÈÎè=Mä ÃõV$õ1¿H+å<Tz?[«bú{·>µ=MÄHÊAN¦É{cðþlÖÑ-3Û u¶Pö6p1Y9UÊöL­£¶¿l3Ç²Ãð{¼Ê'h1yZÍ¯8ú>ÉJH¨If~«þy3³ð½Àjþ= Á«t;FÊ^	R³²c#ðÓq%Ë±¦½çcÀÕòkwé{éÿMèfQ	ßßD¥ð¶ÎSË>"ÿmå(<çó£âüï·B-]²ãñÜGþ¾RFÃbg®Ý.ì¶§ÎN\y©½öZshàw0ønÄ¥X¶ßùF³Ñ´Â¥¸µ!t\=MIÔ±:S
¯E*t9|§äÅ6äÃTï9(×Ý«ÕôËWÉ¶©òó#í7¦âHoëÚUfðd0·hWÓc0¨\0Ë%#°´¾½f?[´ÖòpÕ-¿H uH',4\âæ/=M]=}yÌâWi¶û>lõÂÆq+IñA= =}5ëïx©ÆI	$Cùó8{Ñ·o8ÃµJ^¼+¶è"Ï \ëli)î2»B¢Ã tÁ=Mu/g~kY"Þü=}à42YÑì½ÅÈ9$sS@7ëHëï¾lQÆ
ë¦¶è¿ÁÒeÇ£'»ïïZ4ÐzsñNùá· ôá= eË¸¬f&àÔDIÏÂ!6[µ¨Öýù«j+ad´_R6ÂÏóâÏíð'záaXD<Ç
¨Çä	ni?P-oPæ¡¬-ÀÝóïM/Ð-¸½Åã<nyµ WL(H«3õ<4!:9Ù²©Öh+!8N¯ûÅ(zæ9B*ú¦oL´V^ÿ;öKåSëÁÙRÓE²«W_x7kÒß8ð!Æª A[ QÅôy²Ù°wyf=}4µ'g~L´#ÃÕ÷5ÈÛ#3÷1¬C= J>èGLÂ=MîtºôtRÏ?Ùôyê1?´u
î7&­0L÷zãE¼.Ê¹N6)6?sG=M¹?BE.WÕ³!çÃÓ
zÎä}"ú3Ö¢/µIê"þøÍ¢DZ	(ÕÿIõÒÙTIzL0fõjûNHÛ û]=M£WÐÓr@Gúi<ò,¾8bo µ¸ê ÐNØ9¯.eáVH^cxùê<÷pÂÆ¼&ÆmQ6þý¥XÖuE»Ö&´Ù<¿>Aö4K®%Ç äwiõ/#oF¦5B024¾ÞCYZ©eYêgðÂú³G[¼°þUõIkòsø0$­zY6ÒÑo<ñoå&&w÷*Px4H<Áë	rº?¯WìW®×î3¤öÚ6Ét´WÕ\.ô<¨ïmÑddòiV³1;JU&æI4A5
9Ùz.ÖÊ¿>9ÂgEb§¦Vá>¯ËE»£ÀÉûÃ%TY%yrßMÁæ÷%nSÑZ	"¯Ê×H}Oþãmx9:M?+ ÃpY¦*þÅ2³æÏ«àjð7Ó6T³Ó6J9Ü	óÚþT2nê²¾·< ÆÛ!÷+æzÂ·¿ä¡=MôÌpPýØUb÷_â÷RãmÎ51Êï}·?þ³ógk'X//³Aþ0ËwfÌòYó[èu!áôÓ3$dY[¿Í)¯g$ÂåÈ7íHE¬ún~ÇÊB'y&LãëÅN¼ãÑ>¹µÓÄ¤50ì$9¶î&!ò8mÌh¹Yº	K/wºyÿÃ6(&< {¥á¹«?'ç(î£Ýf(þ§ÝÒwD¬]sãµDgÑE¢x¬{C[Zý>>VvÆåLH×ÝîÅ³gÚëÉÊXë§Ú?¸)Esuy¥Êu
Ä~Ùå8[ÈÛÏÆÕ>\È´©@âñXÇGN%@ÝOþWÛlÇìu½äöÙ:øYïªpÜãr¬®2(¬Ú½õâêG×{ÈcxQ«vºx©Oÿ%ÙÁÆõfÈäL>ZUÀ¶JÃÐ$µ=MHÒ¨Ñ(Én7§4:¶¹²ÓñgÍµ_Mý'^½Ð}=M\¦E³-}ÉYâ£w¹ÉâGY\½«]=M­
çªrò ¬&ÐÍà©îórÁAìàÖP ¨Ý°ÔìÑîa´¸ Ïë¹è{¢°µ¥Þ2x æô²âú-~êìíXÊ%ÕÂv
ô~)hbüX µ¨Õ4~ìÑ_ÜIÏ¦	ë£"¤$#ç=}ø5( yW1Na.Ðêq)àüfÑüpà½fæ5®y\= ú/+
Ï8«âP
ê\.°ûé+<¦³ºcËJ@Ò0Ê°zµ$&EÄ¶ÁÏ2(³	dö©´kèqTßù*ÆÊ°óÛeÅk»)p;§UyJ¨ë¦YòOTrE÷%´eTrET¯Ñ¦0aZÞàò¸ãl²¨%Îñè4<¶E¢XÄëf¡Lð}ó;Ì}= Þ} ÛËðQZÏLÒ¨!@È¦îö¤Õ5oöüoöP â·\îÅ¢<®w}fÿ¼T¨T¨ÛÇ­Æà÷öÂÕïhvPöG6ì PP-nðþ$ôpû_~=MÃ«NXÃ ínîeÛÞµ[mª4ùGl»@i5ï9¾lX©ëîN«6G0´÷#J¸å×ï>RoîPîcV¡C.°2Olèo9	¡üGü)gëâ[¥=MÝÝÒ£â)îr|tSZKÀpX"fìà§»¬= HUmÍÔlôa2Ví9Y§¬k±W¡ñÍjéñ Z¹¥Ê«ú\ÉL)zfBÞ <_^>¬°p¥2= ûìÀàÁðuäe«¼\{&;Ç'v¢»óÄ_¾¸ ÐAÕ%H<J¡Nß?ßj= ¢©'aÉ°i> ;uËD¸XCï¦$;³wDÑRùJ®ýà/Pä%²ð~¾à§k)Ä³r$R:Y®¹xv6ªÖJ&CÖç}È´ÝÖ\×?¿Þt¿ð¨×´]kôCÍnaØý¹õúäøt8àv{ln3û«	ÓÇmË½×µ¡zü7eÏøVÙbø@FE§,î9 }~T)ÉªÂ¸C·-¸?zRf;êÈagÄîßÆm7JòË3aJÒúã¢9¹I¿fWÇç{%¨ÐÌI¡1Y¯Â
½Ý:÷M²ipÌ²õùÇqgÜ5«w¯hI.[+¬Å£Ôáj¯Ï´^8Oµ­øþÒ¨qÜ?X÷o5é¢H¤èò¨@¹Ú2PY5¯DèFþRwy(Fg58ÿ'+ DÂhÏ|I¨EÛcD¤J'K
	ËBðö:ò= ð,¼=M,yí¤l£bítÂ¶ìpE,óÑ¿3Ä$Hr§^+5ÖóP¬0_V®F¦ =}}ä3y¸ñé%HíÓHÊ;é Ä}<?zêÀòp1W§0ÆuáãE¬/E¦ÒZ8òÒêÏÚûïöí°¹!º6äBÔ:I*x5K,5(ØjzÚºP~q
\\=MçEW^³æû;)!*ÊÁÍ¥8(78ævuüÿI×¡ÞEeo	OôCúÞ¹wp£t-¨YÉÑ}Â¾ÁJ ç¦B¸´¦þ-â5hô ëG
RgêUjëG¼CÎ0íÇNUjPä-:5Úý,oáé-¼ðr]
ñ|â39&9¨oe¼qôä nñ¯Ë$reú¼æ×Ó<Né^MÅ¨Ð~Nët¥/Sh6&«}7©ÃÔñl­ÙZÞè½Ð¹·ãU§'Ä¬¡Ã>²®Q4!iÀéc¬ø{ËtÔU3 7-_ì,?UÎì ;p¿;PÖ»õ'cîÑj1çjÓ
«Ô%àõo	þvìÙ!íçsÌí" >ËfÎDL(D\ÏCcð"Wà±{d¾]³FsHÄ´wý6= "ÛèÌOÞ'Xñ,½Øä¿±QÆB×©;ËÏã®ÞYÍJóUýí	~t©V~ÒlÔ{Ù(¡Dk¨!§RrN®X3ªÏE/;¾3bH=}D¸ÿUÃ¹h¾»nO@äDø·ÎsËÒýV××/n-<¢ÝxTcÉiªm¬NnäÑìÄò¿{®OÁ2¦w0cmw§Jaq\c¾ðÖAQÿíÁs°N¦ôgv2QüûAÆìúÑîÕ8{æ%!¿1¦æ±&ßÒp±¶ÞD3ÇªtV5'Ñd/×ëÝH°5Þ.Ï	¡È®,­ÿ}þîphËãý7Ú7"ù=}ýûö\ ¡p;5ftñQ¦¯WyÖ&$Á>GÂU®µºÂåqöót¹7ÃïçZñ67o@Ä:@¼­N6­eñÀµ,ðË3= ë¾p¾+m,³Ão ý@JæAtª¼.í}ö­©×íLs= ¨*R1ú¬tar!ù %þb^ø\Q×ÖámfÏØ¡àdÚº¦Wð]íÓ	Øa¨§¬oãÏ³FÂZJõÖ2Akæè[&õmD ÞUÝ	änçòmÂ0
áà®¥ÒDÕ=MÕí/³²ù+)ç+'&RIÙn0õ¨[<:OòëøÍ!¦ø±¨úÈßO¸~Ñu>ÿ5lçFùD"é¤s²Ô!ÒNU§mRu@â÷pÿÒ»qRNlÒ÷Qv0¡8ä¤ÿP.ÆÌk¾ògihUc=MÙ= úÓ9@ý6ôB²mUn(ÀÕ
ý	)C!y'¿Wgõ#ïÜÑøÃ§«ã3ÔÛq¥m×3WÉ³÷.}Ax$«Ü9hÊ{çÕú²­t]¨oo¯
­Ì¿Â§©ú,ê÷,M5)AÃN#Íp kÃm!?ê [%¿½¶¤¨{b>PªnH0%V®ÖäçÙv×þ0·}ôWOÅt»MÌ=MpeÕm¯WñÈtüb»½iØ3#sgHÙ,ºÏÇ!Êû[ñG¢s¹äfI±E]MeN¸¿FÈVy4®È[.:=MÈ­G¦Ãä
9¯ñ:)ÿÓ95M¹AR{ëå´Y¸43ÓÞÉ©/Y¦Uµ!­)rÑH£;s1V8
ÌO*Gã0d÷@è5¢öDt';>ÁÿÝltÊÛø Z1æ¡e,+©Á ×Þ ÝâjÒÚ9»DbÓåHS üì±H51q|¶íÂ*ÑÁ^ïªØÛb3-Ø°=}©}Ô{?jtÛÁ5ý¶?ÐôbXÐrhÞ8¯ðW"Úéî¦ÎNûò;ÊB¶Xê/<ÿçÀk¿ÖTgm÷ùÄEDö°gåXë&_/¡¥4Gö7ðÃMf9ã¥G9ËÏ=MÀaQh±Xì"Öô ï[ãGgnâ_dU}Æ°}[íáÀýí4Ú ùù@Ë¥= gæý(p1ÇGuÆ3ìâQFÙôLÉè»áUJÔM£'ÇÔKöÖÀQ£õ:gxq/c/-kMpí¯J%Ö!§ï<n§«¨Ø RGÿøjõqY!±¥¶°*ÔYP9h= ¯Þa]¡¹"º¥= Ðh·¯fGÙOéve^E¼ç¡ö ãH1¯Jä Ã¨ØÈ0¥Ä["³ïys/Ö¶¤nR<Ë"cg¹UÌ­a£¼¨ç­Æ³fuåÖ[÷JÆ¢9| â@­ÓD$Á= ÚÙ)üËæI	smOùÈkþRòI­aëÃlÑ1:Íi{¤w­²E¯Ôóm¦7kZÚÈY{øSeõ4'n:Ú¬(:ná:
×*BåÓè<´wCP!ØpæÎ¿çÎË°%4E9{xÁU[ø©qéÒÿ­gÑwæ¾= 4\´ÉB-Ú©Ý0ÓÊ¼h§HeÌ:£Àø¨]-BÕÏï2w3xÓ®º°ùÊêDÊÒæyólÇpVÍ^µ¦ù±¿Ów!6Qòý*ï»Fkª¦;ÿÛÞ¬¹¦­ÜÖLÒ×óÓF<ÙäfÒãã3|À7ñêÒAu»ùª$Õ½ð3è¯ÁO¬(µ+6Ý^äÕeMÚ\åÄôä>¹0Õïté¾)xêl©Èû\&kfÍ5[~pv9¬ÊîRï:ÈtÅã¬äiÑ]è#Pï_ÿéA®Þ²#¦ân\¿³âC´w*W9ðpðO®W#¡F-C(61ÅõfÃ\¿Y´v¯»º¥Õdî	~¢;ÅvÊº²¿_1ðµmjW\6"h»%:ÈðäZÙ¶j6%XªíËr7{OÕhUsWvÉÃVã"Æsë³PÒB?Ï~²Ìß	x£z¿t¬Û¬´ ­"¯}4 åàwK·´Õñ°ÿJjý@_ÉÓS·~Y¶Ö&÷+AY8¦ª¹O4Ù¾ßRøÛüYl£Q¿þÝwþô9¨¿ÐZÙª¿2j6¿ìiîF6{íTjÎ&^-·ÃJqjqy~lÞS!ºdaâ¿bé[¼'®NªI²ÀÌ JùNÔ	?/7-¦tIç´=M¸^\ðÚcÏß%|Ú8µ¢¶,G58J58Mu=M-ýúÁO0zªÓ»®o%ÎÿaN=}Oï6.j*ÄÑ¤Ú9[q³èr.üS¦¹Äæ1ã1Q¨óú{Æ5^¬ ®$:}iQ	9ØTIáâ¤<<¸4@ífyë¼EæÓ!×ðk_8*6= T¨DÎ/®¯!ð½-ÑVª¨´[¯U&TyðÓÊÐ=} cÆÒ:ç*ü£À¯k»EÊ>õ Ñp¦éiÝ5ÓÒ¢¤@·ËôepÁ#qú®×nÍ÷â Sk@ÑÂ?3pIÑAk¯»×ý ½6÷þ öþ°@2Õþ0±Â&D)î7d±BM:ÚüE¼
)f=}6i9§(Iñeë¨9)&=}6P7tëvÁûùÈzÂ±BOâ3®²ëh¼¸×zb±Bö
-")aë.7tðv= ëJ,"9üIC'gºYX'ÛGñ×
[¼àFI^Ö\­òlñ äÇÚw§ªÈ¬õQWF¾ßÓfá%})¶»ä©q¢^âè¸FÂ~aR9;È<Å3,ÉRO[P{ñf{;ø<m<Oö=}¯@ëõf{;Vö=}gD¦»ÝDp{õ;Ðfù4A'M7ìU÷¶¨¹ì;YP[Pû8ö=}ï?«¥»;b²@#Eÿé;x<WP;Â±@C±Û¥F;ÜV°Ý¦ù=M°n°Ï
s¹&®7ÊúfÁ:'ö2"Xö:ö1¢Xòz.)ó8*Éz7)ó88*ÉÚµ²9 1ä®«¬6ªSJ=M§D;Z3XV^hÄyçäÐ=MÍÑn çp­Þ§¦ Âô=MrË¹ Õùü/·õ×fMkåÒ¥Ü(Úµ"2þìÔèr³Ýª2ìV¡ôÿóQ
è	 Ñ§~-]DþÆOjÚ¦xµ5è5ù°Aðóß%}+à©¾ðÑ¶þÏéXùâµª,øð¶o8D®4yÇØ5¶qB¶2Ùúf
= ßå6BË%ZùzT@çº'ZDÉó±OýÂÁòÊhÖð&Y#ÌoÿO- "d¶ø!= X¦_QÄA³/×¨=M¢-,ÇÁî¯VñhK1DóW:²­¶5Ìóðu£Ln7ÔráÔr%Î .¹ÞÃä{C<ÖÈ]¤NýxC:Å¯n¹³/*¸"£sWh¾Ï+Æ(³âóÆYt<0j]9LMsScÒíßr¹aÍ3	= ,­ýø¡U ¥9^f,u53Jµ­ìíÉ³Að#ç¾õH­¨hüÁTJt¶Md°JÛÝîtÅ+~ÈsOggËóÊ$«c§-,uY¸ÙZýÚn\8¾¼âéA#¹'à×Áàò&v¹É> =}7#PbWU<wíî"ÜV]Åx%U£¯ð]ÖÃçvâõ÷/S±@ÝË>DiT:ÿiHiì+;HQ]
ßãT´j\è´gl2X£ /+SÒy\+#ÈÆ²t>äÏ(ô%²ÞóuôëÏÈAC¡ON¾
p¥qTXü&ÛCæáÆhLH\°<ìñU*ñhÜlÙWîtxçÜd¢4É¦ÑèÕ æëdw÷HÏ~~äÀ/µ$ûE2à¶KÌ©KcfB°î»Q'ëÏà~¯¥+Þh\3víÈOÿú¾ívUÈWí¹ÊIWsVþl .²0K²·&%÷?=MSÝì^júï)r)
³#eó§þ'6- Î²ÿ²URp§/c°,}êùzI5Ê\¦r(/rí³ZPRÁñÁo;ë;T"¯æ*£þ8 u.1= J¢iY8KmÙ:E
iÞæ½õíÿòèÊÁ|°±ð0¨]ï°s!Ê­Cp:Ýx5"(z¦æ/Ü<Õ,¨9cÝM9@4= ¬À=M=MæãHóO×ªÊ*õD¼Ï¾j< ·WÈ%Bd,´?x\W¨ÞË=M/üÔÜ÷Ía¼H*òûGm­4I8ÖR²¨÷*NxÇÝeU¸I]îÝ[Çð@fzc:Ïy÷ÓgÙaSçy ½DP0D'= 1dü¸ø~Î^.ä×z+GBû0<o= È¯(Ôí{ÇM¬Õ«-uËá3üæßb&hX ¤(ÛæÄCYÞq8K\sÌðdØëÚðsvÍ
k©ÖlVlXÒÛ{5ÿ ÇVaNîç5³¾YRPôä= wµb^Ùp\= )mbV= h°¦á6uÕbæQ!e°Yª¢ñN¶ÄLü,wÆìh-æxAûQÚ3uÿ\\ävòe¶OÏl8%µaªËeÒjö½dòìwÎÊãtÒ§-´×¿ ïYY¦Ë[Q=Mòa:yG/bÞ
õ¦Kz0læð¢^D= ^ÞoâÛ²@Ð÷fãÏ0)À.u­ùa¥/iÌ e¥ÐÈïU¯=MMd­ÍÅtaæsóãôVÒpÚê³SäÞ?q¦¶]­î¥úpUäÙë ¿È¤ýQäùÕ§	=}³+VÑ¾ÿü±¬Ï:"O%oo@ú2¬l»{p©®"¬ÚÅñ,¤«æÆZ\9©2³Ø£±ä0íg|CÍDP¬cËa8»@¤ÂnàU'­Ö[¦ÙÁ×Åd Û¥Æò&G:r ¢x:j$¶âD¨ØaïÂ³¸?Æ ÿ7¿j×-oúFÆ3>}U[é>#ï}cÐå'ÍØnÒe!,gª2z YÎ°V
u|êÂÖãmÉçñu1àX- ªbO&dùoVxÍoÊÄy­ãhúkäçË!¯äÂÏ©dá_µÛh£ôY,É¥åK4zC\Q.aïE,#´é6§,(¡ú$-3÷ÀÚËz¿^j)hâù&ð4³RÄ¸³êPÝ¥ó1ýÄ1w:= ñè>éÄï$z$Öh[Ü½KV?F{ÕÀ¡Rö!;|ì·¨oF*À~<tK ëØ-vç×Åd,?ß?1Öó¢ÓÔ´¡9nöwö²%Äg¦Ø½Ld§ÆyÂæÀÝ}Ûåß«ÅR--­´è4i®Z.Ñ<BAóI³ñGrqðqhp¬pô¥'©·#óÜÿ«¾ü¢ëçeÌ%Î& ©ÆH eTåÎ/]ÄösÉK¡ò@§¼bzÄ²Ù6ÐD¢*8ÄKU1 2ùS¥½¶ñ±¯0°õ±a7÷)ùé(J'úîúºöåòðqñsò'¤rÀqØ:¡7h0æ5½jÚb·é76$1ZÚ¸¸#³ú82òúº²ø¬Þí,¨~þ½ÁÜHX0ò&®%Î%¢¶Jèrç&0ãY´*Ä|û= IÖý´·ÜÃÀ¿·IÒÂì½íHWNLñü¤pLbÙ­ç
¶¶\xïÓÍ/Ø~§éº.§oØùÇÇí!Á,ÆÛ¡õÑÉ{â#
¯[¦÷AþB´]h¨ô¬
F= ÞïMÈ¡Ü{ñÎ=M
Ê?Æyëí#Un¢§%©Bx?ôÝ¥5oØ¿èù²øYûÅ,º/÷4¾ÁLJppïÁ1;3k5dXY	ZÄ\zøÚüö |º/²ÕÈ[Kp*â
É	¹ü³ w6]f0KÄkÿ}X/õÌéÂ^B]Pe{zËB¦xæÓ°ÂÀ5$Ue#ýÉÇF$%Yg©_µ¾EupïY6&Z]YX'¨%÷ô= ¯AbùÐz 5ybðp]z¸ÂÎàY±Ó!g76Ç¸Yw¥Ö¢j¡:1.Ëp8v&ò)½Êsû|gWì45s§ceEóÃ~E?C0±ò¸´µ,{'Ý¤¼)^ÁÓ O\ÿ?·YÒþ¡Ü%Jæ)÷ë^¥ý|¡mL	"íÌ2¬LÈö¯%!õ Æ¡Á3¶uvIìÓTV#_É,ðÆêÑWs	O´ÄÜYþè[¼ËÆÉGÌ)Ñá:5+øj&JÙø[ð1ÔðeÎÊßÄýßøâ*Ô5Àê­ç/|> seoupö/ü¶ìÄè3%X@ÐªàÙÎöFéznsÁaXgçµ¢©"Xø){ ø·ÿÿÀ¦±¹-|¥m=Mº©	7Vêhxbi¸åà{¢:f²!Tu@iÇ4¡)siw¹üèrÁEBÚ4,¶ÛÁ,{âÛótà²&HA3
Ãòúëà$ûJPªkî/Ùúo #Ô%AÔ¤Ð¤)ùñï,CÙö%#ôBZÇjÒ´-ýÎJ-ü	îM­	8y'ï v·¦!KOôd"} .
!þbg²ë±¨.{¦Ê®Wx.ãü·ÇPÊO¸7	y­¥¼7ZAt³Èy²*S¼FT© lãüÇ{F_³ó«gVlX*üiDÐûõû&cyÿ|PëUÃQQ½jÛ½2[àa}ûêàè¾Î¹_ É± YZG³X²Ð±ðdQÙaEÆìiåñ]ÿ¬eZ¾{pÃuÁÈýWÀ¬}^¨ sh¢¾9ªÌØcBU>°K±ÌwY ÿÃUëÂºË*Ö³BùN«²ûmE®\-Ã,sÂE¶û±B+XaÎ¬TÃ¨ý;r+û}Ñ=}9ï¸3Ì²§\@Ð6M[¿ÛåóHÚ¼¦">ø¿.ä}£ëW|¬:¯a¾ä\À»É[¦Üë]u C³SâØq·Àõ¼dYÈÀ{à»£ô£÷#ÆW©>ÏÐ´§\âÉk{]Ë=}Ñv]Á~HtÆVDÞT»ÓýU]³·V«R/ÙEÎê±å?oþü5Ñs±{}Dvg¢Mÿ;A¨ò+j«2kòtÝO ëDöÄ"f,b«Òùn·fbÙûýa'$4¸dRÖWM!'oýü	µüÀ»ÿtgòòp¸¤³°ø'ª6òéPlvgû¸ßÈ;ÔÚ_³#}!ñ¸B2Zy³m©òt¼å®Ë²íL,Ä= |{Æ¸Ïà= Oz óCºÍC*¤ùÐ¬J Pád¶ÌÌÙPPÜ-0x:å÷÷ë( ÐfÀ¨é÷	ÇwÙL²$#Üè$jE®QX¥6øç÷k2æ¢vêùe£ù0£|¡(&çºùcóÙP9õwàçÅë/04Qø´«%c:ÉÝÇçÇÞê¢¸øh]¡ºÞ6oêç¯2ré$ãCûT¯¤máùÐÁ&l¢¸}tÒÄ¤eÙzû}¥ÝÀÝ¤uÈúÖ¡ã¤é³¼äÓM+ÁÇò/t<"%H¨Å|ôòyûüpPÏ7,iÙoî¶ÇêåÃ8ÈsÃJýkò:7»ÀË@ýÌ [{#sA?}F{ÍD¿»;LSHY(rPÒñ2ÿ4ÖÊ&dÎ7ágì¬êå¥Öÿëµ?
Äë0ä-BH¥{$sq¹'Á(úQ¶+áqh³B­Yæ¬ìÀóë@f±Oö¿TG­-Iï­~!½FrÙ÷] ÑA
ÕËñ*´&aÄ}$Wm¶¤ý^Ò*qN>§bÍï {¤ È4Í¼1)N"ÿç9ø7	îA}eò°¼»pI8¹4
äôøû5ù÷Æ²·níí²IÕNø±nø:ñß¢r¥'ÿlæJQ¸3hÏÓJ°IÓTÔÓ¬ß#¾òMä=Mü =MÇ= D$BÐ:4åÄnZXKqj¥þ8ôR*ø¤QJS)Tí«°ÉÞ@àPÊ&kÌ	n³-ÈvÊØø,ãéyýn5)¢éê8aÍe(waõa.¤}%f'bÉÖ´ß#8rÏÙý¡Ï:Ï¤6Ü:¡x~f¦ôì&îÉQ¸êÿÑÉágØñB)Î5m¢7/4ÎnI×÷/ëöÙÛÌb	Ä°7'ZzP^÷âãr(8(Ðöp*9Ç/ØTTú\®:®GyÄ4«ÊÄK=}4>fÊ,Raá§z¶6.³m:øûCtìÆß§}HÜ ëþlVqdt«yYey^	^ñË?}HQ³Hk&6ã ÒLä0@Ü[æº©9Ö3°$°¤=}ôûæÂ]ÔÈ¢aqÙaùa$ÈÍ§þªÐÖ8YãêOLu·iBéA÷Ú[!p4Õ^îÇ'»ïÃòdR{u´?îôª¿Hçÿ?5Î/íÀÿb#\ôLj Ô)ûJÌÉ[¯7,º$Íh<xA¥vAWeûõK= ÝM¤<lÇrK'DËT­¦óC!òÀáÑ;0ÔÇOìG"Ä®%e CjÌE&½Z»YìÔix-ÿfäÀSlÈlêÏÐ>³©Ï¼#p¯zùjD[»ÃÒk:ÿ%ozÔ{Ñ×AÀv^äÌý&§F	¼ËWsæÔ5= Z-æÜI!0ANH¾üûöÅ¥!¼s^x¦léPõfØpÊ<"<æDTçÔè  Ë°ÎÏßÀÏ÷>ð¬»ÆISopJá:
NÜx16;hiêéßÓöO÷ÀUG(GñÞ_ kÜ,Ý·÷Q¢Ë|¨¨Aa½Ëc¤ß©:À7úå#KÈÑô¦ëc%¼#[= à+Xß½Á+EúD
:%RÌ^ôÙoâÓâF£ºÞp£½±Y7-
Xyk~h~a[Í||jd®%ï©ñ8.æ½ÃkóAÛfûBèÂo÷|k0²Ìê¼JÝÐyùDy3«÷9øí¢®ÉWÍóµ 'í Æ!Â3É¯¯ëîìÓ$W2·63/  4bJ¡éÆÈEJÙ*"¢¤§{k:»	)v­ù3)ônÐRªó#&$YSzhw&üX²WÚANrg?÷ÐÑF­­î]÷·ÊQÊîñ:¬ã7£½Ýã7ÃÃÃ¯Q=}Í#íÓ-çYzÙ·³¨ßM¤Ä Ûv3©ÖÓS$òrmd\\]!èúÑw×ð4¬|"ÿ¦vÿÇë¿7µ'%ª¦nÑ§ï= %Ý%¡ÐúêúÊÊ Õ¹¿êÍ}Ö§¤$Î9ï^bfa¡¿%05º _áêÍìßcm21Ø Bëº÷§ýÐm]Ê_3= ,RÿàÊê½CÐMìBÙwNÜÕ¡æÍMÐòÇL·vïÌ8I0¾°
NRé¤6òÚ$4qÛðãjR¤Ð.î wuØümÇóþá¤uÖ¶¿¡#¿³ÉäÔWÿcBaHW6G	?ÇdBàx^ûhÆ¬à4s5ÿ¯¹ßlÞo%bPÛÜ[G.ËCS?#SM]<×¢¦ú^_c«LFë{G]F<^m¿{Ë<=M=M×zêúó²ßl6ú)¦­qNàeÎC.DQy~­°8'£ª68"øöò	±®YnË_«Ü;´Üå>#4ú.{ËªBM1}Ú®«/L8³®z;êUû,¼v­{QH+zsM¿¥ÅÍâÛ5VÎR³|ÿÄ»>&ÅÔÔ2p2r]³¾9Xêh9ðeûµë{À4;nN^~>3ÎÃOÛ5ê:aùëS@sûiZ´ë= ­*(ò§ü;Jb¦F^lÁùr7°"þv=Méí¡£ÛÒÆÞ(¼!mDdìÌè\ÇG_O¿\iû~ÃÈKtSà4dñqLì5wÂ8'Sè¯®¸?ØM¼ãÚcþ\_è/m&)ý#ìSÆ ªÚk%¢Ó¨j¢éÔ¯ÃVâÎÈ½CâÜ¨òãÏ^'Í8=M  ¯ÖÝ*>¸¸'6ÿW{mçCêµaÒ")xØzà.º]­lÚÆp:ëdI3¨¥ö¸ºë¾L64+HvöÈs×	4>óX[2*o²XþTw3NÖíáOAU¢¶ÕñE4\(-Ù4.ªTr§ÿvTÕ¤ 8ïØ%p/¯
ZVmÝÜ)ßlðz§: 8W^s=}qMnÎ= [C¤¤øÎäù3ºÍ'G:âà!OrVFCO½ÈþèA9¶2ÂæávàOÉ0õùÏ¢b,T x{ÊýòÂôD|1¡MÛÆÜ¶ö¦:×!mÇ.ô§ë/¯osï©ÿl~Hÿê4
NçB#Î}yg~+
YDø*
â
Ók¿%©9õh Ãy.êçÃ¾ç/U¸q{¨ ¼?%·Ñ§h{ØHÀÜaw¯¶þ£¸I%©4&flJ°ºåeÙt¿Êohj2hHSå
øzU)bÂöccI%&3-/=M ¨È«»èéöHY¼Myîîï¸å9ÊxìN(Y¢Öt)5SZYÒ)ÄØaM«ÓLàÛÉãdÁ>¬ÎÈú
kÝÙjPäÙmi%©µ¯·,«xIÝjjáÀH^Óx&ølYmqãYQa²oM»---ùà9~/TwÕZÈ²<Øî×m(ÚÙkÂÖKhõ!PbÎ"µIÍ¥0°ºª·«©2-KbôÓJ¤/¤ÈÇ¶³W°zT~Õ
 Ètã¸r ø¨j®"Hãòø,µ»Ô;ïÉÑsVl[uúo¨óÏ3,á÷:[ö&±¹¸G6Ã¾\ÑZnd&ñ(Z*)<1l!OòÚ²·è!©Ã®T¯%Ì»iP°Ú	]îVy¾©A¾)¶ÕîÃH2&ä´SFYð
røÈSSxèºØ§b!m%Êõ¤NAMW(»y9Ôîÿ Æâ2"ò¢R=Mâ@8#%eÊè+Å°#µÑ= "Él^sõ¦&ÖÅ×35ø¢o\¡.¿]ÔÔÐ(£*Û+ãÿh«öN¼¸^@Ùö3qÜªç1yün!xQTv4.ÝÑèØtj¯!7Cÿ}ÃLQÝ¸'yj¼¾|dÃ§!X@\;A5êúîü>e¿$wo.~î[ZöÒ$«o©JêöÂ "z:Â[ázÕä
{»= §+;æZW}ÇÒÁZ{þ$&>§|@!/¼È( 0¥3UyêB&)$M-Ô¨T¿>Í·@Ü_sV/Fum¦g=M-A#kßÆ^{%ü1WOtC¯9µ@Wá]kHÜ
[QQC¨@_)Û¶[ä~Á£i\yM{WÌ¿_ÁÇ;ÄÁ]BÉ½ÌE´òöKç+Ä¹ØGðoÒ$ãÚ¾>÷Ø'ÁÓØl\q­)/Ä9©ÞÁJSÄôC£~Åã4îá?B5óÊYyÿýÊ?ÖraèÅs¶Õ	u½î± ßéT.7ÔÎb4¶ô{!¼áÜÔ$¦Òjo¢µ#¿¬Yc çN2(ï¬%àLFýâA@{x¶t&¯	ÜØT¤&Næ!C{)1(ÖjØjisÔ®³O-é²^É¬lßÄÑH»ÈÌtG{Ä¯Oxö.f­§è¦¥.GòÇ "s:Dõ;:e@wktwïy²wWÞÙw- w9Á,wÖæKx@èex¿ýx!xLÄ½xÂÚÎxíàxùóxuúxêxOÅ2xI= By/MylZy£fyÅsykyÏZyúyÉ«yëÒºyÂyJÊyÓ Ñy´Ùy«)áyVêy6òyLöúybyòÝy³eyÏöyG%y(-yAÄ6yùK=}zZAz_ÚEzIzfQNGÔ>{×WûÖ¨±8í¨óÈô¡ñ¨1§¶ñÚ±Jma1-Ï<ÐJ\t=}½¨ëIÊ0ÔrSØI!×eî_"ØHý¼\ä	i«ÞíûÎJdyS5ÎVÃèC"Êkm=}^ícÕâô­nÙ±¢NôùoT³eYH-´Å×å5$WEÛ
íÉý: qf®Ó®xÒRV-
¢K@"PgEÝ2}ý{PÂÉæc#Þ!ìÁx¥é·n³ÓÛû«sk¶Ù±|n½Ù²?NCYøQ'9_c4is6«6ÊÛzüe9Êàþ$\QQpp4bÔUL=Mâ#f¸Æá=M2£cD¿ÐXÐï·LÚÔ®Á:ßùPÍ5fÓ,U2âo¤ÉÊ=}ò^ Ú Jà5Ö½Æ½dbß41FI¨L×d#p«ïëCâDíÞ@	y=}ÔÈìÉ¹ºüÅñ½Úºgå¹À¥7qåTxÈò®u¼öÕÔ5¥0nòùÕde©LòÀ¯PÔÔey3åsãê¢PáÐ·÷ä&±= ÉÐ÷-û|Ê¼8³ü	¨EoO7É ü¿qEe.¬Ú
-Å·ÞßïynÖÞ´jÊ&.C
ÞlÊî.3ÐÆ¢i©®«àé¦i«¤Itt7[Â!®Ë¡'§¿jVågg¢lbpFfggz¡m®aaÔÔS#¡3d¾ÌnSg
[¶A&=M$óuØÓ¯Õ2â(o7âßÜËúº­·2äjÎ³Û×ã¶$lÑùÔ/A¦ ³Bs}üüàß=Mæ¢e*	â^jÀ ¾S²^Ô>]TÊLÝ§MþÎöÌG]é>MÄtÚû´=}¦vb«&{wLL,soÇ¢Õs¯×ºX×-7Í®tÁjäl§T~6H§®Ã¡¦ O¨b¬èOÚ1ÍXÖCQb½x«F¢¬ SòOÀ\X°!I¯C¼Ú¾,gC¡®Ò=MAìkÃ¢>TZ ;)T<CÈ;õÏ6ðÖzN5rÊT6·lñ1 4ÝJ¢··7ÖµlWä.Ý)À3%?ÀbZ:´« ÝBÖ³«øØÚhÔ)©oÖÖéóãÐFaà	w¦%Êç*¿v-1Â>mXS3	ÙrD1G¶©8[vo©íûÑÈ§qï¡¦ÑJëá·éP*¬±×= zT¢ü¶$?xIÕ®¬ßtQÕìãàTÂPá¿ÔËP}./=Ml¡M^IïkýyK
"A²l ©¸Í6%ÎçÚJõoD=M lXÑI|®ÅqïóVß Â^ÕGS·Ê¡÷6£ïòÊ]ìcÁÊ_4	CGGu²s,Â¬ºS6²Jö¯mÁ«%©ÊU[H_=M¥[&QH{0øz÷5® zV2^s÷j2/ywÊ*È!Ìï(Æ,dxÔ¯÷Bö1ûuðvUöôV5±ãF±\yõnf±°]öbÙ@¯ õIÃÚ(Ù¬.ÑUþñe§þ¼èäSÕú-ozÍX-ê@Ñrb5¨nEÇÕsädVjra3p¡üÁ7Ëq¡HlÖ»qÒ%ìy½&Lô¾d9N?J;}{<; í¨ñ:ñ¨ñ¢ñ¨ñ¨¦¦:§V>E+µÇ¦^úrtëYb4µçü{òEðôÐÏÏ^ô÷GDMEPÞÃ=}Á¶"ÌùtÒy©	ÈA<V=M´ÑÚðd/«]ª¤]FÚXÞ±Gª®iÍË<LºF^åp¿ò½gE!À;¡ 5ÜùÒéÏg-ý¾^6)7¢eªuì_¼Ø1g¯ïà§áHF çã%¥%Â!¯n iNQT\lËº/dêà7½Iª½ïËåAP°°XPoÞÐËÞC´Q0Ï^.ÉGîÞß#öÍ*:¦:üº-6À'Ú5.Ø> Ô­F-ÑÚëS-Ìï÷²S%ú65FQ	·)~õ$, çÖ«¾cËø3¼®Ç$¶ÕKÚøxý(PBtñR²Ø=MËhB§['èþÍpÓ èç=M9)ÿá.´¦pÖ¡[t·e27aÍ7§Wn®r©sEÂ«µ{×í5jÆ^¯áónPÆÊ°ôõá'ÒM4ýÿÅé=Mý^è0Oe:Ø¿²ÑðóîcºNNÀ5W,)ðÏãF9hu;º;»:FWÀxÂ·x±ªxOxìxôxK&tx Ágx{]ZxgøLxí?xð(wRw±ówF¸Øwmê½w5üw9_UweJvÔâvvi¸ô=M¬öæöáÇb÷¼d÷Ä÷Ûkß÷'8ù÷î÷Ñ/÷lìBøÎQP?ü>SAO{ü¨ñ¨ñ¨È¨5jñ¨q*\-ºTë§ùSUêL±ô}ÿPd$45AøË-Ö* @tÕÛa(
¯ ÿN	íÍºzsWJ$c+LîjüMozñP= Õj$kr1"ÐÐ²ÍyðuÆ²ï82NfÊ:O"z«6 Z=M²:ÊÅJµNðázfAìÜ³cn-ÆlS Éb±ÙÙÚÁÞ&É:sÒêÖQk¸l¶-ÒpPr­¦>6º½8(ÀGtÎsª¹×¼ÐâSr WEií$E¢UêNv.q*ª~$\*w¡´*âóuz^¥6Fù_6¦ú vG·²Ú7çêwÉû$÷MÊº\Ðÿ%WÇ1ThÁ¹âþ<=M"¹»<Â1TL¨ûF1p¢Îð@çãÊò!dg':	¼F8Ø3ÔFÄG²ÞÚB@ÀÙG7ÖÜEy£J-îÀzn>Ä0D5K­M}4:sÉL3ÅoZ-/³Ñù7z¯e_fÐU¤/ZÓüEÂèÚþzþ-{zÚë\À=MhÖ¼= Gcêt²Oek:öÅäªå4*Âê^íùÙi½<{é?<Ûwñ¨ñ¨ñzñ¨
1Æ¬ùðv¶v97«2j¬À.:dÍMzc×8ãCqU¾7ºóv¢g+©W.&?-§bÍ2þ¹oÄ= gfì0ÃmVÓªá:å-¡ÕU½4:°1ªûyÎ¬wwáÀª¾qÁuçõÝþ|%W0s3ÈYá&Þ¢»h>éhotÃYUÌ÷ýÓSN¹¹¥ý¿á×Æp~&ÔTjÕR¨|.^Fyiìÿ\ÅÚªrÕòq¸¦~éÿÑê¨'ó® IÜÙIÏZ®~Ü^ºvýubqsÞ±þÔ½F¦áØ®âHâ©	þkJÑ9ü |/÷s¹Æùoª2Óþz·®ýÒÔ¹·,ûJ9woE[%;ÁÄ¼¯9W}ªK&Ð½$Z *KE¹cZÂ-M@«ªI"÷²?ª
«[vÍÚ©mènÅX*ÞÃÙVÙGrò «fÑ¥´g´Ä¬c9R=M³9óN
À1?a9Ùûã_ÌÂÎÓnrÄHsçgÀÀÖ#í 7	¡õßlõjÈuÊ¯BT"Ðü¾Tµ¡M­[NÔQ¹¶íc«!9§)!ËøqB¢¾uQ äÍwiùªyÁÊ.ô»)²@Wj4}×=}ÆSîòÃÆÙie!MÁ6côý7­iÐ=M#(h e	ä fã[-·@)ÐOèç*Ð·¥éÝ4:3ÀöôÕrÎ¥ó~#Òp÷Gç´hÎz=MÆ°óvkîY8µ½MVû ,Èçè¤ÅeÕS¥(Òÿ¶oÎqæÔ¾rÖ$E¤ÍQaw¥Âãñí7f#qÒò-ëÈçë±qj£b(vXWÓ|þ:uSë%bØÐö+g#êÓx(rÎö·øVhY)Ò/ÛòàÂJµ#,# ®ªjÉâµT6éRy)4ÀyiÈ*b= ùZ$8'"ì>'ÉU;¢Aë4¸»?*|ù£X11|±9mÃÜKzG,5K-\¯HsÇã¯SÀþóØZ5¡SVÂLGFcÚtý&N^7³²?xL¦Þ/°Ãë¿ LrÃ3×S±lñ ÃçªÆlÑ)\ É¿êA_^á}üjM5yód ¨ßÏ¨PÅà§^ $d¸dà1ôÏcPTh±m©À[§ÂGîTméêÎ¬$ÃGÈæmñ9_FTbD3UC÷²OFQSQ«eQëªM#WKÓs]<Î0=}f±DXP#ZP3)íûÇ:C4j=}P²@]YFïùKó.
Ú=}-
GÇ>¯<OÎñ¨öüöì¨Uúñ¨ñ¨ñ¨WÈ":ª *Üz:4 *ÊúE¸:cg:é4|ÜnÀ!rPýe'áKôÜÀ´EL<E¶öe¿£4æø¡ÝaÕtÑaøöT6úa·ÊÔÓmÈ;NbæÔ°	Ì÷ØÇ÷8©/e>
ÞGsÑn«¶ÎÙhµ	%$ïTXV)¤ôàÄàU/7:.cÌveù_æøcýdæÃÒÀh8=}I¿P2¯y âÕw±ÛYø¿INrhÖtxÙaÔW ¹gØù°=MÔÔ×)õ±·ücd§&Ú)¼_Q_LÎ³=}æT®jÉ+¥¬çìÊ ·G â¡ºO.Ù­ñ§_+h×pÂ-³­C"?ÎóvÃ4â>T°n»8ø.~2ÒYú·4Ööº÷ó/Îwc2üØ»"©_¬ 0÷Fz2vn£ØNÊ¢t=Mã>ô1/CñÞµóS1þÁçïÅÞ6íqäJçµnìj(¼¬²ùVõlûðf°æ±ûðc®uMÍ<òQ(Ä³Ñ¬F+máp4°-}FIª®¤Á%¸Ng§À»wí£Ã(%5JèÆõÖð,ùAúb¢~Ê¥×õ@ú7sçÿÝàPkÐ"/íiþ®=M'ÙÍõè·lÑo3­±7ÍZ¢ùÄ¶Ê:&Øf0fùÏ¶Ú&%Ê8¼Gè­Ïú=  êö*Ò æF­51¶%Ï?§zi¶RYÌz^JØ½¸fò/\2¥ªÐÚr7.&-íEtVù²_Vg!Æ)7§TwªÁÙe6Í´ øÞàÿLÍTq}UGÍ²5QG ªÌ'ï	ÌÖ ö÷¿jÃËúp½ÿºëò_¹¯LÒvä³÷ê×#=M$[@z»ã­XêaÅ1Z¾;æt©±Ù).Ø¨§q¹óhñ¨ò(ybJö'hJ:ø¸³y1¬b9ÉeVM]°4eSøOÍ*Cxæ@ÅýäÓ¸ýoÐÈýÍ(Æ@H"¤}
õÜh{g¿¨À~¿ÑxX¿u$õ+ãpq¬§i)çïQ½fï×Ve¶yã-Øîî6¤¸ÏÑo,ÈÈbýßJ @=MûHn= 6 3Q¤Ä¾²%ÖbèÐ)"öúÑ=MUàß¾¨Íö}ØâÉ#ýÖ	2ÚNB­L·¡xY[Ó-)2,·ÁåxZëÐÒU3+ â½³ë_z«xÙ
I2Ù.l÷ô×BYc" Zâ¬Føwj©iî»vêåj"è,jT¦´ü5HóíÔ9.ð²,&¶ô<9£ýÊ,|j-ÅñE)l¿.¥Æî:=}Êæ!¬u©ù3eê·¾òv¯Örnjy:I÷7!zê³6º·2(÷$vi9z×:ýr+¸z3Õ°ú4t7´|f
o¨BÐ(=M@ª7HÌU+çÿlXÌìáNï*½Çé#Haxëªg5F²6Û£9J¢½B[¹:{3°SÇt|~Ûð®ci:UÁfÉ^Ûð³_Ê|BèÎ¯ËYú&s~o V¢N£#ÔÜyWrÑÈS¦UÆÁ,i¯=}¹ÖÃIBhÛ¬Meè£S©¾&1=}ÿn3a÷¦Æ±ó¯ Y(:"»¹zXÜÝ)ÇFøKwýPbÇ+­çv)µùDh-½^.Á(¾ª¸L©%Â¨ºó2J{Ø[¹:Dÿð|+õLÇ×\Óó\O&þëdyWi=}À~]2vMé£/iÅü"/Åþþ¢¬K²²¡=}=}b}ÓCþ«¦O7´Õ½\®þö*¤sú¤Mu¶ßuÙè{Ýa·Z ¬Q=}µ¡^´qYI±ü3·ÀÐgJôe4£ØÐÊ¢ØE<£P]¸\QñOÝLßóOÇ9"Å¬ÿó?ÒÐÛ-ªD/^,ëíO6ÒÜ~¹T&qA(T}
ÉÝtl àWjeWâ»µ@·)dëÛîMåñWA= ±e,î|Äý¹]Gç¯JRgÝìÃzö'Ìg÷i6nLÚzÃ9\Ý.z7ÚÃJ¨]ø9^=MÉr]ÔÅ__=M-GÌmé=M4%Ý_uæ[º²@ôúò¥fÞ¹ õåÏÁd\hðM% 		ïjóË÷^F]_ÚÅ-ãÒiHÜHJí£6ÁíH
[ â¯zÍ>·¤ ¥]1i¼!ÂìÏäR~õc=MúW|öÁ»¦c¨hDáôV>¤ór¸¤&NªÍÙ´=M6)æÐBØ¯¼^= ðñ/$Ò+ÒçyÍ12ÙÊÞT|¾T0dqÜßQ~UáÖú$àÓ¯áµs(ZöâGÝv²6Î6ùÓÆÑ)'¯\ê¤æè¥/±¡Bm¬©Lôº Ô1	
$¡®/= ..3º°ÒénYÙ&Ú¢tÈ'NçtKfZõÂhä-îGÈÐ'õç£Iv¸§eæ	i^=MnÊ¡KûÂvîúgÓ)´^ñ¨¡=M¾Àïäëç¿
ýt$Ñ+ã&dµÜ´0OÜ¥ÚÊËo³ÛëõèÈ¦Öî= 2eW®æ})´Ñ&õ¸¢%ßiÈ¸c´²5\6¤«îø4*6^31)¡·ÂØH×ø!?.æÖMó*9W)¯üö?"V¥!-iQ³
æ³íÉ#(7üÌøwè(kr­w Z!+3@93Xé­ÎvHô
FÙ-Áì0÷7xzn-fÚ,b6ñÄÉ§BFPwYÝÉðzpLDúÒ¯£J31&Èæ64;kYÇ¼rÂ]n¦?1å¥OGm{0^g(¨Å$!8uAb¸^£
rýAnSaýQ®ú^ÛÚNEbóÌâV=MþxxFþ¸û÷7ë¡};É1H}"çC ­ s©]9¸OgQ û_Id¢ì	hL¥Í+|8é'Õ?ø¯?)ûëjÔcãºI1Q] Yÿ4³öñ;ÒQ}tôCfÆ¬í?¡%àÅ¹mgnËÜØG l­¸j:o@@§ØÐS÷ÄfúÏ+]ÐÄsìÿ%Ö]WyÄsgÖ%òßf]&L@tTiÏ²æmõ}xõPêÄÀ¯²·y¤¥ þg5¦Ù|Æ¡ßÌEsÔ{ÑÍò¦OtF^PQÎ8d¤ørê«âf$	o¤ãx8x[Ë(%ÍtÉçnÞÔ6G$AXÝ½Ï¤mÃi2Üiyd0¯*ßá.9*oíÁr·2Ã(s´ÈÅz÷zY¢Á¼öÔ°ç0}Ñ4µEöÖ	r5l®Ä'1Æüç\ã>ÆøièLïÖÀ|e¨ùRBaEHÐ¢MßÏãØª$Äß=Mç. ·¼ªnD õ´÷"T·ñy)5¹ùÊÊ(·ÕJÏLr4jô*2÷5=Mù#¯v#Ñå~¶¢z>õ8ySæ	É{Úõ«:£¿!ÃrYØçµÐÜ ×>åÛ&¼¤æ¸kgz;Ö0}Ë«]WÒÁþwqIM,[x@UbG'1ÿôÃê(}/QÇÁÛâm¿p/|¼éBÐc«Q(ë3º(z2é¹:ºoû;@ÕS?¿GSk«70>³r<ÞaåUGÒ;BAi¤°óGåÅ¥Û7BëUi~vJ;ãG}@OUm½ÛXKÁnnál!kýKe[kWG¼ëÃì½ìÉìÔLs4F³SÆAvÌ{¾ÿ=M	 ~û=Müj[cowmuai\dpxnvbêÛãï÷íõáé|~zswuil= hnvúóçíáéìôøöªÏ¤n¢
÷§ Õ°VrfSu5a¢Rð¯/×u®9=MVñ'¶3r)w·58ÝÅ9Ä@ðØ!iò¨*Î"ªy¹84òÛí¸°2ÇàV²Zx²(îòú_ øÞnVõaóÑØ6ó¹*$&J:Fãs!pÓú±"Ì.rZø5/Æfø5Õ8RZ¹7
ä(Úð³4³Îæbg±'ÎÊºt°=}F6Wó15zö8½8²ùîTòèu8Åz÷µ1ÉfªMv3û¥Ôp8û®&7´âyîÕâ8»á«ôZgÉ&Zësª¶@JÛ<K'ô®áP¨ñåküJ{«974ñ>Óëâ@\S@;ýnñð±æ§ñ(ñ¨ñ¨+ò¨ !5¶½ÔTT7}÷ÂØu°û¼jÿ¦°%æâ(ØLT7}÷âÃÛRðõµ$=MàÞ²ÆGy0âÚy³«ÏÃÛRðõ¯974^±ÈGaúºM:fÍ cîK úD²àç?´=Ms¯]üoÓÄ·= rÄÈÿìÎR}j©ÍÔ!¢aØb' kÃÂO²Ü 
o-ÛÈsUB4SïgtW¦I-ºô­ç= Á(w¦=}õ¬Ðpr4×¥©ðUrêÕ½¹àë®hùâÙ¶è
ö¡Sd(îÏ¤!Ö¬ÏGI.ä=MÕ°ÏT ºÃ«ÐLç}¶ó¯!M\m¿·} rÔÿðîÒª©ûQQ¡R((hmÓÏ«Ì= ÿjo1ËÈtB6Óï"W<Én»¬·{´Ù°ÿïø"²éÌ¤!U¨¢VD()p=MÚ¶O¬ÙÓJ²Ú06¶
ÇG"T ¡TÑ,Bx¡®ÉÌynU¨sqÖÈ7ÒV¥ÝÞFÒ$®mÔä¡æëÔ³±,í#þ¨Eu½!%óu'aÔ¸÷¨uÁ+ÓÍiñ_Æ4ÐaYñDÂ"KZVÆI×b,AmÙJäµfëÙ±+÷Ä#ü°-u÷"¥óU§bÌx÷©eA«ÚÝ	òc.4ÌA)ò<6 ;*ÖÄLwb Áí×z¤¬«×É+ô¤Tív'ÇºÏ°È ~¯µ3¯ Eô×iá+TñKélt¸ô~\"Ãt·2Òx_òê²
Ù= ÑDú^q C$X%NÌF?tü[a+LPqKÉklxô|y¢ÓÊT·²ÎX_ñâr{Y@Q<z>q;äX#>nnÍºL!Eþüï/¿ht|¡5j\eGÃ¥6&zfêº¾ÞyTTQê28ÞºH¼°@{ë±VñÄ¨ñ4ñ¨6(ñ¨¡)®TòÙÑ$Tü¡ôO)ýÁµdOyGNùvùÜ[:=}Âýxý*ÔM¯ó]'°ÎÛ¹v\,çSf±âÎä'´fëàLyÒ((3sØìXBIB¾q×¹Í{ørñ+Ú-·½¹oâ@® /]ãTªÁGà!7a³:S	ÈÈ£gÖñÝAÕ|ðh0£®Ô%ë5OÆø
ïH·ØrÌe¯Q(Ûá^Ð3ºSÏpß=}ªJ=Mâ­s|²¬W"½¤#ÍlyÑÝÁÀ:»uæPÛñ1TÈVÚÂÙÀª/IÝyÎ/§ï7|ò±#mmÛ,ãFjG~.¼)wºEù) ÍÒ(©aÁ;¹6x)zÉf¬½PÃÁ¥æmºÉÿ¤Fp±FÄæUwícÆïô
[S¥#,4F<C§û4ü
Óâï3DQ÷øOüN¹´f'Á	éñwl@ÀÆ(:l¯Z?;ÿkG>Ô h2¶ïY]gªp¢Ù"9ÓÇØtÔvUU£Ê÷nÎ\aíØyX=M uà¯$×)þ[gÁGÞëU¡rGþ-kHþsçJ.ëºÁ$»;;KC}l:å ¾ïÓa¤nÈ=M¥Õào¤Õñsèâ´Ê¼SNìl ÿ	SÅàlPg'ÈüWÎìt°)SÉ lXw·'
>´ÙV.t
Ø.u è.v
 ø.w!"÷5wâÓyCg;S»;iKKÞ£ý6©ZÇaj¸²4¹±8
é"0µ±øÚ&ì¦¸±(é8°Y±ØÊ" 4°Z±Ê2 8pJ±Â.7p±Ò.¡7ÐBö-'Ê´íf± é7B±0¾¸ºb±0Æ¸:±0Î¸ º¢±0Ö¸¢: ¼y À¹ Äù È9 Ìy Ð91Ó"÷¦ø¶èh¦Y1íâøØü××Øüûgÿ§ç'g§ç' [FÔíÍÔ'cÔíÑô'°{R¯}r¯¯²¯Ò¯ò¯¯2¯R°r°°²°Ò°ò°°2T¼DqSÀT±SÄdñSÈt1SÌqT Ð±ngüP»kGþ U´1-ÊwÛ§$.7÷ºùz:Ú.	4"ù®:Ô"Ò´nº1¹r6bÊÎ÷Í-ùv4âÊ/Îù=M5ú$v8ÂÂ+Lý³Eh7HÊþ"+u7I
þ2+y7ÊJ3m9Ç3q9ÈÊ"3u9É
23y9:gD<»{;»kÖLýÇ±ìøf<J=MÂ/]8=MÒ/a8Ê=Mâ/e8
=Mò/i8J/m8/q8Ê"/u8
2/y8
J-Â7]:-Ò7a:Ê-â7e:
-ò7i:J.7m:.7ñ"ºú¨£z	Ú.&7vz
.67zYÃJÀ3\ÙÃjÈ3^YÄÐ3= ÙÄªØ3bYÅÊà3dÙÅêè3fYÆ
ð3hÙÆ*ø3jYÇJ 3lÙÇj3nYÈ3pÙÈª3rYÉÊ 3tÙÉê(3vYÊ
03xÙÊ*83ºíB@;»{K¿Å´î84¼QB!B.À4þ·¹lÓº-Î·= º¢-Ö·b:Â-Þ·dºâ-æ·f:-î·hº"-ö·j:B.þ·lºb.·.7.·/7/·070·1714)6?ü>}[;;;ëØ¨ñ¨ñ¨ñ¨ñ¨VxÜÈí5&éï%U¦êò-¥¦éî9ãÝ¼qµcÞÁau#Þ½u#Ý{p ¸PeàÕ$à×Õ$ßÚ%¤àÖ] z&Îx'.y(®	zÄmaÊ=M_Â·bÆM_Ô¥Á!Ô§ÕÔ!ÓªÅ$¡Ô¦ýßcö÷Ífî×-døç­Ï3&ªø6=Mæª÷8êø4	6jìA'ìUÖ'ë
E&§ì½= «xÒ®X2¬h²ó¥V¨ò­¦¨ñ¹fèò©ÆÑ{@>§+{AH«ûB@¯ëû@<ÍãÃhÙÝÄdÉ3ÝÃiÑó]EpÇëþFtïkþDzÏþErÞÉl1³^Êq!sÊm5ÉSì¬'>Ç_;»úõñ¨êÞ¥§ñôW¢ñ¨@"Ó¢ÿ$èP.ÏñZ¼4ôôDk r­Wkt7"9ö= ¦î»÷n ºP>.mJ±Î}HQ?Û\ÂQWÃ{DxÓ¾½GUë\¿_E#ûÀSIü;MÙ'\ÐgD_Ù¬_M>à/Åjm¤ÿÑÍdßNt= ¾+j¤KDÁNSdÞJn7ÌN±¿ÜàÃiÃKG\Ö¸ßÊpü_Ív	îÚ­5lZposuÅ$ØWáÕ»ôtÆ_TÅB-ÆF¸¸êsv5½n¢"lëg|Cölü<Z]¼F<ÿÛ|ýQ}¾dÉ3MÄMD_Ñ³S¶lþDzÝÀV|ÿÌ»W¶÷D¢Z!so¥ç¬bÓ_Í¯!Ua<§ËÚþè6= &ÓÙ}K¶C;Ûà  Nh¹K8.;	üBSyLÆa8ô!JDï4±ñfR(Hº<a{.V«+n³ ®ÀzþýýøýèýðýÕë_j'CVýhw¢Âêyvø"ÁJúÉUÉVÊTÉ$Ê¤@8ìÅçÅ'Åçí'¼9ÃùÃdêdê°§YñµÿìFåÏ­nèÙ= 2XåfjdfpÑ*ª'vMlQVØðrzæ[ò_øcè3«¥  ¢åõÁ.èq²x¥9½ÆQÊõzå%pT&IâÐYih
ehäk%ÖMÖÎÍAPlFü9ðÔì Ðè(Ìì>øxN®	i«ÞøñÊx¢,í~ÑrôyÕ°ócøë[úÍ×ÌÒ=MÕé%/ä¶o2'?i4@¢ÈSvÝö^A>}Á>ÊA	?hõ©õ(­Þ"ð²õy+ï(vñÆ1©Ê%5=M-E-f-Õðpdp6Vµ~Å Ëxö¢y7Á»°ûC£=M|ÁKaÛáÂ×ÉÙRï·×ÜÐSÉz]usöõ¶³´6354B??A@@Æ7uÜ"Î¤!­ãã=}Ò³öYÕ[ßPÑ[àXÙRgu{jC^ýÏ;[ó8d5ÐD3:9ä	÷ÐüWë?ç· iÉ»nEó>Ù»rF3>¼{k+R¾/OkDM¾<«¨*ªñ¨wñ¨ñ¨ñ¨6ñY¥wÒ_Íe$Íi4Od h0o=Mf(¯=Mj8GmcmgVîdÖî= îhî^vîföîb¶îj6®[B®cÂ®_®g®]b®eâ®a¢®i"®\R®dÒ®= ®h®^r®fò®b²®j2.[J.cÊ._.g
.]j.eê.aª.i*.\Z.dÚ.= .h.^z.fú.bº.j:n²é4îË g tfNkÜ¿NoìÿÎmäßÎqôlàÏpðnèïrø/nkÞÇno1õÒAÌNôPt$ø§à·'wvþð7&·n µRÓV¼F(Dmõ£§¡ilnuÒÕDiÎdâi.E® ém1hÎp!ÿÀ¦((uÔèrb)Gë²¼µEÍë~Èp±ªÓØEò²L±m=MÙ£÷É0×*8aüªN8bºÎØ\Ëýo¢ávvþXÔ)­¢Éö®ËâÑ·pPåèÈ ¥h®Ô0[æ/èòx$ð|
ÈµªÑ|Æg=MiÖT°å¡¸í&ÒÛgÂu]lTÊµ!íÚp¾ÈNn§ñkÞè¥¦n'ñr~~W²p³îÙ)¦¢2"{êJ1ÜùvªÉ/Þ8":xTbu&¢Ù%'n¬Ñö	¬"´)ù{HRæ péñf³Èê.H¥úJò% Ixàò¶/³úZ.^µºA¤ÔwbÖR/íçÐVí¶Á*->Ô¹g 7ÀçrkIì_O9åBxÙsä¢nñ6íñ¨E¶¦¨ñ(ñ¦¨Èút7¶º½ªº¼æºBB»<?sQãK×SATÀûAÐ;Î½Q¥0
=}tZ÷= [Õû¯û;³ÞêBb©<­¢«2>:ck~)Cé<¬j
»·J×Z{ÒûDÑFW= Cw[
M?òÐ0Ò@!|i¤q#g'ÞgÐQ.QFnvÿõ\÷,K9è\7g¿çIéXÞ­:ÀDõ]Ã^]JË C	O¸O.Ïì4q	|qòtìaÁbîÓÞÊ1= Òbëþ9÷JÍÃpÓBÇèØÚÌÿFmg)@í¼ôõ½½ÂeL¦ºÀwßUb¾ùìAîhz×Â%è"ÿª%Ì"pKç\= Ä´Aô~¢±	}:zF6"¨xRsJ^!n1,·÷ÂQÒÄ³/]ÙÆ¬r½zõOîÇ­½Ðf,fìVÌøsæpÞr¦ü'Ó©þôÝX °Ï6²]n?>xã>µl0Ì6÷Z²)[µ\'ÁÌtBªXÀóµ?S §,÷p+Òèº¨·ÞþjéÊÔË£½nq|G6ùÌV§Ä.#îòü/ªº¶×²¨ìnb'Å7r½æ1{XóR¡Z­n2þ*ÊM«î@,C3lTÃü.ûªAÜ4KzW/ÛÚÁ3ºë÷[a@9&½Öhãô\7v~ÿrH®®]½5[½¹w-§* K$?æ%uFóì_G2ÎÁÛÔE×VkÓÔ(psÔHIby6aÀÔHEnnnnî
ÕÕW¸0922hPåcA3åWãÜ·G»ñm=}ñ¾D=}n	;¡HsQkBs>5#AÕÉ»Ò³;®þBÓÇi»äKÛý¹BïÝb«ûIÇ¨ÔG/ýgIQ;ÉY;'*ÛRÇ>á³efæ<â<o¸T[:H»®²> ¬CÓ¿®{vAñ7@L»ÎLX§ÄëLÀú@[©Z¿!ß\®;ýt¥UKïUTÂãÒK6M¬²?¶Éû6>CõuÉýBMóè½è]#¿^?^¹}6lÄ¦uÍV|ÝL¾wúÌßÙrÌ>ÍñE¤R<IL«Öæ?/ãa<Ù4ûUãÀîC\-gR2òDì%ÀË)g)âÆ+÷Ô]%,´Lu_!ÿ'3l	ócáó©M×	#ZUuº±ÑÝ.àãdÙøÙg*£Ó×ö{É]@²w|²séûb¸Ð§&=}= bãe%+PI
l5p UâGäÄL#+d^©®çlV°SêlÜ2ømÊp = A¡ç¯ÔTR§	SmâeÁàä= ïþM¡§tªî¡m.¨#ÖÑ¥±¤pypÑÆ* 21³D¶±ø>¢Ô(Ãu³uD¢W¯ ÔÄ'ºêÐ;eV;~Z»;= »1A{{s½×ÂC%rNÌÛQý%]ó|KªÑüÌÚ+¤n½BâüÞHT	+hæNç¨1¾Ë7sËVüê¦d¿õÉ>õÜI5Ù>WI¾ÌÂ+ÿGÞ®äY£=MÆO$uH"pÜtc·Ázìø2£áH´ØÑ/ó¡Ò/Ow¶öÛFQ1'µÃ6áÅÁ·RôOë<²­_¾µ°ý|ß/ öb=MR©¡µg*5ÑI6#ÜU²¸Û<n2ÛGºªáEW]ãt¿Àl¸-{+&å¡°ð3éð³¢ú¹Ù'7äö¨"÷øýìØèAµg#w¶L°ê7=}=MB¤C&hé#ñ4á´8 &2Éósnæï	î%í¢-ê·m|h*¤WåØ;AÀ>
@3Å[ûNhDîQFü*Ý?uJûØ6ë
A§²Âp[ôsFû .oCtï@ÝÚý#£=MÖ#wìîxýß½GÒÿDó|Ü}5jìÝNÈ°5EÇ>ïvßøNÀªfÈÆHøý	§åpª­( øç°ÓX*)· ©T0¢ÇÂ¹ÆÑB¿¤iÅ5mtímhâ¡'»BNiÇ©¦=}{fLÐË+¡ùC}ØûÀÓ}qb³.x;Ý<¸Ø<å¢ÆrEØø>¬Cä­ ·|ãKLQfäÕ65avTõÝýÃ®tÐ"¦6Ál¬¨6ñý>HG8¶$  =MøÄd»¥BGÁØÇ¼¹$=}¯ã)uYGz;C}pd¿\|6(L=Mf_ï#ß«WÞ¥§fp@0N6
'¤sªQø÷Õ¬Åq¾>.øü·¢D5³TáhÅ8zDvO= ¯óÝyàÙåFÆÒçcËóz?Ê5cèúë.ÌðÐÞ~OË|¿ÓQ§v)BHX6øöÇ¥kÒÚa¡cÙ7¦x©nº¡6¾}®­iÏ< ÎWh2 9's"IÉ<»ïX\#F\Ë_4F[ eÚ¸ø¹2øH$ß9_xì9i2µã
ã/¸Äyf"5TàyÊ0îEê²Þm6ëÞè6ð Ïâ§9¬k=}¼àt<¦Mdç6" p_î3,oO3p"pw÷´/(1ñøs.íA/ &ÏUÃ_XÍpÕ1hÌ80EQö
ow÷!x.AÜ"¢j+ï¦¹¦¶®äRow÷!xêpnâ#ðù
z AÍp\0NHJê´ªØ^U
Iwu¸öôú!3å6³âVq£³¹´RN£%y10º:p#\:J:b9Hµ7h_:¢I9 _¼µV,þ<`
    });
    var imports = {
        "a": wasmImports
    };
    // No ATMODULES hooks
    // Begin runtime exports
    // End runtime exports
    // Begin JS library exports
    // End JS library exports
    this.setModule = (data)=>{
        WASMAudioDecoderCommon.setModule($42da1043ef19c7aa$export$2e2bcd8739ae039, data);
    };
    this.getModule = ()=>WASMAudioDecoderCommon.getModule($42da1043ef19c7aa$export$2e2bcd8739ae039);
    this.instantiate = ()=>{
        this.getModule().then((wasm)=>WebAssembly.instantiate(wasm, imports)).then((instance)=>{
            const wasmExports = instance.exports;
            assignWasmExports(wasmExports);
            wasmMemory = wasmExports["g"];
            updateMemoryViews();
            // No ATPRERUNS hooks
            initRuntime(wasmExports);
            ready();
        });
        // end include: postamble_minimal.js
        // include: src/opus-decoder/src/emscripten-post.js
        this.ready = new Promise((resolve)=>{
            ready = resolve;
        }).then(()=>{
            this.HEAP = wasmMemory.buffer;
            this.malloc = _malloc;
            this.free = _free;
            this.opus_frame_decoder_create = _opus_frame_decoder_create;
            this.opus_frame_decode_float_deinterleaved = _opus_frame_decode_float_deinterleaved;
            this.opus_frame_decoder_destroy = _opus_frame_decoder_destroy;
        });
        return this;
    };
}


function $27034431d4d4accd$export$2e2bcd8739ae039(options = {}) {
    // static properties
    if (!$27034431d4d4accd$export$2e2bcd8739ae039.errors) // prettier-ignore
    Object.defineProperties($27034431d4d4accd$export$2e2bcd8739ae039, {
        errors: {
            value: new Map([
                [
                    -1,
                    "OPUS_BAD_ARG: One or more invalid/out of range arguments"
                ],
                [
                    -2,
                    "OPUS_BUFFER_TOO_SMALL: Not enough bytes allocated in the buffer"
                ],
                [
                    -3,
                    "OPUS_INTERNAL_ERROR: An internal error was detected"
                ],
                [
                    -4,
                    "OPUS_INVALID_PACKET: The compressed data passed is corrupted"
                ],
                [
                    -5,
                    "OPUS_UNIMPLEMENTED: Invalid/unsupported request number"
                ],
                [
                    -6,
                    "OPUS_INVALID_STATE: An encoder or decoder structure is invalid or already freed"
                ],
                [
                    -7,
                    "OPUS_ALLOC_FAIL: Memory allocation has failed"
                ]
            ])
        }
    });
    // injects dependencies when running as a web worker
    // async
    this._init = ()=>new this._WASMAudioDecoderCommon(this).instantiate(this._EmscriptenWASM, this._module).then((common)=>{
            this._common = common;
            this._inputBytes = 0;
            this._outputSamples = 0;
            this._frameNumber = 0;
            this._input = this._common.allocateTypedArray(this._inputSize, Uint8Array);
            this._output = this._common.allocateTypedArray(this._outputChannels * this._outputChannelSize, Float32Array);
            const mapping = this._common.allocateTypedArray(this._channels, Uint8Array);
            mapping.buf.set(this._channelMappingTable);
            this._decoder = this._common.wasm.opus_frame_decoder_create(this._sampleRate, this._channels, this._streamCount, this._coupledStreamCount, mapping.ptr, this._preSkip, this._forceStereo);
        });
    Object.defineProperty(this, "ready", {
        enumerable: true,
        get: ()=>this._ready
    });
    // async
    this.reset = ()=>{
        this.free();
        return this._init();
    };
    this.free = ()=>{
        this._common.free();
        this._common.wasm.opus_frame_decoder_destroy(this._decoder);
        this._common.wasm.free(this._decoder);
    };
    this._decode = (opusFrame)=>{
        if (!(opusFrame instanceof Uint8Array)) throw Error("Data to decode must be Uint8Array. Instead got " + typeof opusFrame);
        this._input.buf.set(opusFrame);
        let samplesDecoded = this._common.wasm.opus_frame_decode_float_deinterleaved(this._decoder, this._input.ptr, opusFrame.length, this._output.ptr);
        let error;
        if (samplesDecoded < 0) {
            error = "libopus " + samplesDecoded + " " + ($27034431d4d4accd$export$2e2bcd8739ae039.errors.get(samplesDecoded) || "Unknown Error");
            console.error(error);
            samplesDecoded = 0;
        }
        return {
            outputBuffer: this._common.getOutputChannels(this._output.buf, this._outputChannels, samplesDecoded),
            samplesDecoded: samplesDecoded,
            error: error
        };
    };
    this.decodeFrame = (opusFrame)=>{
        let errors = [];
        const decoded = this._decode(opusFrame);
        if (decoded.error) this._common.addError(errors, decoded.error, opusFrame.length, this._frameNumber, this._inputBytes, this._outputSamples);
        this._frameNumber++;
        this._inputBytes += opusFrame.length;
        this._outputSamples += decoded.samplesDecoded;
        return this._WASMAudioDecoderCommon.getDecodedAudioMultiChannel(errors, [
            decoded.outputBuffer
        ], this._outputChannels, decoded.samplesDecoded, this._sampleRate);
    };
    this.decodeFrames = (opusFrames)=>{
        let outputBuffers = [], errors = [], samplesDecoded = 0, i = 0;
        while(i < opusFrames.length){
            const opusFrame = opusFrames[i++];
            const decoded = this._decode(opusFrame);
            outputBuffers.push(decoded.outputBuffer);
            samplesDecoded += decoded.samplesDecoded;
            if (decoded.error) this._common.addError(errors, decoded.error, opusFrame.length, this._frameNumber, this._inputBytes, this._outputSamples);
            this._frameNumber++;
            this._inputBytes += opusFrame.length;
            this._outputSamples += decoded.samplesDecoded;
        }
        return this._WASMAudioDecoderCommon.getDecodedAudioMultiChannel(errors, outputBuffers, this._outputChannels, samplesDecoded, this._sampleRate);
    };
    // injects dependencies when running as a web worker
    this._isWebWorker = $27034431d4d4accd$export$2e2bcd8739ae039.isWebWorker;
    this._WASMAudioDecoderCommon = $27034431d4d4accd$export$2e2bcd8739ae039.WASMAudioDecoderCommon || (0, $9l3Lt.default);
    this._EmscriptenWASM = $27034431d4d4accd$export$2e2bcd8739ae039.EmscriptenWASM || (0, $42da1043ef19c7aa$export$2e2bcd8739ae039);
    this._module = $27034431d4d4accd$export$2e2bcd8739ae039.module;
    const MAX_FORCE_STEREO_CHANNELS = 8;
    const isNumber = (param)=>typeof param === "number";
    const sampleRate = options.sampleRate;
    const channels = options.channels;
    const streamCount = options.streamCount;
    const coupledStreamCount = options.coupledStreamCount;
    const channelMappingTable = options.channelMappingTable;
    const preSkip = options.preSkip;
    const forceStereo = options.forceStereo ? 1 : 0;
    // channel mapping family >= 1
    if (channels > 2 && (!isNumber(streamCount) || !isNumber(coupledStreamCount) || !Array.isArray(channelMappingTable))) throw new Error("Invalid Opus Decoder Options for multichannel decoding.");
    // libopus sample rate
    this._sampleRate = [
        8e3,
        12e3,
        16e3,
        24e3,
        48e3
    ].includes(sampleRate) ? sampleRate : 48000;
    // channel mapping family 0
    this._channels = isNumber(channels) ? channels : 2;
    this._streamCount = isNumber(streamCount) ? streamCount : 1;
    this._coupledStreamCount = isNumber(coupledStreamCount) ? coupledStreamCount : this._channels - 1;
    this._channelMappingTable = channelMappingTable || (this._channels === 2 ? [
        0,
        1
    ] : [
        0
    ]);
    this._preSkip = preSkip || 0;
    this._forceStereo = channels <= MAX_FORCE_STEREO_CHANNELS && channels != 2 ? forceStereo : 0;
    this._inputSize = 3840 * this._channels; // 256kbs per channel
    this._outputChannelSize = 5760;
    this._outputChannels = this._forceStereo ? 2 : this._channels;
    this._ready = this._init();
    return this;
}



var $ii0lZ = parcelRequire("ii0lZ");


class $10073398c294630e$export$2e2bcd8739ae039 extends (0, $ii0lZ.default) {
    constructor(options){
        super(options, "opus-decoder", (0, $27034431d4d4accd$export$2e2bcd8739ae039), (0, $42da1043ef19c7aa$export$2e2bcd8739ae039));
    }
    async decodeFrame(data) {
        return this.postToDecoder("decodeFrame", data);
    }
    async decodeFrames(data) {
        return this.postToDecoder("decodeFrames", data);
    }
}



var $ctpdC = parcelRequire("ctpdC");
(0, $ctpdC.assignNames)((0, $27034431d4d4accd$export$2e2bcd8739ae039), "OpusDecoder");
(0, $ctpdC.assignNames)((0, $10073398c294630e$export$2e2bcd8739ae039), "OpusDecoderWebWorker");


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ const $860f0b5184108148$var$symbol = Symbol;
// prettier-ignore
/*
[
  [
    "left, right",
    "left, right, center",
    "left, center, right",
    "center, left, right",
    "center"
  ],
  [
    "front left, front right",
    "front left, front right, front center",
    "front left, front center, front right",
    "front center, front left, front right",
    "front center"
  ],
  [
    "side left, side right",
    "side left, side right, side center",
    "side left, side center, side right",
    "side center, side left, side right",
    "side center"
  ],
  [
    "rear left, rear right",
    "rear left, rear right, rear center",
    "rear left, rear center, rear right",
    "rear center, rear left, rear right",
    "rear center"
  ]
]
*/ const $860f0b5184108148$var$mappingJoin = ", ";
const $860f0b5184108148$export$3e501d20baea1003 = (()=>{
    const front = "front";
    const side = "side";
    const rear = "rear";
    const left = "left";
    const center = "center";
    const right = "right";
    return [
        "",
        front + " ",
        side + " ",
        rear + " "
    ].map((x)=>[
            [
                left,
                right
            ],
            [
                left,
                right,
                center
            ],
            [
                left,
                center,
                right
            ],
            [
                center,
                left,
                right
            ],
            [
                center
            ]
        ].flatMap((y)=>y.map((z)=>x + z).join($860f0b5184108148$var$mappingJoin)));
})();
const $860f0b5184108148$export$3254282aac6747d2 = "LFE";
const $860f0b5184108148$export$25d110495212ae90 = "monophonic (mono)";
const $860f0b5184108148$export$ec7f46128a2f8ed8 = "stereo";
const $860f0b5184108148$var$surround = "surround";
const $860f0b5184108148$export$8ec6a2c9fbba54e0 = (channelCount, ...mappings)=>`${[
        $860f0b5184108148$export$25d110495212ae90,
        $860f0b5184108148$export$ec7f46128a2f8ed8,
        `linear ${$860f0b5184108148$var$surround}`,
        "quadraphonic",
        `5.0 ${$860f0b5184108148$var$surround}`,
        `5.1 ${$860f0b5184108148$var$surround}`,
        `6.1 ${$860f0b5184108148$var$surround}`,
        `7.1 ${$860f0b5184108148$var$surround}`
    ][channelCount - 1]} (${mappings.join($860f0b5184108148$var$mappingJoin)})`;
const $860f0b5184108148$export$c067b99a35ad0847 = [
    $860f0b5184108148$export$25d110495212ae90,
    $860f0b5184108148$export$8ec6a2c9fbba54e0(2, $860f0b5184108148$export$3e501d20baea1003[0][0]),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(3, $860f0b5184108148$export$3e501d20baea1003[0][2]),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(4, $860f0b5184108148$export$3e501d20baea1003[1][0], $860f0b5184108148$export$3e501d20baea1003[3][0]),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(5, $860f0b5184108148$export$3e501d20baea1003[1][2], $860f0b5184108148$export$3e501d20baea1003[3][0]),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(6, $860f0b5184108148$export$3e501d20baea1003[1][2], $860f0b5184108148$export$3e501d20baea1003[3][0], $860f0b5184108148$export$3254282aac6747d2),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(7, $860f0b5184108148$export$3e501d20baea1003[1][2], $860f0b5184108148$export$3e501d20baea1003[2][0], $860f0b5184108148$export$3e501d20baea1003[3][4], $860f0b5184108148$export$3254282aac6747d2),
    $860f0b5184108148$export$8ec6a2c9fbba54e0(8, $860f0b5184108148$export$3e501d20baea1003[1][2], $860f0b5184108148$export$3e501d20baea1003[2][0], $860f0b5184108148$export$3e501d20baea1003[3][0], $860f0b5184108148$export$3254282aac6747d2)
];
const $860f0b5184108148$export$cd63464c02a18ed3 = 192000;
const $860f0b5184108148$export$388131623a5f947b = 176400;
const $860f0b5184108148$export$4a9bd43882a638a3 = 96000;
const $860f0b5184108148$export$308fdd6283300e68 = 88200;
const $860f0b5184108148$export$44cafc10e39936f9 = 64000;
const $860f0b5184108148$export$671a0c9051642a0b = 48000;
const $860f0b5184108148$export$7b8ebc2092af05a9 = 44100;
const $860f0b5184108148$export$8786c8b1e955b2e9 = 32000;
const $860f0b5184108148$export$492422570a89c8b0 = 24000;
const $860f0b5184108148$export$dc67eb20d4395175 = 22050;
const $860f0b5184108148$export$a92c08b19856a52b = 16000;
const $860f0b5184108148$export$d18082a7f1daad0e = 12000;
const $860f0b5184108148$export$dd010cc0b9cbe96a = 11025;
const $860f0b5184108148$export$8024c021d839bc0e = 8000;
const $860f0b5184108148$export$8003a269f1123d37 = 7350;
const $860f0b5184108148$export$b9d4fc21491dc293 = "absoluteGranulePosition";
const $860f0b5184108148$export$2a97ae90773dd351 = "bandwidth";
const $860f0b5184108148$export$cee20cdac1cd19df = "bitDepth";
const $860f0b5184108148$export$fbead197e07be487 = "bitrate";
const $860f0b5184108148$export$d48d8e6e1487adc4 = $860f0b5184108148$export$fbead197e07be487 + "Maximum";
const $860f0b5184108148$export$971636741d86955 = $860f0b5184108148$export$fbead197e07be487 + "Minimum";
const $860f0b5184108148$export$d28b7ae062ff03c5 = $860f0b5184108148$export$fbead197e07be487 + "Nominal";
const $860f0b5184108148$export$ab1029bcae9ddb4a = "buffer";
const $860f0b5184108148$export$e2acf35f1e805875 = $860f0b5184108148$export$ab1029bcae9ddb4a + "Fullness";
const $860f0b5184108148$export$1c37c01eba8ed446 = "codec";
const $860f0b5184108148$export$a53f1e3778a12d7d = $860f0b5184108148$export$1c37c01eba8ed446 + "Frames";
const $860f0b5184108148$export$a592872ee1129cb4 = "coupledStreamCount";
const $860f0b5184108148$export$4fafbcc8068ef7ca = "crc";
const $860f0b5184108148$export$bacf03850837cc9e = $860f0b5184108148$export$4fafbcc8068ef7ca + "16";
const $860f0b5184108148$export$1cd93882633e45f5 = $860f0b5184108148$export$4fafbcc8068ef7ca + "32";
const $860f0b5184108148$export$4051a07651545597 = "data";
const $860f0b5184108148$export$6d59db4903f20f7d = "description";
const $860f0b5184108148$export$1f34108aa9eb96ab = "duration";
const $860f0b5184108148$export$bef81ba411953b51 = "emphasis";
const $860f0b5184108148$export$ae48fe32cc58ab6f = "hasOpusPadding";
const $860f0b5184108148$export$38e42c68cf43b5d4 = "header";
const $860f0b5184108148$export$b046ea5b29155775 = "isContinuedPacket";
const $860f0b5184108148$export$818e7b951c237e5d = "isCopyrighted";
const $860f0b5184108148$export$f7027d263cc898cc = "isFirstPage";
const $860f0b5184108148$export$947c0ccec8fe9e2a = "isHome";
const $860f0b5184108148$export$59545aa1378f3baa = "isLastPage";
const $860f0b5184108148$export$e512c40786d058ff = "isOriginal";
const $860f0b5184108148$export$1d1349f4eb9a7003 = "isPrivate";
const $860f0b5184108148$export$ca9d7e8ef88bd07e = "isVbr";
const $860f0b5184108148$export$50a222d9023da98b = "layer";
const $860f0b5184108148$export$f24224f1c91d8156 = "length";
const $860f0b5184108148$export$549ff81930776885 = "mode";
const $860f0b5184108148$export$f1eb63ab5aca5708 = $860f0b5184108148$export$549ff81930776885 + "Extension";
const $860f0b5184108148$export$a08b701eae9f6dda = "mpeg";
const $860f0b5184108148$export$33a1ce7cb4e60d8d = $860f0b5184108148$export$a08b701eae9f6dda + "Version";
const $860f0b5184108148$export$7a8a2426cba807b6 = "numberAACFrames";
const $860f0b5184108148$export$ed96e046486b4b25 = "outputGain";
const $860f0b5184108148$export$3dc3ed1cd86c68b4 = "preSkip";
const $860f0b5184108148$export$4882ae973e0491e = "profile";
const $860f0b5184108148$export$9840eaf33e948519 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$b9b4c22e291dd3d9 = "protection";
const $860f0b5184108148$export$bfe96fedbe3c1b3b = "rawData";
const $860f0b5184108148$export$27e01f77e7f7ec20 = "segments";
const $860f0b5184108148$export$7ec32827e4221318 = "subarray";
const $860f0b5184108148$export$83d89fbfd8236492 = "version";
const $860f0b5184108148$export$3e1eea38d3db9f18 = "vorbis";
const $860f0b5184108148$export$3a1c3ed71012e84e = $860f0b5184108148$export$3e1eea38d3db9f18 + "Comments";
const $860f0b5184108148$export$fe63a71268ec44ee = $860f0b5184108148$export$3e1eea38d3db9f18 + "Setup";
const $860f0b5184108148$var$block = "block";
const $860f0b5184108148$export$5af3e22a52b4ea9e = $860f0b5184108148$var$block + "ingStrategy";
const $860f0b5184108148$export$f542eb4365e59cc9 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$446963a0ea44fb9d = $860f0b5184108148$var$block + "Size";
const $860f0b5184108148$export$f3cbeb72a3601eb6 = $860f0b5184108148$var$block + "size0";
const $860f0b5184108148$export$6880a9e40f87ae65 = $860f0b5184108148$var$block + "size1";
const $860f0b5184108148$export$99f767e02b81025c = $860f0b5184108148$var$symbol();
const $860f0b5184108148$var$channel = "channel";
const $860f0b5184108148$export$1dbaf4b0a82f5d28 = $860f0b5184108148$var$channel + "MappingFamily";
const $860f0b5184108148$export$e856ca83ff30dbad = $860f0b5184108148$var$channel + "MappingTable";
const $860f0b5184108148$export$589c9a7ae9a79c5e = $860f0b5184108148$var$channel + "Mode";
const $860f0b5184108148$export$4881de1ae3929548 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$9659c395d9de169e = $860f0b5184108148$var$channel + "s";
const $860f0b5184108148$var$copyright = "copyright";
const $860f0b5184108148$export$7306104bb28d5804 = $860f0b5184108148$var$copyright + "Id";
const $860f0b5184108148$export$19129109fa742a6f = $860f0b5184108148$var$copyright + "IdStart";
const $860f0b5184108148$export$2cef06c20297c17d = "frame";
const $860f0b5184108148$export$150180f5f882de62 = $860f0b5184108148$export$2cef06c20297c17d + "Count";
const $860f0b5184108148$export$326bb32b4ec6239b = $860f0b5184108148$export$2cef06c20297c17d + "Length";
const $860f0b5184108148$var$Number = "Number";
const $860f0b5184108148$export$5da2c6384bf58746 = $860f0b5184108148$export$2cef06c20297c17d + $860f0b5184108148$var$Number;
const $860f0b5184108148$export$e4cdad84c725445 = $860f0b5184108148$export$2cef06c20297c17d + "Padding";
const $860f0b5184108148$export$7815706ac4afa67d = $860f0b5184108148$export$2cef06c20297c17d + "Size";
const $860f0b5184108148$var$Rate = "Rate";
const $860f0b5184108148$export$cc7fd71f037082e3 = "inputSample" + $860f0b5184108148$var$Rate;
const $860f0b5184108148$var$page = "page";
const $860f0b5184108148$export$c16a704080c492f2 = $860f0b5184108148$var$page + "Checksum";
const $860f0b5184108148$export$7b4b65786d4d1f7 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$e0e12ae5ee640391 = $860f0b5184108148$var$page + "SegmentTable";
const $860f0b5184108148$export$a60fa1703d7dd487 = $860f0b5184108148$var$page + "Sequence" + $860f0b5184108148$var$Number;
const $860f0b5184108148$var$sample = "sample";
const $860f0b5184108148$export$dda3274d649921c8 = $860f0b5184108148$var$sample + $860f0b5184108148$var$Number;
const $860f0b5184108148$export$851d973a43101ae1 = $860f0b5184108148$var$sample + $860f0b5184108148$var$Rate;
const $860f0b5184108148$export$590421bd05077aa4 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$5f20c3cdf3b5e8be = $860f0b5184108148$var$sample + "s";
const $860f0b5184108148$var$stream = "stream";
const $860f0b5184108148$export$ef26b3900cee0fa3 = $860f0b5184108148$var$stream + "Count";
const $860f0b5184108148$export$9010c500bffe71e6 = $860f0b5184108148$var$stream + "Info";
const $860f0b5184108148$export$462f9602534f6121 = $860f0b5184108148$var$stream + "Serial" + $860f0b5184108148$var$Number;
const $860f0b5184108148$export$fd98de4d87954f15 = $860f0b5184108148$var$stream + "StructureVersion";
const $860f0b5184108148$var$total = "total";
const $860f0b5184108148$export$acdbe6200d314ea0 = $860f0b5184108148$var$total + "BytesOut";
const $860f0b5184108148$export$4ff6995501858325 = $860f0b5184108148$var$total + "Duration";
const $860f0b5184108148$export$27063c03e3b4546e = $860f0b5184108148$var$total + "Samples";
const $860f0b5184108148$export$3027c70a881d60dc = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$ccac409b8bd6669d = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$ebf36ec211205204 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$24d5305cc192425a = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$ebd6064652549ce9 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$58da9968c3170cb1 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$bd2dbf3c3b57dcf1 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$6a29256c87cd443c = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$47ed31abc613cf55 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$604ed74fb893f0e2 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$fd8d2ba2926cdfb6 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$9616b51a1be2e082 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$d9639f7fbeab4358 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$b025372f68843755 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$aad8462122ac592b = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$d7c4a0dd6a4567e5 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$c34399eed923e901 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$b97792a91f8a2a21 = $860f0b5184108148$var$symbol();
const $860f0b5184108148$export$d7e5036dad7e20bb = Uint8Array;
const $860f0b5184108148$export$40b76aa5ded53e7a = DataView;
const $860f0b5184108148$export$e46d647da3214494 = "reserved";
const $860f0b5184108148$export$a4535ec98457231d = "bad";
const $860f0b5184108148$export$13e2de3c33d99539 = "free";
const $860f0b5184108148$export$f883a24d5edde77c = "none";
const $860f0b5184108148$export$26245484299fce57 = "16bit CRC";


const $dd0c961b75cd9139$var$getCrcTable = (crcTable, crcInitialValueFunction, crcFunction)=>{
    for(let byte = 0; byte < crcTable[0, $860f0b5184108148$export$f24224f1c91d8156]; byte++){
        let crc = crcInitialValueFunction(byte);
        for(let bit = 8; bit > 0; bit--)crc = crcFunction(crc);
        crcTable[byte] = crc;
    }
    return crcTable;
};
const $dd0c961b75cd9139$var$crc8Table = $dd0c961b75cd9139$var$getCrcTable(new (0, $860f0b5184108148$export$d7e5036dad7e20bb)(256), (b)=>b, (crc)=>crc & 0x80 ? 0x07 ^ crc << 1 : crc << 1);
const $dd0c961b75cd9139$var$flacCrc16Table = [
    $dd0c961b75cd9139$var$getCrcTable(new Uint16Array(256), (b)=>b << 8, (crc)=>crc << 1 ^ (crc & 32768 ? 0x8005 : 0))
];
const $dd0c961b75cd9139$var$crc32Table = [
    $dd0c961b75cd9139$var$getCrcTable(new Uint32Array(256), (b)=>b, (crc)=>crc >>> 1 ^ (crc & 1) * 0xedb88320)
];
// build crc tables
for(let i = 0; i < 15; i++){
    $dd0c961b75cd9139$var$flacCrc16Table.push(new Uint16Array(256));
    $dd0c961b75cd9139$var$crc32Table.push(new Uint32Array(256));
    for(let j = 0; j <= 0xff; j++){
        $dd0c961b75cd9139$var$flacCrc16Table[i + 1][j] = $dd0c961b75cd9139$var$flacCrc16Table[0][$dd0c961b75cd9139$var$flacCrc16Table[i][j] >>> 8] ^ $dd0c961b75cd9139$var$flacCrc16Table[i][j] << 8;
        $dd0c961b75cd9139$var$crc32Table[i + 1][j] = $dd0c961b75cd9139$var$crc32Table[i][j] >>> 8 ^ $dd0c961b75cd9139$var$crc32Table[0][$dd0c961b75cd9139$var$crc32Table[i][j] & 0xff];
    }
}
const $dd0c961b75cd9139$export$97177c3f756cd8a4 = (data)=>{
    let crc = 0;
    const dataLength = data[0, $860f0b5184108148$export$f24224f1c91d8156];
    for(let i = 0; i !== dataLength; i++)crc = $dd0c961b75cd9139$var$crc8Table[crc ^ data[i]];
    return crc;
};
const $dd0c961b75cd9139$export$bca7964a3cb8eec7 = (data)=>{
    const dataLength = data[0, $860f0b5184108148$export$f24224f1c91d8156];
    const crcChunkSize = dataLength - 16;
    let crc = 0;
    let i = 0;
    while(i <= crcChunkSize){
        crc ^= data[i++] << 8 | data[i++];
        crc = $dd0c961b75cd9139$var$flacCrc16Table[15][crc >> 8] ^ $dd0c961b75cd9139$var$flacCrc16Table[14][crc & 0xff] ^ $dd0c961b75cd9139$var$flacCrc16Table[13][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[12][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[11][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[10][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[9][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[8][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[7][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[6][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[5][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[4][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[3][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[2][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[1][data[i++]] ^ $dd0c961b75cd9139$var$flacCrc16Table[0][data[i++]];
    }
    while(i !== dataLength)crc = (crc & 0xff) << 8 ^ $dd0c961b75cd9139$var$flacCrc16Table[0][crc >> 8 ^ data[i++]];
    return crc;
};
const $dd0c961b75cd9139$export$208e3b04219ed02 = (data)=>{
    const dataLength = data[0, $860f0b5184108148$export$f24224f1c91d8156];
    const crcChunkSize = dataLength - 16;
    let crc = 0;
    let i = 0;
    while(i <= crcChunkSize)crc = $dd0c961b75cd9139$var$crc32Table[15][(data[i++] ^ crc) & 0xff] ^ $dd0c961b75cd9139$var$crc32Table[14][(data[i++] ^ crc >>> 8) & 0xff] ^ $dd0c961b75cd9139$var$crc32Table[13][(data[i++] ^ crc >>> 16) & 0xff] ^ $dd0c961b75cd9139$var$crc32Table[12][data[i++] ^ crc >>> 24] ^ $dd0c961b75cd9139$var$crc32Table[11][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[10][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[9][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[8][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[7][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[6][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[5][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[4][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[3][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[2][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[1][data[i++]] ^ $dd0c961b75cd9139$var$crc32Table[0][data[i++]];
    while(i !== dataLength)crc = $dd0c961b75cd9139$var$crc32Table[0][(crc ^ data[i++]) & 0xff] ^ crc >>> 8;
    return crc ^ -1;
};
const $dd0c961b75cd9139$export$28e250f55413be00 = (...buffers)=>{
    const buffer = new (0, $860f0b5184108148$export$d7e5036dad7e20bb)(buffers.reduce((acc, buf)=>acc + buf[0, $860f0b5184108148$export$f24224f1c91d8156], 0));
    buffers.reduce((offset, buf)=>{
        buffer.set(buf, offset);
        return offset + buf[0, $860f0b5184108148$export$f24224f1c91d8156];
    }, 0);
    return buffer;
};
const $dd0c961b75cd9139$export$7c746b75f47c9c7d = (bytes)=>String.fromCharCode(...bytes);
// prettier-ignore
const $dd0c961b75cd9139$var$reverseTable = [
    0x0,
    0x8,
    0x4,
    0xc,
    0x2,
    0xa,
    0x6,
    0xe,
    0x1,
    0x9,
    0x5,
    0xd,
    0x3,
    0xb,
    0x7,
    0xf
];
const $dd0c961b75cd9139$export$66c1ae025e96b4bc = (val)=>$dd0c961b75cd9139$var$reverseTable[val & 15] << 4 | $dd0c961b75cd9139$var$reverseTable[val >> 4];
class $dd0c961b75cd9139$export$229c1f1c745a2f7a {
    constructor(data){
        this._data = data;
        this._pos = data[0, $860f0b5184108148$export$f24224f1c91d8156] * 8;
    }
    set position(position) {
        this._pos = position;
    }
    get position() {
        return this._pos;
    }
    read(bits) {
        const byte = Math.floor(this._pos / 8);
        const bit = this._pos % 8;
        this._pos -= bits;
        const window = ($dd0c961b75cd9139$export$66c1ae025e96b4bc(this._data[byte - 1]) << 8) + $dd0c961b75cd9139$export$66c1ae025e96b4bc(this._data[byte]);
        return window >> 7 - bit & 0xff;
    }
}
/**
 * @todo Old versions of Safari do not support BigInt
 */ const $dd0c961b75cd9139$export$1c15aa5d34abba6b = (view, offset)=>{
    try {
        return view.getBigInt64(offset, true);
    } catch  {
        const sign = view.getUint8(offset + 7) & 0x80 ? -1 : 1;
        let firstPart = view.getUint32(offset, true);
        let secondPart = view.getUint32(offset + 4, true);
        if (sign === -1) {
            firstPart = ~firstPart + 1;
            secondPart = ~secondPart + 1;
        }
        if (secondPart > 0x000fffff) console.warn("This platform does not support BigInt");
        return sign * (firstPart + secondPart * 2 ** 32);
    }
};



/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
class $0139e6c9e0318001$export$2e2bcd8739ae039 {
    constructor(onCodecHeader, onCodecUpdate){
        this._onCodecHeader = onCodecHeader;
        this._onCodecUpdate = onCodecUpdate;
        this[0, $860f0b5184108148$export$aad8462122ac592b]();
    }
    [(0, $860f0b5184108148$export$d7c4a0dd6a4567e5)]() {
        this._isEnabled = true;
    }
    [(0, $860f0b5184108148$export$aad8462122ac592b)]() {
        this._headerCache = new Map();
        this._codecUpdateData = new WeakMap();
        this._codecHeaderSent = false;
        this._codecShouldUpdate = false;
        this._bitrate = null;
        this._isEnabled = false;
    }
    [(0, $860f0b5184108148$export$b025372f68843755)](bitrate, totalDuration) {
        if (this._onCodecUpdate) {
            if (this._bitrate !== bitrate) {
                this._bitrate = bitrate;
                this._codecShouldUpdate = true;
            }
            // only update if codec data is available
            const codecData = this._codecUpdateData.get(this._headerCache.get(this._currentHeader));
            if (this._codecShouldUpdate && codecData) this._onCodecUpdate({
                bitrate: bitrate,
                ...codecData
            }, totalDuration);
            this._codecShouldUpdate = false;
        }
    }
    [(0, $860f0b5184108148$export$47ed31abc613cf55)](key) {
        const header = this._headerCache.get(key);
        if (header) this._updateCurrentHeader(key);
        return header;
    }
    [(0, $860f0b5184108148$export$604ed74fb893f0e2)](key, header, codecUpdateFields) {
        if (this._isEnabled) {
            if (!this._codecHeaderSent) {
                this._onCodecHeader({
                    ...header
                });
                this._codecHeaderSent = true;
            }
            this._updateCurrentHeader(key);
            this._headerCache.set(key, header);
            this._codecUpdateData.set(header, codecUpdateFields);
        }
    }
    _updateCurrentHeader(key) {
        if (this._onCodecUpdate && key !== this._currentHeader) {
            this._codecShouldUpdate = true;
            this._currentHeader = key;
        }
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ const $5169222015670af0$export$52342bdf89fb39e7 = new WeakMap();
const $5169222015670af0$export$5b0e32d79f1188e7 = new WeakMap();



class $dd7c0f9e54b04fc4$export$2e2bcd8739ae039 {
    constructor(codecParser, headerCache){
        this._codecParser = codecParser;
        this._headerCache = headerCache;
    }
    *[(0, $860f0b5184108148$export$bd2dbf3c3b57dcf1)]() {
        let frameData;
        do {
            frameData = yield* this.Frame[0, $860f0b5184108148$export$fd8d2ba2926cdfb6](this._codecParser, this._headerCache, 0);
            if (frameData) return frameData;
            this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](1); // increment to continue syncing
        }while (true);
    }
    /**
   * @description Searches for Frames within bytes containing a sequence of known codec frames.
   * @param {boolean} ignoreNextFrame Set to true to return frames even if the next frame may not exist at the expected location
   * @returns {Frame}
   */ *[(0, $860f0b5184108148$export$6a29256c87cd443c)](ignoreNextFrame) {
        let frameData = yield* this[0, $860f0b5184108148$export$bd2dbf3c3b57dcf1]();
        const frameLength = (0, $5169222015670af0$export$5b0e32d79f1188e7).get(frameData)[0, $860f0b5184108148$export$f24224f1c91d8156];
        if (ignoreNextFrame || this._codecParser._flushing || // check if there is a frame right after this one
        (yield* this.Header[0, $860f0b5184108148$export$47ed31abc613cf55](this._codecParser, this._headerCache, frameLength))) {
            this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5](); // start caching when synced
            this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](frameLength); // increment to the next frame
            this._codecParser[0, $860f0b5184108148$export$24d5305cc192425a](frameData);
            return frameData;
        }
        this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9](`Missing ${(0, $860f0b5184108148$export$2cef06c20297c17d)} at ${frameLength} bytes from current position.`, `Dropping current ${(0, $860f0b5184108148$export$2cef06c20297c17d)} and trying again.`);
        this._headerCache[0, $860f0b5184108148$export$aad8462122ac592b](); // frame is invalid and must re-sync and clear cache
        this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](1); // increment to invalidate the current frame
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

class $34ee446617012033$export$2e2bcd8739ae039 {
    constructor(headerValue, dataValue){
        (0, $5169222015670af0$export$5b0e32d79f1188e7).set(this, {
            [(0, $860f0b5184108148$export$38e42c68cf43b5d4)]: headerValue
        });
        this[0, $860f0b5184108148$export$4051a07651545597] = dataValue;
    }
}


class $0b17d7d3514fce05$export$2e2bcd8739ae039 extends (0, $34ee446617012033$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$fd8d2ba2926cdfb6)](Header, Frame, codecParser, headerCache, readOffset) {
        const headerValue = yield* Header[0, $860f0b5184108148$export$47ed31abc613cf55](codecParser, headerCache, readOffset);
        if (headerValue) {
            const frameLengthValue = (0, $5169222015670af0$export$52342bdf89fb39e7).get(headerValue)[0, $860f0b5184108148$export$326bb32b4ec6239b];
            const samplesValue = (0, $5169222015670af0$export$52342bdf89fb39e7).get(headerValue)[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
            const frame = (yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](frameLengthValue, readOffset))[0, $860f0b5184108148$export$7ec32827e4221318](0, frameLengthValue);
            return new Frame(headerValue, frame, samplesValue);
        } else return null;
    }
    constructor(headerValue, dataValue, samplesValue){
        super(headerValue, dataValue);
        this[0, $860f0b5184108148$export$38e42c68cf43b5d4] = headerValue;
        this[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = samplesValue;
        this[0, $860f0b5184108148$export$1f34108aa9eb96ab] = samplesValue / headerValue[0, $860f0b5184108148$export$851d973a43101ae1] * 1000;
        this[0, $860f0b5184108148$export$5da2c6384bf58746] = null;
        this[0, $860f0b5184108148$export$acdbe6200d314ea0] = null;
        this[0, $860f0b5184108148$export$27063c03e3b4546e] = null;
        this[0, $860f0b5184108148$export$4ff6995501858325] = null;
        (0, $5169222015670af0$export$5b0e32d79f1188e7).get(this)[0, $860f0b5184108148$export$f24224f1c91d8156] = dataValue[0, $860f0b5184108148$export$f24224f1c91d8156];
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ // https://id3.org/Developer%20Information

const $a7845465f90548da$var$unsynchronizationFlag = "unsynchronizationFlag";
const $a7845465f90548da$var$extendedHeaderFlag = "extendedHeaderFlag";
const $a7845465f90548da$var$experimentalFlag = "experimentalFlag";
const $a7845465f90548da$var$footerPresent = "footerPresent";
class $a7845465f90548da$export$2e2bcd8739ae039 {
    static *getID3v2Header(codecParser, headerCache, readOffset) {
        const headerLength = 10;
        const header = {};
        let data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](3, readOffset);
        // Byte (0-2 of 9)
        // ID3
        if (data[0] !== 0x49 || data[1] !== 0x44 || data[2] !== 0x33) return null;
        data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](headerLength, readOffset);
        // Byte (3-4 of 9)
        // * `BBBBBBBB|........`: Major version
        // * `........|BBBBBBBB`: Minor version
        header[0, $860f0b5184108148$export$83d89fbfd8236492] = `id3v2.${data[3]}.${data[4]}`;
        // Byte (5 of 9)
        // * `....0000.: Zeros (flags not implemented yet)
        if (data[5] & 15) return null;
        // Byte (5 of 9)
        // * `CDEF0000`: Flags
        // * `C.......`: Unsynchronisation (indicates whether or not unsynchronisation is used)
        // * `.D......`: Extended header (indicates whether or not the header is followed by an extended header)
        // * `..E.....`: Experimental indicator (indicates whether or not the tag is in an experimental stage)
        // * `...F....`: Footer present (indicates that a footer is present at the very end of the tag)
        header[$a7845465f90548da$var$unsynchronizationFlag] = !!(data[5] & 128);
        header[$a7845465f90548da$var$extendedHeaderFlag] = !!(data[5] & 64);
        header[$a7845465f90548da$var$experimentalFlag] = !!(data[5] & 32);
        header[$a7845465f90548da$var$footerPresent] = !!(data[5] & 16);
        // Byte (6-9 of 9)
        // * `0.......|0.......|0.......|0.......`: Zeros
        if (data[6] & 128 || data[7] & 128 || data[8] & 128 || data[9] & 128) return null;
        // Byte (6-9 of 9)
        // * `.FFFFFFF|.FFFFFFF|.FFFFFFF|.FFFFFFF`: Tag Length
        // The ID3v2 tag size is encoded with four bytes where the most significant bit (bit 7)
        // is set to zero in every byte, making a total of 28 bits. The zeroed bits are ignored,
        // so a 257 bytes long tag is represented as $00 00 02 01.
        const dataLength = data[6] << 21 | data[7] << 14 | data[8] << 7 | data[9];
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = headerLength + dataLength;
        return new $a7845465f90548da$export$2e2bcd8739ae039(header);
    }
    constructor(header){
        this[0, $860f0b5184108148$export$83d89fbfd8236492] = header[0, $860f0b5184108148$export$83d89fbfd8236492];
        this[$a7845465f90548da$var$unsynchronizationFlag] = header[$a7845465f90548da$var$unsynchronizationFlag];
        this[$a7845465f90548da$var$extendedHeaderFlag] = header[$a7845465f90548da$var$extendedHeaderFlag];
        this[$a7845465f90548da$var$experimentalFlag] = header[$a7845465f90548da$var$experimentalFlag];
        this[$a7845465f90548da$var$footerPresent] = header[$a7845465f90548da$var$footerPresent];
        this[0, $860f0b5184108148$export$f24224f1c91d8156] = header[0, $860f0b5184108148$export$f24224f1c91d8156];
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

class $3fb1607145c26488$export$2e2bcd8739ae039 {
    /**
   * @private
   */ constructor(header){
        (0, $5169222015670af0$export$52342bdf89fb39e7).set(this, header);
        this[0, $860f0b5184108148$export$cee20cdac1cd19df] = header[0, $860f0b5184108148$export$cee20cdac1cd19df];
        this[0, $860f0b5184108148$export$fbead197e07be487] = null; // set during frame mapping
        this[0, $860f0b5184108148$export$9659c395d9de169e] = header[0, $860f0b5184108148$export$9659c395d9de169e];
        this[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = header[0, $860f0b5184108148$export$589c9a7ae9a79c5e];
        this[0, $860f0b5184108148$export$851d973a43101ae1] = header[0, $860f0b5184108148$export$851d973a43101ae1];
    }
}


// http://www.mp3-tech.org/programmer/frame_header.html
const $66a3933fe72fadca$var$bitrateMatrix = {
    // bits | V1,L1 | V1,L2 | V1,L3 | V2,L1 | V2,L2 & L3
    0: [
        (0, $860f0b5184108148$export$13e2de3c33d99539),
        (0, $860f0b5184108148$export$13e2de3c33d99539),
        (0, $860f0b5184108148$export$13e2de3c33d99539),
        (0, $860f0b5184108148$export$13e2de3c33d99539),
        (0, $860f0b5184108148$export$13e2de3c33d99539)
    ],
    16: [
        32,
        32,
        32,
        32,
        8
    ],
    // 0b00100000: [64,   48,  40,  48,  16,],
    // 0b00110000: [96,   56,  48,  56,  24,],
    // 0b01000000: [128,  64,  56,  64,  32,],
    // 0b01010000: [160,  80,  64,  80,  40,],
    // 0b01100000: [192,  96,  80,  96,  48,],
    // 0b01110000: [224, 112,  96, 112,  56,],
    // 0b10000000: [256, 128, 112, 128,  64,],
    // 0b10010000: [288, 160, 128, 144,  80,],
    // 0b10100000: [320, 192, 160, 160,  96,],
    // 0b10110000: [352, 224, 192, 176, 112,],
    // 0b11000000: [384, 256, 224, 192, 128,],
    // 0b11010000: [416, 320, 256, 224, 144,],
    // 0b11100000: [448, 384, 320, 256, 160,],
    240: [
        (0, $860f0b5184108148$export$a4535ec98457231d),
        (0, $860f0b5184108148$export$a4535ec98457231d),
        (0, $860f0b5184108148$export$a4535ec98457231d),
        (0, $860f0b5184108148$export$a4535ec98457231d),
        (0, $860f0b5184108148$export$a4535ec98457231d)
    ]
};
const $66a3933fe72fadca$var$calcBitrate = (idx, interval, intervalOffset)=>8 * ((idx + intervalOffset) % interval + interval) * (1 << (idx + intervalOffset) / interval) - 8 * interval * (interval / 8 | 0);
// generate bitrate matrix
for(let i = 2; i < 15; i++)$66a3933fe72fadca$var$bitrateMatrix[i << 4] = [
    i * 32,
    $66a3933fe72fadca$var$calcBitrate(i, 4, 0),
    $66a3933fe72fadca$var$calcBitrate(i, 4, -1),
    $66a3933fe72fadca$var$calcBitrate(i, 8, 4),
    $66a3933fe72fadca$var$calcBitrate(i, 8, 0)
];
const $66a3933fe72fadca$var$v1Layer1 = 0;
const $66a3933fe72fadca$var$v1Layer2 = 1;
const $66a3933fe72fadca$var$v1Layer3 = 2;
const $66a3933fe72fadca$var$v2Layer1 = 3;
const $66a3933fe72fadca$var$v2Layer23 = 4;
const $66a3933fe72fadca$var$bands = "bands ";
const $66a3933fe72fadca$var$to31 = " to 31";
const $66a3933fe72fadca$var$layer12ModeExtensions = {
    0: $66a3933fe72fadca$var$bands + 4 + $66a3933fe72fadca$var$to31,
    16: $66a3933fe72fadca$var$bands + 8 + $66a3933fe72fadca$var$to31,
    32: $66a3933fe72fadca$var$bands + 12 + $66a3933fe72fadca$var$to31,
    48: $66a3933fe72fadca$var$bands + 16 + $66a3933fe72fadca$var$to31
};
const $66a3933fe72fadca$var$bitrateIndex = "bitrateIndex";
const $66a3933fe72fadca$var$v2 = "v2";
const $66a3933fe72fadca$var$v1 = "v1";
const $66a3933fe72fadca$var$intensityStereo = "Intensity stereo ";
const $66a3933fe72fadca$var$msStereo = ", MS stereo ";
const $66a3933fe72fadca$var$on = "on";
const $66a3933fe72fadca$var$off = "off";
const $66a3933fe72fadca$var$layer3ModeExtensions = {
    0: $66a3933fe72fadca$var$intensityStereo + $66a3933fe72fadca$var$off + $66a3933fe72fadca$var$msStereo + $66a3933fe72fadca$var$off,
    16: $66a3933fe72fadca$var$intensityStereo + $66a3933fe72fadca$var$on + $66a3933fe72fadca$var$msStereo + $66a3933fe72fadca$var$off,
    32: $66a3933fe72fadca$var$intensityStereo + $66a3933fe72fadca$var$off + $66a3933fe72fadca$var$msStereo + $66a3933fe72fadca$var$on,
    48: $66a3933fe72fadca$var$intensityStereo + $66a3933fe72fadca$var$on + $66a3933fe72fadca$var$msStereo + $66a3933fe72fadca$var$on
};
const $66a3933fe72fadca$var$layersValues = {
    0: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$e46d647da3214494)
    },
    2: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "Layer III",
        [(0, $860f0b5184108148$export$e4cdad84c725445)]: 1,
        [(0, $860f0b5184108148$export$f1eb63ab5aca5708)]: $66a3933fe72fadca$var$layer3ModeExtensions,
        [$66a3933fe72fadca$var$v1]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v1Layer3,
            [(0, $860f0b5184108148$export$5f20c3cdf3b5e8be)]: 1152
        },
        [$66a3933fe72fadca$var$v2]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v2Layer23,
            [(0, $860f0b5184108148$export$5f20c3cdf3b5e8be)]: 576
        }
    },
    4: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "Layer II",
        [(0, $860f0b5184108148$export$e4cdad84c725445)]: 1,
        [(0, $860f0b5184108148$export$f1eb63ab5aca5708)]: $66a3933fe72fadca$var$layer12ModeExtensions,
        [(0, $860f0b5184108148$export$5f20c3cdf3b5e8be)]: 1152,
        [$66a3933fe72fadca$var$v1]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v1Layer2
        },
        [$66a3933fe72fadca$var$v2]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v2Layer23
        }
    },
    6: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "Layer I",
        [(0, $860f0b5184108148$export$e4cdad84c725445)]: 4,
        [(0, $860f0b5184108148$export$f1eb63ab5aca5708)]: $66a3933fe72fadca$var$layer12ModeExtensions,
        [(0, $860f0b5184108148$export$5f20c3cdf3b5e8be)]: 384,
        [$66a3933fe72fadca$var$v1]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v1Layer1
        },
        [$66a3933fe72fadca$var$v2]: {
            [$66a3933fe72fadca$var$bitrateIndex]: $66a3933fe72fadca$var$v2Layer1
        }
    }
};
const $66a3933fe72fadca$var$mpegVersionDescription = "MPEG Version ";
const $66a3933fe72fadca$var$isoIec = "ISO/IEC ";
const $66a3933fe72fadca$var$mpegVersions = {
    0: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${$66a3933fe72fadca$var$mpegVersionDescription}2.5 (later extension of MPEG 2)`,
        [(0, $860f0b5184108148$export$50a222d9023da98b)]: $66a3933fe72fadca$var$v2,
        [(0, $860f0b5184108148$export$851d973a43101ae1)]: {
            0: (0, $860f0b5184108148$export$dd010cc0b9cbe96a),
            4: (0, $860f0b5184108148$export$d18082a7f1daad0e),
            8: (0, $860f0b5184108148$export$8024c021d839bc0e),
            12: (0, $860f0b5184108148$export$e46d647da3214494)
        }
    },
    8: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$e46d647da3214494)
    },
    16: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${$66a3933fe72fadca$var$mpegVersionDescription}2 (${$66a3933fe72fadca$var$isoIec}13818-3)`,
        [(0, $860f0b5184108148$export$50a222d9023da98b)]: $66a3933fe72fadca$var$v2,
        [(0, $860f0b5184108148$export$851d973a43101ae1)]: {
            0: (0, $860f0b5184108148$export$dc67eb20d4395175),
            4: (0, $860f0b5184108148$export$492422570a89c8b0),
            8: (0, $860f0b5184108148$export$a92c08b19856a52b),
            12: (0, $860f0b5184108148$export$e46d647da3214494)
        }
    },
    24: {
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${$66a3933fe72fadca$var$mpegVersionDescription}1 (${$66a3933fe72fadca$var$isoIec}11172-3)`,
        [(0, $860f0b5184108148$export$50a222d9023da98b)]: $66a3933fe72fadca$var$v1,
        [(0, $860f0b5184108148$export$851d973a43101ae1)]: {
            0: (0, $860f0b5184108148$export$7b8ebc2092af05a9),
            4: (0, $860f0b5184108148$export$671a0c9051642a0b),
            8: (0, $860f0b5184108148$export$8786c8b1e955b2e9),
            12: (0, $860f0b5184108148$export$e46d647da3214494)
        }
    },
    length: $860f0b5184108148$export$f24224f1c91d8156
};
const $66a3933fe72fadca$var$protectionValues = {
    0: (0, $860f0b5184108148$export$26245484299fce57),
    1: (0, $860f0b5184108148$export$f883a24d5edde77c)
};
const $66a3933fe72fadca$var$emphasisValues = {
    0: (0, $860f0b5184108148$export$f883a24d5edde77c),
    1: "50/15 ms",
    2: (0, $860f0b5184108148$export$e46d647da3214494),
    3: "CCIT J.17"
};
const $66a3933fe72fadca$var$channelModes = {
    0: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$ec7f46128a2f8ed8)
    },
    64: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "joint " + (0, $860f0b5184108148$export$ec7f46128a2f8ed8)
    },
    128: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "dual channel"
    },
    192: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 1,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$25d110495212ae90)
    }
};
class $66a3933fe72fadca$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$47ed31abc613cf55)](codecParser, headerCache, readOffset) {
        const header = {};
        // check for id3 header
        const id3v2Header = yield* (0, $a7845465f90548da$export$2e2bcd8739ae039).getID3v2Header(codecParser, headerCache, readOffset);
        if (id3v2Header) {
            // throw away the data. id3 parsing is not implemented yet.
            yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](id3v2Header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](id3v2Header[0, $860f0b5184108148$export$f24224f1c91d8156]);
        }
        // Must be at least four bytes.
        const data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](4, readOffset);
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, 4));
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (cachedHeader) return new $66a3933fe72fadca$export$2e2bcd8739ae039(cachedHeader);
        // Frame sync (all bits must be set): `11111111|111`:
        if (data[0] !== 0xff || data[1] < 0xe0) return null;
        // Byte (2 of 4)
        // * `111BBCCD`
        // * `...BB...`: MPEG Audio version ID
        // * `.....CC.`: Layer description
        // * `.......D`: Protection bit (0 - Protected by CRC (16bit CRC follows header), 1 = Not protected)
        // Mpeg version (1, 2, 2.5)
        const mpegVersionValues = $66a3933fe72fadca$var$mpegVersions[data[1] & 24];
        if (mpegVersionValues[0, $860f0b5184108148$export$6d59db4903f20f7d] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        // Layer (I, II, III)
        const layerBits = data[1] & 6;
        if ($66a3933fe72fadca$var$layersValues[layerBits][0, $860f0b5184108148$export$6d59db4903f20f7d] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        const layerValues = {
            ...$66a3933fe72fadca$var$layersValues[layerBits],
            ...$66a3933fe72fadca$var$layersValues[layerBits][mpegVersionValues[0, $860f0b5184108148$export$50a222d9023da98b]]
        };
        header[0, $860f0b5184108148$export$33a1ce7cb4e60d8d] = mpegVersionValues[0, $860f0b5184108148$export$6d59db4903f20f7d];
        header[0, $860f0b5184108148$export$50a222d9023da98b] = layerValues[0, $860f0b5184108148$export$6d59db4903f20f7d];
        header[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = layerValues[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
        header[0, $860f0b5184108148$export$b9b4c22e291dd3d9] = $66a3933fe72fadca$var$protectionValues[data[1] & 1];
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = 4;
        // Byte (3 of 4)
        // * `EEEEFFGH`
        // * `EEEE....`: Bitrate index. 1111 is invalid, everything else is accepted
        // * `....FF..`: Sample rate
        // * `......G.`: Padding bit, 0=frame not padded, 1=frame padded
        // * `.......H`: Private bit.
        header[0, $860f0b5184108148$export$fbead197e07be487] = $66a3933fe72fadca$var$bitrateMatrix[data[2] & 240][layerValues[$66a3933fe72fadca$var$bitrateIndex]];
        if (header[0, $860f0b5184108148$export$fbead197e07be487] === (0, $860f0b5184108148$export$a4535ec98457231d)) return null;
        header[0, $860f0b5184108148$export$851d973a43101ae1] = mpegVersionValues[0, $860f0b5184108148$export$851d973a43101ae1][data[2] & 12];
        if (header[0, $860f0b5184108148$export$851d973a43101ae1] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        header[0, $860f0b5184108148$export$e4cdad84c725445] = data[2] & 2 && layerValues[0, $860f0b5184108148$export$e4cdad84c725445];
        header[0, $860f0b5184108148$export$1d1349f4eb9a7003] = !!(data[2] & 1);
        header[0, $860f0b5184108148$export$326bb32b4ec6239b] = Math.floor(125 * header[0, $860f0b5184108148$export$fbead197e07be487] * header[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] / header[0, $860f0b5184108148$export$851d973a43101ae1] + header[0, $860f0b5184108148$export$e4cdad84c725445]);
        if (!header[0, $860f0b5184108148$export$326bb32b4ec6239b]) return null;
        // Byte (4 of 4)
        // * `IIJJKLMM`
        // * `II......`: Channel mode
        // * `..JJ....`: Mode extension (only if joint stereo)
        // * `....K...`: Copyright
        // * `.....L..`: Original
        // * `......MM`: Emphasis
        const channelModeBits = data[3] & 192;
        header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = $66a3933fe72fadca$var$channelModes[channelModeBits][0, $860f0b5184108148$export$6d59db4903f20f7d];
        header[0, $860f0b5184108148$export$9659c395d9de169e] = $66a3933fe72fadca$var$channelModes[channelModeBits][0, $860f0b5184108148$export$9659c395d9de169e];
        header[0, $860f0b5184108148$export$f1eb63ab5aca5708] = layerValues[0, $860f0b5184108148$export$f1eb63ab5aca5708][data[3] & 48];
        header[0, $860f0b5184108148$export$818e7b951c237e5d] = !!(data[3] & 8);
        header[0, $860f0b5184108148$export$e512c40786d058ff] = !!(data[3] & 4);
        header[0, $860f0b5184108148$export$bef81ba411953b51] = $66a3933fe72fadca$var$emphasisValues[data[3] & 3];
        if (header[0, $860f0b5184108148$export$bef81ba411953b51] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        header[0, $860f0b5184108148$export$cee20cdac1cd19df] = 16;
        // set header cache
        {
            const { length: length, frameLength: frameLength, samples: samples, ...codecUpdateFields } = header;
            headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
        }
        return new $66a3933fe72fadca$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call MPEGHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$fbead197e07be487] = header[0, $860f0b5184108148$export$fbead197e07be487];
        this[0, $860f0b5184108148$export$bef81ba411953b51] = header[0, $860f0b5184108148$export$bef81ba411953b51];
        this[0, $860f0b5184108148$export$e4cdad84c725445] = header[0, $860f0b5184108148$export$e4cdad84c725445];
        this[0, $860f0b5184108148$export$818e7b951c237e5d] = header[0, $860f0b5184108148$export$818e7b951c237e5d];
        this[0, $860f0b5184108148$export$e512c40786d058ff] = header[0, $860f0b5184108148$export$e512c40786d058ff];
        this[0, $860f0b5184108148$export$1d1349f4eb9a7003] = header[0, $860f0b5184108148$export$1d1349f4eb9a7003];
        this[0, $860f0b5184108148$export$50a222d9023da98b] = header[0, $860f0b5184108148$export$50a222d9023da98b];
        this[0, $860f0b5184108148$export$f1eb63ab5aca5708] = header[0, $860f0b5184108148$export$f1eb63ab5aca5708];
        this[0, $860f0b5184108148$export$33a1ce7cb4e60d8d] = header[0, $860f0b5184108148$export$33a1ce7cb4e60d8d];
        this[0, $860f0b5184108148$export$b9b4c22e291dd3d9] = header[0, $860f0b5184108148$export$b9b4c22e291dd3d9];
    }
}


class $573eda4ab45988c0$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$fd8d2ba2926cdfb6)](codecParser, headerCache, readOffset) {
        return yield* super[0, $860f0b5184108148$export$fd8d2ba2926cdfb6]((0, $66a3933fe72fadca$export$2e2bcd8739ae039), $573eda4ab45988c0$export$2e2bcd8739ae039, codecParser, headerCache, readOffset);
    }
    constructor(header, frame, samples){
        super(header, frame, samples);
    }
}



class $e60718df768668d6$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $573eda4ab45988c0$export$2e2bcd8739ae039);
        this.Header = (0, $66a3933fe72fadca$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return 0, $860f0b5184108148$export$a08b701eae9f6dda;
    }
    *[(0, $860f0b5184108148$export$9616b51a1be2e082)]() {
        return yield* this[0, $860f0b5184108148$export$6a29256c87cd443c]();
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 

/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*
https://wiki.multimedia.cx/index.php/ADTS

AAAAAAAA AAAABCCD EEFFFFGH HHIJKLMM MMMMMMMM MMMOOOOO OOOOOOPP (QQQQQQQQ QQQQQQQQ)

AACHeader consists of 7 or 9 bytes (without or with CRC).
Letter  Length (bits)  Description
A  12  syncword 0xFFF, all bits must be 1
B  1   MPEG Version: 0 for MPEG-4, 1 for MPEG-2
C  2   Layer: always 0
D  1   protection absent, Warning, set to 1 if there is no CRC and 0 if there is CRC
E  2   profile, the MPEG-4 Audio Object Type minus 1
F  4   MPEG-4 Sampling Frequency Index (15 is forbidden)
G  1   private bit, guaranteed never to be used by MPEG, set to 0 when encoding, ignore when decoding
H  3   MPEG-4 Channel Configuration (in the case of 0, the channel configuration is sent via an inband PCE)
I  1   originality, set to 0 when encoding, ignore when decoding
J  1   home, set to 0 when encoding, ignore when decoding
K  1   copyrighted id bit, the next bit of a centrally registered copyright identifier, set to 0 when encoding, ignore when decoding
L  1   copyright id start, signals that this frame's copyright id bit is the first bit of the copyright id, set to 0 when encoding, ignore when decoding
M  13  frame length, this value must include 7 or 9 bytes of header length: FrameLength = (ProtectionAbsent == 1 ? 7 : 9) + size(AACFrame)
O  11  Buffer fullness // 0x7FF for VBR
P  2   Number of AAC frames (RDBs) in ADTS frame minus 1, for maximum compatibility always use 1 AAC frame per ADTS frame
Q  16  CRC if protection absent is 0 
*/ 



const $2e2502127f04fd04$var$mpegVersionValues = {
    0: "MPEG-4",
    8: "MPEG-2"
};
const $2e2502127f04fd04$var$layerValues = {
    0: "valid",
    2: (0, $860f0b5184108148$export$a4535ec98457231d),
    4: (0, $860f0b5184108148$export$a4535ec98457231d),
    6: (0, $860f0b5184108148$export$a4535ec98457231d)
};
const $2e2502127f04fd04$var$protectionValues = {
    0: (0, $860f0b5184108148$export$26245484299fce57),
    1: (0, $860f0b5184108148$export$f883a24d5edde77c)
};
const $2e2502127f04fd04$var$profileValues = {
    0: "AAC Main",
    64: "AAC LC (Low Complexity)",
    128: "AAC SSR (Scalable Sample Rate)",
    192: "AAC LTP (Long Term Prediction)"
};
const $2e2502127f04fd04$var$sampleRates = {
    0: (0, $860f0b5184108148$export$4a9bd43882a638a3),
    4: (0, $860f0b5184108148$export$308fdd6283300e68),
    8: (0, $860f0b5184108148$export$44cafc10e39936f9),
    12: (0, $860f0b5184108148$export$671a0c9051642a0b),
    16: (0, $860f0b5184108148$export$7b8ebc2092af05a9),
    20: (0, $860f0b5184108148$export$8786c8b1e955b2e9),
    24: (0, $860f0b5184108148$export$492422570a89c8b0),
    28: (0, $860f0b5184108148$export$dc67eb20d4395175),
    32: (0, $860f0b5184108148$export$a92c08b19856a52b),
    36: (0, $860f0b5184108148$export$d18082a7f1daad0e),
    40: (0, $860f0b5184108148$export$dd010cc0b9cbe96a),
    44: (0, $860f0b5184108148$export$8024c021d839bc0e),
    48: (0, $860f0b5184108148$export$8003a269f1123d37),
    52: (0, $860f0b5184108148$export$e46d647da3214494),
    56: (0, $860f0b5184108148$export$e46d647da3214494),
    60: "frequency is written explicitly"
};
// prettier-ignore
const $2e2502127f04fd04$var$channelModeValues = {
    0: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 0,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: "Defined in AOT Specific Config"
    },
    /*
  'monophonic (mono)'
  'stereo (left, right)'
  'linear surround (front center, front left, front right)'
  'quadraphonic (front center, front left, front right, rear center)'
  '5.0 surround (front center, front left, front right, rear left, rear right)'
  '5.1 surround (front center, front left, front right, rear left, rear right, LFE)'
  '7.1 surround (front center, front left, front right, side left, side right, rear left, rear right, LFE)'
  */ 64: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 1,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$25d110495212ae90)
    },
    128: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(2, (0, $860f0b5184108148$export$3e501d20baea1003)[0][0])
    },
    192: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 3,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(3, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3])
    },
    256: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 4,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(4, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3], (0, $860f0b5184108148$export$3e501d20baea1003)[3][4])
    },
    320: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 5,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(5, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0])
    },
    384: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 6,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(6, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0], (0, $860f0b5184108148$export$3254282aac6747d2))
    },
    448: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 8,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(8, (0, $860f0b5184108148$export$3e501d20baea1003)[1][3], (0, $860f0b5184108148$export$3e501d20baea1003)[2][0], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0], (0, $860f0b5184108148$export$3254282aac6747d2))
    }
};
class $2e2502127f04fd04$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$47ed31abc613cf55)](codecParser, headerCache, readOffset) {
        const header = {};
        // Must be at least seven bytes. Out of data
        const data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](7, readOffset);
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)([
            data[0],
            data[1],
            data[2],
            data[3] & 252 | data[6] & 3
        ]);
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (!cachedHeader) {
            // Frame sync (all bits must be set): `11111111|1111`:
            if (data[0] !== 0xff || data[1] < 0xf0) return null;
            // Byte (2 of 7)
            // * `1111BCCD`
            // * `....B...`: MPEG Version: 0 for MPEG-4, 1 for MPEG-2
            // * `.....CC.`: Layer: always 0
            // * `.......D`: protection absent, Warning, set to 1 if there is no CRC and 0 if there is CRC
            header[0, $860f0b5184108148$export$33a1ce7cb4e60d8d] = $2e2502127f04fd04$var$mpegVersionValues[data[1] & 8];
            header[0, $860f0b5184108148$export$50a222d9023da98b] = $2e2502127f04fd04$var$layerValues[data[1] & 6];
            if (header[0, $860f0b5184108148$export$50a222d9023da98b] === (0, $860f0b5184108148$export$a4535ec98457231d)) return null;
            const protectionBit = data[1] & 1;
            header[0, $860f0b5184108148$export$b9b4c22e291dd3d9] = $2e2502127f04fd04$var$protectionValues[protectionBit];
            header[0, $860f0b5184108148$export$f24224f1c91d8156] = protectionBit ? 7 : 9;
            // Byte (3 of 7)
            // * `EEFFFFGH`
            // * `EE......`: profile, the MPEG-4 Audio Object Type minus 1
            // * `..FFFF..`: MPEG-4 Sampling Frequency Index (15 is forbidden)
            // * `......G.`: private bit, guaranteed never to be used by MPEG, set to 0 when encoding, ignore when decoding
            header[0, $860f0b5184108148$export$9840eaf33e948519] = data[2] & 192;
            header[0, $860f0b5184108148$export$590421bd05077aa4] = data[2] & 60;
            const privateBit = data[2] & 2;
            header[0, $860f0b5184108148$export$4882ae973e0491e] = $2e2502127f04fd04$var$profileValues[header[0, $860f0b5184108148$export$9840eaf33e948519]];
            header[0, $860f0b5184108148$export$851d973a43101ae1] = $2e2502127f04fd04$var$sampleRates[header[0, $860f0b5184108148$export$590421bd05077aa4]];
            if (header[0, $860f0b5184108148$export$851d973a43101ae1] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
            header[0, $860f0b5184108148$export$1d1349f4eb9a7003] = !!privateBit;
            // Byte (3,4 of 7)
            // * `.......H|HH......`: MPEG-4 Channel Configuration (in the case of 0, the channel configuration is sent via an inband PCE)
            header[0, $860f0b5184108148$export$4881de1ae3929548] = (data[2] << 8 | data[3]) & 448;
            header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = $2e2502127f04fd04$var$channelModeValues[header[0, $860f0b5184108148$export$4881de1ae3929548]][0, $860f0b5184108148$export$6d59db4903f20f7d];
            header[0, $860f0b5184108148$export$9659c395d9de169e] = $2e2502127f04fd04$var$channelModeValues[header[0, $860f0b5184108148$export$4881de1ae3929548]][0, $860f0b5184108148$export$9659c395d9de169e];
            // Byte (4 of 7)
            // * `HHIJKLMM`
            // * `..I.....`: originality, set to 0 when encoding, ignore when decoding
            // * `...J....`: home, set to 0 when encoding, ignore when decoding
            // * `....K...`: copyrighted id bit, the next bit of a centrally registered copyright identifier, set to 0 when encoding, ignore when decoding
            // * `.....L..`: copyright id start, signals that this frame's copyright id bit is the first bit of the copyright id, set to 0 when encoding, ignore when decoding
            header[0, $860f0b5184108148$export$e512c40786d058ff] = !!(data[3] & 32);
            header[0, $860f0b5184108148$export$947c0ccec8fe9e2a] = !!(data[3] & 8);
            header[0, $860f0b5184108148$export$7306104bb28d5804] = !!(data[3] & 8);
            header[0, $860f0b5184108148$export$19129109fa742a6f] = !!(data[3] & 4);
            header[0, $860f0b5184108148$export$cee20cdac1cd19df] = 16;
            header[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = 1024;
            // Byte (7 of 7)
            // * `......PP` Number of AAC frames (RDBs) in ADTS frame minus 1, for maximum compatibility always use 1 AAC frame per ADTS frame
            header[0, $860f0b5184108148$export$7a8a2426cba807b6] = data[6] & 3;
            {
                const { length: length, channelModeBits: channelModeBits, profileBits: profileBits, sampleRateBits: sampleRateBits, frameLength: frameLength, samples: samples, numberAACFrames: numberAACFrames, ...codecUpdateFields } = header;
                headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
            }
        } else Object.assign(header, cachedHeader);
        // Byte (4,5,6 of 7)
        // * `.......MM|MMMMMMMM|MMM.....`: frame length, this value must include 7 or 9 bytes of header length: FrameLength = (ProtectionAbsent == 1 ? 7 : 9) + size(AACFrame)
        header[0, $860f0b5184108148$export$326bb32b4ec6239b] = (data[3] << 11 | data[4] << 3 | data[5] >> 5) & 0x1fff;
        if (!header[0, $860f0b5184108148$export$326bb32b4ec6239b]) return null;
        // Byte (6,7 of 7)
        // * `...OOOOO|OOOOOO..`: Buffer fullness
        const bufferFullnessBits = (data[5] << 6 | data[6] >> 2) & 0x7ff;
        header[0, $860f0b5184108148$export$e2acf35f1e805875] = bufferFullnessBits === 0x7ff ? "VBR" : bufferFullnessBits;
        return new $2e2502127f04fd04$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call AACHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$7306104bb28d5804] = header[0, $860f0b5184108148$export$7306104bb28d5804];
        this[0, $860f0b5184108148$export$19129109fa742a6f] = header[0, $860f0b5184108148$export$19129109fa742a6f];
        this[0, $860f0b5184108148$export$e2acf35f1e805875] = header[0, $860f0b5184108148$export$e2acf35f1e805875];
        this[0, $860f0b5184108148$export$947c0ccec8fe9e2a] = header[0, $860f0b5184108148$export$947c0ccec8fe9e2a];
        this[0, $860f0b5184108148$export$e512c40786d058ff] = header[0, $860f0b5184108148$export$e512c40786d058ff];
        this[0, $860f0b5184108148$export$1d1349f4eb9a7003] = header[0, $860f0b5184108148$export$1d1349f4eb9a7003];
        this[0, $860f0b5184108148$export$50a222d9023da98b] = header[0, $860f0b5184108148$export$50a222d9023da98b];
        this[0, $860f0b5184108148$export$f24224f1c91d8156] = header[0, $860f0b5184108148$export$f24224f1c91d8156];
        this[0, $860f0b5184108148$export$33a1ce7cb4e60d8d] = header[0, $860f0b5184108148$export$33a1ce7cb4e60d8d];
        this[0, $860f0b5184108148$export$7a8a2426cba807b6] = header[0, $860f0b5184108148$export$7a8a2426cba807b6];
        this[0, $860f0b5184108148$export$4882ae973e0491e] = header[0, $860f0b5184108148$export$4882ae973e0491e];
        this[0, $860f0b5184108148$export$b9b4c22e291dd3d9] = header[0, $860f0b5184108148$export$b9b4c22e291dd3d9];
    }
    get audioSpecificConfig() {
        // Audio Specific Configuration
        // * `000EEFFF|F0HHH000`:
        // * `000EE...|........`: Object Type (profileBit + 1)
        // * `.....FFF|F.......`: Sample Rate
        // * `........|.0HHH...`: Channel Configuration
        // * `........|.....0..`: Frame Length (1024)
        // * `........|......0.`: does not depend on core coder
        // * `........|.......0`: Not Extension
        const header = (0, $5169222015670af0$export$52342bdf89fb39e7).get(this);
        const audioSpecificConfig = header[0, $860f0b5184108148$export$9840eaf33e948519] + 0x40 << 5 | header[0, $860f0b5184108148$export$590421bd05077aa4] << 5 | header[0, $860f0b5184108148$export$4881de1ae3929548] >> 3;
        const bytes = new (0, $860f0b5184108148$export$d7e5036dad7e20bb)(2);
        new (0, $860f0b5184108148$export$40b76aa5ded53e7a)(bytes[0, $860f0b5184108148$export$ab1029bcae9ddb4a]).setUint16(0, audioSpecificConfig, false);
        return bytes;
    }
}


class $f39992d4dc65edc9$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$fd8d2ba2926cdfb6)](codecParser, headerCache, readOffset) {
        return yield* super[0, $860f0b5184108148$export$fd8d2ba2926cdfb6]((0, $2e2502127f04fd04$export$2e2bcd8739ae039), $f39992d4dc65edc9$export$2e2bcd8739ae039, codecParser, headerCache, readOffset);
    }
    constructor(header, frame, samples){
        super(header, frame, samples);
    }
}



class $ea4373f84c96dcef$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $f39992d4dc65edc9$export$2e2bcd8739ae039);
        this.Header = (0, $2e2502127f04fd04$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return "aac";
    }
    *[(0, $860f0b5184108148$export$9616b51a1be2e082)]() {
        return yield* this[0, $860f0b5184108148$export$6a29256c87cd443c]();
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 



class $c609565fc87a2788$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    static _getFrameFooterCrc16(data) {
        return (data[data[0, $860f0b5184108148$export$f24224f1c91d8156] - 2] << 8) + data[data[0, $860f0b5184108148$export$f24224f1c91d8156] - 1];
    }
    // check frame footer crc
    // https://xiph.org/flac/format.html#frame_footer
    static [(0, $860f0b5184108148$export$b97792a91f8a2a21)](data) {
        const expectedCrc16 = $c609565fc87a2788$export$2e2bcd8739ae039._getFrameFooterCrc16(data);
        const actualCrc16 = (0, $dd0c961b75cd9139$export$bca7964a3cb8eec7)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, -2));
        return expectedCrc16 === actualCrc16;
    }
    constructor(data, header, streamInfoValue){
        header[0, $860f0b5184108148$export$9010c500bffe71e6] = streamInfoValue;
        header[0, $860f0b5184108148$export$bacf03850837cc9e] = $c609565fc87a2788$export$2e2bcd8739ae039._getFrameFooterCrc16(data);
        super(header, data, (0, $5169222015670af0$export$52342bdf89fb39e7).get(header)[0, $860f0b5184108148$export$5f20c3cdf3b5e8be]);
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*
https://xiph.org/flac/format.html

AAAAAAAA AAAAAABC DDDDEEEE FFFFGGGH 
(IIIIIIII...)
(JJJJJJJJ|JJJJJJJJ)
(KKKKKKKK|KKKKKKKK)
LLLLLLLLL

FLAC Frame Header
Letter  Length (bits)  Description
A   13  11111111|11111
B   1   Reserved 0 - mandatory, 1 - reserved
C   1   Blocking strategy, 0 - fixed, 1 - variable
D   4   Block size in inter-channel samples
E   4   Sample rate
F   4   Channel assignment
G   3   Sample size in bits
H   1   Reserved 0 - mandatory, 1 - reserved
I   ?   if(variable blocksize)
           <8-56>:"UTF-8" coded sample number (decoded number is 36 bits) [4]
        else
           <8-48>:"UTF-8" coded frame number (decoded number is 31 bits) [4]
J   ?   if(blocksize bits == 011x)
            8/16 bit (blocksize-1)
K   ?   if(sample rate bits == 11xx)
            8/16 bit sample rate
L   8   CRC-8 (polynomial = x^8 + x^2 + x^1 + x^0, initialized with 0) of everything before the crc, including the sync code
        
*/ 


const $ebbc5c9dd68f978b$var$getFromStreamInfo = "get from STREAMINFO metadata block";
const $ebbc5c9dd68f978b$var$blockingStrategyValues = {
    0: "Fixed",
    1: "Variable"
};
const $ebbc5c9dd68f978b$var$blockSizeValues = {
    0: (0, $860f0b5184108148$export$e46d647da3214494),
    16: 192
};
for(let i = 2; i < 16; i++)$ebbc5c9dd68f978b$var$blockSizeValues[i << 4] = i < 6 ? 576 * 2 ** (i - 2) : 2 ** i;
const $ebbc5c9dd68f978b$var$sampleRateValues = {
    0: $ebbc5c9dd68f978b$var$getFromStreamInfo,
    1: (0, $860f0b5184108148$export$308fdd6283300e68),
    2: (0, $860f0b5184108148$export$388131623a5f947b),
    3: (0, $860f0b5184108148$export$cd63464c02a18ed3),
    4: (0, $860f0b5184108148$export$8024c021d839bc0e),
    5: (0, $860f0b5184108148$export$a92c08b19856a52b),
    6: (0, $860f0b5184108148$export$dc67eb20d4395175),
    7: (0, $860f0b5184108148$export$492422570a89c8b0),
    8: (0, $860f0b5184108148$export$8786c8b1e955b2e9),
    9: (0, $860f0b5184108148$export$7b8ebc2092af05a9),
    10: (0, $860f0b5184108148$export$671a0c9051642a0b),
    11: (0, $860f0b5184108148$export$4a9bd43882a638a3),
    // 0b00001100: "8-bit sample rate (in kHz) from end of header",
    // 0b00001101: "16-bit sample rate (in Hz) from end of header",
    // 0b00001110: "16-bit sample rate (in tens of Hz) from end of header",
    15: (0, $860f0b5184108148$export$a4535ec98457231d)
};
/* prettier-ignore */ const $ebbc5c9dd68f978b$var$channelAssignments = {
    /*'
  'monophonic (mono)'
  'stereo (left, right)'
  'linear surround (left, right, center)'
  'quadraphonic (front left, front right, rear left, rear right)'
  '5.0 surround (front left, front right, front center, rear left, rear right)'
  '5.1 surround (front left, front right, front center, LFE, rear left, rear right)'
  '6.1 surround (front left, front right, front center, LFE, rear center, side left, side right)'
  '7.1 surround (front left, front right, front center, LFE, rear left, rear right, side left, side right)'
  */ 0: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 1,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$25d110495212ae90)
    },
    16: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(2, (0, $860f0b5184108148$export$3e501d20baea1003)[0][0])
    },
    32: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 3,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(3, (0, $860f0b5184108148$export$3e501d20baea1003)[0][1])
    },
    48: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 4,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(4, (0, $860f0b5184108148$export$3e501d20baea1003)[1][0], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0])
    },
    64: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 5,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(5, (0, $860f0b5184108148$export$3e501d20baea1003)[1][1], (0, $860f0b5184108148$export$3e501d20baea1003)[3][0])
    },
    80: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 6,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(6, (0, $860f0b5184108148$export$3e501d20baea1003)[1][1], (0, $860f0b5184108148$export$3254282aac6747d2), (0, $860f0b5184108148$export$3e501d20baea1003)[3][0])
    },
    96: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 7,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(7, (0, $860f0b5184108148$export$3e501d20baea1003)[1][1], (0, $860f0b5184108148$export$3254282aac6747d2), (0, $860f0b5184108148$export$3e501d20baea1003)[3][4], (0, $860f0b5184108148$export$3e501d20baea1003)[2][0])
    },
    112: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 8,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: (0, $860f0b5184108148$export$8ec6a2c9fbba54e0)(8, (0, $860f0b5184108148$export$3e501d20baea1003)[1][1], (0, $860f0b5184108148$export$3254282aac6747d2), (0, $860f0b5184108148$export$3e501d20baea1003)[3][0], (0, $860f0b5184108148$export$3e501d20baea1003)[2][0])
    },
    128: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${(0, $860f0b5184108148$export$ec7f46128a2f8ed8)} (left, diff)`
    },
    144: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${(0, $860f0b5184108148$export$ec7f46128a2f8ed8)} (diff, right)`
    },
    160: {
        [(0, $860f0b5184108148$export$9659c395d9de169e)]: 2,
        [(0, $860f0b5184108148$export$6d59db4903f20f7d)]: `${(0, $860f0b5184108148$export$ec7f46128a2f8ed8)} (avg, diff)`
    },
    176: (0, $860f0b5184108148$export$e46d647da3214494),
    192: (0, $860f0b5184108148$export$e46d647da3214494),
    208: (0, $860f0b5184108148$export$e46d647da3214494),
    224: (0, $860f0b5184108148$export$e46d647da3214494),
    240: (0, $860f0b5184108148$export$e46d647da3214494)
};
const $ebbc5c9dd68f978b$var$bitDepthValues = {
    0: $ebbc5c9dd68f978b$var$getFromStreamInfo,
    2: 8,
    4: 12,
    6: (0, $860f0b5184108148$export$e46d647da3214494),
    8: 16,
    10: 20,
    12: 24,
    14: (0, $860f0b5184108148$export$e46d647da3214494)
};
class $ebbc5c9dd68f978b$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    // https://datatracker.ietf.org/doc/html/rfc3629#section-3
    //    Char. number range  |        UTF-8 octet sequence
    //    (hexadecimal)    |              (binary)
    // --------------------+---------------------------------------------
    // 0000 0000-0000 007F | 0xxxxxxx
    // 0000 0080-0000 07FF | 110xxxxx 10xxxxxx
    // 0000 0800-0000 FFFF | 1110xxxx 10xxxxxx 10xxxxxx
    // 0001 0000-0010 FFFF | 11110xxx 10xxxxxx 10xxxxxx 10xxxxxx
    static _decodeUTF8Int(data) {
        if (data[0] > 0xfe) return null; // length byte must have at least one zero as the lsb
        if (data[0] < 0x80) return {
            value: data[0],
            length: 1
        };
        // get length by counting the number of msb that are set to 1
        let length = 1;
        for(let zeroMask = 0x40; zeroMask & data[0]; zeroMask >>= 1)length++;
        let idx = length - 1, value = 0, shift = 0;
        // sum together the encoded bits in bytes 2 to length
        // 1110xxxx 10[cccccc] 10[bbbbbb] 10[aaaaaa]
        //
        //    value = [cccccc] | [bbbbbb] | [aaaaaa]
        for(; idx > 0; shift += 6, idx--){
            if ((data[idx] & 0xc0) !== 0x80) return null; // each byte should have leading 10xxxxxx
            value |= (data[idx] & 0x3f) << shift; // add the encoded bits
        }
        // read the final encoded bits in byte 1
        //     1110[dddd] 10[cccccc] 10[bbbbbb] 10[aaaaaa]
        //
        // value = [dddd] | [cccccc] | [bbbbbb] | [aaaaaa]
        value |= (data[idx] & 0x7f >> length) << shift;
        return {
            value: value,
            length: length
        };
    }
    static [(0, $860f0b5184108148$export$c34399eed923e901)](data, headerCache) {
        const codecParserStub = {
            [(0, $860f0b5184108148$export$3027c70a881d60dc)]: function*() {
                return data;
            }
        };
        return $ebbc5c9dd68f978b$export$2e2bcd8739ae039[0, $860f0b5184108148$export$47ed31abc613cf55](codecParserStub, headerCache, 0).next().value;
    }
    static *[(0, $860f0b5184108148$export$47ed31abc613cf55)](codecParser, headerCache, readOffset) {
        // Must be at least 6 bytes.
        let data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](6, readOffset);
        // Bytes (1-2 of 6)
        // * `11111111|111110..`: Frame sync
        // * `........|......0.`: Reserved 0 - mandatory, 1 - reserved
        if (data[0] !== 0xff || !(data[1] === 0xf8 || data[1] === 0xf9)) return null;
        const header = {};
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, 4));
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (!cachedHeader) {
            // Byte (2 of 6)
            // * `.......C`: Blocking strategy, 0 - fixed, 1 - variable
            header[0, $860f0b5184108148$export$f542eb4365e59cc9] = data[1] & 1;
            header[0, $860f0b5184108148$export$5af3e22a52b4ea9e] = $ebbc5c9dd68f978b$var$blockingStrategyValues[header[0, $860f0b5184108148$export$f542eb4365e59cc9]];
            // Byte (3 of 6)
            // * `DDDD....`: Block size in inter-channel samples
            // * `....EEEE`: Sample rate
            header[0, $860f0b5184108148$export$99f767e02b81025c] = data[2] & 240;
            header[0, $860f0b5184108148$export$590421bd05077aa4] = data[2] & 15;
            header[0, $860f0b5184108148$export$446963a0ea44fb9d] = $ebbc5c9dd68f978b$var$blockSizeValues[header[0, $860f0b5184108148$export$99f767e02b81025c]];
            if (header[0, $860f0b5184108148$export$446963a0ea44fb9d] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
            header[0, $860f0b5184108148$export$851d973a43101ae1] = $ebbc5c9dd68f978b$var$sampleRateValues[header[0, $860f0b5184108148$export$590421bd05077aa4]];
            if (header[0, $860f0b5184108148$export$851d973a43101ae1] === (0, $860f0b5184108148$export$a4535ec98457231d)) return null;
            // Byte (4 of 6)
            // * `FFFF....`: Channel assignment
            // * `....GGG.`: Sample size in bits
            // * `.......H`: Reserved 0 - mandatory, 1 - reserved
            if (data[3] & 1) return null;
            const channelAssignment = $ebbc5c9dd68f978b$var$channelAssignments[data[3] & 240];
            if (channelAssignment === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
            header[0, $860f0b5184108148$export$9659c395d9de169e] = channelAssignment[0, $860f0b5184108148$export$9659c395d9de169e];
            header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = channelAssignment[0, $860f0b5184108148$export$6d59db4903f20f7d];
            header[0, $860f0b5184108148$export$cee20cdac1cd19df] = $ebbc5c9dd68f978b$var$bitDepthValues[data[3] & 14];
            if (header[0, $860f0b5184108148$export$cee20cdac1cd19df] === (0, $860f0b5184108148$export$e46d647da3214494)) return null;
        } else Object.assign(header, cachedHeader);
        // Byte (5...)
        // * `IIIIIIII|...`: VBR block size ? sample number : frame number
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = 5;
        // check if there is enough data to parse UTF8
        data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156] + 8, readOffset);
        const decodedUtf8 = $ebbc5c9dd68f978b$export$2e2bcd8739ae039._decodeUTF8Int(data[0, $860f0b5184108148$export$7ec32827e4221318](4));
        if (!decodedUtf8) return null;
        if (header[0, $860f0b5184108148$export$f542eb4365e59cc9]) header[0, $860f0b5184108148$export$dda3274d649921c8] = decodedUtf8.value;
        else header[0, $860f0b5184108148$export$5da2c6384bf58746] = decodedUtf8.value;
        header[0, $860f0b5184108148$export$f24224f1c91d8156] += decodedUtf8[0, $860f0b5184108148$export$f24224f1c91d8156];
        // Byte (...)
        // * `JJJJJJJJ|(JJJJJJJJ)`: Blocksize (8/16bit custom value)
        if (header[0, $860f0b5184108148$export$99f767e02b81025c] === 96) {
            // 8 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$446963a0ea44fb9d] = data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] + 1;
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 1;
        } else if (header[0, $860f0b5184108148$export$99f767e02b81025c] === 112) {
            // 16 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$446963a0ea44fb9d] = (data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] << 8) + data[header[0, $860f0b5184108148$export$f24224f1c91d8156]] + 1;
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 2;
        }
        header[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = header[0, $860f0b5184108148$export$446963a0ea44fb9d];
        // Byte (...)
        // * `KKKKKKKK|(KKKKKKKK)`: Sample rate (8/16bit custom value)
        if (header[0, $860f0b5184108148$export$590421bd05077aa4] === 12) {
            // 8 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$851d973a43101ae1] = data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] * 1000;
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 1;
        } else if (header[0, $860f0b5184108148$export$590421bd05077aa4] === 13) {
            // 16 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$851d973a43101ae1] = (data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] << 8) + data[header[0, $860f0b5184108148$export$f24224f1c91d8156]];
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 2;
        } else if (header[0, $860f0b5184108148$export$590421bd05077aa4] === 14) {
            // 16 bit
            if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
            header[0, $860f0b5184108148$export$851d973a43101ae1] = ((data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1] << 8) + data[header[0, $860f0b5184108148$export$f24224f1c91d8156]]) * 10;
            header[0, $860f0b5184108148$export$f24224f1c91d8156] += 2;
        }
        // Byte (...)
        // * `LLLLLLLL`: CRC-8
        if (data[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset);
        header[0, $860f0b5184108148$export$4fafbcc8068ef7ca] = data[header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1];
        if (header[0, $860f0b5184108148$export$4fafbcc8068ef7ca] !== (0, $dd0c961b75cd9139$export$97177c3f756cd8a4)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, header[0, $860f0b5184108148$export$f24224f1c91d8156] - 1))) return null;
        if (!cachedHeader) {
            const { blockingStrategyBits: blockingStrategyBits, frameNumber: frameNumber, sampleNumber: sampleNumber, samples: samples, sampleRateBits: sampleRateBits, blockSizeBits: blockSizeBits, crc: crc, length: length, ...codecUpdateFields } = header;
            headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
        }
        return new $ebbc5c9dd68f978b$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call FLACHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$bacf03850837cc9e] = null; // set in FLACFrame
        this[0, $860f0b5184108148$export$5af3e22a52b4ea9e] = header[0, $860f0b5184108148$export$5af3e22a52b4ea9e];
        this[0, $860f0b5184108148$export$446963a0ea44fb9d] = header[0, $860f0b5184108148$export$446963a0ea44fb9d];
        this[0, $860f0b5184108148$export$5da2c6384bf58746] = header[0, $860f0b5184108148$export$5da2c6384bf58746];
        this[0, $860f0b5184108148$export$dda3274d649921c8] = header[0, $860f0b5184108148$export$dda3274d649921c8];
        this[0, $860f0b5184108148$export$9010c500bffe71e6] = null; // set during ogg parsing
    }
}


const $fc8c22388cf24d2d$var$MIN_FLAC_FRAME_SIZE = 2;
const $fc8c22388cf24d2d$var$MAX_FLAC_FRAME_SIZE = 524288;
class $fc8c22388cf24d2d$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $c609565fc87a2788$export$2e2bcd8739ae039);
        this.Header = (0, $ebbc5c9dd68f978b$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return "flac";
    }
    *_getNextFrameSyncOffset(offset) {
        const data = yield* this._codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](2, 0);
        const dataLength = data[0, $860f0b5184108148$export$f24224f1c91d8156] - 2;
        while(offset < dataLength){
            // * `11111111|111110..`: Frame sync
            // * `........|......0.`: Reserved 0 - mandatory, 1 - reserved
            const firstByte = data[offset];
            if (firstByte === 0xff) {
                const secondByte = data[offset + 1];
                if (secondByte === 0xf8 || secondByte === 0xf9) break;
                if (secondByte !== 0xff) offset++; // might as well check for the next sync byte
            }
            offset++;
        }
        return offset;
    }
    *[(0, $860f0b5184108148$export$9616b51a1be2e082)]() {
        // find the first valid frame header
        do {
            const header = yield* (0, $ebbc5c9dd68f978b$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$47ed31abc613cf55](this._codecParser, this._headerCache, 0);
            if (header) {
                // found a valid frame header
                // find the next valid frame header
                let nextHeaderOffset = (0, $5169222015670af0$export$52342bdf89fb39e7).get(header)[0, $860f0b5184108148$export$f24224f1c91d8156] + $fc8c22388cf24d2d$var$MIN_FLAC_FRAME_SIZE;
                while(nextHeaderOffset <= $fc8c22388cf24d2d$var$MAX_FLAC_FRAME_SIZE){
                    if (this._codecParser._flushing || (yield* (0, $ebbc5c9dd68f978b$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$47ed31abc613cf55](this._codecParser, this._headerCache, nextHeaderOffset))) {
                        // found a valid next frame header
                        let frameData = yield* this._codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](nextHeaderOffset);
                        if (!this._codecParser._flushing) frameData = frameData[0, $860f0b5184108148$export$7ec32827e4221318](0, nextHeaderOffset);
                        // check that this is actually the next header by validating the frame footer crc16
                        if ((0, $c609565fc87a2788$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$b97792a91f8a2a21](frameData)) {
                            // both frame headers, and frame footer crc16 are valid, we are synced (odds are pretty low of a false positive)
                            const frame = new (0, $c609565fc87a2788$export$2e2bcd8739ae039)(frameData, header);
                            this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5](); // start caching when synced
                            this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](nextHeaderOffset); // increment to the next frame
                            this._codecParser[0, $860f0b5184108148$export$24d5305cc192425a](frame);
                            return frame;
                        }
                    }
                    nextHeaderOffset = yield* this._getNextFrameSyncOffset(nextHeaderOffset + 1);
                }
                this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9](`Unable to sync FLAC frame after searching ${nextHeaderOffset} bytes.`);
                this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d](nextHeaderOffset);
            } else // not synced, increment data to continue syncing
            this._codecParser[0, $860f0b5184108148$export$ccac409b8bd6669d]((yield* this._getNextFrameSyncOffset(1)));
        }while (true);
    }
    [(0, $860f0b5184108148$export$d9639f7fbeab4358)](oggPage) {
        if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] === 0) {
            // Identification header
            this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5]();
            this._streamInfo = oggPage[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$7ec32827e4221318](13);
        } else if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] === 1) ;
        else oggPage[0, $860f0b5184108148$export$a53f1e3778a12d7d] = (0, $5169222015670af0$export$5b0e32d79f1188e7).get(oggPage)[0, $860f0b5184108148$export$27e01f77e7f7ec20].map((segment)=>{
            const header = (0, $ebbc5c9dd68f978b$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$c34399eed923e901](segment, this._headerCache);
            if (header) return new (0, $c609565fc87a2788$export$2e2bcd8739ae039)(segment, header, this._streamInfo);
            else this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9]("Failed to parse Ogg FLAC frame", "Skipping invalid FLAC frame");
        }).filter((frame)=>!!frame);
        return oggPage;
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 



/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*
https://xiph.org/ogg/doc/framing.html

AAAAAAAA AAAAAAAA AAAAAAAA AAAAAAAA BBBBBBBB 00000CDE

(LSB)                                                             (MSB)
FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF
GGGGGGGG GGGGGGGG GGGGGGGG GGGGGGGG
HHHHHHHH HHHHHHHH HHHHHHHH HHHHHHHH
IIIIIIII IIIIIIII IIIIIIII IIIIIIII

JJJJJJJJ
LLLLLLLL...

Ogg Page Header
Letter  Length (bits)  Description
A   32  0x4f676753, "OggS"
B   8   stream_structure_version
C   1   (0 no, 1 yes) last page of logical bitstream (eos)
D   1   (0 no, 1 yes) first page of logical bitstream (bos)
E   1   (0 no, 1 yes) continued packet

F   64  absolute granule position
G   32  stream serial number
H   32  page sequence no
I   32  page checksum
J   8   Number of page segments in the segment table
L   n   Segment table (n=page_segments+26).
        Segment table values sum to the total length of the packet.
        Last value is always < 0xFF. Last lacing value will be 0x00 if evenly divisible by 0xFF.
        
*/ 


class $a86b95845073ac73$export$2e2bcd8739ae039 {
    static *[(0, $860f0b5184108148$export$47ed31abc613cf55)](codecParser, headerCache, readOffset) {
        const header = {};
        // Must be at least 28 bytes.
        let data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](28, readOffset);
        // Bytes (1-4 of 28)
        // Frame sync (must equal OggS): `AAAAAAAA|AAAAAAAA|AAAAAAAA|AAAAAAAA`:
        if (data[0] !== 0x4f || // O
        data[1] !== 0x67 || // g
        data[2] !== 0x67 || // g
        data[3] !== 0x53 //    S
        ) return null;
        // Byte (5 of 28)
        // * `BBBBBBBB`: stream_structure_version
        header[0, $860f0b5184108148$export$fd98de4d87954f15] = data[4];
        // Byte (6 of 28)
        // * `00000CDE`
        // * `00000...`: All zeros
        // * `.....C..`: (0 no, 1 yes) last page of logical bitstream (eos)
        // * `......D.`: (0 no, 1 yes) first page of logical bitstream (bos)
        // * `.......E`: (0 no, 1 yes) continued packet
        const zeros = data[5] & 248;
        if (zeros) return null;
        header[0, $860f0b5184108148$export$59545aa1378f3baa] = !!(data[5] & 4);
        header[0, $860f0b5184108148$export$f7027d263cc898cc] = !!(data[5] & 2);
        header[0, $860f0b5184108148$export$b046ea5b29155775] = !!(data[5] & 1);
        const view = new (0, $860f0b5184108148$export$40b76aa5ded53e7a)((0, $860f0b5184108148$export$d7e5036dad7e20bb).from(data[0, $860f0b5184108148$export$7ec32827e4221318](0, 28))[0, $860f0b5184108148$export$ab1029bcae9ddb4a]);
        // Byte (7-14 of 28)
        // * `FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF`
        // * Absolute Granule Position
        header[0, $860f0b5184108148$export$b9d4fc21491dc293] = (0, $dd0c961b75cd9139$export$1c15aa5d34abba6b)(view, 6);
        // Byte (15-18 of 28)
        // * `GGGGGGGG|GGGGGGGG|GGGGGGGG|GGGGGGGG`
        // * Stream Serial Number
        header[0, $860f0b5184108148$export$462f9602534f6121] = view.getInt32(14, true);
        // Byte (19-22 of 28)
        // * `HHHHHHHH|HHHHHHHH|HHHHHHHH|HHHHHHHH`
        // * Page Sequence Number
        header[0, $860f0b5184108148$export$a60fa1703d7dd487] = view.getInt32(18, true);
        // Byte (23-26 of 28)
        // * `IIIIIIII|IIIIIIII|IIIIIIII|IIIIIIII`
        // * Page Checksum
        header[0, $860f0b5184108148$export$c16a704080c492f2] = view.getInt32(22, true);
        // Byte (27 of 28)
        // * `JJJJJJJJ`: Number of page segments in the segment table
        const pageSegmentTableLength = data[26];
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = pageSegmentTableLength + 27;
        data = yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](header[0, $860f0b5184108148$export$f24224f1c91d8156], readOffset); // read in the page segment table
        header[0, $860f0b5184108148$export$326bb32b4ec6239b] = 0;
        header[0, $860f0b5184108148$export$e0e12ae5ee640391] = [];
        header[0, $860f0b5184108148$export$7b4b65786d4d1f7] = (0, $860f0b5184108148$export$d7e5036dad7e20bb).from(data[0, $860f0b5184108148$export$7ec32827e4221318](27, header[0, $860f0b5184108148$export$f24224f1c91d8156]));
        for(let i = 0, segmentLength = 0; i < pageSegmentTableLength; i++){
            const segmentByte = header[0, $860f0b5184108148$export$7b4b65786d4d1f7][i];
            header[0, $860f0b5184108148$export$326bb32b4ec6239b] += segmentByte;
            segmentLength += segmentByte;
            if (segmentByte !== 0xff || i === pageSegmentTableLength - 1) {
                header[0, $860f0b5184108148$export$e0e12ae5ee640391].push(segmentLength);
                segmentLength = 0;
            }
        }
        return new $a86b95845073ac73$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call OggPageHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        (0, $5169222015670af0$export$52342bdf89fb39e7).set(this, header);
        this[0, $860f0b5184108148$export$b9d4fc21491dc293] = header[0, $860f0b5184108148$export$b9d4fc21491dc293];
        this[0, $860f0b5184108148$export$b046ea5b29155775] = header[0, $860f0b5184108148$export$b046ea5b29155775];
        this[0, $860f0b5184108148$export$f7027d263cc898cc] = header[0, $860f0b5184108148$export$f7027d263cc898cc];
        this[0, $860f0b5184108148$export$59545aa1378f3baa] = header[0, $860f0b5184108148$export$59545aa1378f3baa];
        this[0, $860f0b5184108148$export$e0e12ae5ee640391] = header[0, $860f0b5184108148$export$e0e12ae5ee640391];
        this[0, $860f0b5184108148$export$a60fa1703d7dd487] = header[0, $860f0b5184108148$export$a60fa1703d7dd487];
        this[0, $860f0b5184108148$export$c16a704080c492f2] = header[0, $860f0b5184108148$export$c16a704080c492f2];
        this[0, $860f0b5184108148$export$462f9602534f6121] = header[0, $860f0b5184108148$export$462f9602534f6121];
    }
}


class $54de051f73360197$export$2e2bcd8739ae039 extends (0, $34ee446617012033$export$2e2bcd8739ae039) {
    static *[(0, $860f0b5184108148$export$fd8d2ba2926cdfb6)](codecParser, headerCache, readOffset) {
        const header = yield* (0, $a86b95845073ac73$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$47ed31abc613cf55](codecParser, headerCache, readOffset);
        if (header) {
            const frameLengthValue = (0, $5169222015670af0$export$52342bdf89fb39e7).get(header)[0, $860f0b5184108148$export$326bb32b4ec6239b];
            const headerLength = (0, $5169222015670af0$export$52342bdf89fb39e7).get(header)[0, $860f0b5184108148$export$f24224f1c91d8156];
            const totalLength = headerLength + frameLengthValue;
            const rawDataValue = (yield* codecParser[0, $860f0b5184108148$export$3027c70a881d60dc](totalLength, 0))[0, $860f0b5184108148$export$7ec32827e4221318](0, totalLength);
            const frame = rawDataValue[0, $860f0b5184108148$export$7ec32827e4221318](headerLength, totalLength);
            return new $54de051f73360197$export$2e2bcd8739ae039(header, frame, rawDataValue);
        } else return null;
    }
    constructor(header, frame, rawDataValue){
        super(header, frame);
        (0, $5169222015670af0$export$5b0e32d79f1188e7).get(this)[0, $860f0b5184108148$export$f24224f1c91d8156] = rawDataValue[0, $860f0b5184108148$export$f24224f1c91d8156];
        this[0, $860f0b5184108148$export$a53f1e3778a12d7d] = [];
        this[0, $860f0b5184108148$export$bfe96fedbe3c1b3b] = rawDataValue;
        this[0, $860f0b5184108148$export$b9d4fc21491dc293] = header[0, $860f0b5184108148$export$b9d4fc21491dc293];
        this[0, $860f0b5184108148$export$1cd93882633e45f5] = header[0, $860f0b5184108148$export$c16a704080c492f2];
        this[0, $860f0b5184108148$export$1f34108aa9eb96ab] = 0;
        this[0, $860f0b5184108148$export$b046ea5b29155775] = header[0, $860f0b5184108148$export$b046ea5b29155775];
        this[0, $860f0b5184108148$export$f7027d263cc898cc] = header[0, $860f0b5184108148$export$f7027d263cc898cc];
        this[0, $860f0b5184108148$export$59545aa1378f3baa] = header[0, $860f0b5184108148$export$59545aa1378f3baa];
        this[0, $860f0b5184108148$export$a60fa1703d7dd487] = header[0, $860f0b5184108148$export$a60fa1703d7dd487];
        this[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = 0;
        this[0, $860f0b5184108148$export$462f9602534f6121] = header[0, $860f0b5184108148$export$462f9602534f6121];
    }
}




/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
class $0c94b01dfaac6aa0$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    constructor(data, header, samples){
        super(header, data, samples);
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*
https://tools.ietf.org/html/rfc7845.html
 0                   1                   2                   3
 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|      'O'      |      'p'      |      'u'      |      's'      |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|      'H'      |      'e'      |      'a'      |      'd'      |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|  Version = 1  | Channel Count |           Pre-skip            |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|                     Input Sample Rate (Hz)                    |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
|   Output Gain (Q7.8 in dB)    | Mapping Family|               |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+               :
|                                                               |
:               Optional Channel Mapping Table...               :
|                                                               |
+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+

Letter  Length (bits)  Description
A  64  Magic Signature - OpusHead
B  8   Version number - 00000001
C  8   Output channel count (unsigned)
D  16  Pre-skip (unsigned, little endian)
E  32  Sample rate (unsigned, little endian)
F  16  Output Gain (signed, little endian)
G  8   Channel Mapping family (unsigned)

// if(channel mapping !== 0)
H  8   Stream count (unsigned)
I  8   Coupled Stream Count (unsigned)
J  8*C Channel Mapping
*/ 


/* prettier-ignore */ const $8d4c615213e2a499$var$channelMappingFamilies = {
    0: (0, $860f0b5184108148$export$c067b99a35ad0847).slice(0, 2),
    /*
    0: "monophonic (mono)"
    1: "stereo (left, right)"
    */ 1: (0, $860f0b5184108148$export$c067b99a35ad0847)
};
const $8d4c615213e2a499$var$silkOnly = "SILK-only";
const $8d4c615213e2a499$var$celtOnly = "CELT-only";
const $8d4c615213e2a499$var$hybrid = "Hybrid";
const $8d4c615213e2a499$var$narrowBand = "narrowband";
const $8d4c615213e2a499$var$mediumBand = "medium-band";
const $8d4c615213e2a499$var$wideBand = "wideband";
const $8d4c615213e2a499$var$superWideBand = "super-wideband";
const $8d4c615213e2a499$var$fullBand = "fullband";
//  0 1 2 3 4 5 6 7
// +-+-+-+-+-+-+-+-+
// | config  |s| c |
// +-+-+-+-+-+-+-+-+
// prettier-ignore
const $8d4c615213e2a499$var$configTable = {
    0: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    8: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    16: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 40
    },
    24: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 60
    },
    32: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$mediumBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    40: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$mediumBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    48: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$mediumBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 40
    },
    56: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$mediumBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 60
    },
    64: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    72: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    80: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 40
    },
    88: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$silkOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 60
    },
    96: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$hybrid,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    104: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$hybrid,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    112: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$hybrid,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    120: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$hybrid,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    128: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 2.5
    },
    136: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 5
    },
    144: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    152: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$narrowBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    160: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 2.5
    },
    168: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 5
    },
    176: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    184: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$wideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    192: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 2.5
    },
    200: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 5
    },
    208: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    216: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$superWideBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    },
    224: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 2.5
    },
    232: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 5
    },
    240: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 10
    },
    248: {
        [(0, $860f0b5184108148$export$549ff81930776885)]: $8d4c615213e2a499$var$celtOnly,
        [(0, $860f0b5184108148$export$2a97ae90773dd351)]: $8d4c615213e2a499$var$fullBand,
        [(0, $860f0b5184108148$export$7815706ac4afa67d)]: 20
    }
};
class $8d4c615213e2a499$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    static [(0, $860f0b5184108148$export$c34399eed923e901)](dataValue, packetData, headerCache) {
        const header = {};
        // get length of header
        // Byte (10 of 19)
        // * `CCCCCCCC`: Channel Count
        header[0, $860f0b5184108148$export$9659c395d9de169e] = dataValue[9];
        // Byte (19 of 19)
        // * `GGGGGGGG`: Channel Mapping Family
        header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] = dataValue[18];
        header[0, $860f0b5184108148$export$f24224f1c91d8156] = header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] !== 0 ? 21 + header[0, $860f0b5184108148$export$9659c395d9de169e] : 19;
        if (dataValue[0, $860f0b5184108148$export$f24224f1c91d8156] < header[0, $860f0b5184108148$export$f24224f1c91d8156]) throw new Error("Out of data while inside an Ogg Page");
        // Page Segment Bytes (1-2)
        // * `AAAAA...`: Packet config
        // * `.....B..`:
        // * `......CC`: Packet code
        const packetMode = packetData[0] & 3;
        const packetLength = packetMode === 3 ? 2 : 1;
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(dataValue[0, $860f0b5184108148$export$7ec32827e4221318](0, header[0, $860f0b5184108148$export$f24224f1c91d8156])) + (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(packetData[0, $860f0b5184108148$export$7ec32827e4221318](0, packetLength));
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (cachedHeader) return new $8d4c615213e2a499$export$2e2bcd8739ae039(cachedHeader);
        // Bytes (1-8 of 19): OpusHead - Magic Signature
        if (key.substr(0, 8) !== "OpusHead") return null;
        // Byte (9 of 19)
        // * `00000001`: Version number
        if (dataValue[8] !== 1) return null;
        header[0, $860f0b5184108148$export$4051a07651545597] = (0, $860f0b5184108148$export$d7e5036dad7e20bb).from(dataValue[0, $860f0b5184108148$export$7ec32827e4221318](0, header[0, $860f0b5184108148$export$f24224f1c91d8156]));
        const view = new (0, $860f0b5184108148$export$40b76aa5ded53e7a)(header[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$ab1029bcae9ddb4a]);
        header[0, $860f0b5184108148$export$cee20cdac1cd19df] = 16;
        // Byte (10 of 19)
        // * `CCCCCCCC`: Channel Count
        // set earlier to determine length
        // Byte (11-12 of 19)
        // * `DDDDDDDD|DDDDDDDD`: Pre skip
        header[0, $860f0b5184108148$export$3dc3ed1cd86c68b4] = view.getUint16(10, true);
        // Byte (13-16 of 19)
        // * `EEEEEEEE|EEEEEEEE|EEEEEEEE|EEEEEEEE`: Sample Rate
        header[0, $860f0b5184108148$export$cc7fd71f037082e3] = view.getUint32(12, true);
        // Opus is always decoded at 48kHz
        header[0, $860f0b5184108148$export$851d973a43101ae1] = (0, $860f0b5184108148$export$671a0c9051642a0b);
        // Byte (17-18 of 19)
        // * `FFFFFFFF|FFFFFFFF`: Output Gain
        header[0, $860f0b5184108148$export$ed96e046486b4b25] = view.getInt16(16, true);
        // Byte (19 of 19)
        // * `GGGGGGGG`: Channel Mapping Family
        // set earlier to determine length
        if (header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] in $8d4c615213e2a499$var$channelMappingFamilies) {
            header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = $8d4c615213e2a499$var$channelMappingFamilies[header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28]][header[0, $860f0b5184108148$export$9659c395d9de169e] - 1];
            if (!header[0, $860f0b5184108148$export$589c9a7ae9a79c5e]) return null;
        }
        if (header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] !== 0) {
            // * `HHHHHHHH`: Stream count
            header[0, $860f0b5184108148$export$ef26b3900cee0fa3] = dataValue[19];
            // * `IIIIIIII`: Coupled Stream count
            header[0, $860f0b5184108148$export$a592872ee1129cb4] = dataValue[20];
            // * `JJJJJJJJ|...` Channel Mapping table
            header[0, $860f0b5184108148$export$e856ca83ff30dbad] = [
                ...dataValue[0, $860f0b5184108148$export$7ec32827e4221318](21, header[0, $860f0b5184108148$export$9659c395d9de169e] + 21)
            ];
        }
        const packetConfig = $8d4c615213e2a499$var$configTable[248 & packetData[0]];
        header[0, $860f0b5184108148$export$549ff81930776885] = packetConfig[0, $860f0b5184108148$export$549ff81930776885];
        header[0, $860f0b5184108148$export$2a97ae90773dd351] = packetConfig[0, $860f0b5184108148$export$2a97ae90773dd351];
        header[0, $860f0b5184108148$export$7815706ac4afa67d] = packetConfig[0, $860f0b5184108148$export$7815706ac4afa67d];
        // https://tools.ietf.org/html/rfc6716#appendix-B
        switch(packetMode){
            case 0:
                // 0: 1 frame in the packet
                header[0, $860f0b5184108148$export$150180f5f882de62] = 1;
                break;
            case 1:
            // 1: 2 frames in the packet, each with equal compressed size
            case 2:
                // 2: 2 frames in the packet, with different compressed sizes
                header[0, $860f0b5184108148$export$150180f5f882de62] = 2;
                break;
            case 3:
                // 3: an arbitrary number of frames in the packet
                header[0, $860f0b5184108148$export$ca9d7e8ef88bd07e] = !!(128 & packetData[1]);
                header[0, $860f0b5184108148$export$ae48fe32cc58ab6f] = !!(64 & packetData[1]);
                header[0, $860f0b5184108148$export$150180f5f882de62] = 63 & packetData[1];
                break;
            default:
                return null;
        }
        // set header cache
        {
            const { length: length, data: headerData, channelMappingFamily: channelMappingFamily, ...codecUpdateFields } = header;
            headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
        }
        return new $8d4c615213e2a499$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call OpusHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$4051a07651545597] = header[0, $860f0b5184108148$export$4051a07651545597];
        this[0, $860f0b5184108148$export$2a97ae90773dd351] = header[0, $860f0b5184108148$export$2a97ae90773dd351];
        this[0, $860f0b5184108148$export$1dbaf4b0a82f5d28] = header[0, $860f0b5184108148$export$1dbaf4b0a82f5d28];
        this[0, $860f0b5184108148$export$e856ca83ff30dbad] = header[0, $860f0b5184108148$export$e856ca83ff30dbad];
        this[0, $860f0b5184108148$export$a592872ee1129cb4] = header[0, $860f0b5184108148$export$a592872ee1129cb4];
        this[0, $860f0b5184108148$export$150180f5f882de62] = header[0, $860f0b5184108148$export$150180f5f882de62];
        this[0, $860f0b5184108148$export$7815706ac4afa67d] = header[0, $860f0b5184108148$export$7815706ac4afa67d];
        this[0, $860f0b5184108148$export$ae48fe32cc58ab6f] = header[0, $860f0b5184108148$export$ae48fe32cc58ab6f];
        this[0, $860f0b5184108148$export$cc7fd71f037082e3] = header[0, $860f0b5184108148$export$cc7fd71f037082e3];
        this[0, $860f0b5184108148$export$ca9d7e8ef88bd07e] = header[0, $860f0b5184108148$export$ca9d7e8ef88bd07e];
        this[0, $860f0b5184108148$export$549ff81930776885] = header[0, $860f0b5184108148$export$549ff81930776885];
        this[0, $860f0b5184108148$export$ed96e046486b4b25] = header[0, $860f0b5184108148$export$ed96e046486b4b25];
        this[0, $860f0b5184108148$export$3dc3ed1cd86c68b4] = header[0, $860f0b5184108148$export$3dc3ed1cd86c68b4];
        this[0, $860f0b5184108148$export$ef26b3900cee0fa3] = header[0, $860f0b5184108148$export$ef26b3900cee0fa3];
    }
}


class $7068865fc990acb1$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $0c94b01dfaac6aa0$export$2e2bcd8739ae039);
        this.Header = (0, $8d4c615213e2a499$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
        this._identificationHeader = null;
        this._preSkipRemaining = null;
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return "opus";
    }
    /**
   * @todo implement continued page support
   */ [(0, $860f0b5184108148$export$d9639f7fbeab4358)](oggPage) {
        if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] === 0) {
            // Identification header
            this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5]();
            this._identificationHeader = oggPage[0, $860f0b5184108148$export$4051a07651545597];
        } else if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] === 1) ;
        else oggPage[0, $860f0b5184108148$export$a53f1e3778a12d7d] = (0, $5169222015670af0$export$5b0e32d79f1188e7).get(oggPage)[0, $860f0b5184108148$export$27e01f77e7f7ec20].map((segment)=>{
            const header = (0, $8d4c615213e2a499$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$c34399eed923e901](this._identificationHeader, segment, this._headerCache);
            if (header) {
                if (this._preSkipRemaining === null) this._preSkipRemaining = header[0, $860f0b5184108148$export$3dc3ed1cd86c68b4];
                let samples = header[0, $860f0b5184108148$export$7815706ac4afa67d] * header[0, $860f0b5184108148$export$150180f5f882de62] / 1000 * header[0, $860f0b5184108148$export$851d973a43101ae1];
                if (this._preSkipRemaining > 0) {
                    this._preSkipRemaining -= samples;
                    samples = this._preSkipRemaining < 0 ? -this._preSkipRemaining : 0;
                }
                return new (0, $0c94b01dfaac6aa0$export$2e2bcd8739ae039)(segment, header, samples);
            }
            this._codecParser[0, $860f0b5184108148$export$58da9968c3170cb1]("Failed to parse Ogg Opus Header", "Not a valid Ogg Opus file");
        });
        return oggPage;
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 



/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ 
class $423631361db2be72$export$2e2bcd8739ae039 extends (0, $0b17d7d3514fce05$export$2e2bcd8739ae039) {
    constructor(data, header, samples){
        super(header, data, samples);
    }
}


/* Copyright 2020-2023 Ethan Halsall
    
    This file is part of codec-parser.
    
    codec-parser is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    codec-parser is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>
*/ /*

1  1) [packet_type] : 8 bit value
2  2) 0x76, 0x6f, 0x72, 0x62, 0x69, 0x73: the characters ’v’,’o’,’r’,’b’,’i’,’s’ as six octets

Letter bits Description
A      8    Packet type
B      48   Magic signature (vorbis)
C      32   Version number
D      8    Channels
E      32   Sample rate
F      32   Bitrate Maximum (signed)
G      32   Bitrate Nominal (signed)
H      32   Bitrate Minimum (signed)
I      4    blocksize 1
J      4    blocksize 0
K      1    Framing flag
*/ 


const $3bc9b95d2966c665$var$blockSizes = {
};
for(let i = 0; i < 8; i++)$3bc9b95d2966c665$var$blockSizes[i + 6] = 2 ** (6 + i);
class $3bc9b95d2966c665$export$2e2bcd8739ae039 extends (0, $3fb1607145c26488$export$2e2bcd8739ae039) {
    static [(0, $860f0b5184108148$export$c34399eed923e901)](dataValue, headerCache, vorbisCommentsData, vorbisSetupData) {
        // Must be at least 30 bytes.
        if (dataValue[0, $860f0b5184108148$export$f24224f1c91d8156] < 30) throw new Error("Out of data while inside an Ogg Page");
        // Check header cache
        const key = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(dataValue[0, $860f0b5184108148$export$7ec32827e4221318](0, 30));
        const cachedHeader = headerCache[0, $860f0b5184108148$export$47ed31abc613cf55](key);
        if (cachedHeader) return new $3bc9b95d2966c665$export$2e2bcd8739ae039(cachedHeader);
        const header = {
            [(0, $860f0b5184108148$export$f24224f1c91d8156)]: 30
        };
        // Bytes (1-7 of 30): /01vorbis - Magic Signature
        if (key.substr(0, 7) !== "\x01vorbis") return null;
        header[0, $860f0b5184108148$export$4051a07651545597] = (0, $860f0b5184108148$export$d7e5036dad7e20bb).from(dataValue[0, $860f0b5184108148$export$7ec32827e4221318](0, 30));
        const view = new (0, $860f0b5184108148$export$40b76aa5ded53e7a)(header[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$ab1029bcae9ddb4a]);
        // Byte (8-11 of 30)
        // * `CCCCCCCC|CCCCCCCC|CCCCCCCC|CCCCCCCC`: Version number
        header[0, $860f0b5184108148$export$83d89fbfd8236492] = view.getUint32(7, true);
        if (header[0, $860f0b5184108148$export$83d89fbfd8236492] !== 0) return null;
        // Byte (12 of 30)
        // * `DDDDDDDD`: Channel Count
        header[0, $860f0b5184108148$export$9659c395d9de169e] = dataValue[11];
        header[0, $860f0b5184108148$export$589c9a7ae9a79c5e] = (0, $860f0b5184108148$export$c067b99a35ad0847)[header[0, $860f0b5184108148$export$9659c395d9de169e] - 1] || "application defined";
        // Byte (13-16 of 30)
        // * `EEEEEEEE|EEEEEEEE|EEEEEEEE|EEEEEEEE`: Sample Rate
        header[0, $860f0b5184108148$export$851d973a43101ae1] = view.getUint32(12, true);
        // Byte (17-20 of 30)
        // * `FFFFFFFF|FFFFFFFF|FFFFFFFF|FFFFFFFF`: Bitrate Maximum
        header[0, $860f0b5184108148$export$d48d8e6e1487adc4] = view.getInt32(16, true);
        // Byte (21-24 of 30)
        // * `GGGGGGGG|GGGGGGGG|GGGGGGGG|GGGGGGGG`: Bitrate Nominal
        header[0, $860f0b5184108148$export$d28b7ae062ff03c5] = view.getInt32(20, true);
        // Byte (25-28 of 30)
        // * `HHHHHHHH|HHHHHHHH|HHHHHHHH|HHHHHHHH`: Bitrate Minimum
        header[0, $860f0b5184108148$export$971636741d86955] = view.getInt32(24, true);
        // Byte (29 of 30)
        // * `IIII....` Blocksize 1
        // * `....JJJJ` Blocksize 0
        header[0, $860f0b5184108148$export$6880a9e40f87ae65] = $3bc9b95d2966c665$var$blockSizes[(dataValue[28] & 240) >> 4];
        header[0, $860f0b5184108148$export$f3cbeb72a3601eb6] = $3bc9b95d2966c665$var$blockSizes[dataValue[28] & 15];
        if (header[0, $860f0b5184108148$export$f3cbeb72a3601eb6] > header[0, $860f0b5184108148$export$6880a9e40f87ae65]) return null;
        // Byte (29 of 30)
        // * `00000001` Framing bit
        if (dataValue[29] !== 0x01) return null;
        header[0, $860f0b5184108148$export$cee20cdac1cd19df] = 32;
        header[0, $860f0b5184108148$export$fe63a71268ec44ee] = vorbisSetupData;
        header[0, $860f0b5184108148$export$3a1c3ed71012e84e] = vorbisCommentsData;
        {
            // set header cache
            const { length: length, data: data, version: version, vorbisSetup: vorbisSetup, vorbisComments: vorbisComments, ...codecUpdateFields } = header;
            headerCache[0, $860f0b5184108148$export$604ed74fb893f0e2](key, header, codecUpdateFields);
        }
        return new $3bc9b95d2966c665$export$2e2bcd8739ae039(header);
    }
    /**
   * @private
   * Call VorbisHeader.getHeader(Array<Uint8>) to get instance
   */ constructor(header){
        super(header);
        this[0, $860f0b5184108148$export$d48d8e6e1487adc4] = header[0, $860f0b5184108148$export$d48d8e6e1487adc4];
        this[0, $860f0b5184108148$export$971636741d86955] = header[0, $860f0b5184108148$export$971636741d86955];
        this[0, $860f0b5184108148$export$d28b7ae062ff03c5] = header[0, $860f0b5184108148$export$d28b7ae062ff03c5];
        this[0, $860f0b5184108148$export$f3cbeb72a3601eb6] = header[0, $860f0b5184108148$export$f3cbeb72a3601eb6];
        this[0, $860f0b5184108148$export$6880a9e40f87ae65] = header[0, $860f0b5184108148$export$6880a9e40f87ae65];
        this[0, $860f0b5184108148$export$4051a07651545597] = header[0, $860f0b5184108148$export$4051a07651545597];
        this[0, $860f0b5184108148$export$3a1c3ed71012e84e] = header[0, $860f0b5184108148$export$3a1c3ed71012e84e];
        this[0, $860f0b5184108148$export$fe63a71268ec44ee] = header[0, $860f0b5184108148$export$fe63a71268ec44ee];
    }
}


class $730ce5ecd1a651d8$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this.Frame = (0, $423631361db2be72$export$2e2bcd8739ae039);
        onCodec(this[0, $860f0b5184108148$export$1c37c01eba8ed446]);
        this._identificationHeader = null;
        this._setupComplete = false;
        this._prevBlockSize = null;
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return 0, $860f0b5184108148$export$3e1eea38d3db9f18;
    }
    [(0, $860f0b5184108148$export$d9639f7fbeab4358)](oggPage) {
        oggPage[0, $860f0b5184108148$export$a53f1e3778a12d7d] = [];
        for (const oggPageSegment of (0, $5169222015670af0$export$5b0e32d79f1188e7).get(oggPage)[0, $860f0b5184108148$export$27e01f77e7f7ec20]){
            if (oggPageSegment[0] === 1) {
                // Identification header
                this._headerCache[0, $860f0b5184108148$export$d7c4a0dd6a4567e5]();
                this._identificationHeader = oggPage[0, $860f0b5184108148$export$4051a07651545597];
                this._setupComplete = false;
            } else if (oggPageSegment[0] === 3) // comment header
            this._vorbisComments = oggPageSegment;
            else if (oggPageSegment[0] === 5) {
                // setup header
                this._vorbisSetup = oggPageSegment;
                this._mode = this._parseSetupHeader(oggPageSegment);
                this._setupComplete = true;
            } else if (this._setupComplete) {
                const header = (0, $3bc9b95d2966c665$export$2e2bcd8739ae039)[0, $860f0b5184108148$export$c34399eed923e901](this._identificationHeader, this._headerCache, this._vorbisComments, this._vorbisSetup);
                if (header) oggPage[0, $860f0b5184108148$export$a53f1e3778a12d7d].push(new (0, $423631361db2be72$export$2e2bcd8739ae039)(oggPageSegment, header, this._getSamples(oggPageSegment, header)));
                else this._codecParser[logError]("Failed to parse Ogg Vorbis Header", "Not a valid Ogg Vorbis file");
            }
        }
        return oggPage;
    }
    _getSamples(segment, header) {
        const blockFlag = this._mode.blockFlags[segment[0] >> 1 & this._mode.mask];
        const currentBlockSize = blockFlag ? header[0, $860f0b5184108148$export$6880a9e40f87ae65] : header[0, $860f0b5184108148$export$f3cbeb72a3601eb6];
        // data is not returned on the first frame, but is used to prime the decoder
        // https://xiph.org/vorbis/doc/Vorbis_I_spec.html#x1-590004
        const samplesValue = this._prevBlockSize === null ? 0 : (this._prevBlockSize + currentBlockSize) / 4;
        this._prevBlockSize = currentBlockSize;
        return samplesValue;
    }
    // https://gitlab.xiph.org/xiph/liboggz/-/blob/master/src/liboggz/oggz_auto.c#L911
    // https://github.com/FFmpeg/FFmpeg/blob/master/libavcodec/vorbis_parser.c
    /*
   * This is the format of the mode data at the end of the packet for all
   * Vorbis Version 1 :
   *
   * [ 6:number_of_modes ]
   * [ 1:size | 16:window_type(0) | 16:transform_type(0) | 8:mapping ]
   * [ 1:size | 16:window_type(0) | 16:transform_type(0) | 8:mapping ]
   * [ 1:size | 16:window_type(0) | 16:transform_type(0) | 8:mapping ]
   * [ 1:framing(1) ]
   *
   * e.g.:
   *
   * MsB         LsB
   *              <-
   * 0 0 0 0 0 1 0 0
   * 0 0 1 0 0 0 0 0
   * 0 0 1 0 0 0 0 0
   * 0 0 1|0 0 0 0 0
   * 0 0 0 0|0|0 0 0
   * 0 0 0 0 0 0 0 0
   * 0 0 0 0|0 0 0 0
   * 0 0 0 0 0 0 0 0
   * 0 0 0 0|0 0 0 0
   * 0 0 0|1|0 0 0 0 |
   * 0 0 0 0 0 0 0 0 V
   * 0 0 0|0 0 0 0 0
   * 0 0 0 0 0 0 0 0
   * 0 0|1 0 0 0 0 0
   *
   * The simplest way to approach this is to start at the end
   * and read backwards to determine the mode configuration.
   *
   * liboggz and ffmpeg both use this method.
   */ _parseSetupHeader(setup) {
        const bitReader = new (0, $dd0c961b75cd9139$export$229c1f1c745a2f7a)(setup);
        const mode = {
            count: 0,
            blockFlags: []
        };
        // sync with the framing bit
        while((bitReader.read(1) & 0x01) !== 1);
        let modeBits;
        // search in reverse to parse out the mode entries
        // limit mode count to 63 so previous block flag will be in first packet byte
        while(mode.count < 64 && bitReader.position > 0){
            (0, $dd0c961b75cd9139$export$66c1ae025e96b4bc)(bitReader.read(8)); // read mapping
            // 16 bits transform type, 16 bits window type, all values must be zero
            let currentByte = 0;
            while(bitReader.read(8) === 0x00 && currentByte++ < 3); // a non-zero value may indicate the end of the mode entries, or invalid data
            if (currentByte === 4) {
                // transform type and window type were all zeros
                modeBits = bitReader.read(7); // modeBits may need to be used in the next iteration if this is the last mode entry
                mode.blockFlags.unshift(modeBits & 0x01); // read and store mode number -> block flag
                bitReader.position += 6; // go back 6 bits so next iteration starts right after the block flag
                mode.count++;
            } else {
                // transform type and window type were not all zeros
                // check for mode count using previous iteration modeBits
                if ((((0, $dd0c961b75cd9139$export$66c1ae025e96b4bc)(modeBits) & 126) >> 1) + 1 !== mode.count) this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9]("vorbis derived mode count did not match actual mode count");
                break;
            }
        }
        // xxxxxxxa packet type
        // xxxxxxbx mode count (number of mode count bits)
        // xxxxxcxx previous window flag
        // xxxxdxxx next window flag
        mode.mask = (1 << Math.log2(mode.count)) - 1;
        return mode;
    }
}


class $34db2c67086ea732$var$OggStream {
    constructor(codecParser, headerCache, onCodec){
        this._codecParser = codecParser;
        this._headerCache = headerCache;
        this._onCodec = onCodec;
        this._continuedPacket = new (0, $860f0b5184108148$export$d7e5036dad7e20bb)();
        this._codec = null;
        this._isSupported = null;
        this._previousAbsoluteGranulePosition = null;
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return this._codec || "";
    }
    _updateCodec(codec, Parser) {
        if (this._codec !== codec) {
            this._headerCache[0, $860f0b5184108148$export$aad8462122ac592b]();
            this._parser = new Parser(this._codecParser, this._headerCache, this._onCodec);
            this._codec = codec;
        }
    }
    _checkCodecSupport({ data: data }) {
        const idString = (0, $dd0c961b75cd9139$export$7c746b75f47c9c7d)(data[0, $860f0b5184108148$export$7ec32827e4221318](0, 8));
        switch(idString){
            case "fishead\0":
                return false; // ignore ogg skeleton packets
            case "OpusHead":
                this._updateCodec("opus", (0, $7068865fc990acb1$export$2e2bcd8739ae039));
                return true;
            case /^\x7fFLAC/.test(idString) && idString:
                this._updateCodec("flac", (0, $fc8c22388cf24d2d$export$2e2bcd8739ae039));
                return true;
            case /^\x01vorbis/.test(idString) && idString:
                this._updateCodec((0, $860f0b5184108148$export$3e1eea38d3db9f18), (0, $730ce5ecd1a651d8$export$2e2bcd8739ae039));
                return true;
            default:
                return false;
        }
    }
    _checkPageSequenceNumber(oggPage) {
        if (oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] !== this._pageSequenceNumber + 1 && this._pageSequenceNumber > 1 && oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487] > 1) this._codecParser[0, $860f0b5184108148$export$ebd6064652549ce9]("Unexpected gap in Ogg Page Sequence Number.", `Expected: ${this._pageSequenceNumber + 1}, Got: ${oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487]}`);
        this._pageSequenceNumber = oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487];
    }
    _parsePage(oggPage) {
        if (this._isSupported === null) {
            this._pageSequenceNumber = oggPage[0, $860f0b5184108148$export$a60fa1703d7dd487];
            this._isSupported = this._checkCodecSupport(oggPage);
        }
        this._checkPageSequenceNumber(oggPage);
        const oggPageStore = (0, $5169222015670af0$export$5b0e32d79f1188e7).get(oggPage);
        const headerData = (0, $5169222015670af0$export$52342bdf89fb39e7).get(oggPageStore[0, $860f0b5184108148$export$38e42c68cf43b5d4]);
        let offset = 0;
        oggPageStore[0, $860f0b5184108148$export$27e01f77e7f7ec20] = headerData[0, $860f0b5184108148$export$e0e12ae5ee640391].map((segmentLength)=>oggPage[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$7ec32827e4221318](offset, offset += segmentLength));
        // prepend any existing continued packet data
        if (this._continuedPacket[0, $860f0b5184108148$export$f24224f1c91d8156]) {
            oggPageStore[0, $860f0b5184108148$export$27e01f77e7f7ec20][0] = (0, $dd0c961b75cd9139$export$28e250f55413be00)(this._continuedPacket, oggPageStore[0, $860f0b5184108148$export$27e01f77e7f7ec20][0]);
            this._continuedPacket = new (0, $860f0b5184108148$export$d7e5036dad7e20bb)();
        }
        // save any new continued packet data
        if (headerData[0, $860f0b5184108148$export$7b4b65786d4d1f7][headerData[0, $860f0b5184108148$export$7b4b65786d4d1f7][0, $860f0b5184108148$export$f24224f1c91d8156] - 1] === 0xff) this._continuedPacket = (0, $dd0c961b75cd9139$export$28e250f55413be00)(this._continuedPacket, oggPageStore[0, $860f0b5184108148$export$27e01f77e7f7ec20].pop());
        // set total samples in this ogg page
        if (this._previousAbsoluteGranulePosition !== null) oggPage[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = Number(oggPage[0, $860f0b5184108148$export$b9d4fc21491dc293] - this._previousAbsoluteGranulePosition);
        this._previousAbsoluteGranulePosition = oggPage[0, $860f0b5184108148$export$b9d4fc21491dc293];
        if (this._isSupported) {
            const frame = this._parser[0, $860f0b5184108148$export$d9639f7fbeab4358](oggPage);
            this._codecParser[0, $860f0b5184108148$export$24d5305cc192425a](frame);
            return frame;
        } else return oggPage;
    }
}
class $34db2c67086ea732$export$2e2bcd8739ae039 extends (0, $dd7c0f9e54b04fc4$export$2e2bcd8739ae039) {
    constructor(codecParser, headerCache, onCodec){
        super(codecParser, headerCache);
        this._onCodec = onCodec;
        this.Frame = (0, $54de051f73360197$export$2e2bcd8739ae039);
        this.Header = (0, $a86b95845073ac73$export$2e2bcd8739ae039);
        this._streams = new Map();
        this._currentSerialNumber = null;
    }
    get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        const oggStream = this._streams.get(this._currentSerialNumber);
        return oggStream ? oggStream.codec : "";
    }
    *[(0, $860f0b5184108148$export$9616b51a1be2e082)]() {
        const oggPage = yield* this[0, $860f0b5184108148$export$6a29256c87cd443c](true);
        this._currentSerialNumber = oggPage[0, $860f0b5184108148$export$462f9602534f6121];
        let oggStream = this._streams.get(this._currentSerialNumber);
        if (!oggStream) {
            oggStream = new $34db2c67086ea732$var$OggStream(this._codecParser, this._headerCache, this._onCodec);
            this._streams.set(this._currentSerialNumber, oggStream);
        }
        if (oggPage[0, $860f0b5184108148$export$59545aa1378f3baa]) this._streams.delete(this._currentSerialNumber);
        return oggStream._parsePage(oggPage);
    }
}


const $9692457505e16c95$var$noOp = ()=>{};
class $9692457505e16c95$export$2e2bcd8739ae039 {
    constructor(mimeType1, { onCodec: onCodec, onCodecHeader: onCodecHeader, onCodecUpdate: onCodecUpdate, enableLogging: enableLogging = false, enableFrameCRC32: enableFrameCRC32 = true } = {}){
        this._inputMimeType = mimeType1;
        this._onCodec = onCodec || $9692457505e16c95$var$noOp;
        this._onCodecHeader = onCodecHeader || $9692457505e16c95$var$noOp;
        this._onCodecUpdate = onCodecUpdate;
        this._enableLogging = enableLogging;
        this._crc32 = enableFrameCRC32 ? (0, $dd0c961b75cd9139$export$208e3b04219ed02) : $9692457505e16c95$var$noOp;
        this[0, $860f0b5184108148$export$aad8462122ac592b]();
    }
    /**
   * @public
   * @returns The detected codec
   */ get [(0, $860f0b5184108148$export$1c37c01eba8ed446)]() {
        return this._parser ? this._parser[0, $860f0b5184108148$export$1c37c01eba8ed446] : "";
    }
    [(0, $860f0b5184108148$export$aad8462122ac592b)]() {
        this._headerCache = new (0, $0139e6c9e0318001$export$2e2bcd8739ae039)(this._onCodecHeader, this._onCodecUpdate);
        this._generator = this._getGenerator();
        this._generator.next();
    }
    /**
   * @public
   * @description Generator function that yields any buffered CodecFrames and resets the CodecParser
   * @returns {Iterable<CodecFrame|OggPage>} Iterator that operates over the codec data.
   * @yields {CodecFrame|OggPage} Parsed codec or ogg page data
   */ *flush() {
        this._flushing = true;
        for(let i = this._generator.next(); i.value; i = this._generator.next())yield i.value;
        this._flushing = false;
        this[0, $860f0b5184108148$export$aad8462122ac592b]();
    }
    /**
   * @public
   * @description Generator function takes in a Uint8Array of data and returns a CodecFrame from the data for each iteration
   * @param {Uint8Array} chunk Next chunk of codec data to read
   * @returns {Iterable<CodecFrame|OggPage>} Iterator that operates over the codec data.
   * @yields {CodecFrame|OggPage} Parsed codec or ogg page data
   */ *parseChunk(chunk) {
        for(let i = this._generator.next(chunk); i.value; i = this._generator.next())yield i.value;
    }
    /**
   * @public
   * @description Parses an entire file and returns all of the contained frames.
   * @param {Uint8Array} fileData Coded data to read
   * @returns {Array<CodecFrame|OggPage>} CodecFrames
   */ parseAll(fileData) {
        return [
            ...this.parseChunk(fileData),
            ...this.flush()
        ];
    }
    /**
   * @private
   */ *_getGenerator() {
        if (this._inputMimeType.match(/aac/)) this._parser = new (0, $ea4373f84c96dcef$export$2e2bcd8739ae039)(this, this._headerCache, this._onCodec);
        else if (this._inputMimeType.match(/mpeg/)) this._parser = new (0, $e60718df768668d6$export$2e2bcd8739ae039)(this, this._headerCache, this._onCodec);
        else if (this._inputMimeType.match(/flac/)) this._parser = new (0, $fc8c22388cf24d2d$export$2e2bcd8739ae039)(this, this._headerCache, this._onCodec);
        else if (this._inputMimeType.match(/ogg/)) this._parser = new (0, $34db2c67086ea732$export$2e2bcd8739ae039)(this, this._headerCache, this._onCodec);
        else throw new Error(`Unsupported Codec ${mimeType}`);
        this._frameNumber = 0;
        this._currentReadPosition = 0;
        this._totalBytesIn = 0;
        this._totalBytesOut = 0;
        this._totalSamples = 0;
        this._sampleRate = undefined;
        this._rawData = new Uint8Array(0);
        // start parsing out frames
        while(true){
            const frame = yield* this._parser[0, $860f0b5184108148$export$9616b51a1be2e082]();
            if (frame) yield frame;
        }
    }
    /**
   * @protected
   * @param {number} minSize Minimum bytes to have present in buffer
   * @returns {Uint8Array} rawData
   */ *[(0, $860f0b5184108148$export$3027c70a881d60dc)](minSize = 0, readOffset = 0) {
        let rawData;
        while(this._rawData[0, $860f0b5184108148$export$f24224f1c91d8156] <= minSize + readOffset){
            rawData = yield;
            if (this._flushing) return this._rawData[0, $860f0b5184108148$export$7ec32827e4221318](readOffset);
            if (rawData) {
                this._totalBytesIn += rawData[0, $860f0b5184108148$export$f24224f1c91d8156];
                this._rawData = (0, $dd0c961b75cd9139$export$28e250f55413be00)(this._rawData, rawData);
            }
        }
        return this._rawData[0, $860f0b5184108148$export$7ec32827e4221318](readOffset);
    }
    /**
   * @protected
   * @param {number} increment Bytes to increment codec data
   */ [(0, $860f0b5184108148$export$ccac409b8bd6669d)](increment) {
        this._currentReadPosition += increment;
        this._rawData = this._rawData[0, $860f0b5184108148$export$7ec32827e4221318](increment);
    }
    /**
   * @protected
   */ [(0, $860f0b5184108148$export$ebf36ec211205204)](frame) {
        this._sampleRate = frame[0, $860f0b5184108148$export$38e42c68cf43b5d4][0, $860f0b5184108148$export$851d973a43101ae1];
        frame[0, $860f0b5184108148$export$38e42c68cf43b5d4][0, $860f0b5184108148$export$fbead197e07be487] = frame[0, $860f0b5184108148$export$1f34108aa9eb96ab] > 0 ? Math.round(frame[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$f24224f1c91d8156] / frame[0, $860f0b5184108148$export$1f34108aa9eb96ab]) * 8 : 0;
        frame[0, $860f0b5184108148$export$5da2c6384bf58746] = this._frameNumber++;
        frame[0, $860f0b5184108148$export$acdbe6200d314ea0] = this._totalBytesOut;
        frame[0, $860f0b5184108148$export$27063c03e3b4546e] = this._totalSamples;
        frame[0, $860f0b5184108148$export$4ff6995501858325] = this._totalSamples / this._sampleRate * 1000;
        frame[0, $860f0b5184108148$export$1cd93882633e45f5] = this._crc32(frame[0, $860f0b5184108148$export$4051a07651545597]);
        this._headerCache[0, $860f0b5184108148$export$b025372f68843755](frame[0, $860f0b5184108148$export$38e42c68cf43b5d4][0, $860f0b5184108148$export$fbead197e07be487], frame[0, $860f0b5184108148$export$4ff6995501858325]);
        this._totalBytesOut += frame[0, $860f0b5184108148$export$4051a07651545597][0, $860f0b5184108148$export$f24224f1c91d8156];
        this._totalSamples += frame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
    }
    /**
   * @protected
   */ [(0, $860f0b5184108148$export$24d5305cc192425a)](frame) {
        if (frame[0, $860f0b5184108148$export$a53f1e3778a12d7d]) {
            // Ogg container
            if (frame[0, $860f0b5184108148$export$59545aa1378f3baa]) {
                // cut any excess samples that fall outside of the absolute granule position
                // some streams put invalid data in absolute granule position, so only do this
                // for the end of the stream
                let absoluteGranulePositionSamples = frame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
                frame[0, $860f0b5184108148$export$a53f1e3778a12d7d].forEach((codecFrame)=>{
                    const untrimmedCodecSamples = codecFrame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
                    if (absoluteGranulePositionSamples < untrimmedCodecSamples) {
                        codecFrame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = absoluteGranulePositionSamples > 0 ? absoluteGranulePositionSamples : 0;
                        codecFrame[0, $860f0b5184108148$export$1f34108aa9eb96ab] = codecFrame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] / codecFrame[0, $860f0b5184108148$export$38e42c68cf43b5d4][0, $860f0b5184108148$export$851d973a43101ae1] * 1000;
                    }
                    absoluteGranulePositionSamples -= untrimmedCodecSamples;
                    this[0, $860f0b5184108148$export$ebf36ec211205204](codecFrame);
                });
            } else {
                frame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] = 0;
                frame[0, $860f0b5184108148$export$a53f1e3778a12d7d].forEach((codecFrame)=>{
                    frame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] += codecFrame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be];
                    this[0, $860f0b5184108148$export$ebf36ec211205204](codecFrame);
                });
            }
            frame[0, $860f0b5184108148$export$1f34108aa9eb96ab] = frame[0, $860f0b5184108148$export$5f20c3cdf3b5e8be] / this._sampleRate * 1000 || 0;
            frame[0, $860f0b5184108148$export$27063c03e3b4546e] = this._totalSamples;
            frame[0, $860f0b5184108148$export$4ff6995501858325] = this._totalSamples / this._sampleRate * 1000 || 0;
            frame[0, $860f0b5184108148$export$acdbe6200d314ea0] = this._totalBytesOut;
        } else this[0, $860f0b5184108148$export$ebf36ec211205204](frame);
    }
    /**
   * @private
   */ _log(logger, messages) {
        if (this._enableLogging) {
            const stats = [
                `${(0, $860f0b5184108148$export$1c37c01eba8ed446)}:         ${this[0, $860f0b5184108148$export$1c37c01eba8ed446]}`,
                `inputMimeType: ${this._inputMimeType}`,
                `readPosition:  ${this._currentReadPosition}`,
                `totalBytesIn:  ${this._totalBytesIn}`,
                `${(0, $860f0b5184108148$export$acdbe6200d314ea0)}: ${this._totalBytesOut}`
            ];
            const width = Math.max(...stats.map((s)=>s[0, $860f0b5184108148$export$f24224f1c91d8156]));
            messages.push(`--stats--${"-".repeat(width - 9)}`, ...stats, "-".repeat(width));
            logger("codec-parser", messages.reduce((acc, message)=>acc + "\n  " + message, ""));
        }
    }
    /**
   * @protected
   */ [(0, $860f0b5184108148$export$ebd6064652549ce9)](...messages) {
        this._log(console.warn, messages);
    }
    /**
   * @protected
   */ [(0, $860f0b5184108148$export$58da9968c3170cb1)](...messages) {
        this._log(console.error, messages);
    }
}



var $9cd9b424bab85416$export$2e2bcd8739ae039 = (0, $9692457505e16c95$export$2e2bcd8739ae039);
const $9cd9b424bab85416$export$b9d4fc21491dc293 = $860f0b5184108148$export$b9d4fc21491dc293;
const $9cd9b424bab85416$export$2a97ae90773dd351 = $860f0b5184108148$export$2a97ae90773dd351;
const $9cd9b424bab85416$export$cee20cdac1cd19df = $860f0b5184108148$export$cee20cdac1cd19df;
const $9cd9b424bab85416$export$fbead197e07be487 = $860f0b5184108148$export$fbead197e07be487;
const $9cd9b424bab85416$export$d48d8e6e1487adc4 = $860f0b5184108148$export$d48d8e6e1487adc4;
const $9cd9b424bab85416$export$971636741d86955 = $860f0b5184108148$export$971636741d86955;
const $9cd9b424bab85416$export$d28b7ae062ff03c5 = $860f0b5184108148$export$d28b7ae062ff03c5;
const $9cd9b424bab85416$export$ab1029bcae9ddb4a = $860f0b5184108148$export$ab1029bcae9ddb4a;
const $9cd9b424bab85416$export$e2acf35f1e805875 = $860f0b5184108148$export$e2acf35f1e805875;
const $9cd9b424bab85416$export$1c37c01eba8ed446 = $860f0b5184108148$export$1c37c01eba8ed446;
const $9cd9b424bab85416$export$a53f1e3778a12d7d = $860f0b5184108148$export$a53f1e3778a12d7d;
const $9cd9b424bab85416$export$a592872ee1129cb4 = $860f0b5184108148$export$a592872ee1129cb4;
const $9cd9b424bab85416$export$4fafbcc8068ef7ca = $860f0b5184108148$export$4fafbcc8068ef7ca;
const $9cd9b424bab85416$export$bacf03850837cc9e = $860f0b5184108148$export$bacf03850837cc9e;
const $9cd9b424bab85416$export$1cd93882633e45f5 = $860f0b5184108148$export$1cd93882633e45f5;
const $9cd9b424bab85416$export$4051a07651545597 = $860f0b5184108148$export$4051a07651545597;
const $9cd9b424bab85416$export$6d59db4903f20f7d = $860f0b5184108148$export$6d59db4903f20f7d;
const $9cd9b424bab85416$export$1f34108aa9eb96ab = $860f0b5184108148$export$1f34108aa9eb96ab;
const $9cd9b424bab85416$export$bef81ba411953b51 = $860f0b5184108148$export$bef81ba411953b51;
const $9cd9b424bab85416$export$ae48fe32cc58ab6f = $860f0b5184108148$export$ae48fe32cc58ab6f;
const $9cd9b424bab85416$export$38e42c68cf43b5d4 = $860f0b5184108148$export$38e42c68cf43b5d4;
const $9cd9b424bab85416$export$b046ea5b29155775 = $860f0b5184108148$export$b046ea5b29155775;
const $9cd9b424bab85416$export$818e7b951c237e5d = $860f0b5184108148$export$818e7b951c237e5d;
const $9cd9b424bab85416$export$f7027d263cc898cc = $860f0b5184108148$export$f7027d263cc898cc;
const $9cd9b424bab85416$export$947c0ccec8fe9e2a = $860f0b5184108148$export$947c0ccec8fe9e2a;
const $9cd9b424bab85416$export$59545aa1378f3baa = $860f0b5184108148$export$59545aa1378f3baa;
const $9cd9b424bab85416$export$e512c40786d058ff = $860f0b5184108148$export$e512c40786d058ff;
const $9cd9b424bab85416$export$1d1349f4eb9a7003 = $860f0b5184108148$export$1d1349f4eb9a7003;
const $9cd9b424bab85416$export$ca9d7e8ef88bd07e = $860f0b5184108148$export$ca9d7e8ef88bd07e;
const $9cd9b424bab85416$export$50a222d9023da98b = $860f0b5184108148$export$50a222d9023da98b;
const $9cd9b424bab85416$export$f24224f1c91d8156 = $860f0b5184108148$export$f24224f1c91d8156;
const $9cd9b424bab85416$export$549ff81930776885 = $860f0b5184108148$export$549ff81930776885;
const $9cd9b424bab85416$export$f1eb63ab5aca5708 = $860f0b5184108148$export$f1eb63ab5aca5708;
const $9cd9b424bab85416$export$a08b701eae9f6dda = $860f0b5184108148$export$a08b701eae9f6dda;
const $9cd9b424bab85416$export$33a1ce7cb4e60d8d = $860f0b5184108148$export$33a1ce7cb4e60d8d;
const $9cd9b424bab85416$export$7a8a2426cba807b6 = $860f0b5184108148$export$7a8a2426cba807b6;
const $9cd9b424bab85416$export$ed96e046486b4b25 = $860f0b5184108148$export$ed96e046486b4b25;
const $9cd9b424bab85416$export$3dc3ed1cd86c68b4 = $860f0b5184108148$export$3dc3ed1cd86c68b4;
const $9cd9b424bab85416$export$4882ae973e0491e = $860f0b5184108148$export$4882ae973e0491e;
const $9cd9b424bab85416$export$b9b4c22e291dd3d9 = $860f0b5184108148$export$b9b4c22e291dd3d9;
const $9cd9b424bab85416$export$bfe96fedbe3c1b3b = $860f0b5184108148$export$bfe96fedbe3c1b3b;
const $9cd9b424bab85416$export$27e01f77e7f7ec20 = $860f0b5184108148$export$27e01f77e7f7ec20;
const $9cd9b424bab85416$export$7ec32827e4221318 = $860f0b5184108148$export$7ec32827e4221318;
const $9cd9b424bab85416$export$83d89fbfd8236492 = $860f0b5184108148$export$83d89fbfd8236492;
const $9cd9b424bab85416$export$3e1eea38d3db9f18 = $860f0b5184108148$export$3e1eea38d3db9f18;
const $9cd9b424bab85416$export$3a1c3ed71012e84e = $860f0b5184108148$export$3a1c3ed71012e84e;
const $9cd9b424bab85416$export$fe63a71268ec44ee = $860f0b5184108148$export$fe63a71268ec44ee;
const $9cd9b424bab85416$export$5af3e22a52b4ea9e = $860f0b5184108148$export$5af3e22a52b4ea9e;
const $9cd9b424bab85416$export$446963a0ea44fb9d = $860f0b5184108148$export$446963a0ea44fb9d;
const $9cd9b424bab85416$export$f3cbeb72a3601eb6 = $860f0b5184108148$export$f3cbeb72a3601eb6;
const $9cd9b424bab85416$export$6880a9e40f87ae65 = $860f0b5184108148$export$6880a9e40f87ae65;
const $9cd9b424bab85416$export$1dbaf4b0a82f5d28 = $860f0b5184108148$export$1dbaf4b0a82f5d28;
const $9cd9b424bab85416$export$e856ca83ff30dbad = $860f0b5184108148$export$e856ca83ff30dbad;
const $9cd9b424bab85416$export$589c9a7ae9a79c5e = $860f0b5184108148$export$589c9a7ae9a79c5e;
const $9cd9b424bab85416$export$9659c395d9de169e = $860f0b5184108148$export$9659c395d9de169e;
const $9cd9b424bab85416$export$7306104bb28d5804 = $860f0b5184108148$export$7306104bb28d5804;
const $9cd9b424bab85416$export$19129109fa742a6f = $860f0b5184108148$export$19129109fa742a6f;
const $9cd9b424bab85416$export$2cef06c20297c17d = $860f0b5184108148$export$2cef06c20297c17d;
const $9cd9b424bab85416$export$150180f5f882de62 = $860f0b5184108148$export$150180f5f882de62;
const $9cd9b424bab85416$export$326bb32b4ec6239b = $860f0b5184108148$export$326bb32b4ec6239b;
const $9cd9b424bab85416$export$5da2c6384bf58746 = $860f0b5184108148$export$5da2c6384bf58746;
const $9cd9b424bab85416$export$e4cdad84c725445 = $860f0b5184108148$export$e4cdad84c725445;
const $9cd9b424bab85416$export$7815706ac4afa67d = $860f0b5184108148$export$7815706ac4afa67d;
const $9cd9b424bab85416$export$cc7fd71f037082e3 = $860f0b5184108148$export$cc7fd71f037082e3;
const $9cd9b424bab85416$export$c16a704080c492f2 = $860f0b5184108148$export$c16a704080c492f2;
const $9cd9b424bab85416$export$e0e12ae5ee640391 = $860f0b5184108148$export$e0e12ae5ee640391;
const $9cd9b424bab85416$export$a60fa1703d7dd487 = $860f0b5184108148$export$a60fa1703d7dd487;
const $9cd9b424bab85416$export$dda3274d649921c8 = $860f0b5184108148$export$dda3274d649921c8;
const $9cd9b424bab85416$export$851d973a43101ae1 = $860f0b5184108148$export$851d973a43101ae1;
const $9cd9b424bab85416$export$5f20c3cdf3b5e8be = $860f0b5184108148$export$5f20c3cdf3b5e8be;
const $9cd9b424bab85416$export$ef26b3900cee0fa3 = $860f0b5184108148$export$ef26b3900cee0fa3;
const $9cd9b424bab85416$export$9010c500bffe71e6 = $860f0b5184108148$export$9010c500bffe71e6;
const $9cd9b424bab85416$export$462f9602534f6121 = $860f0b5184108148$export$462f9602534f6121;
const $9cd9b424bab85416$export$fd98de4d87954f15 = $860f0b5184108148$export$fd98de4d87954f15;
const $9cd9b424bab85416$export$acdbe6200d314ea0 = $860f0b5184108148$export$acdbe6200d314ea0;
const $9cd9b424bab85416$export$4ff6995501858325 = $860f0b5184108148$export$4ff6995501858325;
const $9cd9b424bab85416$export$27063c03e3b4546e = $860f0b5184108148$export$27063c03e3b4546e;


// prettier-ignore
const $38f2fa52cad57bb7$var$simd = async ()=>WebAssembly.validate(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        5,
        1,
        96,
        0,
        1,
        123,
        3,
        2,
        1,
        0,
        10,
        10,
        1,
        8,
        0,
        65,
        0,
        253,
        15,
        253,
        98,
        11
    ]));

class $38f2fa52cad57bb7$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._sampleRate = options.sampleRate || 48000;
        this._speechQualityEnhancement = options.speechQualityEnhancement;
        this._forceStereo = options.forceStereo !== undefined ? options.forceStereo : false;
        this._onCodec = (codec)=>{
            if (codec !== "opus") throw new Error("ogg-opus-decoder does not support this codec " + codec);
        };
        // instantiate to create static properties
        new (0, $9l3Lt.default)();
        this._useMLDecoder = [
            "lace",
            "nolace"
        ].includes(this._speechQualityEnhancement);
        this._decoderLibraryLoaded = this._loadDecoderLibrary();
        this._ready = this._init();
    }
    _initDecoderClass() {
        this._decoderClass = this._useMLDecoder ? this.OpusMLDecoder : this.OpusDecoder;
    }
    async _loadDecoderLibrary() {
        if (this._useMLDecoder) {
            const simdSupported = await $38f2fa52cad57bb7$var$simd();
            if (simdSupported) {
                const { OpusMLDecoder: OpusMLDecoder, OpusMLDecoderWebWorker: OpusMLDecoderWebWorker } = await (parcelRequire("5TAle"));
                this.OpusMLDecoder = OpusMLDecoder;
                this.OpusMLDecoderWebWorker = OpusMLDecoderWebWorker;
            } else {
                console.warn(`ogg-opus-decoder: This platform does not support WebAssembly SIMD; { speechQualityEnhancements: '${this._speechQualityEnhancement}' } has been disabled`);
                this._useMLDecoder = false;
            }
        }
        this.OpusDecoder = (0, $27034431d4d4accd$export$2e2bcd8739ae039);
        this.OpusDecoderWebWorker = (0, $10073398c294630e$export$2e2bcd8739ae039);
        this._initDecoderClass();
    }
    async _init() {
        if (this._decoder) await this._decoder.free();
        this._decoder = null;
        this._decoderReady = null;
        this._codecParser = new (0, $9cd9b424bab85416$export$2e2bcd8739ae039)("application/ogg", {
            onCodec: this._onCodec,
            enableFrameCRC32: false
        });
    }
    async _instantiateDecoder(header) {
        this._totalSamplesDecoded = 0;
        this._preSkip = header[0, $9cd9b424bab85416$export$3dc3ed1cd86c68b4];
        this._channels = this._forceStereo ? 2 : header[0, $9cd9b424bab85416$export$9659c395d9de169e];
        await this._decoderLibraryLoaded;
        this._decoder = new this._decoderClass({
            channels: header[0, $9cd9b424bab85416$export$9659c395d9de169e],
            streamCount: header[0, $9cd9b424bab85416$export$ef26b3900cee0fa3],
            coupledStreamCount: header[0, $9cd9b424bab85416$export$a592872ee1129cb4],
            channelMappingTable: header[0, $9cd9b424bab85416$export$e856ca83ff30dbad],
            preSkip: Math.round(this._preSkip / 48000 * this._sampleRate),
            sampleRate: this._sampleRate,
            speechQualityEnhancement: this._speechQualityEnhancement,
            forceStereo: this._forceStereo
        });
        return this._decoder.ready;
    }
    get ready() {
        return this._ready;
    }
    async reset() {
        this._ready = this._init();
        await this._ready;
    }
    free() {
        if (this._decoder) this._decoder.free();
    }
    async _decode(oggPages) {
        let opusFrames = [], allErrors = [], allChannelData = [], samplesThisDecode = 0;
        const flushFrames = async ()=>{
            if (opusFrames.length) {
                await this._decoderReady;
                const { channelData: channelData, samplesDecoded: samplesDecoded, errors: errors } = await this._decoder.decodeFrames(opusFrames);
                allChannelData.push(channelData);
                allErrors.push(...errors);
                samplesThisDecode += samplesDecoded;
                this._totalSamplesDecoded += samplesDecoded;
                opusFrames = [];
            }
        };
        for(let i = 0; i < oggPages.length; i++){
            const oggPage = oggPages[i];
            // only decode Ogg pages that have codec frames
            const frames = oggPage[0, $9cd9b424bab85416$export$a53f1e3778a12d7d].map((f)=>f[0, $9cd9b424bab85416$export$4051a07651545597]);
            if (frames.length) {
                opusFrames.push(...frames);
                if (!this._decoderReady) // wait until there is an Opus header before instantiating
                this._decoderReady = this._instantiateDecoder(oggPage[0, $9cd9b424bab85416$export$a53f1e3778a12d7d][0][0, $9cd9b424bab85416$export$38e42c68cf43b5d4]);
            }
            if (oggPage[0, $9cd9b424bab85416$export$59545aa1378f3baa]) {
                // decode anything left in the current ogg file
                await flushFrames();
                // in cases where BigInt isn't supported, don't do any absoluteGranulePosition logic (i.e. old iOS versions)
                if (oggPage[0, $9cd9b424bab85416$export$b9d4fc21491dc293] !== undefined && allChannelData.length) {
                    const totalDecodedSamples_48000 = this._totalSamplesDecoded / this._sampleRate * 48000;
                    // trim any extra samples that are decoded beyond the absoluteGranulePosition, relative to where we started in the stream
                    const samplesToTrim = Math.round((totalDecodedSamples_48000 - oggPage[0, $9cd9b424bab85416$export$27063c03e3b4546e]) / 48000 * this._sampleRate);
                    const channelData = allChannelData[allChannelData.length - 1];
                    if (samplesToTrim > 0) for(let i = 0; i < channelData.length; i++)channelData[i] = channelData[i].subarray(0, channelData[i].length - samplesToTrim);
                    samplesThisDecode -= samplesToTrim;
                    this._totalSamplesDecoded -= samplesToTrim;
                }
                // reached the end of an ogg stream, reset the decoder
                await this.reset();
            }
        }
        await flushFrames();
        return [
            allErrors,
            allChannelData,
            this._channels,
            samplesThisDecode,
            this._sampleRate,
            16
        ];
    }
    async decode(oggOpusData) {
        const decoded = await this._decode([
            ...this._codecParser.parseChunk(oggOpusData)
        ]);
        return (0, $9l3Lt.default).getDecodedAudioMultiChannel(...decoded);
    }
    async decodeFile(oggOpusData) {
        const decoded = await this._decode([
            ...this._codecParser.parseAll(oggOpusData)
        ]);
        await this.reset();
        return (0, $9l3Lt.default).getDecodedAudioMultiChannel(...decoded);
    }
    async flush() {
        const decoded = await this._decode([
            ...this._codecParser.flush()
        ]);
        await this.reset();
        return (0, $9l3Lt.default).getDecodedAudioMultiChannel(...decoded);
    }
}



class $8fd7f9fe32fa5ac0$export$2e2bcd8739ae039 extends (0, $38f2fa52cad57bb7$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
    _initDecoderClass() {
        this._decoderClass = this._useMLDecoder ? this.OpusMLDecoderWebWorker : this.OpusDecoderWebWorker;
    }
    async free() {
        if (this._decoder) await this._decoder.free();
    }
}



var $ctpdC = parcelRequire("ctpdC");
(0, $ctpdC.assignNames)((0, $38f2fa52cad57bb7$export$2e2bcd8739ae039), "OggOpusDecoder");
(0, $ctpdC.assignNames)((0, $8fd7f9fe32fa5ac0$export$2e2bcd8739ae039), "OggOpusDecoderWebWorker");


var $00583c9794cbe277$require$OggOpusDecoder = $8fd7f9fe32fa5ac0$export$2e2bcd8739ae039;

var $00583c9794cbe277$require$OpusDecoder = $10073398c294630e$export$2e2bcd8739ae039;
const $00583c9794cbe277$var$codecMap = {
    opus: $00583c9794cbe277$require$OpusDecoder,
    "ogg/opus": $00583c9794cbe277$require$OggOpusDecoder
};
$00583c9794cbe277$exports = (codec)=>{
    if ($00583c9794cbe277$var$codecMap[codec] === undefined) return;
    const decoder = new $00583c9794cbe277$var$codecMap[codec]({
        sampleRate: 24000,
        forceStereo: false
    });
    console.log(decoder);
    const audioCtx = window.audioCtx;
    const player = {
        samples: new Float32Array(0),
        _playing: false,
        _buffering: false,
        _latency: 200,
        _jitterBuffer: 100,
        _playRealtime: ()=>{
            if (player._playing) return;
            player._playing = true;
            const bufferSize = 256;
            const scriptNode = audioCtx.createScriptProcessor(bufferSize, 0, 1);
            scriptNode.addEventListener("audioprocess", (audioProcessingEvent)=>{
                if (player._playing === false) return;
                const outputBuffer = audioProcessingEvent.outputBuffer;
                const outputData = outputBuffer.getChannelData(0);
                if (player.samples.length === 0) {
                    scriptNode.disconnect(audioCtx.destination);
                    player._playing = false;
                    return;
                }
                if (player.samples.length < 256) console.warn(`Buffer underflow: ${player.samples.length}/256 samples`);
                // Copy available samples
                const available = Math.min(player.samples.length, 256);
                for(let i = 0; i < available; i++)outputData[i] = player.samples[i];
                // Zero-fill remainder to avoid clicks
                for(let i = available; i < 256; i++)outputData[i] = 0;
                player.samples = player.samples.slice(256);
            });
            scriptNode.connect(audioCtx.destination);
        },
        _playBuffer: (buffer)=>{
            const myArrayBuffer = audioCtx.createBuffer(1, buffer.length, 24000);
            const chan = myArrayBuffer.getChannelData(0);
            buffer.forEach((sample, key)=>{
                chan[key] = sample;
            });
            const source = audioCtx.createBufferSource();
            source.buffer = myArrayBuffer;
            source.connect(audioCtx.destination);
            source.start();
        },
        _concat: (buffer1, buffer2)=>{
            const tmp = new Float32Array(buffer1.length + buffer2.length);
            tmp.set(new Float32Array(buffer1), 0);
            tmp.set(new Float32Array(buffer2), buffer1.length);
            return tmp;
        },
        _decode: (buffer)=>{
            if (codec === "opus") return decoder.decodeFrame(new Uint8Array(buffer));
            else if (codec === "ogg/opus") return decoder.decode(new Uint8Array(buffer));
            else throw new Error("Unknown codec " + codec);
        },
        decode: (data)=>{
            decoder.ready.then(()=>{
                // Schedule playback timer once on first packet
                if (!player._playing && !player._buffering) {
                    player._buffering = true;
                    const bufferTime = 4 * player._latency + player._jitterBuffer;
                    setTimeout(()=>{
                        player._buffering = false;
                        player._playRealtime();
                    }, bufferTime);
                }
                player._decode(data).then((decoded)=>{
                    if (decoded.channelData[0] === undefined) return;
                    player.samples = player._concat(player.samples, decoded.channelData[0]);
                });
            });
        },
        setLatency: (latency)=>player._latency = latency,
        isPlaying: ()=>player._playing,
        reset: ()=>{
            player._buffering = false;
            try {
                return decoder.reset();
            } catch (e) {
                console.error(e);
            }
        }
    };
    return player;
};



const $8e74d3b1bc8de79d$var$CLIENT_VERSION = "24217c9";
$815844dde2cfbfb2$exports.log("Welcome to nemit, press connect to start. ");
const $8e74d3b1bc8de79d$var$ping = (protocol)=>{
    const start = Date.now();
    return protocol.call("echo", "echo").then(()=>{
        const stop = Date.now();
        return stop - start;
    });
};
const $8e74d3b1bc8de79d$var$estimateLatency = (protocol)=>{
    const pings = Array(10).fill().reduce((prev)=>{
        if (prev.length === 0) {
            prev.push($8e74d3b1bc8de79d$var$ping(protocol));
            return prev;
        }
        prev.push(prev.slice(-1)[0].then(()=>$8e74d3b1bc8de79d$var$ping(protocol)));
        return prev;
    }, []);
    return Promise.all(pings).then((pings)=>{
        return pings.reduce((prev, cur)=>prev + cur * (1 / pings.length), 0);
    });
};
const $8e74d3b1bc8de79d$var$openSocket = (onDisconnect)=>{
    return new Promise((resolve, reject)=>{
        const protocol = "ws" + window.location.protocol.slice(4, -1);
        let url = `${protocol}://${window.location.host}/nemit`;
        if (window.location.hostname === "localhost") url = "wss://nemit.pro/nemit";
        const webSocket = new WebSocket(url);
        webSocket.binaryType = "arraybuffer";
        let disconnected = false;
        const handleDisconnect = ()=>{
            if (disconnected) return;
            disconnected = true;
            onDisconnect();
        };
        webSocket.addEventListener("open", ()=>{
            resolve(webSocket);
        });
        webSocket.addEventListener("close", handleDisconnect);
        webSocket.addEventListener("error", handleDisconnect);
    });
};
const $8e74d3b1bc8de79d$var$openNemit = (onDisconnect, playerInstances, onLatencyMeasured)=>{
    return $8e74d3b1bc8de79d$var$openSocket(onDisconnect).then((socket)=>{
        let lastBroadcastID = undefined;
        const protocol = $fd28d333ad7e5007$exports({
            broadcast: (data)=>{
                if (lastBroadcastID && lastBroadcastID != data.id) playerInstances[data.codec].reset();
                // Convert samples to ArrayBuffer if needed (CLI sends Buffer, browser sends ArrayBuffer)
                let samples = data.samples;
                if (samples && !(samples instanceof ArrayBuffer)) // Convert Uint8Array, Buffer, or array-like to ArrayBuffer
                samples = new Uint8Array(samples).buffer;
                playerInstances[data.codec].decode(samples);
                lastBroadcastID = data.id;
            },
            getLock: (data)=>{
                $815844dde2cfbfb2$exports.log("Someone is transmitting");
                $8e74d3b1bc8de79d$var$button.classList.add("ptt-disabled");
                // Update buffer based on sender's latency + our own
                if (data && data.latency) {
                    const senderLatency = data.latency;
                    onLatencyMeasured(senderLatency, true); // true = from sender
                }
            },
            releaseLock: ()=>{
                // Wait for audio to finish playing before enabling button
                const waitForPlayback = ()=>{
                    const stillPlaying = Object.values(playerInstances).some((p)=>p.isPlaying());
                    if (stillPlaying) setTimeout(waitForPlayback, 100);
                    else $8e74d3b1bc8de79d$var$button.classList.remove("ptt-disabled");
                };
                waitForPlayback();
            },
            clientCount: (count)=>{
                $815844dde2cfbfb2$exports.log(`${count} client${count !== 1 ? "s" : ""} connected`);
            },
            serverLog: (data)=>{
                const level = data.level || "log";
                if ($815844dde2cfbfb2$exports[level]) $815844dde2cfbfb2$exports[level](data.message);
                else $815844dde2cfbfb2$exports.log(data.message);
            }
        }, (...args)=>socket.send(...args));
        $815844dde2cfbfb2$exports.log("Estimating latency");
        $8e74d3b1bc8de79d$var$estimateLatency(protocol).then((realLatency)=>{
            const latency = Math.round(realLatency);
            Object.values(playerInstances).forEach((el)=>el.setLatency(latency));
            onLatencyMeasured(latency);
            $815844dde2cfbfb2$exports.log(`Latency is around ${latency}ms. `);
            // Periodic latency check every 30s
            let lastLatency = latency;
            const latencyCheckInterval = setInterval(()=>{
                $8e74d3b1bc8de79d$var$ping(protocol).then((newLatency)=>{
                    const rounded = Math.round(newLatency);
                    if (Math.abs(rounded - lastLatency) > 50) $815844dde2cfbfb2$exports.log(`Latency changed: ${lastLatency}ms \u{2192} ${rounded}ms`);
                    lastLatency = rounded;
                    onLatencyMeasured(rounded);
                }).catch(()=>{
                    // Connection probably lost, interval will be cleared on reconnect
                    clearInterval(latencyCheckInterval);
                });
            }, 30000);
            // Store interval for cleanup on disconnect
            socket.addEventListener("close", ()=>clearInterval(latencyCheckInterval));
        });
        socket.onmessage = (message)=>protocol.readMethod(message.data);
        return protocol;
    });
};
const $8e74d3b1bc8de79d$var$button = document.querySelector("#ptt");
const $8e74d3b1bc8de79d$var$connect = ()=>{
    $8e74d3b1bc8de79d$var$button.removeEventListener("click", $8e74d3b1bc8de79d$var$connect);
    // Check for mediaDevices support (requires HTTPS)
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        $815844dde2cfbfb2$exports.error("Microphone not supported (requires HTTPS)");
        $8e74d3b1bc8de79d$var$button.innerText = "Not supported";
        return;
    }
    $8e74d3b1bc8de79d$var$button.innerText = "PTT";
    const ctxOption = {
        sampleRate: 24000
    };
    window.audioCtx = new (window.AudioContext || window.webkitAudioContext)(ctxOption);
    $815844dde2cfbfb2$exports.log(`Sample rate will be: ${window.audioCtx.sampleRate}`);
    // Play inaudible audio to keep iOS from suspending in background
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
        const oscillator = window.audioCtx.createOscillator();
        const gain = window.audioCtx.createGain();
        oscillator.frequency.value = 1; // 1Hz - below human hearing
        gain.gain.value = 0.001; // Nearly silent
        oscillator.connect(gain);
        gain.connect(window.audioCtx.destination);
        oscillator.start();
    }
    // Request microphone permission early to avoid iOS issues with PTT
    navigator.mediaDevices.getUserMedia({
        audio: true
    }).then((stream)=>{
        stream.getTracks().forEach((track)=>track.stop());
        $815844dde2cfbfb2$exports.log("Microphone permission granted");
    }).catch((err)=>{
        $815844dde2cfbfb2$exports.error(`Microphone permission denied: ${err}`);
    });
    // Keep microphone permission alive on iOS (can expire over time)
    if (isIOS) setInterval(()=>{
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((stream)=>{
            stream.getTracks().forEach((track)=>track.stop());
        }).catch(()=>{});
    }, 30000);
    let currentProtocol = null;
    let recorderInstance = false;
    let cancel;
    let tx;
    let txTimeout;
    let reconnectAttempts = 0;
    let reconnecting = false;
    let myLatency = 200; // Default, updated after ping
    const playerInstances = {
        "ogg/opus": $00583c9794cbe277$exports("ogg/opus"),
        "opus": $00583c9794cbe277$exports("opus")
    };
    const setupConnection = ()=>{
        if (reconnecting) return;
        reconnecting = true;
        const delay = Math.min(1000 * Math.pow(2, reconnectAttempts), 30000);
        if (reconnectAttempts > 0) $815844dde2cfbfb2$exports.warning(`Reconnecting in ${delay / 1000}s...`);
        setTimeout(()=>{
            $8e74d3b1bc8de79d$var$openNemit(()=>{
                $815844dde2cfbfb2$exports.error("Disconnected from server");
                $8e74d3b1bc8de79d$var$button.classList.add("ptt-disabled");
                currentProtocol = null;
                reconnecting = false;
                setupConnection();
            }, playerInstances, (latency, fromSender)=>{
                if (fromSender) {
                    // Sender's latency received - add to our own for total buffer
                    const totalLatency = latency + myLatency;
                    Object.values(playerInstances).forEach((el)=>el.setLatency(totalLatency));
                    $815844dde2cfbfb2$exports.log(`Buffer: ${4 * totalLatency + 100}ms (4 \xd7 (${latency}ms sender + ${myLatency}ms mine) + 100ms jitter)`);
                } else // Our own latency measured
                myLatency = latency;
            }).then((protocol)=>{
                currentProtocol = protocol;
                const wasReconnect = reconnectAttempts > 0;
                reconnectAttempts = 0;
                reconnecting = false;
                if (wasReconnect) $815844dde2cfbfb2$exports.log("Reconnected to server");
                else $815844dde2cfbfb2$exports.log("Connected to server");
                protocol.call("echo", "connected").then((response)=>{
                    console.log(response);
                    $8e74d3b1bc8de79d$var$button.classList.remove("ptt-disabled");
                });
                // Check version match
                protocol.call("version").then((serverVersion)=>{
                    if (serverVersion !== $8e74d3b1bc8de79d$var$CLIENT_VERSION) $815844dde2cfbfb2$exports.warning(`Version mismatch: server ${serverVersion}, client ${$8e74d3b1bc8de79d$var$CLIENT_VERSION} - refresh recommended`);
                }).catch(()=>{});
            }).catch(()=>{
                reconnectAttempts++;
                reconnecting = false;
                setupConnection();
            });
        }, reconnectAttempts > 0 ? delay : 0);
    };
    const startTx = ()=>{
        if (!currentProtocol) return;
        cancel = false;
        tx = false;
        currentProtocol.call("getLock", {
            latency: myLatency
        }).then((lock)=>{
            tx = true;
            if (cancel) return releaseHandler();
            if (!lock) {
                $815844dde2cfbfb2$exports.error("Someone already talking");
                return;
            }
            $815844dde2cfbfb2$exports.log("You are transmitting");
            const rawModeEnabled = document.getElementById("raw-mode")?.checked || false;
            recorderInstance = $c53890eb3e021adc$exports({
                raw: rawModeEnabled
            });
            recorderInstance.on("samples", (samples)=>{
                samples.arrayBuffer().then((buffer)=>{
                    if (buffer.byteLength === 0) return;
                    if (!currentProtocol) return;
                    currentProtocol.call("broadcast", {
                        codec: "ogg/opus",
                        samples: buffer,
                        id: lock
                    });
                });
            });
            recorderInstance.record().then(()=>{
                $8e74d3b1bc8de79d$var$button.classList.add("ptt-pressed");
                $8e74d3b1bc8de79d$var$button.innerText = "SAMO CQ";
                txTimeout = setTimeout(()=>{
                    console.warn("TX time limit reached (3 minutes), releasing lock");
                    releaseHandler();
                }, 180000);
            });
        });
    };
    const releaseHandler = ()=>{
        clearTimeout(txTimeout);
        cancel = true;
        if (!tx) return;
        tx = false;
        $815844dde2cfbfb2$exports.log("You are not transmitting");
        $8e74d3b1bc8de79d$var$button.classList.remove("ptt-pressed");
        $8e74d3b1bc8de79d$var$button.innerText = "PTT";
        // Delay stop to capture last bit of audio
        setTimeout(()=>{
            if (recorderInstance && recorderInstance.stop) recorderInstance.stop();
            if (currentProtocol) currentProtocol.call("releaseLock");
        }, 200);
    };
    const pressHandler = (e)=>{
        $8e74d3b1bc8de79d$var$button.setPointerCapture(e.pointerId);
        startTx();
    };
    $8e74d3b1bc8de79d$var$button.addEventListener("pointerdown", pressHandler);
    $8e74d3b1bc8de79d$var$button.addEventListener("pointerup", releaseHandler);
    $8e74d3b1bc8de79d$var$button.addEventListener("pointercancel", releaseHandler);
    // Hardware PTT button support (Hytera, Zebra, Blackview, etc.)
    const pttKeyCodes = [
        102,
        135,
        261
    ];
    document.addEventListener("keydown", (e)=>{
        if (pttKeyCodes.includes(e.keyCode) && !e.repeat) {
            e.preventDefault();
            startTx();
        }
    });
    document.addEventListener("keyup", (e)=>{
        if (pttKeyCodes.includes(e.keyCode)) {
            e.preventDefault();
            releaseHandler();
        }
    });
    $8e74d3b1bc8de79d$var$button.addEventListener("touchstart", ()=>{
        if (window.audioCtx.state === "suspended") window.audioCtx.resume();
    }, {
        passive: true
    });
    // Resume when returning from lock screen / background
    document.addEventListener("visibilitychange", ()=>{
        if (document.visibilityState === "visible") {
            if (window.audioCtx.state === "suspended") window.audioCtx.resume();
            // Trigger reconnect if disconnected
            if (!currentProtocol && !reconnecting) setupConnection();
        }
    });
    setupConnection();
};
$8e74d3b1bc8de79d$var$button.addEventListener("contextmenu", (e)=>e.preventDefault());
$8e74d3b1bc8de79d$var$button.addEventListener("click", $8e74d3b1bc8de79d$var$connect);


//# sourceMappingURL=index.00b28e65.js.map
